import { appDemoEn } from "./appDemoTranslations";
import {  navigationMenuEn } from "./navigationMenuTranslations";
import { memberAdminNavigationEn } from "./memberAdminNavigationTranslations";
import { bankingEn } from "../../../../../../shared/frontend/banking/bankingTranslations";
import { merchantPaymentEn } from "../../../../../../shared/frontend/payments/merchantPaymentTranslations";
import { paymentProfileEn } from "./paymentProfileTranslations";
import { settingsNavigationEn } from "./settingsNavigationTranslations";
import { themeEn } from "../../../../../../shared/frontend/theme/themeTranslations";
import { wizardEn } from "../../../../../../shared/frontend/wizard/wizardTranslations";
import { smtpEmailAccountEn } from "../../../../../../shared/frontend/smtp-relay/smtpEmailAccountTranslations";
import { sharedInvoiceDesignEn } from "../../../../../../shared/frontend/billing/invoiceDesignTranslations";
import { sharedPeriodSelectorEn } from "../../../../../../shared/frontend/components/periodSelectorTranslations";
import { sharedAdminEn } from "../../../../../../shared/frontend/admin/adminTranslations";
import { sharedProviderAccessEn } from "../../../../../../shared/frontend/ai/providerAccessTranslations";
import { sharedOfferedModelsEn } from "../../../../../../shared/frontend/ai/offeredModelsTranslations";
import { sharedProviderPricingEn } from "../../../../../../shared/frontend/ai/providerPricingTranslations";
import { sharedAgentModelSelectionEn } from "../../../../../../shared/frontend/ai/agentModelSelectionTranslations";

/**
 * English translations (keys are English).
 */
import { publicIdentityEn } from "../../features/publicForm/publicIdentityTranslations";
export const en = {
  "Message goal": "Goal",
  "Assign the person to this email first.": "Assign the person to this email first.",
  "Request evidence": "Evidence",
  "Appointment booking request": "Appointment booking",
  "Appointment acceptance": "Appointment acceptance",
  "Process appointment request": "Process appointment request",
  "Select the appointment for this request.": "Select the appointment for this request.",
  ...appDemoEn,
  "Available for manual payments": "Available for manual payments",
  "Payment methods could not be loaded.": "Payment methods could not be loaded.",
  ...publicIdentityEn,
  "Assignment readers could not be loaded.": "Assignment readers could not be loaded.",
  "Set the current location in Check-in before assigning an access medium.": "Set the current location in Check-in before assigning an access medium.",
  "No assignment reader configured at this location.": "No assignment reader configured at this location.",
  "Monitored readers": "Monitored readers",
  "All configured assignment readers are offline.": "All configured assignment readers are offline.",
  "Present the chip to one of these readers.": "Present the chip to one of these readers.",
  "Access medium scan failed.": "Access medium scan failed.",
  "Bank account ID is missing. Reload the bank accounts and try again.": "Bank account ID is missing. Reload the bank accounts and try again.",
  ...paymentProfileEn,
  "Bank statement booking status": "Booking status",
  "E_BankStatementCreditConsumed": "The credit from this deposit has already been used. Resolve the related credit allocations before cancelling the deposit.",
  "Bank statement partially booked": "partially booked",
  "Bank statement open": "open",
  "Bank statement ambiguous": "ambiguous",
  "Bank statement refresh assignments": "Check assignments",
  "Bank statement candidates": "Matching people",
  "Bank statement record partial payment": "Record partial payment",
  "Bank statement amount exceeds remainder": "The partial payment must not exceed the remaining amount.",
  "Bank statement booked amount": "Booked",
  "Bank statement unallocated amount": "Still to allocate",
  "E_BankStatementAllocationChanged": "This bank transaction's allocation has changed. Reload the statement and check the remaining amount.",
  "Bank statement known only": "known transactions only",
  "Bank statement search": "Search transactions",
  "Bank statement search fields": "Search account holder, date, amount or purpose",
  "Import maintenance package progress": "Contribution calendars: {0}/{1} contract packages",
  "Bank statement person identified": "Person identified",
  "Bank statement contribution identified": "Item identified",
  "Bank statement remember payer": "Remember payer for future assignments",
  "Bank statement payer recognition": "Payer recognition",
  "Bank statement revoke payer": "Revoke assignment",
  "Bank statement revoke payer title": "Revoke the saved payer assignment?",
  "Bank statement revoke payer consequence": "This confirmed name/IBAN assignment will no longer be used for recognition. Existing bookings are retained.",
  "E_BankStatementPayerUnavailable": "The bank transaction has no valid payer name and IBAN combination. Book without saving a payer assignment.",
  "E_BankStatementPayerConflict": "This name and IBAN are already assigned to another person. Check the saved assignment or book without saving a new payer assignment.",
  "Bank statement last fetched": "Last fetched",
  "Bank statement confirmed assignment": "Unambiguous IBAN or reference assignment",
  "Bank statement suggested assignment": "Review assignment: limited evidence",
  "Bank statement member payment": "Member payment",
  "E_BankStatementAlreadyBooked": "This bank transaction has already been booked.",

  "E_BankingSettings": "Complete the bank code, server and protocol version. RAH-10 requires FinTS 3.0.",
  "Banking customer ID optional": "Customer ID (optional)",
  "Banking section access": "Access",
  "Banking section usage": "Usage",
  "E_BankingNameRequired": "Please enter a name for the online connection.",
  "E_BankingNameDuplicate": "This name is already used by another online connection.",
  "E_BankingOrderUnsupported": "The bank does not offer this order through the online connection. Download the SEPA file and submit it in online banking.",
  "E_BankingNoConnection": "No active online connection is set up or marked as default for this bank account (Settings → Bank → Online connections).",
  "E_BankingOrderAccountMismatch": "The run does not collect entirely to the account of the online connection and therefore cannot be submitted online.",
  "E_BankingOrderRejected": "The bank rejected the order. It was not executed.",
  "E_BankingOrderUnknown": "It is unclear whether the bank accepted the order. Check in online banking and confirm the result here; it cannot be submitted again until then.",
  "E_BankingOrderState": "The order has already been submitted or is awaiting clarification.",
  "E_BankingOrderAfterDownload": "The SEPA file has already been downloaded. Confirm that it has not been uploaded to the bank yet.",
  "Banking credentials blocked": "Access locked",
  "Banking credentials blocked hint": "The bank rejected the sign-in too often. Check and save the credentials to release the access.",
  "E_BankingCredentialsBlocked": "Bank access locked: the bank rejected the sign-in too often. Re-enter the credentials in the online connection setup and save.",
  "E_BankingMethodNotAllowed": "This access method is currently not permitted for the bank connection. Choose a permitted method in the setup.",
  "E_BankingPolicyNoMethod": "At least one access method must be permitted.",
  "E_BankingPayeeDeclined": "Order cancelled after the payee verification. It was not executed.",
  "E_TransferOrderMixedAccounts": "The selected refunds belong to different bank accounts. Transfer them separately per account.",
  "Bank order submitted": "Order submitted to the bank.",
  "Banking use statement": "statement",
  "Banking use direct debit": "direct debit",
  "Banking use transfer": "transfer",
  "Banking default for direct debit": "Default for direct debits",
  "Banking default for transfer": "Default for transfers",
  "Online connection": "Online connection",
  "Banking payee check": "Payee verification",
  "Banking execute order": "Execute order",
  "Banking cancel order": "Cancel order",
  "Banking payee check instruction": "Name and account do not or only partly match. If the order is executed anyway, the bank is not liable should the money reach the wrong payee.",
  "Banking order resolve instruction": "Check in online banking whether the order arrived.",
  "Please select an option.": "Please select an option.",
  "SEPA file already downloaded": "SEPA file already downloaded",
  "Banking submit after download warning": "If the file was already uploaded in online banking, an online submission would collect twice.",
  "Banking send to bank": "Send to bank",
  "Banking send to bank again": "Send to bank again",
  "Banking submit direct debit run": "Send direct debit run to bank",
  "Banking resolve submission": "Resolve submission",
  "Banking order arrived at bank": "Arrived at the bank",
  "Banking order not at bank": "Not at the bank",
  "Banking submitted to bank": "Submitted to bank",
  "Banking submission unclear": "Submission unclear",
  "Banking rejected by bank": "Rejected by bank",
  "Bank handover": "Bank handover",
  "Banking resolve submission before posting": "Resolve the online submission before posting.",
  "Transfer open": "Transfer open",
  "Transfer submitting": "Submitting",
  "Transfer submitted": "Transferred",
  "Transfer rejected": "Rejected by bank",
  "Transfer unclear": "Submission unclear",
  "Transfer done outside": "Done outside",
  "Transfer refunds": "Transfer refunds",
  "Banking resolve transfer": "Resolve transfer",
  "Transfer done outside m1member": "Done outside m1member",
  "Banking default for statement": "Default for statements",
  "Banking default short": "default",
  "Banking stored PIN in use": "Leave empty to use the stored PIN.",
  "Banking save PIN": "Save password",
  "Banking save file password": "Save file PIN",
  "Banking save PIN hint": "Stored encrypted only after a successful sign-in. TAN approvals are still required. Unchecking deletes the stored PIN.",
  "Select bank": "Select bank",
  "Bank reference": "Bank reference",
  "Bank statement transaction": "Transaction",
  "Bank statement booking day": "Booking day",
  "Bank statement value date": "Value date",
  "Bank statement assignment": "Assignment",
  "Bank statement booked": "booked",
  "Bank statement direct debit collection": "Direct debit collection",
  "Bank statement book chargeback": "Book chargeback",
  "Select returned payments": "Select returned payments",
  "No payments available for chargeback.": "No payments available for chargeback.",
  "Chargeback amount": "Chargeback amount",
  "Available payment amount": "Available payment amount",
  "Chargeback date": "Chargeback date",
  "Chargeback date is required": "Chargeback date is required",
  "Chargeback date must not be in the future": "Chargeback date must not be in the future",
  "Bank statement open run": "Open run",
  "Bank statement end-to-end ID": "End-to-end ID",
  "Banking port": "Port",
  "Banking inspect file": "Check file",
  "Banking test connection": "Test connection",
  "Banking signature counter": "Signature counter",
  "Banking file check completed": "File checked successfully.",
  "Banking connection test completed": "Connection tested successfully.",

  "Banking tested": "tested",
  "Banking untested": "untested",
  "Banking security file stored": "Security file stored encrypted",
  "E_BankingFileRequired": "Provide a security file and its file password for this access method.",
  "E_BankingFileEntry": "The file has no unique access for the selected bank. Enter the matching user ID.",
  "Banking optical TAN signal": "Optical TAN signal",
  "Banking optical width": "Width",
  "Banking optical speed": "Speed",
  "Banking verify bank key": "Verify bank key",
  "Banking verify bank key instruction": "Compare this fingerprint with independently obtained bank documents and enter the fingerprint from those documents.",
  "Banking bank document fingerprint": "Fingerprint from bank documents",
  "Banking use changed password": "Use a changed online banking password",
  "E_BankingEndpoint": "The server does not match the bank directory. Check the bank settings.",
  "E_BankingUseStatement": "Use this bank access on the bank statement page.",
  "E_BankingUnavailable": "The banking adapter or product registration is not configured. Contact your administrator.",
  "E_BankingCredentials": "The bank access could not be unlocked. Check your user ID, PIN and security file.",
  "E_BankingBusy": "An operation is already running for this bank access.",
  "E_BankingFailed": "The bank request failed. No automatic retry was started.",
  "E_BankingCancelled": "The bank request was cancelled or approval expired.",
  "E_BankingFileUnsupported": "The security file could not be read. The ALF-BanCo file format is not yet directly supported.",
  "E_BankingAccountUnavailable": "The selected account is not available through this bank access.",
  "E_BankingTrustRequired": "The bank keys must be verified against bank documents before use. The request was stopped.",
  "Banking access method": "Access method",
  "Banking RAH10 file": "Security file (RAH-10)",
  "Banking RDH file": "Security file (RDH)",
  "Banking security file": "Security file",
  "Banking security file entry": "Bank access in the security file",
  "Banking file password": "Security file PIN",
  "Banking security file required": "Select the security file.",
  "Banking host": "Bank server",
  "Banking app approval": "Approve in your banking app",
  "Banking approval completed": "Check approval",
  "Banking TAN image": "TAN generator image",
  "Open bank statement": "Open bank statement",
  "Bank statement fetch completed": "Bank statement fetched.",
  "Complete chargeback processing": "Complete processing",
  "Handle chargeback claim": "Payment request / retry collection",
  "Check mandate and debit blocks": "Check bank details and debit blocks",
  "Processing result": "Processing result",
  "Original request note": "Original message",
  "E_ContractRequestChanged": "The request has changed, been withdrawn or already been processed. Reopen it and check its current state.",
  "Cancellation by email": "Cancellation by email",
  "Cancellation via app": "Cancellation via app",
  "Rest period via app": "Rest period via app",
  "Rest period by email": "Rest period by email",
  "Process cancellation": "Process cancellation",
  "Process rest period": "Process rest period",
  "Request processed": "Request processed",
  "This request can be linked to an existing contract change.": "A contract change already exists for this request. Check the original message before linking it.",
  "Link existing cancellation": "Link existing cancellation",
  "Link existing rest period": "Link existing rest period",
  "Cancellation processed": "Cancellation processed",
  "Rest period processed": "Rest period processed",
  "Check the email assignment before processing.": "Check the email assignment and details before processing.",
  "Check email assignment": "Check email assignment",
  "Aggregator linked": "linked",
  "Aggregator identity required": "Member link missing",
  "Link aggregator membership": "Link membership",
  "Unlink aggregator membership?": "Unlink membership?",
  "Aggregator unlink consequence": "The provider link will be removed for all related contracts and wallets of this person. Access through this membership will require linking it again.",
  ...merchantPaymentEn,
  ...bankingEn,
  ...navigationMenuEn,
  ...settingsNavigationEn,
  "Module & Leistungsumfang nach Vereinbarung": "Modules & scope of services by agreement",
  "Standortpreise & Abrechnung nach Vereinbarung": "Location pricing & billing by agreement",
  "Support, Ansprechpartner & SLA nach Vereinbarung": "Support, contact person & SLA by agreement",
  "Onboarding, Schulung & Datenübernahme nach Vereinbarung": "Onboarding, training & data migration by agreement",
  ...smtpEmailAccountEn,
  ...themeEn,
  ...wizardEn,
  "E_AccountAlreadyUsed": "This user has already been used. Deactivate them instead to retain their assignments and historical data.",
  "E_EntityInactive": "The selected entry is no longer active and cannot be used for this new operation.",
  "E_RestPeriodCancelled": "The rest period is cancelled and cannot be edited or confirmed again.",
  "Aggregator checks": "Aggregator checks",
  "Integration Urban Sports Club description": "Additional access validation through Urban Sports Club.",
  "Aggregators": "Aggregators",
  "EGYM Wellpass": "EGYM Wellpass",
  "Urban Sports Club": "Urban Sports Club",
  "Integration EGYM Wellpass description": "Admission validation for Wellpass members. Requires an API key enabled by EGYM for this gym.",
  "Wellpass environment": "Environment",
  "Test environment": "Test environment",
  "Replace API key": "Replace API key",
  "Link Wellpass": "Link Wellpass",
  "Relink Wellpass": "Verify Wellpass link",
  "Unlink": "Unlink",
  "Unlink Wellpass?": "Unlink Wellpass?",
  "Wellpass unlink consequence": "The local link is removed. Access through a Wellpass contract or wallet is then blocked. The EGYM account and Wellpass membership are retained.",
  "Studio connection": "Gym connection",
  "Wellpass TAN": "Wellpass TAN",
  "Wellpass TAN source": "The member retrieves the nine-digit TAN from the Wellpass app or their Wellpass account.",
  "Wellpass TAN format": "Please enter a nine-digit TAN.",
  "Wellpass setup required": "First configure an active EGYM Wellpass connection for the gym under Integrations.",
  "Wellpass connection verified": "API access was confirmed. A person's admission eligibility is checked when they enter.",
  "E_AggregatorWellpassProfileRequired": "Wellpass linking requires first name, last name, email and gender in the person's profile.",
  "E_AggregatorWellpassTanInvalid": "Please use a valid nine-digit Wellpass TAN.",
  "E_AggregatorWellpassExpired": "The Wellpass membership has expired.",
  "E_AggregatorWellpassNotStarted": "The Wellpass membership has not started yet.",
  "E_AggregatorWellpassStudioNotInNetwork": "This gym is not enabled as a partner for the Wellpass integration. Please clarify activation with EGYM.",
  "E_AggregatorWellpassPlus1Denied": "The Wellpass Plus1 membership does not permit access to this gym.",
  "E_AggregatorWellpassAppCheckInRequired": "Please check in using the Wellpass app first, then scan your access medium again.",
  "E_AggregatorWellpassLinkConflict": "EGYM reported an account conflict. Please clarify existing accounts and the TAN with EGYM before linking again.",
  "E_AggregatorWellpassAccountNotFound": "EGYM could not find the account or TAN for this gym. Please verify the link using a current TAN.",
  "E_AggregatorWellpassRequestInvalid": "EGYM rejected the submitted data. Please check the member details and TAN.",
  "E_AggregatorWellpassFirstAdmission": "Admission confirmed: first Wellpass visit at this gym. Please provide onboarding.",
  "E_AggregatorWellpassEnvironmentConflict": "All Wellpass connections must use the same environment. Unlink existing member accounts before switching environments.",
  "One aggregator confirmation is sufficient": "One confirmed alternative is sufficient.",
  "Aggregator options unavailable": "Aggregator integrations could not be loaded.",
  "Aggregator identities unavailable": "Aggregator identities could not be loaded.",
  "USC customer ID": "USC customer ID",
  "USC location ID": "USC location ID",
  "Invalid USC location ID": "The USC location ID must be a valid UUID.",
  "E_AggregatorNotConfigured": "The aggregator connection for this location is not configured.",
  "E_AggregatorUnavailable": "The aggregator validation is currently unavailable.",
  "E_AggregatorCheckInRequired": "No valid aggregator check-in confirmed for this use.",
  "E_AggregatorIdentityRequired": "The person has no aggregator customer ID.",
  "E_AggregatorAssignmentInvalid": "The aggregator assignment or location configuration is invalid.",
  "E_AggregatorIdentityConflict": "This aggregator customer ID is already linked to another person.",
  "E_EntityAlreadyUsed": "This entry is still in use. Deactivate it instead to retain existing assignments and historical data.",
  "E_AccountLastActiveAdministrator": "The last active company administrator cannot be deactivated.",
  "Only unused users can be deleted. Deactivate users who have already been used.": "Only unused users can be deleted. Deactivate users who have already been used.",
  "Deactivate user?": "Deactivate user?",
  "Deactivating this user revokes all sessions, app access and access media. Historical data and assignments are retained.": "All sessions are revoked, app access is blocked and access media are deactivated. Historical data and assignments are retained.",
  "Please reassign remaining appointments, shifts, default shifts and assigned contacts.": "Please reassign remaining appointments, shifts, default shifts and assigned contacts.",
  "Shifts": "Shifts",
  "Default shifts": "Default shifts",
  "Assigned contacts": "Assigned contacts",
  "Cancellable amount": "Cancellable",
  "Cancellation allocation": "Cancellation share",
  "Contribution cancellation reasons": "Contribution cancellation reasons",
  "Contribution cancellation reason": "Contribution cancellation reason",
  "Reasons for contribution cancellations": "Reasons for cancelling contributions and receivables",
  "New contribution cancellation reason": "New reversal reason",
  "Edit contribution cancellation reason": "Edit reversal reason",
  "Contribution cancellation reason created": "Contribution cancellation reason created",
  "Contribution cancellation reason updated": "Contribution cancellation reason updated",
  "Contribution cancellation reason deleted": "Contribution cancellation reason deleted",
  "Cancellation explanation": "Explanation (optional)",
  "No contribution cancellation reasons available": "No active cancellation reasons available.",
  "Manage contribution cancellation reasons": "Manage contribution cancellation reasons",
  "Contribution cancellation reasons permission help": "Allows viewing or editing cancellation reasons for contributions and receivables.",
  "E_76cbcc883743aa05": "Select an active contribution cancellation reason.",
  "E_76cbcc883743aa06": "This reason has already been used. You may deactivate it, but cannot delete it.",
  "E_76cbcc883743aa07": "The reason name must contain 1 to 200 characters.",
  "E_76cbcc883743aa08": "The selected payment cancellation reason is no longer available. Select an active reason.",
  "openItems.cancel.amount": "Cancellation amount",
  "openItems.cancel.cancelledAmount": "Cancelled amount",
  "openItems.cancel.partial": "partially cancelled",
  "openItems.cancel.none": "No cancellable contributions available.",
  "openItems.cancel.history": "Contribution cancelled",
  "E_76cbcc883743aa01": "This contribution cannot be cancelled. Check existing cancellations, direct debit runs, debt collection and the article sale cancellation workflow.",
  "E_76cbcc883743aa02": "The cancellation amount must be at least 0.01 and must not exceed the remaining contribution after previous cancellations.",
  "E_76cbcc883743aa03": "The explanation must not exceed 500 characters.",
  "E_76cbcc883743aa04": "A cancellation settlement cannot be reversed as a payment. The correction record is retained for audit purposes.",

  ...sharedInvoiceDesignEn,
  ...sharedPeriodSelectorEn,
  ...sharedAdminEn,
  ...sharedProviderAccessEn,
  ...sharedOfferedModelsEn,
  ...sharedProviderPricingEn,
  ...sharedAgentModelSelectionEn,
  "Export appearance": "Export appearance",
  "Import appearance": "Import appearance",
  "Appearance exported successfully": "Appearance exported successfully.",
  "Appearance imported successfully": "Appearance imported successfully.",
  "Invalid appearance file format": "Invalid appearance file format.",
  "Could not read appearance file": "Could not read appearance file.",
  "Alignment": "Alignment",
  "Formatting": "Formatting",
  "Reset block to standard": "Reset block to template",
  "Reset to standard": "Reset to template",
  "Reset block formatting confirmation": "Do you want to reset all formatting for this block? The block will inherit the central appearance format settings again.",
  "Line color": "Line color",
  "Line thickness": "Line thickness",
  "Width": "Width",
  "Block anchor": "Anchor",
  "Block anchor tooltip": "In the text flow the block follows its predecessor and moves with the text. At the page footer it sits directly above the footer, no matter where the text ends. Dragging does the same: dropped at the footer, the block stays there.",
  "In the text flow": "in the text flow",
  "At the page footer": "at the page footer",
  "Backup & transfer": "Backup & transfer",

  "Agent assignments": "Agents",
  "Agent assignments are fixed": "Each row is a place where m1member calls a model. New model profiles are created in the model profiles tab.",
  "No model available for this profile": "No matching model profile available",
  "No matching model in catalog": "No active model profile exists for this purpose. Please create or enable a matching profile in the model profiles tab.",
  "Used by model profile": "Used by a model profile",
  "Model not in catalog": "Model is not in the catalog",
  "OfferedModelUnknown": "The selected model profile is no longer in the model catalog. Reload the list and select it again.",
  "OfferedModelInUse": "The model profile is still used by at least one agent and cannot be disabled or deleted.",
  "No price available": "No price recorded",
  "All tenants": "All tenants",
  "Provider costs platform admin only": "This analysis is visible to platform administrators only.",
  "Delete model": "Remove model",
  "Refresh model list": "Reload model list",
  "Select or enter model name": "Select a model or enter a name",
  "Model name required": "The model name is required.",
  "Use custom model": "Use custom model: {model}",

  // Qeddy help assistant
  "Qeddy": "Qeddy",
  "Qeddy help": "Qeddy help",
  "Open Qeddy": "Open Qeddy",
  "Qeddy unavailable": "Qeddy is currently unavailable",
  "Qeddy credit exhausted": "The AI service is currently unavailable",
  "Qeddy intro": "Qeddy helps you use m1member. Qeddy cannot see member or studio data and does not make changes.",
  "Qeddy AI notice": "",
  "Qeddy input placeholder": "What would you like to do in m1member?",
  "Qeddy empty": "Ask a question about using m1member.",
  "Qeddy thinking": "Qeddy is thinking",
  "Qeddy compacting": "Qeddy is summarizing the previous conversation context",
  "Qeddy conversation compacted": "The previous conversation context has been summarized.",
  "Qeddy new conversation": "New conversation",
  "Qeddy conversation expired": "A new conversation was started after a longer period of inactivity.",
  "Qeddy open page": "Open page",
  "Qeddy related pages": "Related pages",
  "Qeddy helpful": "Helpful",
  "Qeddy not helpful": "Not helpful",
  "Qeddy feedback thanks": "Thank you for your feedback.",
  "Qeddy feedback not answered": "Question not answered",
  "Qeddy feedback unclear": "Answer unclear",
  "Qeddy feedback outdated": "Help is outdated",
  "Qeddy feedback steps incorrect": "Steps are incorrect",
  "Qeddy feedback failed": "The feedback could not be saved.",
  "Qeddy suggestions": "Related to this page",
  "Qeddy metrics 30 days": "Qeddy usage in the last 30 days",
  "Qeddy metric answers": "answers",
  "Qeddy metric clarifications": "clarifications",
  "Qeddy metric suggestions": "suggestions",
  "Qeddy metric not answerable": "not answerable",
  "Qeddy metric operational errors": "operational errors",
  "Qeddy metric helpful": "helpful",
  "Qeddy metric not helpful": "not helpful",
  "Qeddy metric support handoffs": "support handoffs",
  "Qeddy metric active tenants": "active tenants",
  "Qeddy metric average duration": "average duration",
  "Qeddy metric average model stages": "average model stages",
  "Qeddy model profiles": "Qeddy model profiles",
  "Qeddy model profile": "Qeddy model profile",
  "Qeddy answer model": "Qeddy answer model",
  "Qeddy documentation model": "Qeddy documentation model",
  "Qeddy search model": "Qeddy search model",
  "Answer generation": "Answer generation",
  "Help search and indexing": "Help search and indexing",
  "AI providers settings card description": "Manage AI provider access and model profiles for Qeddy",
  "Use": "Use",
  "All languages": "All languages",
  "Agent model profiles": "Agent model profiles",
  "Agent model profile": "Agent model profile",
  "Member email intake model": "Member email intake model",
  "Email intake classification": "Analyze and classify inbound email",
  "Relevant": "relevant",
  "Irrelevant": "irrelevant",
  "Uncertain": "uncertain",
  "Review required": "review required",
  "Processing status": "Processing status",
  "Relevance": "Relevance",
  "Request type": "Request type",
  "(no subject)": "(no subject)",
  "Confidence": "Confidence",
  "Not assigned": "Not assigned",
  "Search sender, subject, content, person or contract": "Search sender, subject, content, person or contract",
  "All relevance levels": "All relevance levels",
  "All processing statuses": "All processing statuses",
  "Mailbox": "Mailbox",
  "Manually corrected": "Manually corrected",
  "Not manually corrected": "Not manually corrected",
  "Correction status": "Correction status",
  "Attachments": "Attachments",
  "With attachments": "With attachments",
  "Without attachments": "Without attachments",
  "Processing failed": "Processing failed",
  "Original message": "Original message",
  "No attachments": "No attachments",
  "AI classification": "AI classification",
  "Original relevance": "Original relevance",
  "Original request type": "Original request type",
  "Evidence": "Evidence",
  "Cancellation comparison": "Cancellation comparison",
  "Cancellation received": "Cancellation received",
  "Requested cancellation date": "Requested cancellation date",
  "Calculated cancellation date": "Calculated cancellation date",
  "Rest period details": "Rest period details",
  "Detected candidates": "Detected candidates",
  "Correct classification": "Correct classification",
  "Save correction": "Save correction",
  "Save result": "Save result",
  "Decision basis": "Decision basis",
  "Core requests": "Core requests",
  "Extracted information": "Extracted information",
  "Open points": "Open points",
  "Current message": "Current message",
  "Sender": "Sender",
  "Directly available": "directly available",
  "Name in the message": "Name in the message",
  "Matched uniquely": "matched uniquely",
  "Not assigned automatically": "not assigned automatically",
  "Explicitly stated": "explicitly stated",
  "The person was matched uniquely.": "The person was matched uniquely.",
  "The assignment is ambiguous and needs review.": "The assignment is ambiguous and needs review.",
  "Classification assignment": "Assignment",
  "Contract candidates": "Contract candidates",
  "No textual evidence was extracted.": "No textual evidence was extracted.",
  "AI confidence": "AI confidence",
  "Assessment confidence": "Assessment confidence",
  "Not assessed": "not assessed",
  "No business request recognized": "No business request recognized",
  "No core request identified": "No core request identified",
  "Not analyzed": "not analyzed",
  "Quoted history": "Quoted history",
  "Appointment change": "Appointment change",
  "Appointment cancellation": "Appointment cancellation",
  "Appointment reschedule": "Appointment reschedule",
  "Other service request": "Other service request",
  "Appointment candidates": "Appointment candidates",
  "No matching appointment was found.": "No matching appointment was found.",
  "uniquely matched": "uniquely matched",
  "Reschedule": "Reschedule",
  "Unclear": "unclear",
  "Person reference in the message": "Person reference in the message",
  "Without an assigned person there are no contract candidates.":
    "Without an assigned person there are no contract candidates.",
  "Assessment": "Assessment",
  "No contracts found": "No contracts found",
  "Contract is active": "Contract is active",
  "Contract already ended or cancelled": "Contract already ended or cancelled",
  "Rest periods are allowed": "Rest periods are allowed",
  "Rest periods are not allowed": "Rest periods are not allowed",
  "Fixed-term contract": "Fixed-term contract",
  "No fixed term": "No fixed term",
  "Requested date matches contract end": "Requested date matches contract end",
  "Requested date is near contract end": "Requested date is near contract end",
  "Requested date is close to contract end": "Requested date is close to contract end",
  "Suggested from previous assignments": "Suggested from previous assignments",
  "Text extracted": "Text extracted",
  "Unsupported attachment": "Unsupported attachment",
  "Extraction failed": "Extraction failed",
  "Review inbox classifications": "Review inbox classifications",
  "Review inbox classifications permission help": "Review and manually correct AI classifications for inbound email.",
  "Qeddy help admin card description": "Manage help documents, review, and RAG index",
  "Qeddy source language": "Source language",
  "Qeddy canonical index": "Canonical Qeddy index",
  "Qeddy pending reviews title": "Approvals pending",
  "Qeddy pending updates description": "Qeddy continues to use the last approved help documents. New or revised versions are used only after approval.",
  "Qeddy initial review required description": "No approved help version is available yet. Review and approve the help documents so Qeddy can use them.",
  "Qeddy reindex finished": "Qeddy index was updated",
  "Qeddy reindex failed": "Qeddy reindex failed: {0}",
  "Qeddy reindex produced no index": "Qeddy reindex ran but did not produce an active index.",
  "Qeddy reindex started": "Qeddy reindex was started",
  "Qeddy reindex queued": "Qeddy reindex is waiting to start",
  "Qeddy reindex cancelled": "Qeddy reindex was cancelled",
  "Qeddy reindex required after review": "The approval is available to Qeddy only after reindexing.",
  "Qeddy reindex required title": "Reindex required",
  "Qeddy reindex required description": "Help documents were reviewed or changed but are not yet included in the active Qeddy index. Start reindexing so Qeddy uses this state.",
  "Qeddy reindex job title": "Reindex Qeddy help",
  "qeddyReindex.job.queued": "Qeddy reindex is waiting to start",
  "qeddyReindex.job.readDocuments": "Reading help documents",
  "qeddyReindex.job.syncDocuments": "Synchronizing help documents",
  "qeddyReindex.job.checkReviews": "Checking review approvals",
  "qeddyReindex.job.noReviewedDocuments": "No reviewed help documents found",
  "qeddyReindex.job.resolveModel": "Preparing embedding model",
  "qeddyReindex.job.createEmbeddings": "Indexing search chunks",
  "qeddyReindex.job.saveIndex": "Saving Qeddy index",
  "qeddyReindex.job.done": "Qeddy index is ready",
  "qeddyReindex.job.failed": "Qeddy reindex failed",
  "Qeddy documents reviewed": "Qeddy help documents were reviewed",
  "Qeddy review all": "Review all current help",
  "Qeddy review all disabled hint": "No current help documents are loaded for review.",
  "Qeddy review all no changes hint": "There are no new, stale, or changed help documents to review.",
  "Qeddy review all confirm title": "Review current help?",
  "Qeddy review all confirm text": "{0} currently loaded help documents will be marked as reviewed. Check the list or preview before continuing.",
  "Qeddy current help documents": "current help",
  "Qeddy reviewed help documents": "reviewed help",
  "Qeddy draft help documents": "draft help",
  "Qeddy stale help documents": "stale help",
  "Qeddy reindex requires reviewed documents": "At least one help document must be reviewed before reindexing.",
  "Qeddy review status draft": "Draft",
  "Qeddy review status stale": "Stale",
  "Qeddy review status reviewed": "Reviewed",
  "Feature generated cancellation confirmation": "System-generated cancellation confirmation",
  "Feature qeddy help": "Qeddy help",
  "Feature flags": "Feature flags",
  "Index status": "Index status",
  "Menu path": "Menu path",
  "Review status": "Review status",
  "Chunks": "Chunks",
  "Last reindex": "Last reindex",
  "Last status": "Last status",
  "Last reviewed": "Last reviewed",
  "Source review status": "Source review status",
  "Source hash": "Source hash",
  "Reviewed source hash": "Reviewed source hash",
  "Source changes": "Source changes",
  "Changed": "Changed",
  "Unchanged": "Unchanged",
  "Source file": "Source file",
  "Markdown preview": "Markdown preview",
  "Enabled providers": "Enabled providers",
  "Reindex": "Reindex",
  "Not ready": "Not ready",
  "Outdated": "Outdated",
  "Never": "Never",
  "Ready": "Ready",
  "Ask": "Ask",
  "Review": "Review",

  // Reports: custom lists
  "Custom lists": "Custom lists",
  "Custom recipient list": "Custom recipient list",
  "Build reusable target tables from approved data bases": "Build reusable target tables from approved data bases",
  "New list": "New list",
  "Delete list": "Delete list",
  "Really delete list?": "Really delete list?",
  "Fields": "Fields",
  "Search fields": "Search fields",
  "No fields found": "No fields found",
  "Field already selected": "Field already selected",
  "Target table": "Target table",
  "Drag fields here": "Drag fields here",
  "Drag fields into the table": "Drag fields into the table",
  "Move column": "Move column",
  "Column name": "Column name",
  "Rename column": "Rename column",
  "Clear filter": "Clear filter",
  "contains": "contains",
  "equals": "equals",
  "greater than or equal": "greater than or equal",
  "less than or equal": "less than or equal",
  "after": "after",
  "before": "before",
  "is empty": "is empty",
  "is not empty": "is not empty",
  "Date and time": "Date and time",
  "Yes/No": "Yes/no",
  "Load preview": "Load preview",
  "Preview is outdated": "Preview is outdated",
  "Preview row limit reached": "Preview shows at most {0} rows",
  "Load preview to show real data": "Load preview to show real data",
  "Fields cannot be combined in this list": "These fields cannot be combined in this list: {0}",
  "Field cannot be linked to the current list": "This field cannot be linked to the current list: {0}",
  "List settings": "List settings",
  "Data basis": "Data basis",
  "Source table": "Source table",
  "Start template": "Start template",
  "Visibility": "Visibility",
  "List name placeholder": "e.g. open items for reminders",
  "Person type": "Person type",
  "Form of address": "Form of address",
  "WhatsApp status": "WhatsApp status",
  "SEPA direct debit blocked until": "SEPA direct debit blocked until",
  "Manual check-in blocked": "Manual check-in blocked",
  "Mobile phone": "Mobile phone",
  "Contract value": "Contract value",
  "Open amount__detail": "Open amount",
  "Total open": "Total open",
  "Total overdue": "Total overdue",
  "Open item count": "Open item count",
  "Oldest due date": "Oldest due date",
  "Primary contract": "Primary contract",
  "Original contract end": "Original contract end",
  "Access scope": "Access scope",
  "Requires no arrears": "Requires no arrears",
  "Allows access": "Allows access",
  "Manual override": "Manual override",
  "Externally managed until": "Externally managed until",
  "Period start": "Period start",
  "Period end": "Period end",
  "Document number": "Document number",
  "Submitted to SEPA at": "Submitted to SEPA at",
  "Booked at": "Booked at",
  "Check-in time": "Check-in time",
  "Reader endpoint": "Reader endpoint",
  "Reader endpoint identifier": "Reader endpoint identifier",
  "Last check-in": "Last check-in",
  "Days since last check-in": "Days since last check-in",
  "Lead origin": "Lead origin",
  "Closed at": "Closed at",
  "Closed outcome": "Closed outcome",
  "Inbound text": "Inbound text",
  "Assigned employee": "Assigned employee",
  "Report list purpose recipients": "Recipient list",
  "Report list purpose analysis": "Analysis",
  "Report list purpose export": "Export",
  "Report list purpose work list": "Work list",
  "Report list visibility private": "Private",
  "Report list visibility tenant": "Visible to everyone",
  "Report list source persons": "People",
  "Report list source persons description": "People and contact data",
  "Report list source contracts": "Contracts",
  "Report list source contracts description": "Contract data with person and studio",
  "Report list source open items": "Open items",
  "Report list source open items description": "Open and overdue receivables",
  "Report list source check ins": "Check-ins",
  "Report list source check ins description": "Usage events with person, studio and device",
  "Report list source leads": "Leads",
  "Report list source leads description": "Lead data with linked person",
  "Report list template blank persons": "Blank people list",
  "Report list template active members": "Active members",
  "Report list template birthdays": "Birthdays",
  "Report list template expiring contracts": "Expiring contracts",
  "Report list template open items": "Open items",
  "Report list template overdue open items": "Overdue items",
  "Report list template check ins": "Check-ins",
  "Report list template leads follow up": "Leads for follow-up",
  "Report list relationship direct": "directly linked",
  "Report list relationship via person": "linked through person",
  "Report list relationship via contract": "linked through contract",
  "Report list relationship via lead person": "linked through lead person",
  "Report list relationship via check ins": "calculated through check-ins",
  "Report list source is not allowed": "Data basis is not allowed",
  "Report list field is not allowed": "Field is not allowed for this data basis",
  "Report list filter is not allowed": "Filter is not allowed for this data basis",

  // Tenant backups (tools/backup)
  "Backup details": "Backup details",
  "Backup label hint": "Optional description — falls back to date and time",
  "Backup label placeholder": "e.g. \"Before data fix May 2026\"",
  "Backup details saved": "Backup details saved",
  "Tenant backup schema version": "Schema version",
  "Create new appointment notification": "Create new appointment notification",
  "Create new template": "Create new template",
  "Edit assigned template": "Edit assigned template",
  "Assigned template is no longer available": "The selected template is no longer available",
  "Set up appointment notification": "Set up appointment notification",
  "Appointment notification setup context": "For appointment type \"{0}\"",
  "Appointment notification guided editor hint": "Configure the notification in this editor. It is linked to the appointment type only after saving.",
  "Appointment notification draft status hint": "Drafts remain editable and are not sent automatically.",
  "Appointment reminder template name": "Appointment reminder - {0}",
  "Appointment confirmation template name": "Appointment confirmation - {0}",
  "Appointment reminder subject": "Your appointment reminder",
  "Appointment confirmation subject": "Your appointment confirmation",
  "Appointment reminder body draft": "Please edit this appointment reminder draft.",
  "Appointment confirmation body draft": "Please edit this appointment confirmation draft.",
  "Appointment reminder text draft": "Please edit this appointment reminder draft.",
  "Appointment confirmation text draft": "Please edit this appointment confirmation draft.",
  "Appointment notification email template usage tooltip": "Only email templates with the notification usage purpose can be selected for appointment confirmations and reminders.",
  "No notification email templates available": "No email templates with the notification usage purpose are available.",
  "Template required for enabled notification channel": "A template is required for every enabled notification channel.",
  "Usage purpose information": "Usage purpose information",
  "Usage purpose contract management description": "For emails related to contracts, contract documents, cancellations, and letter delivery.",
  "Usage purpose password sending description": "For password, OTP, and login emails.",
  "Usage purpose notifications description": "For appointment confirmations, appointment reminders, automations, and general notifications.",
  "Usage purpose marketing description": "For marketing and campaign emails.",
  "Usage purpose system error notifications description": "For technical error reports in release mode. This option is only relevant in the admin context.",
  "Usage purpose member inbox description": "Only accounts with this usage purpose and an active IMAP inbox are fetched for the member inbox.",

  // Person detail: consolidated documents tab (timeline)
  "Documents": "Documents",
  "Direction": "Direction",
  "Attachment": "Attachment",
  "Attachment available": "Attachment available",
  "Incoming": "Incoming",
  "Outgoing": "Outgoing",
  "Write letter": "Write letter",
  "Open PDF": "Open PDF",
  "Open email": "Open email",
  "Tenant capabilities": "Tenant capabilities",
  "Manage tenant capabilities": "Enable modules and interfaces per tenant",
  "Included in plan": "Included in plan",
  "Not included in plan": "Not included in plan",
  "like plan": "like plan",
  "on": "on",
  "off": "off",
  "Base function without plan": "Base function, active without plan",
  "No plan booked": "No plan booked",
  "Active by default": "Active by default",
  "Inactive by default": "Inactive by default",
  "Capability calendar": "Calendar",
  "Capability reminders": "Reminders",
  "Capability finance": "Finance",
  "Capability communication": "Communication",
  "Capability debt collection": "Debt collection",
  "Capability lead manager": "Lead manager",
  "Capability member app": "Studio app",
  "Capability finTS": "FinTS bank connection",
  "Capability article sales": "Article sales",
  "Capability reports": "Reports",
  "Capability booking widgets": "Booking widgets",
  "Capability contract signing widgets": "Contract signing widgets",
  "Capability import export": "Import/export",
  "Capability staff scheduling": "Staff scheduling",
  "Integration gateway": "GatewayAPI",
  "Integration online brief 24": "onlinebrief24.de",
  "Integration lead import": "Lead import",
  "Integration m1member": "m1member integration",
  "Integration google calendar": "Google Calendar",
  "Integration meta whatsapp": "WhatsApp (Meta)",
  "Add tenant": "Add tenant",
  "Delete tenant confirmation": "Do you really want to delete this tenant?",
  "Dispatch": "Outbound",
  "Pending approval": "Pending approval",
  "Approve dispatch": "Approve for sending",
  "Do you want to approve this dispatch now?": "Approve this outbound message for sending now?",
  "Dispatch cancelled": "Removed from outbox",
  "Cancel dispatch": "Cancel outbound message",
  "Do you want to cancel this dispatch?": "Do you want to cancel this outbound message?",
  "Retry scheduled": "Retry scheduled",
  "Dispatch & approvals": "Outbound & approvals",
  "Configure which dispatches require approval before they are sent.": "Configure which outbound messages require approval before they are sent.",
  "Communication test mode": "Communication test mode",
  "Communication test mode is active.": "Communication test mode is active.",
  "Default requires approval": "Default requires approval",
  "Allow editing while pending approval": "Allow editing while pending approval",
  "Approval rules (JSON)": "Approval rules (JSON)",
  "Rules override the default. Highest priority wins.": "Rules override the default. Highest priority wins.",
  "Selected channels are sent to this address. Leave empty to suppress external delivery.": "Selected channels are sent to this address. Leave empty to suppress external delivery.",
  "Test email address": "Test email address",
  "If the test email address is empty, selected channels are completed without external delivery.": "If the test email address is empty, selected channels are completed without external delivery.",
  "When the communication test mode is active, selected channels are redirected to the test email address or suppressed when no test email address is set.": "When the communication test mode is active, selected channels are redirected to the test email address or suppressed when no test email address is set.",
  "Approval rules for dispatch and central approvals": "Approval rules for outbound and central approvals",
  "Open dispatch queue": "Open outbound queue",
  "No data": "No data",
  "Bulk dispatch created: {0} created, {1} pending approval, {2} queued, {3} skipped": "Outbound batch: {0} created, {1} pending approval, {2} queued, {3} skipped",
  "Articles": "Articles",
  "Article sales": "Article sales",
  "View article sales": "View article sales",
  "Cash registers": "Cash registers",
  "Cash register": "Cash register",
  "Cash register saved": "Cash register saved",
  "Configure default cash registers for cash payments": "Configure default cash registers for cash payments",
  "e.g. Main cash register": "e.g. Main cash register",
  "e.g. KASSE-1": "e.g. CASH-1",
  "CashRegisterDefaultMissing": "No active default cash register is configured for this studio.",
  "CashRegisterStudioRequired": "No studio could be determined for this cash payment.",
  "Record article sales": "Record article sales",
  "View articles": "View articles",
  "Edit articles": "Edit articles",
  "Article": "Article",
  "Add article": "Add article",
  "Edit article": "Edit article",
  "Create contract package template": "Create contract package template",
  "Edit contract package template": "Edit contract package template",
  "Duplicate contract package template": "Duplicate contract package template",
  "Assign multiple articles to a contract package template (quantity per package closing).": "Assign multiple articles to a contract package template (quantity per package closing).",
  "No articles available (Settings → Articles).": "No articles available (Settings → Articles).",
  "ArticleStudioScopeMismatch": "This article is not enabled for the selected sales studio.",
  "ArticleCannotDeleteInUse": "This article cannot be deleted because it appears in sales or is linked to a contract package template.",
  "Article master data for article sales": "Article master data for article sales",
  "SKU": "SKU",
  "Accounting account": "Accounting account",
  "Accounting exports": "Accounting exports",
  "Accounting exports card description": "Export bookings, open items and DATEV-oriented files.",
  "Accounting export billing period": "Billing period",
  "Download tax advisor package": "Download export package",
  "Export period": "Period",
  "Please select an export period.": "Please select an export period.",
  "Selected period": "Selected period",
  "Studio scope": "Studio scope",
  "Tax advisor export": "Tax advisor export",
  "Tax advisor export description": "Export package for accounting and tax advisors with bookings, open items and a summary.",
  "Tax advisor export downloaded.": "Tax advisor export downloaded.",
  "Sell articles": "Sell articles",
  "Create an article sale for a person": "Create an article sale for a person",
  "Please select a person.": "Please select a person.",
  "Person search min chars hint": "Enter at least 2 characters.",
  "Please add at least one article.": "Please add at least one article.",
  "Please select a payment method.": "Please select a payment method.",
  "Gross": "Gross",
  "Sales count": "Sales count",
  "Visits suffix": "visits",
  "Total gross (article sales)": "Total gross (article sales)",
  "Article sales report": "Article sales",
  "Article sales report description": "Article sales by sale period: gross, net, VAT and number of sales.",
  "Sale date": "Sale date",
  "Generate receipt number": "Generate receipt number",
  "Register immediate payment": "Register immediate payment",
  "New article sale": "New sale",
  "Article sales history": "Recent sales",
  "Article sale status open": "Open",
  "Article sale status paid": "Paid",
  "Article sale status cancelled": "Cancelled",
  "German / EU": "German / EU",
  "English (UK)": "English (UK)",
  "English (US)": "English (US)",
  "European": "European",
  "English/US": "English/US",
  "Level must be >= 1": "Level must be >= 1",
  "Days after due date must be >= 0": "Days after due date must be >= 0",
  "Studio app preview for March 2025": "for March 2025",
  "Direct debit": "Direct debit",
  "Bank transfer": "Bank transfer",
  "Debt collection": "Debt collection",
  "Editor unavailable": "Editor unavailable",
  "rows skipped": "rows skipped",
  "available": "available",
  "not available": "not available",
  "no value": "no value",
  "No matching email template for this studio configured": "No matching email template is configured for this studio. Configure it in Email settings > Templates.",
  "Email template validation failed": "Validation failed",
  "No linked login account": "No linked login account",
  "Regenerate password confirmation": "Regenerate the password? The old password will no longer be valid.",
  "Response is not JSON": "Response is not JSON",
  "Response body is empty": "Response body is empty. The endpoint may not have been found.",
  "Full request URL": "Full request URL",
  "Could not queue command": "Could not queue command",
  "Gateway test started": "Test started: Device ID: {0}, QR ID: {1}",
  "Gateway base URL log": "Gateway Base URL: {0}",
  "Gateway full URL log": "Full Gateway URL: {0}",
  "Gateway base URL missing": "Gateway Base URL is not configured",
  "Gateway settings load failed": "Could not load gateway settings: {0}",
  "Request body log": "Request body: {0}",
  "Request URL relative log": "Request URL (relative): {0}",
  "Request URL full log": "Request URL (full): {0}",
  "Authorization log": "Authorization: {0}",
  "No token": "no token",
  "Raw response status log": "Raw response status: {0}",
  "Raw response text log": "Raw response text: {0}",
  "Raw response headers log": "Raw response headers: {0}",
  "Parsed error response log": "Parsed error response: {0}",
  "Gateway URL log": "Gateway URL: {0}",
  "Gateway status code log": "Gateway status code: {0}",
  "Gateway status text log": "Gateway status text: {0}",
  "Gateway response body log": "Gateway response body: {0}",
  "Gateway response headers log": "Gateway response headers: {0}",
  "Response status log": "Response status: {0}",
  "Response body log": "Response body: {0}",
  "Request ID log": "Request ID: {0}",
  "Unexpected request error log": "Unexpected request error: {0}",
  "Gateway ping test started": "Ping test started...",
  "Ping success log": "Ping successful! Server time: {0}",
  "Ping failed log": "Ping failed: {0}",
  "Starting status polling": "Starting status polling",
  "Waiting for device": "waiting for device",
  "Command not found yet, waiting": "Command not found yet, waiting...",
  "Tariff: Duration incomplete or invalid.": "Tariff: Duration incomplete or invalid.",
  "Tariff: If no duration is defined, no renewal may be defined.": "Tariff: If no duration is defined, no renewal may be defined.",
  "Tariff: Renewal incomplete or invalid.": "Tariff: Renewal incomplete or invalid.",
  "Tariff: Usage limit incomplete or invalid.": "Tariff: Usage limit incomplete or invalid.",
  "Wallet: Initial value must be >= 0.": "Wallet: Initial value must be >= 0.",
  "Wallet: Validity incomplete or invalid.": "Wallet: Validity incomplete or invalid.",
  "Wallet: Usage limit incomplete or invalid.": "Wallet: Usage limit incomplete or invalid.",
  "Wallet: For selected studios only, studios must be selected.": "Wallet: For selected studios only, studios must be selected.",
  "Weekly contributions count": "{0} weekly contributions",
  "extends contract": "extends contract",
  "does not extend contract": "does not extend contract",
  "payment continues": "payment continues",
  "free until term end": "free until term end",
  "check-in allowed": "check-in allowed",
  "Delete rest period": "Delete rest period",
  "delete": "delete",
  "cancel": "cancel",
  "Cancel article sale": "Cancel article sale",
  "Confirm article sale void": "Void sale",
  "Article sale void action": "Void",
  "Article sale void hint": "The sale stays visible as voided. The amount already paid is credited to the member.",
  "Delete article sale": "Delete article sale",
  "Confirm article sale delete": "Delete sale",
  "Article sale delete action": "Delete",
  "Article sale delete hint": "Nothing was paid for this sale. It is removed from the sales lists and remains traceable only in the change history.",
  "Article sale created": "Article sold",
  "Article sale cancelled": "Article sale voided",
  "Article sale deleted": "Article sale deleted",
  "Article sale sepa group changed": "Direct debit group changed",
  "Article sale sepa group hint": "Determines which direct debit run collects the goods. Without a group the receipt stays outside every run.",
  "Edit article sale": "Edit article sale",
  "Receipt": "Receipt",
  "Article sales receipt settings": "Article sales — receipt numbers",
  "Article sales receipt settings intro": "Set the prefix and the next sequential number used when a receipt number is generated for an article sale.",
  "Receipt number prefix": "Receipt number prefix",
  "Next receipt number": "Next receipt number",
  "Receipt prefix is required": "A receipt prefix is required.",
  "Article default account hint": "The default booking account for new articles is configured in Accounting.",
  "Open accounting settings": "Open Accounting",
  "Edit JSON": "Edit JSON",
  "Widget JSON configuration": "Widget configuration (JSON)",
  "JSON applied": "JSON applied.",
  "You can edit the widget configuration as JSON.": "You can edit the widget configuration as JSON.",
  "Selected slot not available": "The selected time is no longer available. Please choose another slot.",
  "Default booking widget header text": "Book your appointment online",
  "Default booking widget confirmation title": "Thank you for your booking!",
  "Default booking widget confirmation message": "Your appointment has been confirmed. Appointment number: {{bookingNumber}}",
  "Street / House No.": "Street / House No.",
  " (Copy)": " (Copy)",
  " months": " months",
  "(all resources)": "(all resources)",
  "StaffShiftAccountNotInScope": "A shift block belongs to an employee outside the current selection.",
  "(all statuses)": "(all statuses)",
  "(all studios for primary account)": "(all studios for primary account)",
  "(all studios)": "(all studios)",
  "(all)": "(all)",
  "(Copy)": "(Copy)",
  "(default pipeline)": "(default pipeline)",
  "(different)": "(different)",
  "(locked)": "(locked)",
  "(no default)": "(no default)",
  "(no limit)": "(no limit)",
  "(no member)": "(no member)",
  "(no name)": "(no name)",
  "(no name)__alt1": "(no name)",
  "(no title)": "(no title)",
  "(none)": "(none)",
  "(none)__alt2": "(none)",
  "(none)__alt3": "(none)",
  "(none)__alt4": "(none)",
  "(optional)": "",
  "(please select)": "(please select)",
  "(Primary account)": "(Primary account)",
  "(required for primary account)": "(required for primary account)",
  "(same as default)": "(same as default)",
  "(system)": "(system)",
  "-": "-",
  "12345": "12345",
  "30-60 Days Inactive": "30-60 Days Inactive",
  "31-60 Days": "31-60 Days",
  "60-90 Days Inactive": "60-90 Days Inactive",
  "61-90 Days": "61-90 Days",
  "90+ Days Inactive": "90+ Days Inactive",
  "A configuration for all studios already exists. Please edit it or select at least one studio.": "A configuration for all studios already exists. Please edit it or select at least one studio.",
  "A higher batch size speeds up sending, but may cause issues with the email provider.": "A higher batch size speeds up sending, but may cause issues with the email provider.",
  "A lead with this data already exists.": "A lead with this data already exists.",
  "At least one option must be selected": "At least one option must be selected",
  "A SEPA group must be selected when payment method is SEPA.": "A SEPA group must be selected when payment method is SEPA.",
  "Abbr.": "Abbr.",
  "Abbreviation": "Abbreviation",
  "Collection user": "Collection user",
  "Allows this account to sign in to the web application.": "Allows this account to sign in to the web application.",
  "Allows this account to use the m1app.": "Allows this account to use the m1app.",
  "Lists this account as an employee in staff planning.": "Lists this account as an employee in staff planning.",
  "For collection users, an abbreviation is requested to identify the acting person.": "For collection users, an abbreviation is requested to identify the acting person.",
  "Abbreviation for confirmation": "Abbreviation for confirmation",
  "Abbreviation is invalid or not found": "Abbreviation is invalid or not found",
  "Abbreviation is required": "Abbreviation is required",
  "Abbreviation of the person's home studio (configurable in studio settings)": "Abbreviation of the person's home studio (configurable in studio settings)",
  "Author": "Author",
  "Acceptance Required": "Acceptance Required",
  "Access & Devices": "Access & Devices",
  "Access & Restrictions": "Access & Restrictions",
  "Access block removed": "Access block removed",
  "App manufacturer": "mQorva",
  "Access blocked": "Access blocked",
  "Access blocking": "Access blocking",
  "Access denied": "Access denied",
  "Access denied__alt2": "Access denied",
  "Access media": "Access media",
  "Access media permission help": "Allows viewing or assigning, reassigning and removing access media for people without editing reader device configuration.",
  "Access medium deleted.": "Access medium deleted.",
  "Access medium": "Access medium",
  "Access medium reassigned.": "Access medium reassigned.",
  "Access medium saved.": "Access medium saved.",
  "Access right": "Access right",
  "Access": "Access",
  "Access__alt1": "Access",
  "Account created.": "Account created.",
  "Account deleted.": "Account deleted.",
  "Account holder": "Account holder",
  "Account Number": "Account Number",
  "Account number is required": "Account number is required",
  "Account saved.": "Account saved.",
  "Accounting": "Accounting",
  "Accounting Account": "Accounting Account",
  "accounts": "accounts",
  "Accounts": "Accounts",
  "Accounts & spooler": "Accounts & spooler",
  "Accounts, assignments & cost centers": "Accounts, assignments & cost centers",
  "Actions": "Actions",
  "Standort für QR-Zutritt prüfen": "Check location for QR access",
  "ReaderDeviceLocationCheckUnavailable": "Location checking can only be enabled after the studio address has been resolved successfully.",
  "PersonDateOfBirthInvalid": "The date of birth must be from 1900 and must not be in the future.",
  "Activate tenant": "Activate tenant",
  "Active": "Active",
  "Active__aktiv": "active",
  "Inactive__inaktiv": "inactive",
  "Active contract": "Active contract",
  "Active contract (signed)": "Active contract (signed)",
  "Active contracts": "Active contracts",
  "Active Contracts": "Active Contracts",
  "Active contracts/wallets": "Active contracts/wallets",
  "Active media": "Active media",
  "Active wallets": "Active wallets",
  "Activity Rate": "Activity Rate",
  "Add": "Add",
  "add__hinzufügen": "Add",
  "add_configuration__hinzufügen": "Add configuration",
  "Add access medium": "Add access medium",
  "Add note": "Add note",
  "Add account": "Add account",
  "Add appointment notification": "Add appointment notification",
  "Add bank account": "Add bank account",
  "Add calendar configuration": "Add calendar configuration",
  "Add configuration": "Add configuration",
  "Add contract package": "Add contract package",
  "Add contract package…": "Add contract package…",
  "Add Custom Holiday": "Add Custom Holiday",
  "Add priceAdjustment": "Add price adjustment",
  "Add price adjustment": "Add price adjustment",
  "Add document": "Add document",
  "Add email address": "Add email address",
  "Add entry": "Add entry",
  "Add holiday": "Add holiday",
  "Add payment": "Add payment",
  "Add person": "Add person",
  "Add phase": "Add phase",
  "Add rest period": "Add rest period",
  "Add rule": "Add rule",
  "Add schedule": "Add schedule",
  "Add Slot": "Add Slot",
  "Add source": "Add source",
  "Add studio app configuration": "Add studio app configuration",
  "Add member app configuration": "Add member app configuration",
  "Add transition": "Add transition",
  "Add unavailability": "Add unavailability",
  "Add version": "Add version",
  "Add wallet": "Add wallet",
  "Address": "Address",
  "Address (formal/informal)": "Address (formal/informal)",
  "Address is required": "Address is required",
  "Addressing": "Addressing",
  "Addressing (formal/informal)": "Addressing (formal/informal)",
  "Addressing is required": "Addressing is required",
  "Adjust amount": "Adjust amount",
  "Adjust contributions (calculate proportionally)": "Adjust contributions (calculate proportionally)",
  "Admin": "Admin",
  "Admin deleted": "Admin deleted",
  "Admin Settings": "Admin Settings",
  "Admin settings hub card description": "Global settings and system defaults",
  "Import run column created": "Created",
  "Import run column status": "Status",
  "Import run column tenant name": "Tenant (name)",
  "Import run column designation": "Designation",
  "Import run schema outdated tag": "Schema outdated",
  "Import run schema outdated tooltip": "The underlying import schema is behind the current target model. Please update the schema from the template before committing the import.",
  "Import run schema changed title": "Import schema changed in another tab",
  "Import run schema changed details": "The loaded schema revision is no longer current. Reload the schema before saving, starting PreCheck, or executing the import so old mappings are not used or saved.",
  "Import run schema changed reload": "Reload schema",
  "Import run schema changed reload success": "Schema reloaded.",
  "Import run schema changed blocking error": "The import schema changed in another tab. Please reload the schema.",
  "Import run edit designation aria": "Change designation",
  "Import run designation saved": "Designation saved.",
  "Import run status Committed": "Committed",
  "Import run status Draft": "Draft",
  "Import run status Failed": "Validation failed",
  "Import run status Ready": "Ready",
  "Import run status RolledBack": "Rolled back",
  "Import run status Uploaded": "Uploaded",
  "Import run status Validating": "Validating",
  "Import run confirm delete": "Really delete this import run and all uploaded files?",
  "Import run create": "New import run",
  "Import run list continue": "Continue",
  "Import run created": "Import run created.",
  "Import run delete error": "Failed to delete import run.",
  "Import run deleted": "Import run deleted.",
  "Import run drop zip": "Drop ZIP file here or click to select",
  "Import run select schema": "Select schema",
  "Import run select tenant": "Select tenant",
  "Import run select zip": "Please select a ZIP file.",
  "Import run select files": "Please select at least one file.",
  "Import run tenant required": "Tenant is required.",
  "Import run upload zip": "Upload ZIP",
  "Import run upload zip hint": "A ZIP file containing CSV files, images, or other import data. Contents are stored under the run in object storage.",
  "Import run upload data": "Upload import data",
  "Import run drop data file": "Drop files here or click",
  "Import run clear upload data": "delete all uploaded data",
  "Import run clear upload confirm title": "Delete uploaded data?",
  "Import run clear upload confirm desc": "All files under the upload path (including subfolders) will be removed from storage. The label and schema are kept.",
  "Import run clear upload success": "All data was removed.",
  "Import run clear upload error": "Could not delete the data.",
  "Import run clear upload data hint": "Remove ZIP contents and intermediate state (validation, preview).",
  "Import run clear upload no data hint": "No data has been uploaded yet.",
  "Import run upload blocked while clearing": "Please wait until removal has finished.",
  "Import run recover from storage": "Existing files found in storage.",
  "Import run recover from storage title": "Existing upload data detected",
  "Import run upload completed in background": "Upload connection dropped, but the server kept going. Please check in validation that all files arrived.",
  "Import run upload completed in background title": "Upload finished server-side",
  "Import run step upload": "Upload import data",
  "Import run step validate": "Validate",
  "Import run step preview": "Preview",
  "Import run step mapping": "Mapping",
  "Import run step package snapshot rules": "Package snapshots",
  "Import run step data select": "Data selection",
  "Import run step data select desc": "Choose which data areas to import. Dependent areas are only available when their prerequisites are enabled. Save persists the selection to the schema.",
  "Import run data select no schema": "No schema loaded. Assign an import schema in the Mapping step first.",
  "Import data area basis": "Core / base",
  "Import data area personen": "People",
  "Import data area vertraege": "Contracts",
  "Import data area finanzen": "Payments / finance",
  "Import data area mahnwesen": "Dunning",
  "Import data area leads": "Leads",
  "Import data cat prerequisite hint": "Enable the required areas first.",
  "Import data cat go to mapping": "Go to mapping →",
  "Import data cat unmapped required fk warning": "Required foreign keys without mapping",
  "Import data cat detail entity col": "Target",
  "Import data cat detail source col": "Source table",
  "Import data cat detail source none": "(none)",
  "Import data cat detail toggle": "Details",
  "Import data cat studios": "Studios",
  "Import data cat persons": "Person records",
  "Import data cat person photos": "Person photos (profile image)",
  "Import data cat person notes": "Person notes",
  "Import data cat person documents": "Person documents",
  "Import data cat check ins": "Check-ins",
  "Import data cat contract packages": "Customer contracts",
  "Import data cat contracts": "Contracts",
  "Import data cat rest periods": "Rest periods",
  "Import data cat rest period reasons": "Rest period reasons",
  "Import data cat cancellation reasons": "Cancellation reasons",
  "Import data cat cancellation models": "Cancellation models",
  "Import data cat contract templates": "Contract components",
  "Import data cat tariff templates": "Tariff templates (package, plans, terms)",
  "Import data cat rest period templates": "Rest period templates",
  "Import data cat priceAdjustments": "Price adjustments",
  "Import data cat payments": "Payments",
  "Import data cat open items": "Open items",
  "Import data cat article sales": "Article sales",
  "Import data cat accounts": "User accounts (staff logins)",
  "Import data cat sepa groups": "SEPA direct debit groups",
  "Import data cat wallet products": "Wallet products",
  "Import data cat wallets": "Wallets & wallet transactions",
  "Import data cat bank data": "Bank data & bank accounts",
  "Import data cat payment plans": "Installment plans",
  "Import data cat payment methods": "Payment methods",
  "Import data cat payment cancel reasons": "Payment cancellation reasons",
  "Import data cat chargeback reasons": "Chargeback reasons",
  "Import data cat reminder levels": "Dunning levels",
  "Import data cat reminders": "Reminders",
  "Import data cat debt collection": "Debt collection agencies",
  "Import data cat lead widget ui presets": "Lead forms",
  "Import data cat lead sources": "Lead sources",
  "Import data cat lead pipelines": "Lead pipelines",
  "Import data cat lead phases": "Lead phases",
  "Import run step precheck": "Precheck",
  "Import run step execute": "Execute import",
  "Import run step mapping desc": "Step by step: assign source table, source column and converter per target field. Save changes to schema.",
  "Import run step package snapshot rules desc":
    "Configure contract package snapshot rules and related contribution-calendar settings for this import. Save persists them to the schema.",
  "Import run step upload short": "Upload data",
  "Import run step upload desc": "Upload a ZIP file with CSV files (and optionally images) directly in this step.",
  "Import run step validate desc": "Check uploaded files and schema.",
  "Import run step preview desc": "Preview data to be imported. Adjust schema if needed.",
  "Import run step precheck desc": "Precheck before import: read all mapped tables/rows, validate converters, and verify target access.",
  "Import run step execute desc": "Write data to the tenant database. After a successful import, rollback can be triggered if needed.",
  "Import run open upload drawer": "Upload import data",
  "Import run open settings drawer": "Import data & settings",
  "Import run drawer settings title": "Import data & settings",
  "Import run settings drawer hint": "Use this area to add additional data and images for the import run.",
  "Import run drawer upload title": "Add data & images",
  "Import run drawer upload hint": "You can upload additional data and images here.",
  "Import run drawer drop file": "Drop file here or click (data and images)",
  "Import run drawer upload button": "Upload",
  "Import run drawer schema json label": "Schema JSON",
  "Import run continue to validate": "Continue to validation",
  "Import run continue to preview": "Continue to preview",
  "Import run step upload done": "Upload and import completed.",
  "Import run step upload pending": "No import data uploaded yet.",
  "Import run step validate pending": "Validation has not been run yet.",
  "Import run step validate passed": "Validation completed successfully.",
  "Import run step validate failed hint": "Validation reported errors. Please review data or schema and validate again.",
  "Import run uploading in progress": "Uploading import data …",
  "Import run validating in progress": "Validating …",
  "Import run loading in progress": "Loading import run …",
  "Import run long running hint": "— Operation is taking unusually long. Please wait or reload the page.",
  "Import run validation rebuild lookup index": "Rebuild index",
  "Import run validation rebuild forced after upload hint":
    "Enabled after a new upload until validation has run once.",
  "Import run validation rebuild lookup index hint": "Enable only when new or changed files/relations should be considered. Without this option, the existing index is reused.",
  "Import run validation rerun on next": "Run validation again",
  "Import run status summary title": "Current status",
  "Import run status summary upload done": "Data has been uploaded.",
  "Import run status summary upload pending": "No data uploaded yet.",
  "Import run status summary validation done": "Validation is complete.",
  "Import run status summary validation failed": "Validation reported errors.",
  "Import run status summary validation pending": "Validation is still pending.",
  "Import run status summary can revalidate": "Validation can be started again at any time.",
  "Import run committing in progress": "Executing import …",
  "Import run progress uploading": "Uploading import data …",
  "Import run progress server processing": "Server processing data …",
  "Import run progress server unzipping": "Extracting ZIP ({0}/{1}): {2}",
  "Import run progress upload stalled": "Waiting for server response …",
  "Import run progress extracting": "Extracting data …",
  "Import run progress saving files": "Saving files …",
  "Import run progress listing files": "Listing files …",
  "Import run progress indexing complete": "Indexing complete",
  "Import run progress validating tables": "Validating tables …",
  "Import run progress validating tables detail": "Validating {2} ({0}/{1})",
  "Import run progress validating tables current": "Validating table {0} …",
  "Import run progress validating data": "Validating tables and files …",
  "Import run progress analyzing relations": "Analyzing relations ({0}/{1}): {2}",
  "Import run progress prechecking": "Running precheck …",
  "Import run progress precheck running preview": "Precheck: running preview …",
  "Import run progress precheck loading data": "Precheck: loading data …",
  "Import run progress precheck loading table pending": "Precheck: table {0} (loading)",
  "Import run progress precheck loading table detail": "Precheck: table {2} ({0} of {1} rows)",
  "Import run progress precheck entities detail": "Precheck: entity {2} ({0} of {1})",
  "Import run progress committing": "Writing data to database …",
  "Import run progress creating tenant backup": "Creating a backup of the current tenant …",
  "Import run progress committing preparing": "Preparing import …",
  "Import run progress committing open item status": "Updating open-item status …",
  "Import run progress committing wallet balances": "Calculating wallet balances …",
  "Import run progress committing debt collection cases": "Linking debt-collection cases …",
  "Import run progress committing package snapshots": "Creating contract-package snapshots …",
  "Import run progress committing entities detail": "Writing entity {2} ({0} of {1})",
  "Import run progress committing entities current": "Writing database entity {0}",
  "Import run progress committing files detail": "Copying files ({0} of {1})",
  "Import run progress clearing": "Removing uploaded files",
  "Import run upload extracting": "Extract upload",
  "Import run zip uploaded uncounted": "Upload successful — moving to validation.",
  "Import run drawer schema section": "Schema / mapping (JSON)",
  "Import run drawer schema save": "Save schema",
  "Import run drawer schema saved": "Schema saved.",
  "Import run drawer schema save error": "Failed to save schema.",
  "Import run step save": "Save",
  "Import run undo": "Discard changes",
  "Import run undo confirm title": "Discard unsaved changes?",
  "Import run undo confirm": "All changes since the last save will be discarded. Continue?",
  "Import run undo success": "Changes were reset to the last saved state.",
  "Import run undo error": "Failed to reset changes.",
  "Import run save tooltip unsaved": "Unsaved changes detected. Please save.",
  "Import run step save not available": "There is currently nothing to save for this step.",
  "Import run step saved": "Import run saved.",
  "Import run step save error": "Failed to save import run.",
  "Import run wizard step locked hint": "This step is not available yet. Please complete the previous steps first.",
  "Import run step locked reason upload": "Please upload files first.",
  "Import run step locked reason validate": "Please complete validation first.",
  "Import run step locked reason mapping": "Please configure mapping first.",
  "Import run step locked reason dataselect": "Please complete data selection first.",
  "Import run step locked reason precheck": "Please run the PreCheck and resolve all errors first.",
  "Import run unsaved changes hint": "There are unsaved mapping or relation changes. Only “Save” writes this state to the schema; “Discard changes” resets both.",
  "Import run preview table tab": "{0} → {1}",
  "Import run validate": "Validate",
  "Import run validation failed": "Validation failed.",
  "Import run validation result success": "Validation successful",
  "Import run validation result success detail": "{0} files detected: {1} tables, {2} images, {3} documents.",
  "Import run validation storage structure": "File list indexed. Subfolders: {0}. Top-level folders: {1}. Files: {2} CSV, {3} images, {4} documents.",
  "Import run validation storage structure yes": "yes",
  "Import run validation storage structure no": "no",
  "Import run validation ok": "Validation OK. {0} file(s) in run.",
  "Import run zip error": "ZIP upload failed.",
  "Import run upload stalled warning": "Upload progress has stalled. Checking network/proxy …",
  "Import run upload stalled error": "Upload was aborted after stalling without progress for too long.",
  "Import run upload timeout": "Upload was aborted after maximum wait time. Try a smaller file or check the connection.",
  "Import run upload interrupted": "Upload connection was interrupted (no server response). Please check network/proxy and try again.",
  "Import run upload too large": "File is too large for server upload (HTTP 413). Please check proxy upload limit.",
  "Import run zip uploaded": "{0} file(s) uploaded.",
  "Import runs": "Mapping imports",
  "Import runs started": "Started mapping imports",
  "Import runs empty hint": "No import runs yet. Create a run and upload a ZIP.",
  "Import runs started empty hint": "No import runs yet. Create a run and upload a ZIP.",
  "Admin Import": "Import",
  "Mapping templates": "Mapping templates",
  "Mapping imports": "Mapping imports",
  "Adapter imports": "Adapter imports",
  "Mapping templates group card description": "Reusable table mapping templates (CSV ↔ database tables)",
  "Mapping imports group card description": "Concrete import runs based on a mapping template",
  "Adapter imports group card description": "Import runs via system adapters (e.g. CenterCom)",
  "Import schemas group card description": "Manage import schemas and edit source-to-target mapping",
  "Import runs group card description": "Create import runs, preview, commit, and rollback",
  "Back to Import": "Back to Import",
  "Import run preview": "Load preview",
  "Import run preview title": "Import preview",
  "Import run preview loading": "Loading preview…",
  "Import run preview error": "Preview failed.",
  "Import run target preview error": "Target preview could not be loaded.",
  "Import run source preview error": "Source preview could not be loaded.",
  "Import run source columns error": "Source columns could not be loaded.",
  "Import run enum source values error": "Source values for mapping could not be loaded.",
  "Import run preview warning": "Preview with warnings",
  "Import run preview include unresolved foreign keys": "import unresolved rows anyway",
  "Import run preview include unresolved foreign keys short": "import unresolved rows anyway",
  "Import run precheck strict fk rows skipped notice":
    "These source rows will not be imported because the link (e.g. to the person) is missing. Other rows in the source table are unaffected.",
  "Import run precheck strict fk skip acknowledge": "skip unresolved rows",
  "Import run precheck strict fk include unresolved blocking":
    "This run includes unresolved FK rows in the preview; disable the API option or fix the data.",
  "Import run preview no data": "No preview data (schema has no source mapping or run has no files).",
  "Import run preview mapping hint": "The schema has no usable source mapping. Please review and save the mapping.",
  "Import run go to mapping": "Go to mapping",
  "Import run mapping preview title": "Preview",
  "Import run mapping preview mode": "View",
  "Import run mapping preview source": "Source",
  "Import run mapping preview target": "Target",
  "Import run mapping preview conversion mode": "Target data",
  "Import run mapping preview conversion raw": "Raw data",
  "Import run mapping preview conversion converted": "Display values",
  "Import run mapping preview debug mode": "Debug output",
  "Import run mapping preview debug output": "Debug output (copyable)",
  "Import run mapping preview source loading": "Loading source preview …",
  "Import run mapping preview source loading table": "Loading source preview: {0} …",
  "Import run mapping preview source loading detail": "Source preview: entity {0}/{1} · table {2} · rows {3}/{4}",
  "Import run mapping preview target loading": "Loading target preview …",
  "Import run mapping preview target loading detail": "Target preview: entity {0}/{1} · {2} · rows {3}/{4}",
  "Import run mapping preview target loading detail entity and table": "Target preview: entity {0}/{1} · {2} · table {3} · rows {4}/{5}",
  "Import run mapping preview target existing loading": "Loading existing target data …",
  "Import run mapping preview target progress status": "Target preview running",
  "Import run mapping preview target progress requesting": "Request is being processed",
  "Import run mapping preview target progress processing": "Preparing result",
  "Import run mapping preview target data source mode": "Data source",
  "Import run mapping preview target data source planned": "Import preview",
  "Import run mapping preview target data source existing": "Existing data",
  "Import run mapping preview source empty": "No source data available for this table.",
  "Import run mapping preview source waiting for enum": "Waiting for enum values …",
  "Import run mapping preview target waiting for source": "Waiting for source preview …",
  "Import run mapping preview source not selected": "No source table selected.",
  "Import run mapping preview target empty": "No converted target data available.",
  "Import run mapping preview target empty with source hint": "No target data available for the current mapping. Please check field mapping and target table assignment.",
  "Import run mapping preview target existing empty": "No existing data available for this target entity.",
  "Import run preview phase entity": "Phase {0}: {1}",
  "Import run preview rows": "{0} row(s)",
  "Import run precheck": "Run precheck",
  "Import run precheck success": "Precheck successful: {0} tables/entities checked, {1} rows read.",
  "Import run precheck failed": "Precheck failed.",
  "Import run precheck failed with count": "Precheck failed ({0} errors).",
  "Import run precheck failed details": "Precheck found errors. Please fix mapping/assignments.",
  "Import run precheck failed errors heading": "Reported errors:",
  "Import run precheck failed errors col text": "Error",
  "Import run precheck blocking errors banner":
    "{0} blocking error(s) (e.g. missing table, invalid relationship) – cannot be waived with a checkbox.",
  "Import run precheck global blocking errors title": "Blocking errors (import cannot continue)",
  "Import run precheck run again": "Run precheck again",
  "Import run precheck debug export title": "PreCheck debug export (for support)",
  "Import run precheck debug export desc":
    "Plain-text snapshot of precheck context, unified groups, flat errors and warnings. Choose open vs. resolved before copying.",
  "Import run precheck debug filter open": "Include open items",
  "Import run precheck debug filter resolved": "Include resolved items",
  "Import run precheck debug copied": "Copied to clipboard",
  "Import run precheck debug copy failed": "Copy failed",
  "Import run precheck debug copy": "Copy to clipboard",
  "Import run precheck debug clipboard truncated": "... Clipboard output truncated.",
  "Import run precheck debug section context": "Context & summary",
  "Import run precheck debug section groups": "Unified groups",
  "Import run precheck debug section errors": "Flat precheck errors",
  "Import run precheck debug section warnings": "Flat precheck warnings",
  "Import run precheck debug filter none": "Select at least one filter (open or resolved) to generate text.",
  "Import run precheck debug tag open": "open",
  "Import run precheck debug tag resolved": "resolved",
  "Import run precheck debug valid ok": "yes",
  "Import run precheck debug valid failed": "no",
  "Import run precheck debug valid unknown": "unknown",
  "Import run precheck debug can proceed yes": "yes",
  "Import run precheck debug can proceed no": "no",
  "Import run precheck debug report banner": "=== m1member PreCheck debug export ===",
  "Import run precheck debug report k timestamp utc": "Timestamp (UTC):",
  "Import run precheck debug report k import run id": "Import run ID:",
  "Import run precheck debug report empty collection": "(none)",
  "Import run precheck debug report k precheck valid": "Precheck valid:",
  "Import run precheck debug report k can proceed": "May proceed to execute:",
  "Import run precheck debug report k skip rows": "Skipped rows by source table:",
  "Import run precheck debug report skip row line": "  {0}: count={1}, sample={2}",
  "Import run precheck debug report k fill timestamps": "Fill empty timestamps for source table(s):",
  "Import run precheck debug report k accept fk cells": "Explicitly allowed empty foreign-key cells:",
  "Import run precheck debug report accept fk count": "count={0}",
  "Import run precheck debug report accept fk row": "  - {0} row {1} col {2}",
  "Import run precheck debug report more": "  … (+{0} more)",
  "Import run precheck debug report no groups": "(no groups in current filter)",
  "Import run precheck debug report no error lines": "(no error lines in current filter)",
  "Import run precheck debug report no warning lines": "(no warning lines in current filter)",
  "Import run precheck debug report row sample none": "(none)",
  "Import run precheck debug report row sample more": " … (+{0} more)",
  "Import run precheck debug report entity line":
    "- {0} <= {1}: total={2}, skipped_filter={3}, skipped_fk={4}, to_import={5}, commitSupported={6}",
  "Import run precheck debug report entity summary":
    "SUMMARY (dedup by source table): total={0}, skipped={1}, to_import={2}",
  "Import run precheck debug report na": "n/a",
  "Import run precheck warnings": "Precheck warnings",
  "Import run precheck result title": "Precheck result",
  "Import run precheck col phase": "Mapping phase",
  "Import run precheck col target": "Target entity",
  "Import run precheck col source": "Source table",
  "Import run precheck col rows": "Rows",
  "Import run precheck row count skip tooltip":
    "Rows are marked as skipped for this source table. The count reflects the last precheck preview (excluding those rows). Wait until the precheck run triggered by your selection has finished.",
  "Import run precheck col commit": "On import execution",
  "Import run precheck importable": "will be written to the database",
  "Import run precheck not importable": "not importable",
  "Import run precheck no commit handler": "no commit handler (skipped on import)",
  "Import run precheck not written to db": "not written (not available yet)",
  "Import run precheck row summary title": "Row counts (per source table)",
  "Import run precheck row summary col total": "Total rows",
  "Import run precheck row summary col filter skipped": "Skipped (filter)",
  "Import run precheck row summary col filter skipped tooltip": "Schema filter: {0}",
  "Import run precheck row summary col cascade": "Cascade skip",
  "Import run precheck row summary col cascade hint":
    "Rows skipped because their foreign-key target was excluded by configuration (cascade).",
  "Import run precheck row summary col error skipped": "Skipped (errors)",
  "Import run precheck row summary col to import": "To import",
  "Import run precheck row summary col multi col lookup": "FK resolution (hits/ambiguous/misses)",
  "Import schema mapping multi col lookup preview heading": "Preview: FK resolution (all rows)",
  "Import schema mapping multi col lookup preview empty": "No configuration yet — as soon as key columns are set, the hit statistics appear here automatically.",
  "Import schema mapping multi col lookup preview source only hint":
    "This target only provides the composite key (LookupKeyColumns). The hit statistics are shown at the FK field of the consuming target (e.g. OpenItems.contract_id) — switch there and open the drawer.",
  "Import schema mapping multi col lookup preview total": "{0} rows checked",
  "Import schema mapping multi col lookup preview hits label": "Exact (multi-column)",
  "Import schema mapping multi col lookup preview fallback label": "Fallback (naked PK)",
  "Import schema mapping multi col lookup preview cascade label": "Cascade skip (filtered)",
  "Import schema mapping multi col lookup preview ambig label": "Ambiguous (multiple matches)",
  "Import schema mapping multi col lookup preview miss label": "No match found",
  "Import schema mapping multi col lookup preview ambig rows": "Sample rows (ambiguous): {0}",
  "Import schema mapping multi col lookup preview miss rows": "Sample rows (no match): {0}",
  "Import schema mapping multi col lookup preview ambig rows header": "Sample rows with ambiguous match:",
  "Import schema mapping multi col lookup preview miss rows header": "Sample rows without match:",
  "Import schema mapping multi col lookup preview all miss title": "Not a single row was resolved",
  "Import schema mapping multi col lookup preview all miss hint":
    "Check: (1) Are LookupKeyColumns set on ALL source targets of the same target entity? (2) Do the match columns (left) exist in the current source table by name? (3) Are date/number formats normalizable (e.g. dd.MM.yyyy or yyyy-MM-dd, comma or dot for decimals)?",
  "Import schema mapping multi col lookup debug search keys": "Search keys (from source)",
  "Import schema mapping multi col lookup debug buckets empty":
    "Target buckets are empty. LookupKeyColumns are not set on the target source-targets or yield no values.",
  "Import schema mapping multi col lookup desc":
    "For target entities served by multiple source tables (e.g. Contracts from VERTHIST + Sonderzahlung) the unique key can be defined here. FK resolution probes all buckets and takes the unique hit.",
  "Import schema mapping lookup key columns label": "Lookup key columns (source table)",
  "Import schema mapping lookup key columns hint":
    "Columns of this source table that uniquely identify a row (order matters). Example VERTHIST: VertragsID + VertBegn.",
  "Import schema mapping lookup key columns placeholder": "Select columns …",
  "Import schema mapping lookup match columns label": "Lookup match columns per FK field",
  "Import schema mapping lookup match columns placeholder": "Select source columns …",
  "Import schema mapping lookup indexes id field icon tooltip": "Manage composite lookup indexes",
  "Import schema mapping lookup indexes section": "Composite lookup indexes (on id field)",
  "Import schema mapping lookup indexes hint":
    "Secondary indexes of the target table that FK fields of other entities can reach this target through. Multiple indexes per id are allowed. Column order is part of the key.",
  "Import schema mapping lookup index name label": "Index name",
  "Import schema mapping lookup index name placeholder": "e.g. byPersonNumber",
  "Import schema mapping lookup index columns label": "Columns",
  "Import schema mapping lookup index columns placeholder": "Select source-table columns …",
  "Import schema mapping lookup index add": "Add index",
  "Import schema mapping lookup index remove": "Remove",
  "Import schema mapping lookup index empty": "No composite indexes defined yet.",
  "Import schema mapping lookup index legacy migrate label": "Legacy format detected — migrate to id field",
  "Import schema mapping lookup index legacy migrate hint":
    "This schema still uses the old block-level LookupKeyColumns. Apply the migration to port them as an unnamed index on the id field; the block-level setting is then removed.",
  "Import schema mapping lookup index legacy migrate apply": "Apply migration",
  "Import schema mapping lookup config drawer title": "Lookup configuration",
  "Import schema mapping lookup config drawer title focused": "Lookup configuration — {0}",
  "Import schema mapping lookup config drawer fk no focus":
    "This section configures FK resolution for a single field. Click the magnifier icon on a FK field to focus it here.",
  "Import schema mapping fk source table placeholder": "Bucket …",
  "Import schema mapping multi col lookup test loading": "Refreshing lookup preview …",
  "Import schema mapping multi col lookup progress stage": "Stage: {0}",
  "Import schema mapping multi col lookup progress entities": "Entities: {0} / {1}",
  "Import schema mapping multi col lookup progress rows": "Rows: {0} / {1}",
  "Import run precheck multi col lookup hit": "hits",
  "Import run precheck multi col lookup ambiguous": "ambiguous",
  "Import run precheck multi col lookup miss": "no match",
  "Import run precheck row summary total row": "Total",
  "Import schema mapping row filter op equals": "equals",
  "Import schema mapping row filter op not equals": "not equals",
  "Import schema mapping row filter op is empty": "is empty",
  "Import schema mapping row filter op is not empty": "is not empty",
  "Import schema mapping row filter op contains": "contains",
  "Import schema mapping row filter op not contains": "does not contain",
  "Import schema mapping row filter op starts with": "starts with",
  "Import schema mapping row filter op ends with": "ends with",
  "Import schema mapping row filter op regex": "regex",
  "Import schema mapping row filter relation path": "Lookup path (linked table)",
  "Import schema mapping dedup cols placeholder": "Select columns …",
  "Import schema mapping dedup hint":
    "Rows that share the same values in all selected columns are treated as duplicates; only one row per distinct combination is kept during import.",
  "Import schema mapping dedup title": "Deduplication",
  "Import schema mapping dedup priority title": "Duplicate preference",
  "Import schema mapping dedup priority hint":
    "Optional: When multiple rows share the same key, the row whose value in the chosen column appears in the positive list wins. Without a match, the default behaviour applies (first row wins).",
  "Import schema mapping dedup priority col label": "Column",
  "Import schema mapping dedup priority col placeholder": "Select column …",
  "Import schema mapping dedup priority values label": "Preferred values",
  "Import schema mapping dedup priority values placeholder": "Enter values (press Enter); an empty entry matches a blank column",
  "Import schema mapping dedup priority values placeholder suggestions": "Suggestions from column – custom values can also be typed",
  "Import schema mapping row filter add": "Add condition",
  "Import schema mapping row filter add rule": "Add rule",
  "Import schema mapping row filter col": "Column",
  "Import schema mapping row filter hint":
    "Rows that match this rule’s conditions are excluded from import (skipped for this source table).",
  "Import schema mapping row filter hint include":
    "Only rows that match this rule’s conditions are imported; all other rows from this source table are skipped.",
  "Import schema mapping row filter logic and": "AND",
  "Import schema mapping row filter logic or": "OR",
  "Import schema mapping row filter mode exclude": "Exclude matches",
  "Import schema mapping row filter mode include": "Include matches only",
  "Import schema mapping row filter multiple exclude hint":
    "Several rules are combined with OR: a row is excluded if it matches any rule.",
  "Import schema mapping row filter multiple include hint":
    "Several rules are combined with OR: a row is imported if it matches any rule.",
  "Import schema mapping row filter multiple mixed hint":
    "Rules use different include/exclude modes; each rule is evaluated on its own.",
  "Import schema mapping row filter op": "Operator",
  "Import schema mapping row filter rule or separator": "or",
  "Import schema mapping row filter rule title": "Rule {0}",
  "Import schema mapping row filter title": "Row filters",
  "Import schema mapping row filter val": "Value",
  "Import schema mapping row filter val empty": "(empty)",
  "Import schema mapping row filter column invalid tooltip":
    "Column \"{0}\" does not exist in source table \"{1}\". As a result the filter always matches (like \"empty\") and removes every row. Please fix the column or remove the filter.",
  "Import schema mapping row filter column invalid badge": "not in source table",
  "Import package snapshot rules title": "Contract packages: snapshot rules",
  "Import package snapshot rules enabled": "enable rules",
  "Import package snapshot rules distinct load error title": "Distinct check failed",
  "Import package snapshot rules distinct load error": "Distinct check could not be loaded.",
  "Import package snapshot rules rest section": "Rest period rules",
  "Import package snapshot rules cancellation section": "Cancellation rules",
  "Import package snapshot rules empty rules": "No rules defined.",
  "Import package snapshot rules rule title": "Rule {0}",
  "Import package snapshot rules remove rule": "Remove rule",
  "Import package snapshot rules rest template": "Rest period model",
  "Import package snapshot rules template select": "Select model …",
  "Import package snapshot rules cancellation template": "Cancellation model",
  "Import package snapshot rules add rest rule": "Add rest period rule",
  "Import package snapshot rules add cancellation rule": "Add cancellation rule",
  "Import package snapshot rules add condition": "Add condition",
  "Import package snapshot rules remove condition": "Remove condition",
  "Import package snapshot rules logic and": "AND",
  "Import package snapshot rules logic or": "OR",
  "Import package snapshot rules filter field placeholder": "Select field …",
  "Import package snapshot rules filter value select placeholder": "Value …",
  "Import package snapshot rules filter case sensitive": "Case sensitive",
  "Import cc generation mode title": "Contribution calendar: generation mode",
  "Import cc generation mode hint": "Determines how the contribution calendar is built during import.",
  "Import cc generation mode auto label": "Auto (recommended)",
  "Import cc generation mode auto desc": "Contribution calendar is derived 1:1 from the imported invoices (OpenItems) — same due date, same amount, status mapped from OI status. Rest periods are imported as info records and do not affect the calendar. Direct CSV import of the calendar is suppressed.",
  "Import cc generation mode direct label": "Direct import",
  "Import cc generation mode direct desc": "Contribution calendar rows are imported directly from CSV. Processor will not run.",
  "Import contribution paid override title": "Contribution calendar: mark as paid by rules",
  "Import contribution paid override hint": "Applies only to contract packages written in this import run. Calculated contribution rows are marked paid without creating matching payments.",
  "Import contribution paid override enabled": "enable rules",
  "Import contribution paid override rules section": "Rules",
  "Import contribution paid override rule title": "Rule {0}",
  "Import contribution paid override add rule": "Add rule",
  "Import contribution paid override filter value placeholder": "Value …",
  "Import contribution paid override due on or before": "Due date on or before",
  "Import contribution paid override due on or after": "Due date on or after",
  "Import contribution paid override payment placeholder": "Select payment method …",
  "Import contribution paid override pm 1": "Cash",
  "Import contribution paid override pm 2": "Direct debit",
  "Import contribution paid override pm 3": "Bank transfer",
  "Import contribution paid override pm 4": "Debit card",
  "Import contribution paid override pm 5": "Credit card",
  "Import contribution paid override pm 6": "PayPal",
  "Import contribution paid override pm 7": "SEPA transfer",
  "Import contribution paid override pm 8": "Other",
  "Import contribution paid override pm 9": "Voucher",
  "Import run precheck entity section generated": "Generated by system (no source data import)",
  "Import run precheck entity cc will build": "Will be built",
  "Import run precheck entity cc will build auto": "Will be built (Processor)",
  "Import run precheck entity cc skipped": "Will be skipped",
  "Import run precheck entity section written": "Targets with database import",
  "Import run precheck entity section not written": "Other targets with preview rows ({0}) – no database import",
  "Import run precheck entity section not written hint":
    "These targets have preview rows, but no commit handler is available for the tenant database yet. Mapping alone is not enough; the import must be implemented before these rows can be written.",
  "Import run precheck entity hidden zero rows":
    "{0} more target rows hidden (no preview data, often mapping/reference only).",
  "Import run precheck entity table supported empty":
    "No target with active database import in this preview—expand the section below if shown.",
  "Import run precheck no validation errors for target": "ok",
  "Import run precheck entity status ok": "ok",
  "Import run precheck entity file pending": "open",
  "Import run precheck entity strict fk pending": "open",
  "Import run precheck entity file resolved": "resolved",
  "Import run precheck target ok import blocked globally": "import blocked overall; this target is fine",
  "Import run precheck ambiguous photo accept action": "proceed with ambiguous photo matches on import",
  "Import run precheck summary importable": "Import is approved. Precheck completed without errors.",
  "Import run precheck summary importable with decisions": "Import is approved. Precheck decisions will be applied.",
  "Import run precheck summary decision pending": "Before import: confirm missing files below (one checkbox per source table).",
  "Import run precheck summary not importable": "Import is not approved. Please fix the reported errors.",
  "Import run precheck error groups by source": "Errors by source table",
  "Import run precheck affected rows": "affected rows",
  "Import run precheck affected rows count": "rows",
  "Import run precheck show source records": "Select source table (show affected records)",
  "Import run precheck source preview tabular none": "No tabular validation errors – file notices are under File references above.",
  "Import run precheck source preview tabular empty selection": "No validation errors for this selection (pick another source table).",
  "Import run precheck no rows in preview": "No rows in preview (max row limit exceeded?).",
  "Import run precheck empty rows omitted": "{0} empty row(s) not shown.",
  "Import run precheck col row": "Row",
  "Import run precheck problem columns": "Affected columns",
  "Import run precheck skip rows": "skip affected rows",
  "Import run precheck decision open": "not decided yet",
  "Import run precheck fk option import clear": "Import rows and leave foreign keys empty",
  "Import run precheck fk option import clear with target": "Import {0} {1} rows and leave foreign keys empty",
  "Import run precheck fk option skip rows": "Do not import these rows",
  "Import run precheck optional fk filtered option import clear":
    "Accept rows whose package foreign key is filtered (leave the foreign key empty)",
  "Import run precheck optional fk filtered option skip rows":
    "Filter these rows as well (do not import rows whose package foreign key is filtered)",
  "Import run precheck unified title": "Precheck result",
  "Import precheck section mapping issues": "Mapping issues (configuration missing or incorrect)",
  "Import precheck section source issues": "Source data issues (data in CSV)",
  "Import precheck cause mapping": "Mapping",
  "Import precheck cause source": "Source data",
  "Import precheck source value hint": "Source value (could not be resolved)",
  "Import run precheck unified global heading": "Additional messages",
  "Import run precheck unified col severity": " ",
  "Import run precheck unified col message": "Message",
  "Import run precheck unified sev blocking": "blocking",
  "Import run precheck unified sev action": "action required",
  "Import run precheck unified sev warning": "notice",
  "Import run precheck unified sev cleared": "resolved",
  "Import run precheck unified cat file": "File / storage",
  "Import run precheck unified cat timestamp": "Timestamp",
  "Import run precheck unified cat fk empty": "Optional foreign key",
  "Import run precheck unified cat fk filtered dep": "Foreign key on filtered dependency",
  "Import run precheck unified cat multiple primary": "Multiple primary contracts per package",
  "Import run precheck multiple primary in package help": "Each contract package may have only one contract with \"is_primary_in_package=true\". Please choose a strategy — it will be applied to all affected packages.",
  "Import run precheck multiple primary option prefer active": "Prefer active contract (one without end date wins; first as fallback)",
  "Import run precheck multiple primary option prefer first": "First wins (in CSV order)",
  "Import run precheck multiple primary option prefer last": "Last wins (in CSV order)",
  "Import run precheck multiple primary samples header": "Sample affected packages:",
  "Import run precheck unified cat fk strict": "Foreign key target",
  "Import run precheck unified cat fk validation miss": "FK validation miss",
  "Import run precheck unified cat contract no billing": "Contract / contribution calendar",
  "Import run precheck unified cat validation": "Validation",
  "Import run precheck unified source label": "Source table",
  "Import run precheck unified source column label": "Source",
  "Import run precheck unified hint label": "Hint",
  "Import run precheck unified examples label": "Examples",
  "Import run precheck unified rows label": "Data rows (CSV)",
  "Import run precheck unified affected records": "Affected records",
  "Import run precheck unified affected records with total": "of {0} records: {1} affected",
  "Import run precheck unified affected and unaffected with total": "of {0} records: {1} affected, not affected: {2}",
  "Import run precheck unified unaffected records": "not affected: {0}",
  "Import run precheck unified details available": "Details available",
  "Import run precheck unified details missing": "Details missing",
  "Import run precheck unified tabular col fields": "Columns",
  "Import run precheck unified tabular col excerpt": "Row excerpt",
  "Import run precheck unified tabular error title": "Error",
  "Import run precheck unified tabular empty cell": "(empty)",
  "Import run precheck unified tabular empty": "No rows",
  "Import run precheck unified tabular loading": "Loading CSV…",
  "Import run precheck unified tabular load failed": "Could not load CSV rows.",
  "Import run precheck unified positives not yet in sample": "Positive examples are outside the currently loaded sample.",
  "Import run precheck unified tabular partial loaded": "Loaded reduced sample ({0} rows); load more to include affected rows up to {1}.",
  "Import run precheck unified fk strict hint":
    "See the source sample below. Importing with an empty key only makes sense if target records exist.",
  "Import run precheck unified enum solution headline": "Enum mapping “{0}”: {1} invalid value(s)",
  "Import run precheck unified enum solution source target": "Field mapping: {0}",
  "Import run precheck unified enum solution map heading": "Map source values to target values",
  "Import run precheck unified enum solution map source col": "Source value",
  "Import run precheck unified enum solution map target col": "Target value",
  "Import run precheck unified enum solution map target placeholder": "Select or type target value",
  "Import run precheck unified enum solution map use entered": "Use \"{0}\"",
  "Import run precheck unified enum solution map apply": "Apply mappings",
  "Import run precheck unified enum solution map applied": "Mappings applied.",
  "Import run precheck unified enum solution option disable": "Or disable the field for import",
  "Import run precheck unified enum solution decision disable field": "Do not import field {0}",
  "Import run precheck unified enum solution rerun": "Run precheck again after saving changes.",
  "Import run precheck unified enum solution decision apply failed": "Enum mapping could not be saved.",
  "Import run precheck unified enum solution decision applied": "Enum mapping saved.",
  "Import run precheck unified fk diagnosis source empty": "Source key column is empty.",
  "Import run precheck unified fk diagnosis source unresolved": "Source key could not be resolved along the configured path.",
  "Import run precheck unified fk diagnosis target missing": "Matching target record was not found.",
  "Import run precheck unified fk diagnosis generic": "Foreign key could not be resolved.",
  "Import run precheck navigate to field": "Open field in mapping",
  "Import run precheck unified fk path break config error label": "Mapping / configuration issue",
  "Import run precheck unified fk target field label": "Target field",
  "Import run precheck unified source column inline label": "Source column",
  "Import run precheck unified fk path label": "Resolution path",
  "Import run precheck unified fk path break config error": "Path blocked at step {0}{1}",
  "Import run precheck unified fk path break with reason": "Path blocked at step {0}: {1}",
  "Import run precheck unified fk path break label": "Path blocked at step {0}",
  "Import run precheck unified fk target label": "Target",
  "Import run precheck unified rows table source": "Source table: {0}",
  "Import run precheck unified tabular rows beyond preview": "{0} affected row(s) are outside the loaded preview.",
  "Import run precheck unified fk dep exclusion schema filter": "Schema filter",
  "Import run precheck unified fk dep exclusion dedup": "Deduplication",
  "Import run precheck unified fk dep exclusion conditional rule": "Conditional rule (skip row)",
  "Import run precheck unified fk dep exclusion enum unmapped": "Enum mapping (no match)",
  "Import run precheck unified fk dep exclusion precheck decision": "Precheck decision (skip rows)",
  "Import run precheck unified fk dep total rows": "{0} total rows",
  "Import run precheck unified sample keys skipped rows": "{0} in skipped rows",
  "Import run precheck unified sample keys schema filter": "{0} by schema filter",
  "Import run precheck unified sample keys not in source": "{0} not in source file",
  "Import run precheck unified sample keys label": "Sample keys (column {0}): {1}",
  "Import run precheck cause fk keys missing in source": "The FK keys do not exist in source table \"{0}\". They cannot be resolved without correcting the data.",
  "Import run precheck cause manually skipped entries": "{0} manually skipped {1} entries",
  "Import run precheck cause schema filtered entries": "{0} {1} entries excluded by schema filter{2}",
  "Import run precheck cause unmapped enum entries": "{0} {1} entries excluded by missing enum mapping",
  "Import run precheck cause deduplicated entries": "{0} {1} entries excluded by deduplication",
  "Import run precheck cause conditional rule entries": "{0} {1} entries excluded by conditional rule",
  "Import run precheck cause final with target": "{0}. These {1} rows no longer have a resolvable target entry.",
  "Import run precheck cause final without target": "{0}. These rows no longer have a resolvable target entry.",
  "Import run precheck entity filter detail suffix": ": {0}",
  "Import run precheck entity filter dedup detail suffix": " (key: {0})",
  "Import run precheck entity filter enum detail suffix": " (fields: {0})",
  "Import run precheck entity filter schema": "{0} by row filter (entity level){1}",
  "Import run precheck entity filter conditional rule": "{0} by conditional rule{1}",
  "Import run precheck entity filter dedup": "{0} by deduplication{1}",
  "Import run precheck entity filter enum": "{0} due to missing enum mapping{1}",
  "Import run precheck entity filter message": "{0} {1} rows are excluded by configuration filters.{2}",
  "Import run precheck unified fk kind optional fk": "Optional FK",
  "Import run precheck unified fk kind strict fk": "Strict FK",
  "Import run precheck unified fk kind empty fk source": "Empty FK source",
  "Import run precheck unified fk kind validation fk": "Validation FK",
  "Import run precheck unified fk kind other": "Validation error",
  "Import run precheck unified fk kind contract calendar": "Contribution calendar",
  "Import run precheck unified fk strict overlap rows":
    "{0} of these rows are already excluded by another strict FK check for the same entity.",
  "Import run precheck warnings unified title": "Further notices (preview)",
  "Import run precheck warnings unified fk heading": "Foreign keys / mapping",
  "Import run precheck warnings unified other heading": "Other",
  "Import run precheck warnings technical diagnostics in debug": "Technical filter hints ({0}): full text is in the debug export below — on purpose, so the same messages are not duplicated in this box.",
  "Import run precheck sample data section title": "Source sample",
  "Import run precheck sample include ok rows": "Include rows without errors in sample",
  "Import run precheck sample data intro":
    "Rows from the selected CSV: issues highlighted; optionally up to five clean rows for comparison (aligned with items in the precheck result).",
  "Import run precheck sample only errors none in preview":
    "No affected error rows in the loaded preview – pick another table or load more rows.",
  "Import run precheck sample tag validation": "{0}× validation",
  "Import run precheck sample tag file missing": "{0}× file missing",
  "Import run precheck sample tag file ambiguous": "{0}× ambiguous file",
  "Import run precheck row status validation": "Validation",
  "Import run precheck row status strict fk unresolved": "FK target missing",
  "Import run precheck sample tag strict fk": "{0}× FK target missing",
  "Import run precheck row status file missing": "File missing",
  "Import run precheck row status file ambiguous": "Ambiguous file",
  "Import run precheck missing files block title": "File references (photos/documents)",
  "Import run precheck file kind photo": "Person photo",
  "Import run precheck file kind document": "Person document",
  "Import run precheck file kind ambiguous": "Ambiguous photo",
  "Import run precheck missing file effect photo": "No match: photo left empty; person row still imported.",
  "Import run precheck missing file effect document": "No match: document row skipped.",
  "Import run precheck missing file effect ambiguous": "Multiple files match – narrow the source reference.",
  "Import run precheck missing file single field": "Person photo",
  "Import run precheck ambiguous photo field": "Ambiguous photo",
  "Import run precheck missing file whole row": "Person document",
  "Import run precheck missing file list": "Missing references (samples, max. 50):",
  "Import run precheck missing file list exact": "These values were not found (exactly as after converter/stem – samples, max. 50):",
  "Import run precheck missing file list more": "… and {0} more",
  "Import run precheck missing file search path label": "Search under",
  "Import run precheck missing file stats line": "of {0} references: {1} with an exact match in import files, {2} without match{3}",
  "Import run precheck missing file stats ambiguous suffix": " · {0} ambiguous",
  "Import run precheck missing file counts label": "File references",
  "Import run precheck missing file counts with total": "checked: {0}, found: {1}, missing: {2}, ambiguous: {3}",
  "Import run precheck missing file counts missing only": "missing: {0}",
  "Import run precheck missing file badge ok": "ok: {0}",
  "Import run precheck missing file badge missing": "missing: {0}",
  "Import run precheck missing file badge ambiguous": "ambiguous: {0}",
  "Import run precheck entity pending file checkbox": "open",
  "Import run precheck missing file decision pending": "Still to confirm: {0} source table(s) – checkbox on each card.",
  "Import run precheck missing photo accept action": "leave missing photos empty on import",
  "Import run precheck missing document accept action": "accept missing documents during import (create no document)",
  "Import run precheck missing file decision required title": "File handling decision required",
  "Import run precheck missing file decision required details": "Please tick each open file checkbox in the precheck result.",
  "Import run precheck missing file decision required tables": "Source tables without decision:",
  "Import run precheck resolved file table title": "Resolved matches (samples, max. 20)",
  "Import run precheck resolved file col path": "Resolved path",
  "Import run precheck missing file list row fallback": "Row numbers only (reference values not provided)",
  "Import run precheck missing file col status": " ",
  "Import run precheck missing file rows affected": "{0} rows with no match (no sample detail).",
  "Import run precheck missing file col row": "Row",
  "Import run precheck missing file col cell": "Cell content",
  "Import run precheck missing file col path": "Lookup pattern (no match)",
  "Import run precheck col status": "Status",
  "Import run precheck status ok": "ok",
  "Import run precheck status error": "error",
  "Import run precheck status missing": "missing",
  "Import run precheck status ambiguous": "ambiguous",
  "Import run precheck table sample ok": "Sample rows ok: {0}",
  "Import run precheck table sample error": "Sample rows with errors: {0}",
  "Import run precheck row label": "Row",
  "Import run fill empty created at updated at": "accept these errors and fill affected fields with default values during import",
  "Import run commit": "Run commit",
  "Import run commit confirm": "Write data to tenant DB and copy files? Afterwards, rollback can be started via \"Rollback import\" if needed.",
  "Import run commit success": "Commit completed: {0}.",
  "Import run commit error": "Commit failed.",
  "Import run commit error detail intro": "The following errors occurred:",
  "Import run commit imported rows": "{0} records imported",
  "Import run commit failed details": "The following errors occurred:",
  "Import run already committed": "This run has already been committed.",
  "Import run commit files copied": "{0} file(s) copied",
  "Import run rollback": "Roll back import",
  "Import run rollback confirm": "All data created by this run will be deleted. Uploaded source files are kept so the run can be committed again without re-upload. Continue?",
  "Import run rollback success": "Import was rolled back.",
  "Import run rollback error": "Rollback failed.",
  "Import run precheck cluster siblings title": "{0} additional error(s) affect the same rows:",
  "Import run precheck cluster siblings hint": "The decision on this card applies to all listed errors at once.",
  "Import run admin actions title": "Actions after import",
  "Import run rollback tooltip": "Remove all data imported by this run. Uploaded source files are kept so the run can be imported again without re-upload.",
  "Import precheck sort label": "Sort order",
  "Import precheck sort default": "Default (as checked)",
  "Import precheck sort by severity": "By severity (blocking first)",
  "Import precheck sort by status": "By status (open first)",
  "Import precheck sort by source table": "By source table (A–Z)",
  "Import precheck hide info groups": "Hide info boxes ({0})",
  "Import precheck info groups hidden empty": "All info boxes are hidden.",
  "Import run cleanup storage": "Delete source files",
  "Import run cleanup storage tooltip": "Remove uploaded CSVs, images and documents from storage (e.g. after a successful commit to free up space).",
  "Import run cleanup storage confirm": "All uploaded source files of this run will be permanently removed from storage. A later re-commit or rollback will only be possible after re-uploading. Continue?",
  "Import run cleanup storage success": "Source files have been removed from storage.",
  "Import run cleanup storage error": "Source files could not be deleted.",
  "Back to Import runs": "Back to mapping imports",
  "Import run page heading bare": "Import run",
  "Import run page heading with schema": "Import run {0}",
  "Import run not found": "Import run not found.",
  "Import run load error": "Failed to load import run.",
  "Import schema confirm delete": "Really delete this import schema?",
  "Import schema add": "Add schema",
  "Import schema create": "Create schema",
  "Import schema create description": "Without file: The current system mapping is used as template (as on the target mapping schema page). With uploaded JSON file: The existing schema is imported. If it is from an older version, the schema can be updated to the current mapping later.",
  "Import schema create from template": "Create schema",
  "Import schema create from template description": "Without file, the current system mapping is used as template. With JSON file, the schema is imported (can be updated later if outdated).",
  "Import schema created from template": "Import schema created.",
  "Import schema upload json optional": "Schema JSON",
  "Import schema upload json hint": "Drop JSON file here or click. Without file, the current system mapping is used as template.",
  "Import schema update from template": "Update to current mapping",
  "Import schema update from template hint": "Applies the current m1member data model and keeps your source mappings (SourceTable, SourceColumn, converter). New tables/fields are added. Non-empty ShortDescription values you set per target/field are kept; empty ones are filled from the system.",
  "Import schema outdated save to update hint": "Save the schema first; then the “Update from template” button becomes available.",
  "Import schema updated from template": "Schema has been updated to the current mapping.",
  "Import schema updated from template locally": "Schema update has been applied. Save to write mapping and relations to the schema.",
  "Import schema update from template error": "Schema could not be updated to the current mapping.",
  "Import schema tenant resolution fallback warning": "{0} target assignments were not found in the current tenant and will fall back to import when saved.",
  "Import schema template merge preview title": "Review schema update",
  "Import schema template merge confirm": "Apply changes",
  "Import schema template merge preview summary": "{0} field configurations and {1} target configurations will be preserved.",
  "Import schema template merge lost config warning": "{0} existing configurations would be removed because their table or field no longer exists in the current data model. Review the details before applying.",
  "Import schema template merge no lost config": "No existing mappings or configurations were found that would be lost by this update.",
  "Import schema template merge no changes in group": "No changes in this group.",
  "Import schema template merge added targets": "New target tables ({0})",
  "Import schema template merge removed targets": "Removed target tables ({0})",
  "Import schema template merge added fields": "New fields ({0})",
  "Import schema template merge removed fields": "Removed fields ({0})",
  "Import schema template merge lost configured targets": "Configured target tables that would be removed ({0})",
  "Import schema template merge lost configured fields": "Configured fields that would be removed ({0})",
  "Import schema refresh column descriptions": "Refresh column descriptions",
  "Import schema refresh column descriptions hint": "Overwrites every ShortDescription from the current data model in your UI language—including manual edits. Source mappings (SourceTable, SourceColumn, converters) are unchanged. Without this button, your own short texts stay when loading the schema and when using “Update to current mapping” (empty descriptions are still filled automatically). If new tables or columns exist in the system, use “Update to current mapping” first.",
  "Import schema refreshed column descriptions": "Column descriptions have been updated.",
  "Import schema refresh column descriptions error": "Column descriptions could not be updated.",
  "Import schema template status outdated": "Schema is based on an older version of the data model. Update available.",
  "Import schema template status up to date": "Schema matches the current mapping.",
  "Import schema download mapping": "Download mapping",
  "Import schema duplicated": "Import schema duplicated.",
  "Import schema duplicate error": "Failed to duplicate import schema.",
  "Import schema deleted": "Import schema deleted.",
  "Import schema delete error": "Failed to delete import schema.",
  "Import schema in use cannot delete": "The schema is still in use by at least one import run and cannot be deleted.",
  "Import schema json required": "SchemaJson is required.",
  "Import schema load error": "Failed to load import schema.",
  "Import schema changed since load": "The import schema has changed since it was loaded. Please reload it and review the change again.",
  "Import schemas": "Mapping templates",
  "Import schemas column name": "Name",
  "Import schemas column source tag": "Source system",
  "Import schemas column source tag hint": "Free text for labelling only (e.g. CenterCom 2.4). Not used during import.",
  "Import schemas column tenant": "Tenant",
  "Import schemas column tenant hint": "Optional. For list filter and assignment only. The run’s tenant is used for the actual import.",
  "Import schemas column updated": "Updated",
  "Import schemas name required": "Name is required.",
  "Import schema mapping": "Mapping",
  "Import schema edit drawer title": "Edit schema",
  "Import schema duplicate drawer title": "Create copy",
  "Import schema duplicate copy suffix": "Copy",
  "Import schema mapping edit": "Edit mapping",
  "Import schema source relations title": "Source relations",
  "Import schema source relations hint": "Load a relations JSON so foreign-key mappings/lookups can be suggested more accurately.",
  "Import schema source relations status": "Relations loaded: {0} entities, {1} edges",
  "Import schema source relations missing": "No source relations stored in this schema.",
  "Import schema source relations import button": "Load relations JSON",
  "Import schema source relations download button": "Download relations JSON",
  "Import schema source relations remove button": "Remove relations",
  "Import schema source relations imported": "Relations loaded ({0} entities, {1} edges).",
  "Import schema source relations removed": "Source relations removed.",
  "Import schema source relations import error": "Could not load relations JSON.",
  "Import schema mapping import button": "Load mapping JSON",
  "Import schema mapping remove button": "Remove mapping",
  "Import schema mapping imported": "Mapping JSON loaded.",
  "Import schema mapping loaded status": "Mapping JSON loaded.",
  "Import schema mapping removed": "Mapping removed.",
  "Import schema mapping import error": "Could not load mapping JSON.",
  "Import schema mapping run hint": "Select a run to load source tables and columns.",
  "Import schema mapping source table": "Source table",
  "Import schema mapping source table default": "Default source table",
  "Import schema mapping source table manual": "Manual",
  "Import schema mapping source table mode direct": "Direct",
  "Import schema mapping source table mode lookup": "Lookup",
  "Import schema mapping relation hint": "Reference: {0}.id via {1}.{2}",
  "Import schema mapping relation marker short": "Reference",
  "Import schema mapping relation source marker": "Reference key",
  "Import schema mapping relation locked": "automatic via reference",
  "Import schema mapping relation selector placeholder": "Select relation",
  "Import schema mapping relation selector applied": "Relation applied.",
  "Import schema mapping lookup assistant": "Lookup assistant",
  "Import schema mapping lookup assistant path": "Path",
  "Import schema mapping lookup assistant coverage": "Coverage",
  "Import schema mapping lookup assistant apply": "Apply",
  "Import schema mapping lookup assistant continue": "Use as next base",
  "Import schema mapping lookup assistant resolve paths": "Resolve paths",
  "Import schema mapping lookup assistant empty": "No matching lookup suggestions found.",
  "Import schema mapping lookup assistant load error": "Lookup suggestions could not be loaded.",
  "Import schema mapping lookup assistant applied": "Lookup suggestion applied.",
  "Import schema mapping lookup assistant missing base table": "Please select a source table for the target table first.",
  "Import schema mapping lookup assistant current base": "Current base: {0} · key: {1}",
  "Import schema mapping lookup assistant current path": "Current field selection (manual): {0}.{1} -> {2}.{3}",
  "Import schema mapping lookup assistant current relation path": "Current field path: {0}",
  "Import schema mapping lookup assistant relation type current": "Relationship type: manual current selection",
  "Import schema mapping lookup assistant relation type schema": "Relationship type: schema relation",
  "Import schema mapping lookup assistant relation type indexed": "Relationship type: indexed relation",
  "Import schema mapping lookup assistant target resolution": "Target resolution: {0} -> {1}.{2}",
  "Import schema mapping lookup assistant target resolution full path": "Target resolution: {0}",
  "Import schema mapping lookup assistant target source": "Target source: {0}.{1}",
  "Import schema mapping lookup assistant target resolution unknown": "Target resolution: not resolved",
  "Import schema mapping lookup assistant id path": "ID path",
  "Import schema mapping lookup assistant no schema path hint": "No path in relations JSON: no schema relation from the current source to the FK target source was found.",
  "Import schema mapping lookup assistant mode target": "leads to target entity",
  "Import schema mapping lookup assistant mode step": "intermediate step (multi-hop chain)",
  "Import schema mapping lookup assistant known only": "Known relations only",
  "Import schema mapping lookup assistant known only no relation": "No known relation exists for this field in the relations JSON.",
  "Import schema mapping lookup assistant manual title": "Manual path (table + column)",
  "Import schema mapping lookup assistant relation path title": "Path used for relation",
  "Import schema mapping lookup assistant take path": "Take path to top",
  "Import schema mapping lookup assistant manual table": "Table",
  "Import schema mapping lookup assistant manual column": "Column",
  "Import schema mapping lookup assistant manual missing": "Please select table and column first.",
  "Import schema mapping lookup assistant multi select hint": "Multiple columns in each path step form composite bridges; multiple columns at endpoint form composite match.",
  "Import schema mapping lookup assistant id field hint": "One column → primary key source. Multiple columns → composite identity per source row.",
  "Import schema mapping lookup assistant mixed source warning": "Composite columns must originate from the same source table/path",
  "Import schema mapping lookup assistant id field multi select warning": "Primary-key fields must use exactly one source column — composite is only allowed on FK fields.",
  "Import schema mapping source cell composite reset tooltip": "Reset composite lookup",
  "Import schema mapping source cell bridge reset tooltip": "Reset bridge path",
  "Import schema mapping lookup assistant path add row": "Add path row",
  "Import schema mapping lookup assistant path remove row": "Remove path row",
  "Import schema mapping lookup assistant path details": "Path details",
  "Import schema mapping lookup assistant result column": "Result column",
  "Import schema mapping lookup assistant result column final": "Target ID",
  "Import schema mapping lookup assistant result column intermediate": "Carry column",
  "Import schema mapping lookup assistant output column": "Output",
  "Import schema mapping lookup assistant result column placeholder": "optional: value for next step",
  "Import schema mapping lookup assistant path filter": "Filter",
  "Import schema mapping lookup assistant path filter count": "{0} filters",
  "Import schema mapping lookup assistant path filter empty": "No filters",
  "Import schema mapping lookup assistant path filter add": "Add step filter",
  "Import schema mapping lookup assistant path filter remove": "Remove step filter",
  "Import schema mapping lookup assistant path filter column": "Filter column",
  "Import schema mapping lookup assistant path filter value": "Value",
  "Import schema mapping lookup assistant filter include": "Include terms",
  "Import schema mapping lookup assistant filter exclude": "Exclude terms",
  "Import schema mapping lookup assistant filter suggestions": "Filter suggestions by table or column …",
  "Import schema mapping lookup assistant filter no match": "No suggestion matches the search. Try a different term.",
  "Import schema mapping lookup assistant check path": "Check path",
  "Import schema mapping lookup assistant check path missing": "Please select at least two complete path rows first.",
  "Import schema mapping lookup assistant check path running": "Path is being checked …",
  "Import schema mapping lookup assistant check path success": "Path can be resolved.",
  "Import schema mapping lookup assistant check path failed segment": "Path cannot be resolved: {0}.",
  "Import schema mapping lookup assistant max tables": "Maximum tables",
  "Import schema mapping lookup assistant debug": "Debug log",
  "Import schema mapping lookup assistant debug clear": "Clear",
  "Import schema mapping lookup assistant debug empty": "No debug entries yet.",
  "Import schema mapping mode": "Mode",
  "Import schema mapping disabled hint": "Import for this table is disabled. Field mapping and enum mapping are hidden.",
  "Import schema mapping mode import": "Import",
  "Import schema mapping mode reference": "Reference mapping only",
  "Import schema mapping mode hybrid": "Hybrid (reference + import)",
  "Import schema mapping reference source label column": "Display column",
  "Import schema mapping reference source label column placeholder": "Source label",
  "Import schema mapping reference source label": "Source label",
  "Import schema mapping enum source label column": "Display column",
  "Import schema mapping enum source label column placeholder": "Source label",
  "Import schema mapping enum source label": "Source label",
  "Import schema label path editor button": "Path …",
  "Import schema label path editor title": "Display column via path",
  "Import schema label path editor hint": "When the label lives in a linked table: choose the target table and the column containing the source ID. The display column is the human-readable column in that target table.",
  "Import schema label path editor hop table": "Linked table",
  "Import schema label path editor hop column": "Match column (contains the source ID)",
  "Import schema label path editor label column": "Display column in linked table",
  "Import schema label path editor base relations": "Existing base relation",
  "Import schema label path editor base relations placeholder": "Choose from saved relations …",
  "Import schema label path editor save as base relation": "Save this relation as a base (reusable in other mappings)",
  "Import schema mapping source column": "Source column",
  "Import schema mapping source column invalid for selected table": "Column not in selected source table",
  "Import schema mapping source columns loading": "Loading columns …",
  "Import schema mapping source column or value": "Source column/value",
  "Import schema mapping source csv file override": "Source CSV file override",
  "Import schema mapping source csv file override hint": "Optional: CSV file name in this import run to use for this source table instead of the default mapping.",
  "Import schema mapping reference source column": "Reference source column",
  "Import schema mapping reference target id column": "Target column (ID)",
  "Import schema mapping reference assignments title": "Assignment",
  "Import schema mapping reference hint": "Map source IDs to existing target IDs. The referenced table is not imported; it is only used for foreign key resolution.",
  "Import schema mapping reference step source": "1. Select source",
  "Import schema mapping reference step mapping": "2. Map source ID to target ID",
  "Import schema mapping reference source value": "Source ID",
  "Import schema mapping reference target value": "Target ID",
  "Import schema mapping reference target label": "Target label",
  "Import schema mapping reference target null": "(NULL)",
  "Import schema mapping reference add row": "Add mapping",
  "Import schema mapping reference options empty": "No target values available for this target entity.",
  "Import schema mapping reference values empty": "No reference source values found. Please select a reference source column or load preview.",
  "Import schema mapping enum values title": "Enum and value mapping",
  "Import schema mapping enum values hint": "Field \"{0}\" uses enum \"{1}\". This mapping is reused globally for all fields using the same enum.",
  "Import schema mapping enum values field select": "Enum/value field",
  "Import schema mapping enum values unavailable": "No enum or value mapping is active.",
  "Import schema mapping enum values unavailable hint": "Choose \"Enum mapping\" or \"Value mapping\" in the converter column for a field, then it appears here.",
  "Import schema mapping enum values empty": "No source values found. Please select source column or load preview.",
  "Import schema mapping enum source value": "Source value",
  "Import schema mapping enum source value title": "Source value: {0}",
  "Import schema mapping enum source value empty": "(empty)",
  "Import schema mapping enum source distinct loading": "Loading source values…",
  "Import schema mapping enum source count": "Count in source",
  "Import schema mapping enum target value": "Target value",
  "Import schema mapping mapping group id": "Mapping group",
  "Import schema mapping mapping group id placeholder": "e.g. billing_cycle",
  "Import schema mapping enum group key mismatch": "Fields in the same mapping group use different enum mapping keys — align them.",
  "Import schema mapping enum group source column mismatch": "Fields in the same mapping group should use the same source column.",
  "Import schema mapping enum ignore source case": "Ignore case for source values",
  "Import schema mapping enum composite column enum suffix": "enum",
  "Import schema mapping enum composite column value suffix": "value",
  "Import schema mapping manual enum select placeholder": "Select target value",
  "Import schema mapping enum target null": "(NULL)",
  "Import schema mapping enum clear": "reset",
  "Import schema mapping enabled": "Enable",
  "Import schema mapping enum conditional rules column": "conditional rules",
  "Import schema mapping enum conditional rules tooltip": "Source-data correction: value differs from default mapping in special cases. First matching rule wins.",
  "Import schema mapping enum conditional rules configured": "conditional rules (configured)",
  "Import schema mapping enum conditional rules drawer title": "Conditional rules for \"{0}\"",
  "Import schema mapping enum conditional rules target heading": "Target values (applied when conditions match)",
  "Import schema mapping enum conditional rules target value label": "Target value",
  "Import schema mapping enum conditional rules target value placeholder": "override target value",
  "Import schema mapping enum conditional rules property target placeholder": "override value for this column",
  "Import schema mapping enum managed below": "managed by enum mapping",
  "Import schema mapping enum option not specified": "not specified",
  "Import schema mapping enum option male": "male",
  "Import schema mapping enum option female": "female",
  "Import schema mapping enum option diverse": "diverse",
  "Import schema mapping enum option mr": "Mr",
  "Import schema mapping enum option mrs": "Mrs",
  "Import schema mapping enum label PersonKind": "Person kind",
  "Import schema mapping conditional rules": "conditional mapping rules",
  "Import schema mapping conditional rules action include row": "Include row",
  "Import schema mapping conditional rules action set value": "Set value",
  "Import schema mapping conditional rules action skip row": "Skip row",
  "Import schema mapping conditional rules action negate": "Negate value (invert sign)",
  "Import schema mapping conditional rules add": "Add rule",
  "Import schema mapping conditional rules base table": "Base table: {0}",
  "Import schema mapping conditional rules case sensitive": "Case sensitive",
  "Import schema mapping conditional rules clear": "Clear rules",
  "Import schema mapping conditional rules column": "Source column",
  "Import schema mapping conditional rules condition add": "Add condition",
  "Import schema mapping conditional rules condition remove": "Remove condition",
  "Import schema mapping conditional rules conditions title": "Conditions",
  "Import schema mapping conditional rules configured": "conditional rules (configured)",
  "Import schema mapping conditional rules context missing": "Mapping context is not available.",
  "Import schema mapping conditional rules drawer title": "Conditional rules: {0}",
  "Import schema mapping conditional rules empty": "No rules defined yet.",
  "Import schema mapping conditional rules join and": "and",
  "Import schema mapping conditional rules join or": "or",
  "Import schema mapping conditional rules manual only": "Conditional rules are only available for manual values or foreign-key fields.",
  "Import schema mapping conditional rules missing base table": "Select a source table for this target first.",
  "Import schema mapping conditional rules operator contains": "contains",
  "Import schema mapping conditional rules operator ends with": "ends with",
  "Import schema mapping conditional rules operator equals": "equals",
  "Import schema mapping conditional rules operator not contains": "does not contain",
  "Import schema mapping conditional rules operator not ends with": "does not end with",
  "Import schema mapping conditional rules operator not equals": "not equals",
  "Import schema mapping conditional rules operator not starts with": "does not start with",
  "Import schema mapping conditional rules operator not wildcard": "does not match wildcard",
  "Import schema mapping conditional rules operator starts with": "starts with",
  "Import schema mapping conditional rules operator wildcard": "matches wildcard",
  "Import schema mapping conditional rules preview action": "Action",
  "Import schema mapping conditional rules preview count": "{0} matches (of {1} preview rows)",
  "Import schema mapping conditional rules preview count total": "total",
  "Import schema mapping conditional rules preview empty": "No rows to preview.",
  "Import schema mapping conditional rules preview no match hint": "No matches in the loaded sample. The rule will still be applied to all rows during import.",
  "Import schema mapping conditional rules preview load error": "Could not load preview data.",
  "Import schema mapping conditional rules preview target value": "Result value",
  "Import schema mapping conditional rules preview title": "Matched rows preview",
  "Import schema mapping conditional rules preview value column": "Highlight column",
  "Import schema mapping conditional rules remove": "Remove rule",
  "Import schema mapping conditional rules rule title": "Rule {0}",
  "Import schema mapping conditional rules target value": "Target value",
  "Import schema mapping conditional rules value": "Compare value",
  "Import schema mapping conditional target enum key placeholder": "Enum mapping key",
  "Import schema mapping conditional target enum mapping empty hint": "No enum value mappings are defined in this schema. Add enum mappings to enable this option.",
  "Import schema mapping conditional target enum source placeholder": "Source value (from mapping)",
  "Import schema mapping conditional target mode enum mapping": "Enum mapping",
  "Import schema mapping conditional target mode literal": "Literal value",
  "Import schema mapping converter": "Converter",
  "Import schema mapping converter enum": "Enum mapping",
  "Import schema mapping converter value map": "Value mapping",
  "Import schema mapping converter related row exists": "related row exists",
  "Import schema mapping converter related row missing": "related row does not exist",
  "Import schema mapping converter manual": "Manual",
  "Import schema mapping converter key disabled": "Key field - no converter",
  "Import schema mapping tenant fixed": "fixed to tenant",
  "Import schema mapping boolean true": "True",
  "Import schema mapping boolean false": "False",
  "Import schema mapping fixed value": "Fixed value",
  "Import schema mapping skip": "Enable",
  "Import schema mapping include table": "Include",
  "Import schema mapping remove assignment button": "Remove table mapping",
  "Import schema mapping remove assignment confirm title": "Remove table mapping?",
  "Import schema mapping remove assignment confirm desc": "The mapping for \"{0}\" will be removed. The base schema stays unchanged.",
  "Import schema mapping remove assignment success": "Table mapping removed.",
  "Import schema mapping target entity": "Target entity",
  "Import schema mapping show field comments": "Notes",
  "Import schema mapping mapping short description": "ShortDescription",
  "Import schema mapping mapping notes": "Notes",
  "Import schema mapping mapping short description placeholder": "Short note on source meaning …",
  "Import schema mapping mapping notes placeholder": "Further source notes …",
  "Import schema mapping field": "Target field",
  "Import schema mapping key field": "Key field",
  "Import schema mapping required field hint": "Required field (NOT NULL) — must be mapped",
  "Import schema mapping required field mapped hint": "Required field mapped",
  "Import schema mapping virtual field tag": "virtual",
  "Import schema mapping save success": "Mapping saved.",
  "Import schema mapping no run": "— no run —",
  "Import schema mapping assigned steps": "Assigned steps",
  "Import schema mapping add more steps": "Additional steps",
  "Import schema mapping add assignment": "Add mapping",
  "Import schema mapping unassigned hint": "{0} target table(s) without mapping. Use \"Add mapping\" to assign source table and columns.",
  "Import schema edit json hint": "Target mapping (targets, fields, converters). Actual mapping to source tables/columns is done during import.",
  "Import schema json invalid": "The schema JSON is invalid.",
  "Import schema json collapse label": "Schema (JSON)",
  "Import schema mapping no targets": "No target entities with fields in schema.",
  "Import schema mapping add step button": "Add",
  "Import schema mapping add section title": "Add another table",
  "Import schema mapping add section empty": "All target tables are already mapped.",
  "Import schema mapping step new table": "Map new table",
  "Import schema mapping step new table hint":
    "Pick the next target entity and source CSV. After adding, configure field mappings. Use Next to return to this step while more target tables can still be mapped.",
  "Import schema mapping table progress": "Table {0} of {1}",
  "Import schema mapping source variant label": "Source mapping {0} of {1}",
  "Import schema mapping source variant requires primary source":
    "Enable the first source mapping for this target before using additional sources.",
  "Import schema mapping source variant duplicate table warning":
    "Two active mappings use the same source table; change the source or disable one mapping.",
  "Import schema mapping source variant missing key source warning":
    "Several sources are mapped to this entity and other tables reference it: map the ID from a source column so references stay unambiguous.",
  "Import schema mapping table title": "Field mapping",
  "Import schema mapping table previous": "Previous table",
  "Import schema mapping table next": "Next table",
  "Import schema mapping add step modal title": "Add step from template",
  "Import schema mapping add step select entity": "Target entity",
  "Import schema mapping add step no options": "No additional entities in template.",
  "Admin sign in": "Admin sign in",
  "Administrator": "Administrator",
  "Advance (days)": "Advance (days)",
  "Advance Booking Period (Days)": "Advance Booking Period (Days)",
  "Advanced filters": "Advanced filters",
  "Advanced filters active": "Advanced filters active",
  "Advanced filters…": "Advanced filters…",
  "Advanced search": "Advanced search",
  "Advanced search active": "Advanced search active",
  "Advanced search…": "Advanced search…",
  "Person detail no access embedded": "No access to this person.",
  "Person detail no access redirect to list": "No access to this person. You were redirected to the persons list.",
  "Person detail not found embedded": "This person was not found.",
  "Person detail not found redirect to list": "This person was not found. You were redirected to the persons list.",
  "all": "all",
  "All changes deleted.": "All changes deleted.",
  "All categories": "All categories",
  "All custom holidays and exclusions in this scope will be removed. Continue?": "All custom holidays and exclusions in this scope will be removed. Continue?",
  "Holiday calendar assignment and all custom holidays in this scope will be removed. The scope can be added again later. Continue?": "Holiday calendar assignment and all custom holidays in this scope will be removed. Continue?",
  "All scopes already have a holiday configuration.": "Each scope (tenant default and each studio) may only be assigned once.",
  "All Direct Debits": "All Direct Debits",
  "All errors have been fixed. You can now download the SEPA file.": "All errors have been fixed. You can now download the SEPA file.",
  "All groups": "All groups",
  "All leads": "All leads",
  "All permitted studios": "All permitted studios",
  "All resources": "All resources",
  "All resources available in this booking. Empty = derive from selected appointment types. Multiple selection possible (e.g. same appointment type bookable twice).": "All resources available in this booking. Empty = derive from selected appointment types. Multiple selection possible (e.g. same appointment type bookable twice).",
  "all studios": "all studios",
  "all studios__alt1": "all studios",
  "All statuses": "All statuses",
  "All types": "All types",
  "All__alt2": "All",
  "Allow Access": "Allow Access",
  "Allow Free Bookings": "Allow Free Bookings",
  "Allow Paid Bookings": "Allow Paid Bookings",
  "Allow trial period cancellation": "Allow trial period cancellation",
  "Allow withdrawal": "Allow withdrawal",
  "Allowed": "Allowed",
  "allowed": "allowed",
  "Allowed Actions": "Allowed Actions",
  "Allowed studios": "Allowed studios",
  "Allow overlapping appointment bookings": "Allow overlapping appointment bookings",
  "Allows booking appointments despite overlaps or insufficient resource capacity.": "Allows booking appointments despite overlaps or insufficient resource capacity.",
  "Allows changing start and end time/duration when creating or editing appointments.": "Allows changing the appointment duration when creating or editing appointments.",
  "Allows changing the appointment duration instead of using the duration from the appointment type.": "Allows changing the appointment duration instead of using the duration from the appointment type.",
  "Allows changing the appointment price instead of using the appointment type price.": "Allows changing the appointment price instead of using the appointment type price.",
  "Allows creating appointments outside stored resource or staff availability.": "Allows creating appointments outside stored resource or staff availability.",
  "Already paid": "Already paid",
  "Already posted": "Already posted",
  "Amount": "Amount",
  "Rows": "Rows",
  "Amount is required": "Amount is required",
  "Amount must be > 0": "Amount must be > 0",
  "Amount must be greater than 0": "Amount must be greater than 0",
  "Amount must not exceed balance.": "Amount must not exceed balance.",
  "Amount must not exceed payment amount": "Amount must not exceed payment amount",
  "Amount must not exceed selected payment total": "Amount must not exceed selected payment total",
  "Anytime": "Anytime",
  "API key": "API key",
  "API key is required": "API key is required",
  "App": "App",
  "Appearance": "Appearance",
  "Append free time to end": "Append free time to end",
  "Append to end": "Append to end",
  "Applies to": "Applies to",
  "Applies to ping/open/status requests from m1member to the gateway.": "Applies to ping/open/status requests from m1member to the gateway.",
  "Apply all": "Apply all",
  "Changes applied.": "Changes applied.",
  "Change applied.": "Change applied.",
  "Apply check-in settings": "Apply check-in settings",
  "Apply to next due items": "Apply to next due items",
  "Apply to studios__alt1": "Apply to studios",
  "Apply to studios__alt2": "Apply to studios",
  "Apply__alt2": "Apply",
  "Appointment": "Appointment",
  "Appointment cannot be moved to this resource.": "The appointment cannot be moved to this resource.",
  "Appointment deleted": "Appointment deleted",
  "Appointment Details": "Appointment Details",
  "Appointment move from": "Previous",
  "Appointment move to": "New",
  "Appointment moved.": "Appointment moved.",
  "Appointment notifications": "Appointment notifications",
  "Appointment notification scope": "Scope",
  "Appointment notification scope tooltip": "Studios where this template can be selected for appointments. Empty = available everywhere.",
  "Appointment notification template intro": "This template can be assigned to appointments. Empty = available for all studios; otherwise only for selected studios.",
  "Appointment outcomes": "Appointment outcomes",
  "Appointment Type": "Appointment Type",
  "Appointment type": "Appointment type",
  "Appointment participant status attended": "attended",
  "Appointment participant status cancelled by customer": "cancelled by customer",
  "Appointment participant status cancelled by studio": "cancelled by studio",
  "Appointment participant status no-show": "no-show",
  "Appointment participant status planned": "planned",
  "Appointment completion result": "Completion result",
  "Appointment completion result none": "no result",
  "Appointment completion result open": "open",
  "Appointment completion result successful": "successful",
  "Appointment completion result unsuccessful": "unsuccessful",
  "Appointment status completed": "conducted",
  "Appointment status no-show": "no-show",
  "Appointment status scheduled": "scheduled",
  "Appointment type created": "Appointment type created",
  "Appointment type deleted": "Appointment type deleted",
  "Appointment type is required": "Appointment type is required",
  "Appointment type updated": "Appointment type updated",
  "Appointment types": "Appointment types",
  "appointment(s)": "appointment(s)",
  "Appointments": "Appointments",
  "Arrears": "Arrears",
  "Asset": "Asset",
  "Assign access medium": "Assign access medium",
  "Assigned automatically": "Assigned automatically",
  "Assigned Persons": "Assigned Persons",
  "Assigned__alt2": "Assigned",
  "Assign": "Assign",
  "Assigned": "Assigned",
  "Assignments": "Assignments",
  "Assignment saved": "Assignment saved",
  "Assignment reader": "Assignment reader",
  "Assignment": "Assignment",
  "Assignments saved.": "Assignments saved.",
  "Reader device assignments conflict": "This assignment already exists. Reload the assignments and try again.",
  "Reader device assignments save failed": "Reader device assignments could not be saved. Reload the page and try again.",
  "Reader device assignments save server error": "Reader device assignments could not be saved. If this happened after an update, the database migrations probably still need to run.",
  "Assignments__alt2": "Assignments",
  "Assignments__zuordnung": "Assignment",
  "At least 8 characters": "At least 8 characters",
  "At least one active tariff block is required.": "At least one active tariff block is required.",
  "At least one digit": "At least one digit",
  "At least one lowercase letter": "At least one lowercase letter",
  "At least one schedule is required": "At least one schedule is required",
  "At least one schedule is required.": "At least one schedule is required.",
  "At least one special character (!@#$%^&*...)": "At least one special character (!@#$%^&*...)",
  "At least one uppercase letter": "At least one uppercase letter",
  "Auto changelog saved": "Auto changelog saved",
  "Auto-communication": "Auto-communication",
  "Auto-Refresh": "Auto-Refresh",
  "Automatic changelog entries…": "Automatic changelog entries…",
  "Automatic changes (Cursor)": "Automatic changes (Cursor)",
  "Automatic emails & notifications": "Automatic emails & notifications",
  "Automatic SEPA direct debits": "Automatic SEPA direct debits",
  "Automatic Updates": "Automatic Updates",
  "Automatically determined from IBAN": "Automatically determined from IBAN",
  "Bank placeholder example": "e.g. Sample bank",
  "Automation": "Automation",
  "Automation rules for leads": "Automation rules for leads",
  "Availabilities": "Availabilities",
  "Availability": "Availability",
  "Available": "Available",
  "Available folders:": "Available folders:",
  "Available Placeholders": "Available Placeholders",
  "Available variables": "Available variables",
  "Average Duration": "Average Duration",
  "Average Frequency": "Average Frequency",
  "Average per Month": "Average per Month",
  "Average Utilization": "Average Utilization",
  "Avg Attendance": "Avg Attendance",
  "Avg. check-ins per active member": "Avg. check-ins per active member",
  "Avg. Check-ins/Member": "Avg. Check-ins/Member",
  "Avg. per Day": "Avg. per Day",
  "Avg. per Month": "Avg. per Month",
  "Avg. per week": "Avg. per week",
  "Back": "Back",
  "Back to Access & Devices": "Back to Access & Devices",
  "Back to Automation": "Back to Automation",
  "Back to Calendar": "Back to Calendar",
  "Back to Calendar & Appointments": "Back to Calendar & Appointments",
  "Back to Communication": "Back to Communication",
  "Back to Contracts": "Back to Contracts",
  "Back to default search": "Back to default search",
  "Back to dashboard": "Back to dashboard",
  "Back to inbox": "Back to inbox",
  "Back to direct debits": "Back to direct debits",
  "Back to direct debit run": "Back to direct debit run",
  "Back to finance": "Back to finance",
  "Back to Finances": "Back to Finances",
  "Back to Leads": "Back to Leads",
  "Back to contract signing settings": "Back to contract signing",
  "Back to login": "Back to login",
  "Back to Member management": "Back to Member management",
  "Back to Members": "Back to Members",
  "Back to Organisation & Users": "Back to Organisation & Users",
  "Back to Payments & Billing": "Back to Payments & Billing",
  "Back to Products & Contracts": "Back to Products & Contracts",
  "Back to reports": "Back to reports",
  "Back to report: {0}": "back to {0}",
  "Back to sales": "Back to sales",
  "Back to sending": "Back to sending",
  "Back to Admin": "Back to Admin",
  "Back to Admin Settings": "Back to Admin Settings",
  "Back to settings": "Back to settings",
  "Back to tools": "Back to tools",
  "Back to System": "Back to System",
  "Back to Usage": "Back to Usage",
  "Back to Prospects": "Back to Prospects",
  "Back to Former": "Back to Former",
  "Back to People": "Back to People",
  "Back to Open items": "Back to Open items",
  "Back to Check-in": "Back to Check-in",
  "Back to Reminders": "Back to Reminders",
  "Back to duplicate finder": "Back to duplicate finder",
  "Back to tasks": "Back to tasks",
  "Back to birthday list": "Back to birthday list",
  "Back to custom lists": "Back to custom lists",
  "Back to lead": "Back to lead",
  "Back to list": "Back to list",
  "Background Color": "Background Color",
  "Background color": "Background color",
  "Background Services": "Background Services",
  "Scheduler tick interval (seconds)": "Scheduler tick interval (seconds)",
  "Scheduler tick interval (seconds) description": "How often the scheduler checks for due jobs (10–3600).",
  "Scheduler interval saved": "Scheduler interval saved",
  "Interval (minutes)": "Interval (minutes)",
  "Scheduled service holiday auto import": "Automatic holiday import",
  "Scheduled service holiday auto import description": "Imports global holidays (DE, AT, CH) according to interval",
  "Scheduled service bank data auto update": "Automatic bank data update",
  "Scheduled service bank data auto update description": "Updates bank data (Bundesbank) according to interval and configuration",
  "Scheduled service gateway ping": "Gateway ping",
  "Scheduled service gateway ping description": "Periodically sends a ping to m1gateway (admin tenant).",
  "Scheduled service member inbox polling": "Retrieve member inbox",
  "Scheduled service payment providers": "Payment providers",
  "Scheduled service payment providers description": "checks available payment methods regularly through the job queue",
  "Scheduled service payment providers queued": "Payment provider check queued",
  "Scheduled service member inbox polling description": "Retrieves new emails from the enabled accounts for the member inbox",
  "Scheduled service email queue": "Email queue",
  "Scheduled service email queue description": "Sends emails from the queue",
  "Scheduled service check-in auto checkout": "Automatic check-out",
  "Scheduled service check-in auto checkout description": "Automatically checks out stale check-ins",
  "Scheduled service communication rules": "Automatic communication",
  "Scheduled service communication rules description": "Processes communication rules and sends messages",
  "Scheduled service member promotions": "Member promotions",
  "Scheduled service member promotions description": "Checks and processes scheduled member promotions",
  "Scheduled service contract status check": "Contract check",
  "Scheduled service contract status check description": "Checks contracts and sets status to 'ended' when the end date has passed",
  "Scheduled service contribution calendar": "Contribution calendar",
  "Scheduled service contribution calendar description": "Calculates and updates the contribution calendar",
  "Scheduled service birthday tasks": "Birthday tasks",
  "Scheduled service birthday tasks description": "Creates due birthday tasks from person default rules",
  "Admin services scheduler configuration updated": "Scheduler configuration updated",
  "Admin service configuration updated": "Configuration updated",
  "Scheduled service holiday auto import completed": "Holiday import completed",
  "Scheduled service member inbox polling completed": "Member inbox retrieved",
  "Scheduled service member inbox polling completed with errors": "Member inbox retrieved with errors",
  "Scheduled service email queue completed": "Email queue processed",
  "Scheduled service check-in auto checkout completed": "Automatic check-out completed",
  "Scheduled service communication rules completed": "Communication rules processed",
  "Scheduled service contract status check completed": "Contract status checked",
  "Scheduled service contribution calendar completed": "Contribution calendar updated",
  "EmailQueueService": "Email queue",
  "CheckInAutoCheckoutService": "Automatic check-out",
  "CommunicationRuleService": "Automatic communication",
  "ContributionCalendarService": "Contribution calendar",
  "GlobalHolidayImport": "Holiday import",
  "BankDataAutoUpdate": "Automatic bank data update",
  "GatewayPingService": "Gateway ping",
  "Service executed successfully": "Service executed successfully",
  "Running": "running",
  "Stopped": "stopped",
  "Balance credited.": "Balance credited.",
  "Balance debited.": "Balance debited.",
  "Credit (currency)": "deposit",
  "Debit (currency)": "withdraw",
  "Post entry": "post",
  "credited (past)": "credited",
  "debited (past)": "debited",
  "deposited (past)": "deposited",
  "withdrawn (past)": "withdrawn",
  "Balance deposited.": "Amount deposited.",
  "Balance withdrawn.": "Amount withdrawn.",
  "wallet.reason.manualAdjustment": "Manual adjustment",
  "wallet.reason.stornoCredit": "Reversal credit",
  "wallet.reason.offsetAgainstReceivable": "Credit offset",
  "wallet.reason.paymentTopUp": "Top-up",
  "wallet.reason.usage": "Usage",
  "wallet.reason.import": "Data import",
  "wallet.reason.promotionBonus": "Promotion bonus",
  "wallet.reason.restPeriodCredit": "Rest period",
  "wallet.reason.priceCorrectionCredit": "Price correction",
  "Balance is required": "Balance is required",
  "Balance retrieved successfully": "Balance retrieved successfully",
  "Balance:": "Balance:",
  "Balance (history)": "balance",
  "Balance": "Balance",
  "Balance__alt1": "Balance",
  "Balance__alt2": "Balance",
  "Bank": "Bank",
  "Bank / SEPA": "Bank / SEPA",
  "Bank account": "Bank account",
  "Bank account deleted.": "Bank account deleted.",
  "Bank account saved.": "Bank account saved.",
  "Bank statement": "Bank statement",
  "Fetch statement": "Fetch statement",
  "Fetch statement and show transaction list": "Fetch statement and show transaction list",
  "Bank statement book run": "Post direct debit run",
  "Bank statement fetch added": "Fetch completed: {count} new transactions.",
  "Fetch completed.": "Fetch completed.",
  "Fetch failed.": "Fetch failed.",
  "Transaction list": "Transaction list",
  "No transactions yet.": "No transactions yet.",
  "Bank statement fetch hint": "If your bank requires a TAN, a dialog will appear to enter it.",
  "Bank statement fetch hint tan required": "This bank requires a TAN. Please enter it in the dialog.",
  "Bank statement tan title": "Enter TAN",
  "Bank statement tan prompt": "Your bank requires a TAN. Please enter the displayed TAN.",
  "Bank statement tan placeholder": "TAN",
  "Bank statement tan submitted": "TAN submitted.",
  "Bank statement tan submit": "Submit TAN",
  "Bank statement book success": "Payment assigned.",
  "Bank statement book already booked": "This transaction was already booked.",
  "Bank statement book error": "Booking failed.",
  "Bank statement book hint": "Transaction",
  "Select open item": "Select open item",
  "Select open items": "Select open items",
  "Select contributions": "Select contributions",
  "Select items": "Select items",
  "No contributions available": "No contributions available",
  "No open items available": "No open items available",
  "No items available": "No items available",
  "Overpayment": "Overpayment",
  "Underpayment amount distributed": "The amount will be automatically distributed by due date.",
  "Terms": "Terms",
  "Loading history…": "Loading history…",
  "No history entries yet.": "No history entries yet.",
  "Pagination range": "{0}-{1} of {2}",
  "Total count": "Total: {0}",
  "Installments of amount": "{0} installments of {1}",
  "Number of installments must be between": "Number of installments must be between {0} and {1}",
  "Installment plan created for items": "Installment plan created for {0} items",
  "per installment": " per installment",
  "of total": "of total",
  "Financial breakdown": "Financial breakdown",
  "Base amount (open item)": "Base amount (open item)",
  "Base amount (selected open items)": "Base amount (selected open items)",
  "Resend document": "Resend document",
  "Resend document__brief": "Resend document",
  "Print failed.": "Print failed.",
  "Resend": "Resend",
  "How should the document be sent?": "How should the document be sent?",
  "Document sent to person email": "The document will be sent to the person's stored email address. PDF as attachment, otherwise as email body.",
  "Online letter (Brief24)": "Online letter (Brief24)",
  "Coming soon.": "Coming soon.",
  "Person data": "Person data",
  "Person overview access entitled": "allowed",
  "Person overview access limited": "limited",
  "Person overview access not entitled": "no access",
  "Person overview access blocked": "blocked",
  "Person overview access reason manual": "manually",
  "Person overview access reason rest period": "rest period",
  "Person overview access reason studio limited": "not in all studios",
  "Person overview access reason no basis": "no valid contract",
  "Person overview open balance": "open",
  "Person overview next contribution": "next contribution",
  "Person overview change home studio": "change home studio",
  "Person overview never": "never",
  "Person overview todo title": "Action needed",
  "Person overview todo open item overdue": "1 overdue item of {0}, due since {1}",
  "Person overview todo open items overdue": "{0} overdue items, {1} in total, oldest due since {2}",
  "Person overview todo access blocked manual": "Access blocked manually",
  "Person overview todo access blocked reminder": "Access blocked by {0}",
  "Person overview todo sepa iban": "Direct debit without IBAN: {0}",
  "Person overview todo sepa mandate": "Direct debit without mandate reference: {0}",
  "Person overview todo app request cancellation": "App request for cancellation from {0}",
  "Person overview todo app request rest period": "App request for rest period from {0}",
  "Person overview todo contract cancelled": "{0}: cancellation effective {1}",
  "Person overview todo contract term end": "{0}: term ends on {1}",
  "Person overview todo rest period ending": "{0}: rest period ends on {1}",
  "Person overview todo care follow up": "{0}: follow-up on {1}",
  "Person overview todo no valid contract": "no valid contract",
  "Person overview todo action request": "open request",
  "Person overview todo action care": "open case",
  "Person overview unblock access": "remove block",
  "Person overview block access": "block access",
  "Person overview add access medium": "access medium",
  "Person overview no check-ins": "no check-ins",
  "Person overview no open items": "no open items",
  "Person overview no timeline entries": "no entries",
  "Person overview no todos": "nothing to do",
  "Person overview situation title": "Status",
  "Person overview timeline title": "Recent activity",
  "Person overview check-ins total": "check-ins total",
  "Person overview rows per list": "rows",
  "Person overview rows count": "{0} rows",
  "Person overview configure layout": "arrange overview",
  "Person overview attendance title": "Attendance",
  "Person overview membership title": "Membership",
  "Person overview since": "since {0}",
  "Person overview until": "until {0}",
  "Person overview cancelled to": "cancelled effective {0}",
  "Person overview rest period range": "rest period {0}",
  "Person overview no running contract": "no running contract",
  "Person overview credit": "credit",
  "Person overview points": "points",
  "Person overview chip overdue": "{0} overdue · {1}",
  "Person overview chip access blocked": "access blocked",
  "Person overview chip iban missing": "IBAN missing",
  "Person overview chip mandate missing": "mandate missing",
  "Person overview chip cancellation request": "cancellation request",
  "Person overview chip rest period request": "rest period request",
  "Person overview chip contract cancelled": "cancelled as of {0}",
  "Person overview chip contract term end": "term ends {0}",
  "Person overview chip rest period ending": "rest period ends {0}",
  "Person overview chip care follow up": "follow-up {0}",
  "Person overview visits 30 days": "visits in 30 days",
  "Person overview per week": "avg. per week",
  "Person overview trend tooltip": "{0} compared to the previous 30 days",
  "Person overview heatmap cell": "{0}: {1} visits",
  "Person overview heatmap label": "visits in the last 13 weeks",
  "Person overview renews": "renews",
  "Person overview term progress": "{0}% of the term elapsed",
  "Person overview no reader actions yet": "No reader or wallet actions yet.",
  "Manual check-in block confirm title": "Block check-in manually?",
  "Manual check-in block confirm content":
    "The person will not be able to check in until you remove this block. Reminder-based blocks are not changed.",
  "Manual check-in block confirm ok": "Yes, block check-in",
  "Consent (App)": "Consent (App)",
  "Cancellation / Rest period": "Cancellation / Rest period",
  "Contract cancelled": "Contract cancelled",
  "Purpose__column": "Purpose",
  "Consent__column": "Consent",
  "Type__column": "Type",
  "Installment payment plan": "Installment payment ({0})",
  "Number of installments must be between min max": "Number of installments must be between {0} and {1}.",
  "Min max installments": "Min. {0} / Max. {1}",
  "contributions selected": "{0} contribution(s) selected",
  "Document created and sent": "Document has been created and sent.",
  "Document ready for printing.": "Document has been created and opened for printing.",
  "Preparing print...": "Preparing print...",
  "Change home studio to": "Change home studio to \"{0}\"?",
  "Mandate reference exists confirm": "A mandate reference already exists. If you regenerate it, the old reference will be overwritten and the mandate date will be set to the default date.\n\nContinue?",
  "Delete contract package confirm": "Do you want to delete the contract package \"{0}\"?",
  "Delete document confirm": "Do you really want to delete \"{0}\"?",
  "Delete sub-contract confirm": "Do you really want to delete the sub-contract \"{0}\"?",
  "Contract package in studio change home": "This contract package will be closed in studio \"{0}\".\n\nShould the person's home studio also be changed to this studio?",
  "Delete wallet confirm": "Do you really want to delete the wallet \"{0}\"?",
  "Chip already assigned to": "This chip is already assigned to: {0}",
  "Select bank account": "Select bank account",
  "Bank Accounts": "Bank Accounts",
  "Bank accounts": "Bank accounts",
  "Bank Data": "Bank Data",
  "Bank data additional settings": "Bank data – additional settings",
  "Bank Data List": "Bank Data List",
  "Bank details": "Bank details",
  "Bank details, direct debit groups & mandate reference": "Bank details, direct debit groups & mandate reference",
  "Bank details__alt2": "Bank details",
  "Bank Name": "Bank Name",
  "Bank name (automatically filled from IBAN)": "Bank name (automatically filled from IBAN)",
  "Base URL": "Base URL",
  "Base URL is required": "Base URL is required",
  "Base URL example placeholder": "e.g. https://api.example.com",
  "Base URL max 500 characters": "Base URL must be at most 500 characters",
  "Base URL must start with http or https": "Base URL must start with http:// or https://",
  "Basic Information": "Basic Information",
  "Batch size": "Batch size",
  "Batch size is required": "Batch size is required",
  "Became member": "Became member",
  "Beginning Balance": "Beginning Balance",
  "Behavior": "Behavior",
  "Behavior on holidays": "Behavior on holidays",
  "Available on holidays": "Available on holidays",
  "Holiday calendar per studio hint": "The holiday calendar is set per studio in appointment configuration (holidays).",
  "BIC": "BIC",
  "BIC is required for foreign IBANs": "BIC is required for foreign IBANs",
  "Billing cycle": "Payment cycle",
  "Birthdate": "Birthdate",
  "Birthday": "Birthday",
  "Birthday today": "Birthday today",
  "Birthdays": "Birthdays",
  "Member birthdays in selected period": "Member birthdays in selected period",
  "With last attendance": "With last attendance",
  "Without last attendance": "Without last attendance",
  "Last attendance": "Last attendance",
  "Last attendance within days": "Last attendance within days",
  "Days since last attendance": "Days since last attendance",
  "Age": "Age",
  "Report period last week": "last week",
  "Report period current month": "this month",
  "Report period last month": "last month",
  "Report period last quarter": "last quarter",
  "Report period last half year": "last 6 months",
  "Report period current year": "this year",
  "Report period last year": "last year",
  "Report period last 12 months": "last 12 months",
  "Next month": "Next month",
  "Custom period": "Custom period",
  "Currently in studio": "Currently in studio",
  "Resting contracts": "Resting contracts",
  "Cancelled still running": "Cancelled, still running",
  "Open app requests": "Open app requests",
  "Open items total": "Open items total",
  "Total revenue": "Total revenue",
  "of which article sales": "of which article sales",
  "Chargeback rate": "Chargeback rate",
  "Won leads": "Won leads",
  "Membership entries": "Membership entries",
  "Member departures": "Member departures",
  "New members": "New members",
  "New contracts": "New contracts",
  "Net member change": "Net member change",
  "Contract member history": "Contract members over time",
  "Change in contract members": "Change",
  "Joins and cancellations": "Joins and cancellations",
  "Next 7 days": "Next 7 days",
  "Next 30 days": "Next 30 days",
  "Next 60 days": "Next 60 days",
  "Next 90 days": "Next 90 days",
  "Today's appointments": "Today's appointments",
  "To calendar": "To calendar",
  "No appointments today": "No appointments today",
  "No appointments in period": "No appointments in period",
  "No birthdays this week": "No birthdays this week",
  "No birthdays in period": "No birthdays in period",
  "Create tasks for birthdays": "Create tasks for birthdays",
  "Birthday tasks only for members": "Birthday tasks only for members",
  "Hide prospect detail sections": "Hide check-ins, contributions, and open items for prospects",
  "Hide unused person features": "Hide unused person features",
  "Birthday task drawer title": "Birthday reminder",
  "Birthday task note label": "Note (optional)",
  "Birthday task note hint": "For your own reference, e.g. greeting sent.",
  "Birthday task mark done": "Mark as done",
  "Birthday task done message": "Birthday reminder marked as done.",
  "To tasks": "To tasks",
  "Task type": "Task type",
  "Block access:": "Block access:",
  "Block check-in": "Block check-in",
  "Block contact": "Block contact",
  "Block until": "Block until",
  "blocked": "blocked",
  "SEPA direct debit blocked": "SEPA direct debit blocked",
  "SEPA blocked": "SEPA blocked",
  "SEPA blocks": "SEPA blocks",
  "SEPA blocks card description": "View and manage active and released direct debit blocks",
  "Payment cancellations": "Payment cancellations",
  "This person is blocked for SEPA direct debits (e.g. after a chargeback). You can unblock after clarification.": "This person is blocked for SEPA direct debits (e.g. after a chargeback). You can unblock after clarification.",
  "Unblock SEPA": "Unblock SEPA",
  "SEPA unblocked.": "SEPA unblocked.",
  "SEPA block note": "SEPA block note",
  "Comment (optional, saved when unblocking SEPA)": "Comment (optional, saved when unblocking SEPA)",
  "Open reminder assistant afterwards": "Open reminder assistant afterwards",
  "No dunnable open item, reminder assistant skipped": "No dunnable open item — reminder assistant skipped.",
  "Blocked (no access)": "Blocked (no access)",
  "blocks": "blocks",
  "Blue": "Blue",
  "BLZ": "BLZ",
  "Body": "Body",
  "Book": "Book",
  "Book appointment": "Book appointment",
  "Book appointment anyway?": "Book anyway?",
  "Book Now": "Book Now",
  "Book payments": "Book payments",
  "Booked": "Booked",
  "Booked direct debit runs cannot be deleted.": "Booked direct debit runs cannot be deleted.",
  "Booking code": "Booking code",
  "Booking date": "Booking date",
  "Booking group": "Booking group",
  "Booking link": "Booking link",
  "Widget link": "Widget link",
  "Booking links & embed": "Booking links & embed",
  "Booking restrictions": "Booking restrictions",
  "Booking Widget": "Booking Widget",
  "Booking widgets": "Booking widgets",
  "Booking widgets for leads": "Booking widgets for leads",
  "Online bookings, design & iFrame configuration": "Online bookings, design & iFrame configuration",
  "Bookings": "Bookings",
  "Border Radius": "Border Radius",
  "Border radius": "Border radius",
  "Branding": "Branding",
  "Briefly note what happened …": "Briefly note what happened …",
  "Bulk Communication": "Bulk Communication",
  "Bulk email": "Bulk email",
  "Bulk email sending (selection, preview, queue).": "Bulk email sending (selection, preview, queue).",
  "Bulk letter": "Bulk letter",
  "Bulk letters (selection, merge, print/export).": "Bulk letters (selection, merge, print/export).",
  "Bulk sending": "Bulk sending",
  "Button uses server reset. New password is filled into the field (not revealable for security reasons).": "Button uses server reset. New password is filled into the field (not revealable for security reasons).",
  "Calculate proportionally": "Calculate proportionally",
  "No proportional calculation": "No proportional calculation",
  "Calculation Method": "Calculation Method",
  "Calculation method for last contribution on cancellation": "Calculation method for last contribution on cancellation",
  "Calendar": "Calendar",
  "Calendar filter studio and resources": "Studio & resources",
  "Calendar filter resources": "Resources",
  "Hide resources without availability": "Hide resources and employees without availability",
  "Show resources without availability": "Show resources and employees without availability",
  "Calendar & Appointments": "Calendar & Appointments",
  "Calendar configuration": "Calendar configuration",
  "Calendar studio already has configuration": "One or more selected studios already have a calendar configuration.",
  "Calendar module": "Calendar module",
  "Calendar Reports": "Calendar Reports",
  "Calendar reports": "Calendar reports",
  "Calendar role created": "Calendar role created",
  "Calendar role deleted": "Calendar role deleted",
  "Calendar role updated": "Calendar role updated",
  "Fill screen: on – click for standard row height": "Fill screen: on – click for standard row height",
  "Fill screen: off – click to fill the screen": "Fill screen: off – click to fill the screen",
  "Call": "Call",
  "Call__alt2": "Call",
  "Call__anrufen": "Call",
  "Camera access is not available.": "Camera access is not available.",
  "Camera access was denied. Please allow camera permission in your browser.": "Camera access was denied. Please allow camera permission in your browser.",
  "Camera is not ready yet. Please wait a moment.": "Camera is not ready yet. Please wait a moment.",
  "Camera is not supported by the browser. Please use file upload.": "Camera is not supported by the browser. Please use file upload.",
  "Automation leads to:": "Automation leads to:",
  "No automation configured": "No automation configured",
  "Default email template": "Default email template",
  "Default email template help": "Preselected when composing an email to a contact in this phase. With no selection, no template is loaded.",
  "Calendar for appointments": "Calendar for appointments",
  "Calendar for appointments help": "Determines which calendar an appointment is created in when booked for a contact in this pipeline.",
  "Appointment types for lead booking": "Appointment types for lead booking",
  "Appointment types for lead booking help": "These appointment types are offered when booking from a lead. Every appointment linked to the lead counts for phase automation regardless of this selection.",
  "Phases are the steps a contact goes through. Drag to reorder.": "Phases are the steps a contact goes through. Drag to reorder.",
  "Phase type": "Phase type",
  "Phase type in progress": "In progress",
  "Phase type won": "Became member",
  "Phase type not realized": "Did not happen",
  "Phase type neutral": "No rating",
  "Cancel contract": "Cancel contract",
  "Cancel contracts": "Cancel contracts",
  "Customize contract cancellations": "Customize contract cancellations",
  "Customize contract cancellations help":
    "Manually set the effective cancellation date and membership end date. Without this permission, only dates calculated from the cancellation model apply (requires cancel contracts).",
  "Customize rest periods": "Customize rest periods",
  "Customize rest periods help":
    "Choose a different rest period template or set fees and options manually. Without this permission, only the rest period model stored on the contract is used (requires edit rest periods).",
  "Cancellation dates follow system model help":
    "Cancellation and membership end dates follow the cancellation model; without the customize permission they cannot be changed.",
  "Rest period contract package missing template warning":
    "The selected contract package has no rest period model. Add one on the contract before recording a rest period.",
  "Rest period model locked to contract help":
    "Model, fees and options match the rest period model on the contract; without the customize permission they cannot be changed.",
  "Edit cancellation": "Edit cancellation",
  "Cancel direct debit": "Cancel direct debit",
  "Cancel direct debit run": "Cancel direct debit run",
  "Cancel payment": "Cancel payment",
  "Cancel run": "Cancel run",
  "Cancel booking": "Cancel appointment",
  "Do you really want to cancel this booking?": "Do you really want to cancel this appointment?",
  "Booking reference": "Appointment reference",
  "Reason (optional)": "Reason",
  "Booking cancelled successfully.": "Appointment cancelled successfully.",
  "Invalid or missing booking reference.": "Invalid or missing appointment reference.",
  "Booking not found.": "Appointment not found.",
  "Email is required": "Email is required.",
  "Email does not match.": "Email does not match.",
  "Email not registered": "Email not registered",
  "Booking cannot be cancelled.": "Appointment cannot be cancelled.",
  "Cancel": "Cancel",
  "Cancel booking link": "Cancel appointment URL",
  "Terminate": "Terminate",
  "Void": "Void",
  "Stornierung": "Void",
  "Cancellation": "Cancellation",
  "Cancellation confirmation": "Cancellation confirmation",
  "Cancellation blocked during free period": "The sales promotion does not allow cancellation during the granted free period.",
  "Cancellation date": "Cancellation date",
  "Cancellation Date": "Cancellation Date",
  "Cancellation Model": "Cancellation Model",
  "Cancellation model": "Cancellation model",
  "Cancellation model (optional)": "Cancellation model",
  "Cancellation models": "Cancellation models",
  "Cancellation note": "Cancellation note",
  "Cancellation processed by": "Cancellation processed by",
  "Cancellation reason created": "Cancellation reason created",
  "Cancellation reason deleted": "Cancellation reason deleted",
  "Cancellation reason updated": "Cancellation reason updated",
  "Cancellation reason": "Cancellation reason",
  "Cancellation reason__alt2": "Cancellation reason",
  "Cancellation reason__stornierungsgrund": "Cancellation reason",
  "Cancellation reasons": "Cancellation reasons",
  "Cancellation request date": "Cancellation request date",
  "Cancellation request date is required": "Cancellation request date is required",
  "Cancellation revoked.": "Cancellation revoked.",
  "Cancellation type": "Cancellation type",
  "Cancellations": "Cancellations",
  "Kündigungen": "Cancellations",
  "Cancellations & Churn": "Cancellations & Churn",
  "Stornierungen": "Payment cancellations",
  "Payment cancellations description": "View cancelled payments",
  "Cancelled amount": "Cancelled amount",
  "Cancelled": "Cancelled",
  "Appointment status cancelled": "Cancelled",
  "Cancelled__alt1": "Cancelled",
  "Cancelled__alt2": "Cancelled",
  "Cancelled__alt4": "Cancelled",
  "Cannot delete: payments have already been booked for this contract.": "Cannot delete: payments have already been booked for this contract.",
  "Cannot save": "Cannot save",
  "Capabilities": "Capabilities",
  "Capacity": "Capacity",
  "Capture": "Capture",
  "Capture failed.": "Capture failed.",
  "Cash": "Cash",
  "Cash transactions at checkout": "Cash transactions at checkout",
  "Categories": "Categories",
  "Categories for text templates": "Categories for text templates",
  "Category": "Category",
  "Central settings for reminder and confirmation (email/SMS). An entry can apply to all studios or to selected studios.": "Central settings for reminder and confirmation (email/SMS). An entry can apply to all studios or to selected studios.",
  "Change appointment (duration)": "Change appointment (duration)",
  "Change home studio": "Change home studio",
  "Change home studio?": "Change home studio?",
  "Change language": "Change language",
  "Change order": "Change order",
  "Change password": "Change password",
  "Change": "Change",
  "Change__alt2": "Change",
  "Changelog": "Changelog",
  "What's new": "What's new",
  "Changes": "Changes",
  "Channel": "Channel",
  "Channel is required": "Channel is required",
  "Channel change": "Channel change",
  "If you change the channel, the current content may be lost or become invalid. Continue?": "If you change the channel, the current content may be lost or become invalid. Continue?",
  "Unsaved changes": "Unsaved changes",
  "You have unsaved changes. Leave anyway?": "You have unsaved changes. Leave anyway?",
  "Save or discard changes?": "Save or discard changes?",
  "Leave": "Leave",
  "Chargeback": "Chargeback",
  "Checking email availability…": "Checking email availability…",
  "Chargebacks last 7 days": "Chargebacks (last 7 days)",
  "Chargeback Rate": "Chargeback Rate",
  "Rücklastschriftenquote": "Chargeback Rate",
  "Chargeback Rate__alt1": "Chargeback Rate",
  "Chargeback reason": "Chargeback reason",
  "Manual chargeback reason MS03": "Other reasons",
  "Manual chargeback reason MS02": "Direct debit refused by the customer before collection",
  "Manual chargeback reason MD06": "Direct debit refund requested by the customer",
  "Manual chargeback reason MD01": "No valid direct debit mandate",
  "Manual chargeback reason MD02": "Incorrect or incomplete mandate details",
  "Manual chargeback reason AC01": "Incorrect IBAN",
  "Manual chargeback reason AC04": "Account closed",
  "Manual chargeback reason AC06": "Account blocked",
  "Manual chargeback reason AG01": "Direct debit not allowed for this account",
  "Manual chargeback reason SL01": "Direct debit blocked by the customer",
  "Manual chargeback reason AM04": "Insufficient funds",
  "Manual chargeback reason AM05": "Duplicate direct debit collection",
  "Chargeback reason AC01": "Incorrect account number",
  "Chargeback reason AC04": "Closed account",
  "Chargeback reason AC06": "Blocked account",
  "Chargeback reason AC13": "Invalid account type (consumer account)",
  "Chargeback reason AG01": "Direct debit not allowed",
  "Chargeback reason AG02": "Invalid bank operation code",
  "Chargeback reason AM04": "Insufficient funds",
  "Chargeback reason AM05": "Duplicate payment",
  "Chargeback reason BE05": "Unknown creditor identifier",
  "Chargeback reason FF01": "Invalid file format",
  "Chargeback reason FF05": "Invalid direct debit scheme",
  "Chargeback reason MD01": "No valid mandate",
  "Chargeback reason MD02": "Incomplete mandate details",
  "Chargeback reason MD06": "Refund requested by debtor",
  "Chargeback reason MD07": "Debtor deceased",
  "Chargeback reason MS02": "Refusal by debtor",
  "Chargeback reason MS03": "Reason not specified (bank)",
  "Chargeback reason RC01": "Incorrect BIC",
  "Chargeback reason RR01": "Missing debtor details",
  "Chargeback reason RR02": "Missing debtor name/address",
  "Chargeback reason RR03": "Missing creditor name/address",
  "Chargeback reason RR04": "Regulatory reason",
  "Chargeback reason SL01": "Blocked by debtor",
  "Chargeback reason TM01": "Cut-off time exceeded",
  "Chargeback fee (per chargeback)": "Chargeback fee (per chargeback)",
  "Chargeback fee (% of chargeback amount)": "Chargeback fee (% of chargeback amount)",
  "If set, this amount is automatically posted as an open item when a payment is cancelled as chargeback (SEPA return).": "If set, this amount is automatically posted as an open item when a payment is cancelled as chargeback (SEPA return).",
  "Chargebacks": "Chargebacks",
  "Check in": "Check in",
  "Check in__alt1": "Check in",
  "Check out": "Check out",
  "Check out__alt2": "Check out",
  "Check-in": "Check-in",
  "Check-in allowed": "Check-in allowed",
  "check-in blocked": "check-in blocked",
  "Check-in failed": "Check-in failed",
  "Check-in settings": "Check-in settings",
  "Check-in settings saved.": "Check-in settings saved.",
  "Check-in view": "Check-in view",
  "Check-in current list photo": "Photo",
  "Check-ins last 30 days": "Check-ins last 30 days",
  "Check-ins today": "Check-ins today",
  "Check-ins": "Check-ins",
  "Check-ins (attendance)": "Check-ins (attendance)",
  "Walk-in guest": "walk-in",
  "Inbound call at desk": "inbound call",
  "Capture walk-in guest": "walk-in",
  "Capture inbound call": "inbound call",
  "Walk-in guest recorded": "walk-in recorded",
  "Inbound call recorded": "inbound call recorded",
  "Reception next step": "What came of it?",
  "Reception follow-up done": "not captured",
  "Reception follow-up done help": "Neither capture a contact nor book an appointment.",
  "Reception follow-up done help call": "Neither capture a contact nor book an appointment.",
  "Put on call list": "capture as contact",
  "Put on call list help": "Capture name and phone, without booking an appointment.",
  "Put on call list already help": "Capture name and phone, without booking an appointment.",
  "Put on call list done": "Captured as contact.",
  "Reception chip booked": "appointment",
  "Reception chip on call list": "contact",
  "Book appointment from reception": "book appointment",
  "Book appointment from reception help": "Book an appointment.",
  "Reception studio missing": "Set the studio on this computer first.",
  "Reception today": "today at reception",
  "Reception guests today": "walk-ins today",
  "Reception calls today": "inbound calls today",
  "No reception guests yet": "No walk-in yet today.",
  "No reception calls yet": "No inbound call yet today.",
  "No reception entries yet": "No entry yet today.",
  "Reception kind": "type",
  "Reception kind short walk-in": "WI",
  "Reception kind short call": "IC",
  "Reception guest unnamed": "walk-in",
  "Reception call unnamed": "inbound call",
  "Back to check-in": "back to check-in",
  "Check-ins__alt1": "Check-ins",
  "Checked in": "Checked in",
  "Checked in since": "Checked in since",
  "Checked out": "Checked out",
  "Automatically checked out": "automatically checked out (timeout)",
  "Checked-in": "Checked-in",
  "Checkin": "Check-in",
  "checking": "checking",
  "Checkout": "Check-out",
  "Checkout failed": "Check-out failed",
  "Chip": "Chip",
  "Magnetic stripe card": "Magnetic stripe card",
  "Choose file": "Choose file",
  "Churn Rate": "Churn Rate",
  "Churn Rate %": "Churn Rate %",
  "City (optional)": "City",
  "City__alt2": "City",
  "Claims in debt collection process": "Claims in debt collection process",
  "Clean up": "Clean up",
  "Clean up orphaned items": "Clean up orphaned items",
  "Clean up orphaned open items": "Clean up orphaned open items",
  "Clear": "Clear",
  "Clear logs": "Clear logs",
  "Clear logs__alt2": "Clear logs",
  "Clear system logs": "Clear system logs",
  "Close & edit contracts": "Close & edit contracts",
  "Close a new contract for a person": "Close a new contract for a person",
  "Close contract": "Close contract",
  "Close contracts": "Close contracts",
  "Close lead": "Close lead",
  "Close phase description": "Close reasons offered to the user when closing a contact in this phase. Only available for phases without follow-up phases (loose end); whether the phase means won or lost follows from the assigned reasons.",
  "Close phase requires no transitions": "only available when the phase has no follow-up phases",
  "Closed": "Closed",
  "Open leads": "Open",
  "Reset filters": "Reset filters",
  "Create contract": "Create contract",
  "Email delivery pending": "In delivery",
  "Email delivery sent": "Sent",
  "Email delivery failed": "Failed",
  "Email delivery cancelled": "Cancelled",
  "Close reason": "Close reason",
  "Close reasons": "Close reasons",
  "Close reasons description": "Reasons for closing a contact incl. the \"became customer\" flag",
  "New close reason": "New close reason",
  "Edit close reason": "Edit close reason",
  "Close reason created": "Close reason created",
  "Close reason updated": "Close reason updated",
  "Close reason deleted": "Close reason deleted",
  "Became customer": "Became customer",
  "Close reasons missing": "Close reasons missing",
  "Pipeline activation requires close reasons": "Activation is only possible once all end phases without follow-up phases have assigned close reasons",
  "Log note": "Log note",
  "Close reasons could not be loaded": "Close reasons could not be loaded. Please reload the page.",
  "No close reasons configured in pipeline": "No end phase with close reasons is configured in this pipeline",
  "Close moves lead to phase": "The contact will be moved to phase \"{0}\"",
  "Last 30 days": "Last 30 days",
  "Last 90 days": "Last 90 days",
  "This year": "This year",
  "Clear period": "Clear period",
  "Close__alt1": "Close",
  "Reached": "Reached",
  "Due today": "Due today",
  "Reopen lead": "Reopen lead",
  "Lead reopened.": "Lead reopened.",
  "Change phase": "Change phase",
  "Phase changed.": "Phase changed.",
  "New phase": "New phase",
  "Closes contact": "closes contact",
  "No close reasons configured for this phase": "No close reasons configured for this phase",
  "Close reason is mandatory": "Close reason is mandatory",
  "+{0} days": "+{0} days",
  "+{0} weeks": "+{0} weeks",
  "+{0} months": "+{0} months",
  "+1 day": "+1 day",
  "+2 days": "+2 days",
  "+3 days": "+3 days",
  "+1 week": "+1 week",
  "+2 weeks": "+2 weeks",
  "+1 month": "+1 month",
  "e.g. Info material - {{person.firstName}} {{person.lastName}}": "e.g. Info material - {{person.firstName}} {{person.lastName}}",
  "e.g. Document title - {{person.firstName}} {{person.lastName}}": "e.g. Document title - {{person.firstName}} {{person.lastName}}",
  "Closed by": "Closed by",
  "Closed, use configured holidays": "Closed, use configured holidays",
  "Closing": "Closing",
  "Closing date": "Closing date",
  "Closing date is required": "Closing date is required",
  "Closing date is required.": "Closing date is required.",
  "Closing employee": "Closing employee",
  "Closing user": "Closing user",
  "Code": "Code",
  "Code (for link)": "Code (for link)",
  "Code cannot be changed if payment method is already in use": "Code cannot be changed if payment method is already in use",
  "Code copied!": "Code copied!",
  "Code is required": "Code is required",
  "Code regenerated": "Code regenerated",
  "Color": "Color",
  "Color (Calendar View)": "Color (Calendar View)",
  "Color (optional)": "Color",
  "Color for calendar view": "Color for calendar view",
  "Color picker blue channel": "Blue",
  "Color picker green channel": "Green",
  "Color picker hex value": "Hex value",
  "Color picker red channel": "Red",
  "Color picker tonal variants": "Tonal variants",
  "Column settings deleted": "Column settings deleted",
  "Column settings saved": "Column settings saved",
  "Columns": "Columns",
  "Comment": "Comment",
  "Commercial (nearest)": "Commercial (nearest)",
  "Communication": "Communication",
  "Communication spooler nav": "System send queue (email & SMS)",
  "Compact": "Compact",
  "Detailed": "Detailed",
  "Compact View": "Compact View",
  "Company & Studios": "Company & Studios",
  "Company Name": "Company Name",
  "Complete": "Complete",
  "Complete amount": "Complete amount",
  "Complete phase": "Complete phase",
  "Completed": "Completed",
  "Completion": "Completion",
  "Components for contract packages": "Components for contract packages",
  "Conditions": "Conditions",
  "Conditions (all must match)": "Conditions (all must match)",
  "Configuration created": "Configuration created",
  "Configuration deleted": "Configuration deleted",
  "Configuration duplicated": "Configuration duplicated",
  "Configuration for incoming email via IMAP.": "Configuration for incoming email via IMAP.",
  "Configure reminder levels": "Configure reminder levels",
  "Configure when and how often bank data should be automatically updated from the German Bundesbank.": "Configure when and how often bank data should be automatically updated from the German Bundesbank.",
  "Confirm": "Confirm",
  "Confirm new password": "Confirm new password",
  "Confirm password": "Confirm password",
  "Confirmation": "Confirmation",
  "Confirmation Email": "Confirmation Email",
  "Confirmation Message": "Confirmation Message",
  "Confirmation text:": "Confirmation text:",
  "Confirmation Title": "Confirmation Title",
  "Confirmation & Reminder": "Confirmation & Reminder",
  "The actual confirmation and reminder emails for appointments are configured under Settings → Appointment notifications.": "The actual confirmation and reminder emails for appointments are configured under Settings → Appointment notifications.",
  "Restriction & Lead on Booking": "Restriction & Lead on Booking",
  "When membersOnly or leadsOnly is set, the backend checks on book whether the person is a member/lead; otherwise the appointment is not confirmed. When the customer books as a lead, a lead can be created.": "When booking is restricted to members only or non-members only, the backend checks on book whether the person belongs to the allowed group; otherwise the appointment is not confirmed. When the customer books as a lead, a lead can be created.",
  "Connection failed": "Connection failed",
  "Connection successful": "Connection successful",
  "Connection successful!": "Connection successful!",
  "Connection successful. The API integration is working correctly.": "Connection successful. The API integration is working correctly.",
  "Connection test failed": "Connection test failed",
  "Consideration of bank business days and lead times for SEPA submission.": "Consideration of bank business days and lead times for SEPA submission.",
  "Contact": "Contact",
  "Contact & address": "Contact & address",
  "Contact data on booking": "Contact data on booking",
  "Contact person": "Contact person",
  "Contact Person": "Contact Person",
  "Contact form fields": "Contact form fields",
  "Select which fields are shown in the booking form and which are required.": "Select which fields are shown in the booking form and which are required.",
  "Field": "Field",
  "Continue": "Continue",
  "Choose the visit that fits you best": "Choose the visit that fits you best",
  "Custom CSS placeholder": ".booking-widget { /* your styles */ }",
  "Arial": "Arial",
  "Helvetica": "Helvetica",
  "Georgia": "Georgia",
  "Times New Roman": "Times New Roman",
  "Review & confirm": "Review & confirm",
  "Select studios (optional)": "Select studios",
  "continue payment": "continue payment",
  "Continue payment": "Continue payment",
  "Contract block": "Contract block",
  "Contract blocks": "Contract blocks",
  "Primary contract block": "Primary block",
  "Contract cancelled.": "Contract cancelled.",
  "Contract closed.": "Contract closed.",
  "The contract is now available in m1member.": "The contract is now available in m1member.",
  "Contract closing date": "Contract closing date",
  "Contract component": "Contract component",
  "Contract components": "Contract components",
  "Contract created": "Contract created",
  "Contract Duration (Months)": "Contract Duration (Months)",
  "Contract end date": "Contract end date",
  "Contract extension": "Contract extension",
  "Contract is required": "Contract is required",
  "Contract management": "Contract management",
  "Member inbox": "Member inbox",
  "Try again": "Analyze again",
  "Original person": "Originally detected person",
  "Original contract": "Originally detected contract",
  "Corrected person": "Corrected person",
  "Corrected contract": "Corrected contract",
  "Contract name/Plan": "Contract name/Plan",
  "Contract not found": "Contract not found",
  "Contract not found.": "Contract not found.",
  "The requested contract could not be found. It may have been deleted or is not assigned to this person.": "The requested contract could not be found. It may have been deleted or is not assigned to this person.",
  "The task could not be loaded. Please try again or open the person directly.": "The task could not be loaded. Please try again or open the person directly.",
  "Contract Options": "Contract Options",
  "Selected color": "Selected color",
  "Selected customer": "Selected customer",
  "Please select a contract package first": "Please select a contract package first",
  "Contract package": "Contract package",
  "Contract package added.": "Contract package added.",
  "Contract package deleted.": "Contract package deleted.",
  "Contract package not found": "Contract package not found",
  "Contract package templates": "Contract package templates",
  "Contract packages": "Contract packages",
  "Contract price": "Contract price",
  "Contract Reports": "Contract Reports",
  "Contract reports": "Contract reports",
  "Contract start": "Contract start",
  "Contract Start": "Contract Start",
  "Contract start date": "Contract start date",
  "Contract start date is required": "Contract start date is required",
  "Contract start is required": "Contract start is required",
  "Contract starting": "Contract starting",
  "Contract status": "Contract status",
  "Contract Template": "Contract Template",
  "Contract template": "Contract template",
  "Contract templates": "Contract templates",
  "Contract templates__alt1": "Contract templates",
  "Contract templates__vertragsbaustein-vorlagen": "Contract templates",
  "Contract": "Contract",
  "Contract__alt2": "Contract block",
  "Contracts": "Contracts",
  "Contracts (SEPA)": "Contracts (SEPA)",
  "Contribution": "Contribution",
  "Contribution manually waived": "Waived manually",
  "Contribution deleted.": "Contribution deleted.",
  "Contribution is already fully paid": "Contribution is already fully paid",
  "Already paid contributions cannot be edited": "Already paid contributions cannot be edited.",
  "Amount locked due to partial payment": "Amount locked due to partial payment – only payment method editable.",
  "Contribution is already in a SEPA direct debit run": "Contribution is already in a SEPA direct debit run",
  "Contribution is already in a SEPA direct debit run and cannot be paid manually": "Contribution is already in a SEPA direct debit run and cannot be paid manually",
  "Contribution saved.": "Contribution saved.",
  "Contributions": "Contributions",
  "Conversion Rate": "Conversion Rate",
  "Conversions": "Conversions",
  "Converted": "Converted",
  "Copy all": "Copy all",
  "Copy column settings": "Copy column settings",
  "Copy column settings to user:": "Copy column settings to user:",
  "Copy code": "Copy code",
  "Copy link": "Copy link",
  "Copy not possible (browser permission).": "Copy not possible (browser permission).",
  "Copy template": "Copy template",
  "Copy user preferences": "Copy user preferences",
  "Copy user preferences hint": "Select a source user, one or more target users, and which settings to copy.",
  "Source user": "Source user",
  "Target users": "Target users",
  "Which icons are shown in the check-in list.": "Which icons are shown in the check-in list.",
  "What do you want to automate?": "What do you want to automate?",
  "What to copy": "What to copy?",
  "Copy report templates": "Copy saved report views",
  "Copy list layouts": "Copy list layouts",
  "Copy table columns": "Copy table columns",
  "Copy dashboard layout": "Copy dashboard layout",
  "Copy preferences": "Copy preferences",
  "Preferences copied successfully": "Preferences copied successfully.",
  "Select at least one item to copy": "Please select at least one option to copy.",
  "Copy template to user:": "Copy template to user:",
  "Copy to other weeks": "Copy to other weeks",
  "Copy/reset": "Copy/reset",
  "Copy availabilities": "Copy availabilities",
  "Please select at least one studio and one resource for source.": "Please select at least one studio and one resource for source.",
  "Please select at least one studio and one resource for target.": "Please select at least one studio and one resource for target.",
  "Please select at least one studio and one employee for reset.": "Please select at least one studio and one employee for reset.",
  "Source and target studios must not overlap.": "Source and target studios must not overlap.",
  "Reset explicit week shifts so the default week applies again.": "Deletes only explicitly set week shifts. The default week is kept and applies again afterwards.",
  "Copying…": "Copying…",
  "Importing…": "Importing…",
  "Copy is 1:1 by order: first source studio → first target studio, first source resource → first target resource, etc.": "Copy is 1:1 by order: first source studio → first target studio, first source resource → first target resource, etc.",
  "All shifts of the source week are copied to the selected target week(s). Existing shifts of selected target employees in those weeks are replaced.": "All shifts of the source week are copied to the selected target week(s). Existing shifts of selected target employees in those weeks are replaced.",
  "Select only studios that are not in the source.": "Select only studios that are not in the source.",
  "Reset all availabilities": "Reset all availabilities",
  "Reset all availabilities?": "Reset all availabilities?",
  "Reset all availabilities confirmation": "All availability blocks for all resources and studios will be permanently deleted. This cannot be undone.",
  "All availabilities reset": "All availabilities have been reset.",
  "Copy__alt1": "Copy",
  "Chargeback fee": "Chargeback fee",
  "Fee type": "Fee type",
  "System fees": "System fees",
  "Tax": "Tax",
  "Cost center": "Cost center",
  "Cost Center": "Cost Center",
  "Cost center saved": "Cost center saved",
  "Cost centers": "Cost centers",
  "Costs & Calculation": "Costs & Calculation",
  "Count": "Count",
  "Correction document": "Correction document",
  "Country": "Country",
  "Country (optional)": "Country",
  "Country is required": "Country is required",
  "Create account": "Create account",
  "Create admin": "Create admin",
  "Create appointment": "Create appointment",
  "Create appointment anyway (with confirmation)": "Create appointment anyway",
  "Create appointment outside availability": "Create appointment outside availability",
  "Create Appointment Outcome": "Create Appointment Outcome",
  "Create appointment?": "Create appointment?",
  "Create category": "Create category",
  "Create configuration": "Create configuration",
  "Create Contract Template__alt1": "Create Contract Template",
  "Create Contract Template__alt2": "Create Contract Template",
  "Create Debt Collection Agency": "Create Debt Collection Agency",
  "Create direct debit run": "Create direct debit run",
  "Create PriceAdjustment": "Create price adjustment",
  "Create price adjustment": "Create price adjustment",
  "Create installment plan": "Create installment plan",
  "Create lead": "Create lead",
  "Create lead on first app login": "Create lead on first app login",
  "Create lead when creating person": "Create lead when creating person",
  "Create new": "Create new",
  "Create online booking": "Create online booking",
  "Create payment method": "Create payment method",
  "Create Payment Plan": "Create Payment Plan",
  "Create phase": "Create phase",
  "Create pipeline": "Create pipeline",
  "Create preset": "Create preset",
  "Create reminder": "Create reminder",
  "Create reminders": "Create reminders",
  "Create reminder…": "Create reminder…",
  "Create Rest Period Template": "Create Rest Period Template",
  "Create role": "Create role",
  "Create SEPA Group": "Create SEPA Group",
  "Create tenant": "Create tenant",
  "Create text template": "Create text template",
  "Create VAT setting": "Create VAT setting",
  "Create Wallet Product": "New template",
  "Create widget": "Create widget",
  "Create, export and post direct debit runs": "Create, export and post direct debit runs",
  "Create/send reminders": "Create/send reminders",
  "Reminders execute group": "Create reminders",
  "Create__alt2": "Create",
  "Created at": "Created at",
  "Created at__alt1": "Created at",
  "Created.": "Created.",
  "Created": "Created",
  "Created__alt1": "Created",
  "Credit": "Credit",
  "Credit account": "Credit account",
  "Credit automation": "Credit automation",
  "Credit account per scope": "Credit account per scope",
  "Credit account used for credit payments. You can set a different account per studio; otherwise the tenant default applies.": "Credit account used for credit payments. You can set a different account per studio; otherwise the tenant default applies.",
  "Transfer surplus contribution credits to credit account": "Transfer surplus contribution credits to credit account",
  "Paid contribution corrections are moved to the configured credit account when they leave a surplus.": "Paid contribution corrections are moved to the configured credit account when they leave a surplus.",
  "Automatically apply credit account to open receivables": "Automatically apply credit account to open receivables",
  "Available credit is automatically used to settle open items.": "Available credit is automatically used to settle open items.",
  "Credit/debit card payments": "Credit/debit card payments",
  "Recurring bank transfers / standing orders": "Recurring bank transfers / standing orders",
  "Creditor ID": "Creditor ID",
  "Creditor ID (for SEPA direct debit)": "Creditor ID (for SEPA direct debit)",
  "Creditor ID is required when direct debit is active": "Creditor ID is required when direct debit is active",
  "Cross-tenant import": "Cross-tenant import",
  "Currency": "Currency",
  "Current": "Current",
  "Current date": "Current date",
  "current date": "current date",
  "Current date & time": "Current date & time",
  "Current date (long)": "Current date (long)",
  "Current day": "Current day",
  "Current Members": "Current Members",
  "Current month": "Current month",
  "Current password": "Current password",
  "Current phase": "Current phase",
  "Current time": "Current time",
  "Current year": "Current year",
  "Custom": "Custom",
  "Custom CSS Rules": "Custom CSS Rules",
  "Custom CSS__alt1": "Custom CSS",
  "Custom CSS__alt2": "Custom CSS",
  "Custom Holiday": "Custom Holiday",
  "Custom reason": "Custom reason",
  "Manual correction": "Manual correction",
  "Cancellation reason type": "Cancellation reason type",
  "Payments & amount": "Payments & amount",
  "Please select a reason": "Please select a reason",
  "Please select a cancellation type": "Please select a cancellation type",
  "No chargeback reasons configured.": "No chargeback reasons configured.",
  "Select reason…": "Select reason…",
  "Select type__general": "Select type",
  "Selected payments count": "{0} payment(s) selected",
  "Type is required__general": "Type is required",
  "Customer": "Customer",
  "Customer Number": "Customer Number",
  "Customer Type": "Customer Type",
  "Column": "Column",
  "Custom sender text": "Custom sender text",
  "Custom sender text tooltip": "Optional custom sender text. If empty, data from the chosen source (studio or tenant) will be used.",
  "Customize columns": "Customize columns",
  "Cycle": "Cycle",
  "Cycle unit once": "once",
  "Cycle unit daily": "daily",
  "Cycle unit weekly": "weekly",
  "Cycle unit monthly": "monthly",
  "Cycle unit yearly": "yearly",
  "Daily": "Daily",
  "Daily Distribution": "Daily Distribution",
  "Dark": "Dark",
  "Dashboard": "Dashboard",
  "Dashboard & Check-in": "Dashboard & Check-in",
  "Configure dashboard layout": "Configure dashboard layout",
  "Save dashboard layout": "Save dashboard layout",
  "Save layout": "Save layout",
  "Primary action": "Primary action",
  "Secondary action": "Secondary action",
  "No action": "No action",
  "Copy my dashboard layout to this user": "Copy my dashboard layout to this user",
  "Dashboard layout": "Dashboard layout",
  "Dashboard layout hint": "Change order by drag & drop, turn widgets on or off. In normal mode only enabled widgets are shown.",
  "Drop here": "Drop here",
  "Dashboard copy to user hint": "Select a user to apply your current dashboard layout (visible widgets and order) to their account.",
  "Also apply to (users)": "Also apply to (users)",
  "Save for me only": "Save for me only",
  "Data updated": "Data updated",
  "Date": "Date",
  "Date & Time": "Date & Time",
  "Date format (Locale)": "Date format (Locale)",
  "Date is required": "Date is required",
  "Date of birth": "Date of birth",
  "Date, time, timezone, currency": "Date, time, timezone, currency",
  "Date, time, timezone, currency – your settings in admin": "Date, time, timezone, currency – your settings in admin",
  "Date/time is invalid": "Date/time is invalid",
  "Date/time is required": "Date/time is required",
  "Day": "Day",
  "Day of month": "Day of month",
  "Day of month (e.g. 1st or 15th)": "Day of month (e.g. 1st or 15th)",
  "Day:": "Day:",
  "Days": "Days",
  "Days After Due Date": "Days After Due Date",
  "Days Inactive": "Days Inactive",
  "Days Overdue": "Days Overdue",
  "Days Until Expiry": "Days Until Expiry",
  "Days/Month": "Days/Month",
  "Days/month": "Days/month",
  "Days/Year": "Days/Year",
  "Days/year": "Days/year",
  "DE": "DE",
  "EN": "EN",
  "Deactivate tenant": "Deactivate tenant",
  "Deadline passed! Execution date is not reachable.": "Deadline passed! Execution date is not reachable.",
  "Deadlines & rules for cancellations": "Deadlines & rules for cancellations",
  "Dear (formal)": "Dear (formal)",
  "Dear neutral": "Dear",
  "Dear + first name": "Dear + first name",
  "Dear + Mr./Ms. last name": "Dear + Mr./Ms. last name",
  "Dear Sir/Madam + last name": "Dear Sir/Madam + last name",
  "Dear__alt1": "Dear",
  "Dear__alt2": "Dear",
  "Dear__alt3": "Dear",
  "Dear__alt4": "Dear",
  "Debit": "Debit",
  "Debt Collection": "Debt Collection",
  "Debt management tab agencies": "Debt collection agencies",
  "Debt collection (status)": "Debt collection",
  "Debt collection case submitted": "Debt collection case was created.",
  "Debt collection case validation hint": "Please select a person, debt collection agency, and at least one open item.",
  "Debt collection cases": "Debt collection cases",
  "Debt collection cases card description": "View debt collection cases; finalize prepared handovers here.",
  "Debt collection cases hint":
    "Handovers do not create payment records. New cases are created from reminders when a person is at a debt-collection stage. Open items are linked to the case; complete two-step handovers here with \"Finalize now\".",
  "Debt collection interface": "Interface",
  "Debt collection interface type": "Interface type",
  "KOHL GmbH & Co. KG (E-Mail)": "KOHL GmbH & Co. KG (email)",
  "Debt collection handover amount": "Handover amount",
  "Debt collection person total handover": "Total handed over",
  "Debt collection with agency": "Debt collection: {0}",
  "Debt collection transmission id": "Submission ID",
  "External reference": "External reference",
  "DebtCollectionCaseAgencyInvalid": "Debt collection agency is invalid or inactive.",
  "DebtCollectionCaseOpenItemsNotAllowed": "At least one item is not open, does not belong to the person, or was already handed to debt collection.",
  "DebtCollectionCaseOpenItemsRequired": "Please select at least one open item.",
  "DebtCollectionCaseNotPrepared": "The debt collection case is not in “prepared” status or cannot be finalized.",
  "DebtCollectionCaseFinalizeOpenItemsInvalid": "For final handover, all case items must still be open and belong to the case person.",
  "Submitted at": "Submitted at",
  "Deduct points": "Deduct points",
  "Default": "Default",
  "Default pipeline": "Default pipeline",
  "Default (for all weeks)": "Default (for all weeks)",
  "Default (tenant)": "Default (tenant)",
  "Default Account for Contract Templates": "Default Account for Contract Templates",
  "Default account for credit payments": "Default account for credit payments",
  "Default Account for Articles": "Default account for new articles (article sales)",
  "Default addressing (formal/informal)": "Default addressing (formal/informal)",
  "Default appointment type": "Default appointment type",
  "Default appointment type (for “Book appointment”)": "Default appointment type (for “Book appointment”)",
  "Default assignments": "Default assignments",
  "Default assignments saved.": "Default assignments saved.",
  "Default availabilities": "Default availabilities",
  "Default Balance": "Default Balance",
  "Default balance must be >= 0": "Default balance must be >= 0",
  "Default End Time": "Default End Time",
  "Default history window": "Default history window",
  "Default language": "Default language",
  "Default Lead Source": "Default Lead Source",
  "Default Price": "Default Price",
  "Default Price (optional)": "Default Price",
  "Default role for new users": "Default role for new users",
  "Default Start": "Default Start",
  "Default Start Time": "Default Start Time",
  "Default Studios": "Default Studios",
  "Default template": "Default template",
  "Default template cleared.": "Default template cleared.",
  "Default template set.": "Default template set.",
  "Default templates": "Default templates",
  "Default templates & categories": "Default templates & categories",
  "Default templates and sending settings__alt1": "Default templates and sending settings",
  "Default templates and sending settings__alt2": "Default templates and sending settings",
  "Default theme": "Default theme",
  "Available themes and app default": "Available themes and app default",
  "Default theme for users without own choice": "Theme for all users without their own choice",
  "Default login image": "Default login image",
  "Default login image saved": "Default login image saved",
  "Default login image removed": "Default login image removed",
  "Image shown on the member app login screen before tenant selection. Recommended format: 1080×1920.": "Image shown on the member app login screen before tenant selection. Recommended format: 1080×1920.",
  "Studio app default": "Studio app default",
  "Studio app default (before login)": "Studio app default (before login)",
  "Design and images for member app before login": "Design and images for member app before login",
  "Design and images shown in the member app before the user has logged in. Used as standard when no tenant is selected.": "Design and images shown in the member app before the user has logged in. Used as standard when no tenant is selected.",
  "Comma-separated: home, contracts, bookings, wallets, openItems, payments, paymentMethods, checkinHistory, profile, settings, studios, restPeriods, cancellation": "Comma-separated: home, contracts, bookings, wallets, openItems, payments, paymentMethods, checkinHistory, profile, settings, studios, restPeriods, cancellation",
  "Default Usage Limit": "Default Usage Limit",
  "Default Validity": "Default Validity",
  "Default values for new members & start page": "Default values for new members & start page",
  "Default window": "Default window",
  "Defines the permissions for this user. Roles can be managed under 'Settings > Roles'.": "Defines the permissions for this user. Roles can be managed under 'Settings > Roles'.",
  "Delete": "Delete",
  "Delete document": "Delete document",
  "Delete__löschen": "Delete",
  "Delete access medium?": "Delete access medium?",
  "Delete account?": "Delete account?",
  "Delete admin": "Delete admin",
  "Delete block": "Delete block",
  "Delete all changes": "Delete all changes",
  "Delete all changes?": "Delete all changes?",
  "Delete already booked entities": "Delete already booked entities",
  "Delete anyway": "Delete anyway",
  "Delete appointment?": "Delete appointment?",
  "Delete bank account?": "Delete bank account?",
  "Delete Cancellation Model": "Delete Cancellation Model",
  "Delete category": "Delete category",
  "Delete column settings": "Delete column settings",
  "Delete contract package": "Delete contract package",
  "Delete Contract Template": "Delete Contract Template",
  "Delete contribution": "Delete contribution",
  "Delete Debt Collection Agency": "Delete Debt Collection Agency",
  "Delete direct debit run with SEPA file?": "Delete direct debit run with SEPA file?",
  "Delete direct debit run?": "Delete direct debit run?",
  "Delete priceAdjustment": "Delete price adjustment",
  "Delete PriceAdjustment": "Delete price adjustment",
  "Delete price adjustment": "Delete price adjustment",
  "Delete document?": "Delete document?",
  "Delete email account?": "Delete email account?",
  "Delete failed": "Delete failed",
  "Delete blocked title": "Cannot delete",
  "Delete holiday configuration?": "Delete holiday configuration?",
  "Delete holiday?": "Delete holiday?",
  "Holidays (current and next year)": "Holidays (current and next year)",
  "Really delete this holiday?": "Really delete this holiday?",
  "Delete integration": "Delete integration",
  "Delete lead": "Delete lead",
  "Delete leads": "Delete leads",
  "Delete logs": "Delete logs",
  "Delete logs description": "Filter and delete logs.",
  "Delete payment method": "Delete payment method",
  "Delete payment method?": "Delete payment method?",
  "Delete Payment Plan": "Delete Payment Plan",
  "Delete reader device": "Delete reader device",
  "Delete Rest Period Template": "Delete Rest Period Template",
  "Delete rest period template": "Delete rest period template",
  "Delete role": "Delete role",
  "Delete rule?": "Delete rule?",
  "Delete SEPA Group": "Delete SEPA Group",
  "Delete setting?": "Delete setting?",
  "Delete sub-contract": "Delete sub-contract",
  "Delete template": "Delete template",
  "Delete tenant": "Delete tenant",
  "Delete my data": "Delete my data",
  "Delete VAT setting?": "Delete VAT setting?",
  "Delete version": "Delete version",
  "Delete wallet": "Delete wallet",
  "Delete Wallet Product": "Delete Wallet Product",
  "Deleted": "Deleted",
  "Deleted.": "Deleted.",
  "Delete people": "Delete people",
  "Delete people help": "Allows deleting empty people without contracts, payments, appointments, leads, documents, communication, or other linked data.",
  "Delete person": "Delete person",
  "Delete person action": "Delete",
  "Delete person confirmation": "This person will be permanently deleted. A sole associated contact including its history will also be deleted. Other linked data prevents deletion.",
  "Delivery channel": "Delivery channel",
  "Delivery channels": "Delivery channels",
  "Denied": "Denied",
  "Denied__alt1": "Denied",
  "Describe changes…": "Describe changes…",
  "Description (DE)": "Description (DE)",
  "Description (EN)": "Description (EN)",
  "Description__alt2": "Description",
  "Click an element in the preview to configure it": "Click an element in the preview to configure it",
  "Design": "Design",
  "Design & Colors": "Design & Colors",
  "Design mode": "Design mode",
  "Design preview page": "Preview page",
  "Design page type": "Appointment type",
  "Design page slot": "Date & time",
  "Design page contact": "Contact details",
  "Design page review": "Review & confirm",
  "Design page done": "Done",
  "Design Editor": "Design Editor",
  "Design editor editing": "Editing",
  "Design element page": "Page",
  "Design element header": "Header",
  "Design element stepsIndicator": "Step indicator",
  "Design element appointmentTypeCard": "Appointment type card",
  "Design element appointmentTypeIcon": "Appointment type icon",
  "Design element weekBar": "Week bar",
  "Design element daySelectorContainer": "Day selector",
  "Design element daySelector": "Day tile",
  "Design element daySelectorIndicator": "Day indicator",
  "Design element timeSlot": "Time slot",
  "Design element secondaryButton": "Secondary button",
  "Design element primaryButton": "Primary button",
  "Design element card": "Card",
  "Design element contactForm": "Contact form",
  "Design element footer": "Footer",
  "Design element reviewConfirm": "Review & confirm",
  "Design element confirmation": "Confirmation",
  "Design element buttonBar": "Button bar",
  "Button bar alignment": "Button bar alignment",
  "Design element studioSelector": "Studio selection",
  "Design element studioCard": "Studio card",
  "Design style background": "Background",
  "Design style border": "Border color",
  "Design style step active": "Step active color",
  "Design style step inactive": "Step inactive color",
  "Design style step text active": "Step text color (active)",
  "Design style step text inactive": "Step text color (inactive)",
  "Design style day tile unselected": "Day tile (unselected)",
  "Design style day tile selected": "Day tile (selected)",
  "Design style border width": "Border width",
  "Design style duration color": "Duration (time) color",
  "Design style price color": "Price color",
  "Design style day tile date": "Date color",
  "Design style day tile weekday": "Weekday color",
  "Design style border selected": "Border (selected)",
  "Design style label and card border": "Label and card border color",
  "Design style card border": "Card border color",
  "Design style label color": "Label color",
  "Design style background selected": "Background (selected)",
  "Design style text color selected": "Text color (selected)",
  "Design style input background": "Input background",
  "Design style input border and text": "Input border & text",
  "Design style input border": "Input border color",
  "Design style input border width": "Input border width",
  "Design style input text": "Input text color",
  "Design style card shadow": "Card shadow",
  "Design style input size": "Input size",
  "Design style card body padding": "Card body padding",
  "Design style contract preview shadow": "Contract preview box shadow",
  "Design style form field spacing": "Form field spacing",
  "Required and validation error color": "Required and validation error color",
  "Contact form alignment excludes selected slot card": "Applies only to heading and form, not to the selected slot card.",
  "Design style selected slot background": "Selected slot background",
  "Design style selected slot border": "Selected slot border",
  "Design style selected slot text": "Selected slot text",
  "Design style confirmation title color": "Confirmation title color",
  "Design style confirmation subtitle color": "Confirmation subtitle color",
  "Design style hover background": "Hover background",
  "Design style hover text": "Hover text color",
  "Link color": "Link color",
  "Link color tooltip": "Color for links (e.g. privacy policy, terms, „Change“).",
  "Contact form heading color": "Contact form heading color",
  "Selected slot contact and confirmation": "Selected slot (contact & confirmation)",
  "Privacy policy text color": "Privacy policy text color",
  "Review confirm heading color": "Review & confirm heading color",
  "Checkmark color selected": "Checkmark color (selected)",
  "Checkmark color unselected": "Checkmark color (unselected)",
  "Header heading color": "Heading",
  "Header text color": "Text (body)",
  "Step number color active": "Step number (active)",
  "Step number color inactive": "Step number (inactive)",
  "Studio selector heading color": "Heading",
  "Studio selector text color": "Text",
  "Studio card heading color": "Heading (studio name)",
  "Studio card text color": "Text",
  "Studio name": "Studio name",
  "Day tile weekday unselected": "Weekday (unselected)",
  "Day tile weekday selected": "Weekday (selected)",
  "Day tile text unselected": "Text/date (unselected)",
  "Day tile text selected": "Text/date (selected)",
  "Availability indicator shape": "Availability indicator shape",
  "Availability shape round": "Round",
  "Availability shape square": "Square",
  "Availability shape trapezoid": "Trapezoid",
  "Availability shape diamond": "Diamond",
  "Week bar button color": "Button color",
  "Week bar button border": "Button border color",
  "Week bar button border width": "Button border width",
  "Design panel general": "General",
  "Design panel general colors": "General colors",
  "Design panel font and corners": "Font & corners",
  "Design color clear hint": "Click the clear icon (×) to set transparent or no color.",
  "Design & iFrame configuration": "Design & iFrame configuration",
  "Design preset": "Design preset",
  "Design presets for booking widgets": "Design presets for booking widgets",
  "Details__alt1": "Details",
  "Details": "Details",
  "Device": "Device",
  "Device default": "Device default",
  "Device ID": "Device ID",
  "Device is offline": "Device is offline",
  "Device is online": "Device is online",
  "Device is registered": "Device is registered",
  "Device was successfully registered and synchronized with m1connect": "Device was successfully registered and synchronized with m1connect",
  "Disconnect m1connect": "Disconnect m1connect",
  "Disconnect m1connect device?": "Disconnect m1connect device?",
  "m1connect device disconnected.": "m1connect device disconnected.",
  "m1connect client ID": "m1connect client ID",
  "The reader device remains in m1member, but the current m1connect client will be disconnected and must register again with a new registration code.": "The reader device remains in m1member, but the current m1connect client will be disconnected and must register again with a new registration code.",
  "DeviceId": "DeviceId",
  "DeviceId is required": "DeviceId is required",
  "DeviceId must be exactly 32 hexadecimal characters": "DeviceId must be exactly 32 hexadecimal characters",
  "DeviceId must contain hexadecimal characters only": "DeviceId must contain hexadecimal characters only",
  "DE…": "DE…",
  "Different Tariffs": "Different Tariffs",
  "Digital file": "Documents",
  "Direct Debit": "Direct Debit",
  "Direct debit active": "Direct debit active",
  "Direct debit cancelled.": "Direct debit cancelled.",
  "Direct debit export": "Direct debit export",
  "Direct debit group is required": "Direct debit group is required",
  "Direct debit group(s)": "Direct debit group(s)",
  "Direct Debit Groups": "Direct Debit Groups",
  "Direct debit report": "Direct debit report",
  "Direct debit run": "Direct debit run",
  "Direct debit run deleted.": "Direct debit run deleted.",
  "Direct debit run deletion failed.": "The direct debit run could not be deleted because of a system error.",
  "Direct debit run is being deleted": "Direct debit run is being deleted",
  "Direct debit item excluded.": "Direct debit item excluded.",
  "Deleting direct debit run": "Deleting direct debit run",
  "Sepa direct debit create empty modal title": "no direct debit run created",
  "Sepa direct debit create empty modal default":
    "No contribution-calendar lines matched this run’s scope (studios, direct-debit groups, “Due until” / execution date). That does not contradict “open items”: that list shows all unpaid demands for the person — including sales, invoice payers, instalments, or contributions not on direct debit — while a batch run only picks calendar rows with the right SEPA group, direct-debit payment method, and due date.",
  "Sepa direct debit create empty modal footnote":
    "In short: open items = many kinds of balance; a direct-debit run = filtered calendar debits. If technical reasons appear above, read those lines first.",
  "Direct debit run posted.": "Direct debit run posted.",
  "Direct debit run posting started.": "Posting is running in the background.",
  "Direct debit run has errors": "Direct debit run has errors",
  "Fix the direct debit errors before downloading or posting this run.": "Fix the direct debit errors before downloading or posting this run.",
  "Exclude customer": "Exclude customer",
  "Include customer": "Include customer",
  "Sepa direct debit create job title": "Creating direct debit run",
  "Sepa direct debit create job started": "Direct debit run is being created in the background.",
  "Selected studio and direct debit group combination is already reserved.": "At least one selected studio and direct debit group combination is already reserved by an active direct debit run.",
  "SepaReportExecutionDateRequired": "The direct debit report is only available once an execution date has been set.",
  "SepaBookingDateInFuture": "The actual execution date must not be in the future.",
  "sepaDirectDebitRuns.createJob.prepare": "Preparing direct debit run",
  "sepaDirectDebitRuns.createJob.calendar": "Updating contribution calendar",
  "sepaDirectDebitRuns.createJob.collect": "Collecting contributions",
  "sepaDirectDebitRuns.createJob.openItems": "Preparing open items",
  "sepaDirectDebitRuns.createJob.items": "Creating direct debit items",
  "sepaDirectDebitRuns.createJob.xml": "Creating SEPA file",
  "sepaDirectDebitRuns.createJob.done": "Direct debit run created",
  "Direct debit run is already being posted.": "This direct debit run is already being posted.",
  "Direct Debit Runs (Admin)": "Direct Debit Runs (Admin)",
  "Direct Debit Settings": "Direct Debit Settings",
  "Direct debit submitted": "Direct debit submitted",
  "Dispatch failed messages": "Failed messages",
  "Dispatch pending approvals": "Pending approvals",
  "Rebooking": "Rebooking",
  "Applied correction": "applied",
  "Import post-import hooks title": "Post-import hooks",
  "Import post-import hooks hint": "Heuristic corrections that run after the schema import. Default: enabled. Disable per schema when not applicable to a tenant.",
  "CenterCom": "CenterCom",
  "Overridden": "overridden",
  "Direct Debits": "Direct Debits",
  "Direct debits": "Direct debits",
  "Disabled": "Disabled",
  "disabled": "disabled",
  "Discard": "Discard",
  "PriceAdjustment": "Price adjustment",
  "PriceAdjustment (optional)": "Price adjustment",
  "PriceAdjustment is required": "Price adjustment is required",
  "PriceAdjustment templates for contracts": "Price adjustment templates for contracts",
  "PriceAdjustment value cannot be negative": "Price adjustment value cannot be negative",
  "PriceAdjustment value is required": "Price adjustment value is required",
  "PriceAdjustments": "Price adjustments",
  "Adjustment": "Adjustment",
  "Adjustment value is required": "Adjustment value is required",
  "Display name": "Display name",
  "Display name on welcome card": "Display name on welcome card",
  "Display name is required": "Display name is required",
  "Display name max 255 characters": "Display name must be at most 255 characters",
  "Lead form": "Lead form",
  "Reset link URL": "Reset link URL",
  "Display Options": "Display Options",
  "Distribution by Duration": "Distribution by Duration",
  "Distribution by Duration (Bar)": "Distribution by Duration (Bar)",
  "Distribution by Status": "Distribution by Status",
  "Distribution by Tariff": "Distribution by Tariff",
  "Distribution by Time Period": "Distribution by Time Period",
  "Distribution by Time Period (Bar)": "Distribution by Time Period (Bar)",
  "Diverse": "Diverse",
  "Do not contact": "Do not contact",
  "Do you really want to cancel this direct debit?": "Do you really want to cancel this direct debit?",
  "Do you really want to cancel this entire direct debit run?": "Do you really want to cancel this entire direct debit run?",
  "Do you really want to cancel this payment?": "Do you really want to cancel this payment?",
  "Do you really want to clean up all orphaned open items? This removes OpenItem references from the contribution calendar that are not in booked direct debit runs. This action cannot be undone.": "Do you really want to clean up all orphaned open items? This removes OpenItem references from the contribution calendar that are not in booked direct debit runs. This action cannot be undone.",
  "Do you really want to delete this access medium?": "Do you really want to delete this access medium?",
  "Do you really want to delete this bank account?": "Do you really want to delete this bank account?",
  "Do you really want to delete this contribution?": "Do you really want to delete this contribution?",
  "Do you really want to delete this direct debit run?": "Do you really want to delete this direct debit run?",
  "Do you really want to delete this reader device?": "Do you really want to delete this reader device?",
  "Do you really want to permanently delete all changes for this person?": "Do you really want to permanently delete all changes for this person?",
  "Do you really want to post this direct debit run? Payments will be recorded with the specified booking date.": "Do you really want to post this direct debit run? Payments will be recorded with the specified booking date.",
  "Do you really want to post this direct debit run? Payments will be recorded with the actual execution date.": "Do you really want to post this direct debit run? Payments will be recorded with the actual execution date.",
  "Do you really want to post this direct debit run? Payments will be recorded with the execution date.": "Do you really want to post this direct debit run? Payments will be recorded with the execution date.",
  "Do you really want to revoke the cancellation?": "Do you really want to revoke the cancellation?",
  "Do you want to delete all logs matching the current filter (even if multiple pages are affected)?": "Do you want to delete all logs matching the current filter (even if multiple pages are affected)?",
  "Do you want to delete all system logs matching the current filter?": "Do you want to delete all system logs matching the current filter?",
  "Do you want to import bank data from the German Bundesbank? This may take a few minutes.": "Do you want to import bank data from the German Bundesbank? This may take a few minutes.",
  "Document": "Document",
  "Document file not available": "No file is stored for this record.",
  "No file": "No file",
  "Document deleted.": "Document deleted.",
  "Document generation": "Document generation",
  "Document is being resent.": "Document is being resent.",
  "Document title (digital file)": "Document title",
  "Document uploaded.": "Document uploaded.",
  "done": "done",
  "Done__alt1": "Done",
  "Done__alt2": "Done",
  "Door": "Door",
  "down": "down",
  "Download": "Download",
  "Download PDF": "Download PDF",
  "Download backup": "Download",
  "Download document": "Download document",
  "Download failed": "Download failed",
  "Download SEPA file": "Download SEPA file",
  "Download SEPA file again": "Download SEPA file again",
  "Draft": "Draft",
  "Drag column to change order": "Drag column to change order",
  "Due Date": "Due Date",
  "Due date until": "Due date until",
  "Due date": "Due date",
  "Due date__alt2": "Due date",
  "Due since": "Due since",
  "Due on": "Due on",
  "Originally due": "Originally due",
  "Next action date": "Executable from",
  "Next reminder on": "Next reminder on",
  "Sent on": "Sent on",
  "Due": "Due",
  "Due__alt2": "Due",
  "Dues": "Dues",
  "Dunning": "Dunning",
  "Dunning / overdue": "Dunning / overdue",
  "Duplicate": "Duplicate",
  "Copy from template": "Copy from template",
  "None (empty tenant)": "None (empty tenant)",
  "Optional. Only tenants marked as copy template are listed. Configuration and assets will be copied.": "Optional. Only tenants marked as copy template are listed. Configuration and assets will be copied.",
  "Use as copy template": "Use as copy template",
  "If enabled, this tenant appears in the template dropdown when creating new tenants.": "If enabled, this tenant appears in the template dropdown when creating new tenants.",
  "Duplicate Contract Template": "Duplicate Contract Template",
  "Copy holiday configuration from one scope to another.": "Copy holiday configuration from one scope to another.",
  "Duplicate holidays": "Duplicate holidays",
  "Duplicate of": "Duplicate of",
  "Duplicate rest period template": "Duplicate rest period template",
  "Duplicate units": "Duplicate units",
  "Duplicated.": "Duplicated.",
  "Duplicated": "Duplicated",
  "Zoom in": "Zoom in",
  "Zoom out": "Zoom out",
  "Duplicate record name suffix": " (copy)",
  "Duration (Minutes)": "Duration (Minutes)",
  "Duration (Months)": "Duration (Months)",
  "Duration changed.": "Duration changed.",
  "Drag appointment end": "Drag appointment end",
  "Drag appointment start": "Drag appointment start",
  "Duration is required": "Duration is required",
  "Duration": "Duration",
  "Duration__alt2": "Duration",
  "E-Mail": "E-Mail",
  "e.g. 0.99": "e.g. 0.99",
  "e.g. 0176…": "e.g. 0176…",
  "e.g. 02:00": "e.g. 02:00",
  "e.g. 040…": "e.g. 040…",
  "e.g. 10 Card EMS": "e.g. 10 Card EMS",
  "e.g. 19": "e.g. 19",
  "e.g. 19% VAT": "e.g. 19% VAT",
  "e.g. 6 installments": "e.g. 6 installments",
  "e.g. 8400": "e.g. 8400",
  "e.g. Cancellation confirmation - {{person.firstName}} {{person.lastName}}": "e.g. Cancellation confirmation - {{person.firstName}} {{person.lastName}}",
  "e.g. Rest period confirmation - {{person.firstName}} {{person.lastName}}": "e.g. Rest period confirmation - {{person.firstName}} {{person.lastName}}",
  "e.g. Cancellation confirmation, Contract, etc.": "e.g. Cancellation confirmation, Contract, etc.",
  "e.g. COBADEFFXXX": "e.g. COBADEFFXXX",
  "e.g. Company Holiday": "e.g. Company Holiday",
  "e.g. CONS, TT, CHK": "e.g. CONS, TT, CHK",
  "e.g. Consultation, Trial Training, Checkup": "e.g. Consultation, Trial Training, Checkup",
  "e.g. Consulting Team": "e.g. Consulting Team",
  "e.g. Course Room A": "e.g. Course Room A",
  "e.g. DE89370400440532013000": "e.g. DE89370400440532013000",
  "e.g. Dr., Prof.": "e.g. Dr., Prof.",
  "e.g. Inactive leads after 3 months": "e.g. Inactive leads after 3 months",
  "e.g. JD, CT, TM1": "e.g. JD, CT, TM1",
  "e.g. John Doe": "e.g. John Doe",
  "e.g. Trainer, Consultant": "e.g. Trainer, Consultant",
  "e.g. m1member Studio Ltd.": "e.g. m1member Studio Ltd.",
  "e.g. Main location, Branch North": "e.g. Main location, Branch North",
  "e.g. Max Mustermann": "e.g. Max Mustermann",
  "e.g. member_welcome_email": "e.g. member_welcome_email",
  "e.g. Membership fees": "e.g. Membership fees",
  "e.g. MK": "e.g. MK",
  "e.g. Office365": "e.g. Office365",
  "e.g. pelvic floor, back pain": "e.g. pelvic floor, back pain",
  "e.g. reminders, welcome emails": "e.g. reminders, welcome emails",
  "e.g. Rest period ending reminder": "e.g. Rest period ending reminder",
  "e.g. SEPA Direct Debit": "e.g. SEPA Direct Debit",
  "e.g. ST01, Center": "e.g. ST01, Center",
  "e.g. Standard": "e.g. Standard",
  "e.g. standard rest period": "e.g. standard rest period",
  "e.g. Standard Week": "e.g. Standard Week",
  "e.g. Standard, Dark, Minimal": "e.g. Standard, Dark, Minimal",
  "e.g. Student priceAdjustment": "e.g. student reduction",
  "e.g. Summer rest period": "e.g. Summer rest period",
  "e.g. Trainer A, Room 1": "e.g. Trainer A, Room 1",
  "e.g. Training Machine 1": "e.g. Training Machine 1",
  "e.g. Trial": "e.g. Trial",
  "e.g. trial (optional)": "e.g. trial",
  "e.g. Trial session": "e.g. Trial session",
  "e.g. Welcome Email": "e.g. Welcome Email",
  "e.g. welcome email": "e.g. welcome email",
  "e.g. xxxx-xxxx-xxxx-xxxx": "e.g. xxxx-xxxx-xxxx-xxxx",
  "Each source must have exactly ONE of either ContractTemplateId OR WalletProductId": "Each source must have exactly ONE of either ContractTemplateId OR WalletProductId",
  "Edit": "Edit",
  "Edit account": "Edit account",
  "Edit appointment": "Edit appointment",
  "Edit appointment duration": "Edit appointment duration",
  "Edit appointment price": "Edit appointment price",
  "Edit appointment notification": "Edit appointment notification",
  "Edit Appointment Outcome": "Edit Appointment Outcome",
  "Edit Appointment Type": "Edit Appointment Type",
  "Edit bank account": "Edit bank account",
  "Edit bank account__alt2": "Edit bank account",
  "Edit bank account__bankverbindung-ändern": "Edit bank account",
  "Edit booking link": "Edit appointment URL",
  "Edit before sending": "Edit before sending",
  "Editing is required when no template is selected.": "Editing before sending is required when no template is selected.",
  "Document is not ready yet.": "The document is not ready yet.",
  "Edit confirmation document": "Edit confirmation",
  "Edit Calendar Role": "Edit Calendar Role",
  "Edit Cancellation Model": "Edit Cancellation Model",
  "Edit Cancellation Reason": "Edit Cancellation Reason",
  "Edit category": "Edit category",
  "Edit check-in settings": "Edit check-in settings",
  "Edit columns": "Edit columns",
  "Edit contracts": "Edit contracts",
  "Edit digital file": "Edit documents",
  "Edit contract": "Edit contract",
  "Edit contract block": "Edit contract block",
  "Edit Contract Template": "Edit contract template",
  "Edit Contract Template__alt1": "Edit Contract Template",
  "Edit Contract Template__alt2": "Edit Contract Template",
  "Edit contribution": "Edit contribution",
  "Edit Debt Collection Agency": "Edit Debt Collection Agency",
  "Edit details": "Edit details",
  "Edit priceAdjustment": "Edit price adjustment",
  "Edit PriceAdjustment": "Edit price adjustment",
  "Edit price adjustment": "Edit price adjustment",
  "Edit email account": "Edit email account",
  "Edit finances": "Edit finances",
  "Edit holiday": "Edit holiday",
  "Edit Holiday": "Edit Holiday",
  "Edit lead": "Edit lead",
  "Edit Lead Source": "Edit Lead Source",
  "Edit leads": "Edit leads",
  "Edit online booking": "Edit online booking",
  "Edit open items": "Edit open items",
  "Agree installment plan": "Agree installment plan",
  "Edit payment": "Edit payment",
  "Edit Payment Cancellation Reason": "Payment reversal reason",
  "Edit Rest Period Reason": "Edit Rest Period Reason",
  "Edit payment method": "Edit payment method",
  "Edit Payment Plan": "Edit Payment Plan",
  "Edit people": "Edit people",
  "Edit person": "Edit person",
  "Edit phase": "Edit phase",
  "Edit pipeline": "Edit pipeline",
  "Edit preset": "Edit preset",
  "Edit reader device": "Edit reader device",
  "Edit Resource": "Edit Resource",
  "Edit rest period": "Edit rest period",
  "Edit Rest Period Template": "Edit Rest Period Template",
  "Edit rest period template": "Edit rest period template",
  "Edit role": "Edit role",
  "Edit rule": "Edit rule",
  "Edit SEPA Group": "Edit SEPA Group",
  "Edit settings": "Edit settings",
  "Edit Studio": "Edit Studio",
  "Edit Template": "Edit Template",
  "Edit templates": "Edit templates",
  "Edit tenant": "Edit tenant",
  "Edit text template": "Edit text template",
  "Edit system email template": "Edit system email template",
  "Edit transitions": "Edit transitions",
  "Edit unavailability": "Edit unavailability",
  "Edit unavailability reason": "Edit unavailability reason",
  "Edit user": "Edit user",
  "Edit VAT setting": "Edit VAT setting",
  "Edit version": "Edit version",
  "Edit wallet": "Edit wallet",
  "Edit Wallet Product": "Template",
  "Edit widget": "Edit widget",
  "Edit zone": "Edit zone",
  "Editor not ready - please reload page": "Editor not ready - please reload page",
  "Email": "Email",
  "Email (optional)": "Email",
  "Email / username": "Email / username",
  "Email / username__alt2": "Email / username",
  "Email account added.": "Email account added.",
  "Email accounts": "Email accounts",
  "Email accounts and system templates (password reset)": "Email accounts and system templates (password reset)",
  "Email address": "Email address",
  "Email address added": "Email address added",
  "Email address or username": "Email address or username",
  "Email and letter can be combined. SMS must be separate.": "Email and letter can be combined. SMS must be separate.",
  "Email Body": "Email Body",
  "Email cannot be removed for the primary account": "Email cannot be removed for the primary account",
  "Email details": "Email details",
  "All time": "All time",
  "Last 7 days": "Last 7 days",
  "Analysis queued": "Analysis queued",
  "Reanalysis failed": "Reanalysis failed",
  "Next automatic attempt": "Next automatic attempt",
  "No further automatic retry is scheduled.": "No further automatic retry is scheduled.",
  "The automatic analysis attempts are exhausted.": "The automatic analysis attempts are exhausted.",
  "Classification": "Classification",
  "Effective request type": "Effective request type",
  "Analysis reason": "Analysis reason",
  "Contract selection reason": "Contract selection reason",
  "Initial notice period": "Initial notice period",
  "Renewal notice period": "Renewal notice period",
  "Uncertainties": "Uncertainties",
  "Selected": "Selected",
  "Selected by analysis": "Selected by analysis",
  "Contract no longer exists": "Contract no longer exists",
  "Unique sender address": "Unique sender address",
  "Analyze again": "Analyze again",
  "The analysis model is not configured.": "The analysis model is not configured.",
  "The analysis result could not be validated.": "The analysis result could not be validated.",
  "The classification could not be created because of an invalid AI response.": "The classification could not be created because of an invalid AI response.",
  "The analysis answer was cut off at the token limit.":
    "The analysis answer was cut off at the token limit.",
  "The analysis model is currently unavailable.": "The analysis model is currently unavailable.",
  "The analysis model did not respond in time.": "The analysis model did not respond in time.",
  "At least one attachment requires manual review.": "At least one attachment requires manual review.",
  "No person could be assigned from the sender address.": "No person could be assigned from the sender address.",
  "No person could be matched to this message.": "No person could be matched to this message.",
  "More than one person matches this message.": "More than one person matches this message.",
  "Person candidates": "Person candidates",
  "No person candidates found.": "No person candidates found.",
  "The sender address belongs to more than one person.": "The sender address belongs to more than one person.",
  "No active contract could be assigned.": "No active contract could be assigned.",
  "The contract selection requires manual review.": "The contract selection requires manual review.",
  "This request requires a manual response.": "This request requires a manual response.",
  "The classification is uncertain.": "The classification is uncertain.",
  "The analysis failed because of a system error.": "The analysis failed because of a system error.",
  "An attachment is too large for automatic analysis.": "An attachment is too large for automatic analysis.",
  "The message is too large for automatic analysis.": "The message is too large for automatic analysis.",
  "The attachment format is not supported.": "The attachment format is not supported.",
  "Text recognition is currently unavailable.": "Text recognition is currently unavailable.",
  "Text recognition of the attachment failed.": "Text recognition of the attachment failed.",
  "No readable text was found in the attachment.": "No readable text was found in the attachment.",
  "The text extracted from the attachment is too large.":
    "The text extracted from the attachment is too large.",
  "The attachment is damaged and could not be read.": "The attachment is damaged and could not be read.",
  "The message requires manual review.": "The message requires manual review.",
  "InboundEmailReanalysisInProgress": "The message is already being analyzed.",
  "InboundEmailReanalysisInvalidState": "The message cannot be analyzed again in its current state.",
  "InboundEmailAccountHasMessages": "The email account cannot be deleted while inbound messages still reference it.",
  "InboundEmailInboxMaintenanceBusy": "The inbox is currently being synchronized or processed. Try deleting it again after processing has finished.",
  "InboundEmailProviderUnavailable": "The IMAP connection could not be established. Please check the credentials and server settings.",
  "InboundEmailAnalysisUnavailable": "No usable model profile is configured for email analysis.",
  "Email has been restored": "Email has been restored",
  "Email is required for the primary account": "Email is required for the primary account",
  "Email is required__alt1": "Email is required",
  "Email is required__alt2": "Email is required",
  "Email sending": "Email sending",
  "Email spooler": "Email spooler",
  "Email subject": "Email subject",
  "Email Subject": "Email Subject",
  "Email template used as signature.": "Email template used as signature.",
  "Email/username": "Email/username",
  "Email/username is required": "Email/username is required",
  "email@example.com": "email@example.com",
  "Embed": "Embed",
  "Embed code": "Embed code",
  "Embed Code for Widget": "Embed Code for Widget",
  "Employee": "Employee",
  "Employee name (without user account)": "Employee name (without user account)",
  "Employee assignable": "Employee assignable",
  "Empty = all studios.": "Empty = all studios.",
  "Empty = all studios. Already assigned studios are disabled.": "Empty = all studios. Each studio can only be assigned once.",
  "Empty = all studios. Multiple selection (e.g. for lead assignment).": "Empty = all studios. Multiple selection (e.g. for lead assignment).",
  "Empty = available for all studios.": "Empty = available for all studios.",
  "Empty = for all studios. Multiple selection – resource is then available in all selected studios (same availability).": "Empty = for all studios. Multiple selection – resource is then available in all selected studios (same availability).",
  "Empty = for all studios. Multiple selection.": "Empty = for all studios. Multiple selection.",
  "Empty = for all studios. Studios without access are disabled.": "Empty = for all studios. Studios without access are disabled.",
  "Empty = not filtered": "Empty = not filtered",
  "Enable automatic updates": "Enable automatic updates",
  "Enable assignment for at least one m1connect reader in reader device settings.": "Enable assignment for at least one m1connect reader in reader device settings.",
  "Enable Dark Mode": "Enable Dark Mode",
  "Enable lead time": "Enable lead time",
  "Email typography": "Email typography",
  "Enabled": "Enabled",
  "End": "End",
  "End (optional)": "End",
  "End date": "End date",
  "End Date": "End Date",
  "End date must be after start date": "End date must be after start date",
  "End date must not be before start date": "End date must not be before start date",
  "End must be after start": "End must be after start",
  "End of half-year only": "End of half-year only",
  "End of month only": "End of month only",
  "End of quarter only": "End of quarter only",
  "End of year only": "End of year only",
  "End time must be after start time": "End time must be after start time",
  "Ended": "Ended",
  "Ending (optional)": "Ending",
  "Ending Balance": "Ending Balance",
  "English": "English",
  "Enrollment Fee": "Enrollment Fee",
  "Enter description...": "Enter description...",
  "Enter name": "Enter name",
  "Enter note...": "Enter note...",
  "Enter password": "Enter password",
  "Enter QR code...": "Enter QR code...",
  "Enter reason...": "Enter reason...",
  "Enter the email address of your account.": "Enter the email address of your account.",
  "Enter this code in m1connect to connect the reader device.": "Enter this code in m1connect to connect the reader device.",
  "Enter title...": "Enter title...",
  "Enter your API key": "API key",
  "LeadImport API key tooltip": "Copy this key into Make.com or n8n as header X-Api-Key. Keep it secret.",
  "LeadImport copy success": "Copied to clipboard.",
  "LeadImport data for automation label": "Data for the API endpoint",
  "LeadImport data for automation tooltip": "Use this URL when calling the API endpoint.",
  "LeadImport default studio placeholder": "No default studio",
  "LeadImport generate key": "Generate",
  "M1member integration functions": "Functions",
  "M1member integration function required": "Select at least one function",
  "M1member integration leads": "Leads",
  "M1member integration calendar": "Calendar",
  "M1member integration appointment types": "Allowed appointment types",
  "M1member integration appointment type required": "Select at least one appointment type",
  "Enter your new password.": "Enter your new password.",
  "Entitlement Sources": "Entitlement Sources",
  "Entitlement sources updated": "Entitlement sources updated",
  "Entries": "entries",
  "Entries (dative)": "entries",
  "entries__alt1": "entries",
  "entries__alt2": "entries",
  "entries__einträge": "entries",
  "entries__einträgen": "entries",
  "Entry created.": "Entry created.",
  "Equipment (Machine)": "Equipment (Machine)",
  "Equipment": "Equipment",
  "Equipment__alt2": "Equipment",
  "Equipment__gerät": "Device",
  "Equipment__geräte": "Equipment",
  "Escalation": "Escalation",
  "Error": "Error",
  "Error booking": "Error booking",
  "(system default)": "(system default)",
  "Error changing password": "Error changing password",
  "Error checking deletion possibility": "Error checking deletion possibility",
  "Error checking status": "Error checking status",
  "Error copying": "Error copying",
  "Error creating account.": "Error creating account.",
  "Error creating direct debit run": "Error creating direct debit run",
  "Error deleting": "Error deleting",
  "Error deleting.": "Error deleting.",
  "Error duplicating": "Error duplicating",
  "Error during cleanup": "Error during cleanup",
  "Error during import": "Error during import",
  "Error fetching folders.": "Error fetching folders.",
  "Error fetching integrations": "Error fetching integrations",
  "Error fetching status": "Error fetching status",
  "Error generating": "Error generating",
  "Error generating code": "Error generating code",
  "Check-in indicators could not be loaded": "Check-in indicators could not be loaded.",
  "E_CheckInIndicatorLimit": "A request may contain at most 100 people.",
  "Error loading": "Error loading",
  "Error loading accounts": "Error loading accounts",
  "Error loading email": "Error loading email",
  "Error loading holidays": "Error loading holidays",
  "Error loading items": "Error loading items",
  "Error loading open items.": "Error loading open items.",
  "Error loading persons": "Error loading persons",
  "Error loading resources": "Error loading resources",
  "Error loading roles": "Error loading roles",
  "Error loading settings": "Error loading settings",
  "Error loading studios": "Error loading studios",
  "Error loading users": "Error loading users",
  "Error loading.": "Error loading.",
  "Error opening": "Error opening",
  "Error opening device": "Error opening device",
  "Error opening imported document": "Error opening imported document",
  "Error opening report": "Error opening report",
  "Error refreshing folders.": "Error refreshing folders.",
  "Error resending.": "Error resending.",
  "Error retrieving balance": "Error retrieving balance",
  "Error saving": "Error saving",
  "Error saving order": "Error saving order",
  "Error saving resources": "Error saving resources",
  "Error sending": "Error sending",
  "Error submitting": "Error submitting",
  "Error testing": "Error testing",
  "Error testing connection": "Error testing connection",
  "Error testing ping": "Error testing ping",
  "Error updating sub-contract": "Error updating sub-contract",
  "Error uploading.": "Error uploading.",
  "Error while changing language:": "Error while changing language:",
  "Error while loading": "Error while loading",
  "Error while saving": "Error while saving",
  "Error while sending": "Error while sending",
  "Errors": "Errors",
  "Events": "Events",
  "every n days": "every n days",
  "every n weeks (weekday)": "every n weeks (weekday)",
  "Example Street 1": "Example Street 1",
  "Example: Step 1.00 + Ending 0.99 results in prices like 9.99 / 10.99 / 11.99 … (depending on mode).": "Example: Step 1.00 + Ending 0.99 results in prices like 9.99 / 10.99 / 11.99 … (depending on mode).",
  "Exception details": "Exception details",
  "Executed": "Executed",
  "Execution": "Execution",
  "Execution date": "Execution date",
  "Actual execution date": "Actual execution date",
  "Execution date is required": "Execution date is required",
  "Execution date must not be in the past": "Execution date must not be in the past",
  "Execution date of direct debit in format DD.MM.YY": "Execution date of direct debit in format DD.MM.YY",
  "Exclude": "Exclude",
  "Exclude from run": "Exclude from run",
  "Include": "Include",
  "Include in run": "Include in run",
  "Excluded": "Excluded",
  "Expense": "Expense",
  "Expenses": "Expenses",
  "expired": "expired",
  "Expiring Contracts": "Expiring Contracts",
  "Export": "Export",
  "Export reports": "Export reports",
  "Export and print reports": "Export and print reports",
  "Export and print reports permission help": "Allows exports and print views for reports the user may view.",
  "Download report and accounting export files.": "Download report and accounting export files.",
  "Export as CSV": "Export as CSV",
  "Export as Excel": "Export as Excel",
  "Export as PDF": "Export as PDF",
  "Export & Import": "Export & Import",
  "Backup & Restore": "Backups",
  "Tools": "Tools",
  "Duplicate finder": "Duplicate finder",
  "Rules & log for leads, auto-communication and other automation": "Rules and log for leads, auto-communication, and other automation",
  "Find and merge duplicate person records": "Find and merge duplicate person records",
  "Fields for comparison": "Fields for comparison",
  "Group": "Group",
  "Records": "Records",
  "Persons affected": "Persons affected",
  "Lenient": "Lenient",
  "Strict": "Strict",
  "Duplicate search": "Duplicate search",
  "Score": "Score",
  "Score threshold": "Score threshold",
  "Minimum checkable criteria": "Minimum checkable criteria",
  "Start scan": "Start scan",
  "Review selected": "Review selected",
  "Merge": "Merge",
  "Merge selected": "Merge selected",
  "Merge into selected master": "Merge into selected master",
  "Merge selected duplicate groups?": "Merge selected duplicate groups?",
  "Merge confirmation text": "{groups} group(s) with {persons} persons will be merged. The oldest person remains as master, empty fields are filled from duplicates.",
  "Merge completed": "Merge completed.",
  "Bank account holder": "Bank account holder",
  "Merge review": "Merge review",
  "Merge assistant": "Merge assistant",
  "No duplicate review job available": "No duplicate review job available.",
  "No duplicate merge job available": "No duplicate merge job available.",
  "Review before merge": "Review before merge",
  "Merge one group at a time": "Merge one group at a time",
  "Duplicate review warning": "The selected merge will be executed directly. Check the master person and field decisions before merging this group.",
  "Duplicate merge assistant warning": "When you confirm this group, it is merged immediately. You can open and correct errors directly in each person beforehand.",
  "Choose master person": "Choose master person",
  "Merge decision": "Merge decision",
  "Apply to same cases": "Apply to same cases",
  "Merge same cases?": "Merge same cases?",
  "{count} groups share the same matching pattern and will all be merged in one step. The suggested master person is kept for each group.": "{count} groups share the same matching pattern and will all be merged in one step. The suggested master person is kept for each group.",
  "{count} groups merged": "{count} groups merged.",
  "Merge all matching groups": "Merge all matching groups",
  "Drag a value into the result column to choose it": "Drag a value into the result column (or click it) to choose it",
  "from {person}": "from {person}",
  "Merge with selected decisions": "Merge with selected decisions",
  "Merge this group now": "Merge this group now",
  "Skip duplicate group": "Skip duplicate group",
  "Field decisions": "Field decisions",
  "Comparison": "Comparison",
  "Conflict": "Conflict",
  "No conflict": "No conflict",
  "Person A": "Person A",
  "Person B": "Person B",
  "Person {index}": "Person {index}",
  "Review finished": "Review finished.",
  "Merge workflow finished": "Merge finished.",
  "Merge group details": "Merge group details",
  "Merge this group": "Merge this group",
  "Criterion": "Criterion",
  "Matched fields": "Matched fields",
  "Suggested master": "Suggested master",
  "Backup downloaded.": "Backup downloaded.",
  "Backup failed.": "Backup failed.",
  "Create backup": "Create backup",
  "Restore from backup": "Restore from backup",
  "Restore completed.": "Restore completed.",
  "Restore failed.": "Restore failed.",
  "Create and restore tenant backup (database + files)": "Manage backups",
  "Adding tenant backup": "Creating backup.",
  "Create tenant backup": "Create backup",
  "Delete backup": "Delete",
  "Delete backup blocked body": "This backup cannot be deleted right now.",
  "Delete backup blocked title": "Cannot delete",
  "Delete backup confirm body": "This backup will be permanently deleted.",
  "Delete backup confirm title": "Delete backup?",
  "Delete tenant backup": "Backup deleted.",
  "Job title TenantBackupCreate": "Backup",
  "Job title TenantBackupRestore": "Restore",
  "Restore backup": "Restore",
  "Tenant backup restore confirm body": "The backup from {0} will be restored.",
  "Tenant backup restore confirm title": "Restore backup?",
  "Tenant backup restore target tenant": "Target tenant",
  "Tenant backup restore cross tenant warning": "The target tenant will be completely overwritten by this backup.",
  "Tenant backup restore no selectable areas": "This backup does not contain any partial backup areas.",
  "Tenant backup restore scope": "Restore scope",
  "Tenant backup restore scope full": "full restore",
  "Tenant backup restore select at least one area": "Select at least one area.",
  "Tenant backups": "Backups",
  "Tenant restore job started": "Restore started.",
  "Tenant backup column created at": "Created",
  "Tenant backup column kind": "Kind",
  "Tenant backup column label": "Label",
  "Tenant backup column schema version": "Schema version",
  "Tenant backup column size": "Size",
  "Tenant backup column status": "Status",
  "Tenant backup kind automated": "automated",
  "Tenant backup kind configuration": "configuration",
  "Tenant backup kind manual": "manual",
  "Tenant backup scope": "Scope",
  "Tenant backup scope configuration": "partial backup",
  "Tenant backup scope full": "full backup",
  "Tenant backup scope reader devices": "reader devices",
  "Tenant backup scope calendar appointments": "calendar and appointments",
  "Tenant backup scope reminder levels": "reminder levels",
  "Tenant backup scope reminders and templates": "reminder levels and document templates only",
  "Tenant backup status creating": "creating",
  "Tenant backup status failed": "failed",
  "Tenant backup status ready": "ready",
  "tenantBackup.job.download": "downloading",
  "tenantBackup.job.export": "creating",
  "tenantBackup.job.verify": "verifying",
  "tenantBackup.job.import": "restoring",
  "tenantBackup.job.databaseDelete": "preparing existing data",
  "tenantBackup.job.databaseImport": "restoring database",
  "tenantBackup.job.files": "restoring files",
  "tenantBackup.job.promote": "publishing files",
  "tenantBackup.job.commit": "finalizing",
  "tenantBackup.job.cleanup": "cleaning up",
  "tenantBackup.job.upload": "saving",
  "sepaDirectDebitRuns.job.prepare": "Preparing posting",
  "sepaDirectDebitRuns.job.createPayments": "Creating payments",
  "sepaDirectDebitRuns.job.savePayments": "Saving payments",
  "sepaDirectDebitRuns.job.refreshCalendar": "Updating contribution calendar",
  "sepaDirectDebitRuns.deleteJob.prepare": "Preparing deletion",
  "sepaDirectDebitRuns.deleteJob.cleanup": "Resetting items and open items",
  "sepaDirectDebitRuns.deleteJob.refreshCalendar": "Updating contribution calendar",
  "sepaDirectDebitRuns.deleteJob.done": "Direct debit run deleted",
  "sepaDirectDebitRuns.deleteJob.systemFailure": "The direct debit run could not be deleted because of a system error. The error has been logged.",
  "sepaDirectDebitRuns.job.done": "Direct debit run posted",
  "Tenant backup restore blocking title": "The backup is being restored…",
  "Tenant backup restore blocking hint": "Please wait until the restore has finished.",
  "Tenant backup restore progress pending": "starting",
  "Cancel job": "Cancel",
  "Job active label": "active",
  "Job running label": "Running …",
  "tenantBackup.activeJobInProgress.modalBody": "A backup or restore is already running. Please wait until it finishes.",
  "tenantBackup.activeJobInProgress.modalTitle": "Backup or restore in progress",
  "Realtime status idle": "Realtime: idle",
  "Realtime status connecting": "Realtime: connecting",
  "Realtime status connected": "Realtime: connected",
  "Realtime status reconnecting": "Realtime: reconnecting",
  "Realtime status closed": "Realtime: closed",
  "Complete PostgreSQL dump and all stored files (all tenants). For disaster recovery.": "Complete PostgreSQL dump and all stored files (all tenants). For disaster recovery.",
  "Export CSV": "Export CSV",
  "Export downloaded.": "Export downloaded.",
  "Export failed": "Export failed",
  "Export failed.": "Export failed.",
  "Export started": "Export started",
  "extends": "extends",
  "Extends contract": "Extends contract",
  "External APIs & integrations (e.g. letter sending)": "External APIs & integrations (e.g. letter sending)",
  "External logo URL (optional)": "External logo URL",
  "failed": "failed",
  "Failed to copy": "Failed to copy",
  "Failed to copy template": "Failed to copy template",
  "Failed to delete": "Failed to delete",
  "Failed to load": "Failed to load",
  "Failed to load content": "Failed to load content",
  "Failed to load preferences": "Failed to load preferences",
  "Failed to load recipients": "Failed to load recipients",
  "Failed to load resources": "Failed to load resources",
  "Failed to load templates": "Failed to load templates",
  "Failed to load users": "Failed to load users",
  "Failed to load.": "Failed to load.",
  "Failed to save": "Failed to save",
  "Failed to send": "Failed to send",
  "Failed": "Failed",
  "Failed__alt2": "Failed",
  "Fee": "Fee",
  "Fee Type": "Fee Type",
  "Female": "Female",
  "Fetch folders": "Fetch folders",
  "File": "File",
  "File name": "File name",
  "File too large (max 200MB)": "File too large (max 200MB)",
  "Filter": "Filter",
  "More filters": "More filters",
  "Filter by resources": "Filter by resources",
  "Sales studio": "Sales studio",
  "Filter by studio": "Filter by studio",
  "Filter by studio(s)": "Filter by studio(s)",
  "Filter by status": "Filter by status",
  "Filter by type": "Filter by type",
  "Finance": "Finance",
  "Finance Reports": "Finance Reports",
  "Finance reports": "Finance reports",
  "Finances": "Finances",
  "first 8 characters of person ID (without hyphens)": "first 8 characters of person ID (without hyphens)",
  "First Check-In": "First check-in",
  "First collection": "First collection",
  "First debit": "First debit",
  "First name": "First name",
  "First name (default)": "First name (default)",
  "First Name": "First Name",
  "first name (sanitized), max. 12 characters": "first name (sanitized), max. 12 characters",
  "First name and last name are required": "First name and last name are required",
  "First name is required": "First name is required",
  "First name Last name": "First name Last name",
  "First name or last name required": "First name or last name required",
  "First name or last name required.": "First name or last name required.",
  "Fix errors": "Error details",
  "SEPA error fix pending exclusion": "Marked for exclusion",
  "SEPA error fix remember": "Remember",
  "SEPA error fixes applied.": "Changes applied.",
  "Discard pending SEPA error fixes?": "Discard pending corrections?",
  "Discard pending SEPA error fixes detail": "Changes that have not been applied will be lost.",
  "Fixed": "Fixed",
  "Fixed amount__alt1": "Fixed amount",
  "Fixed amount__alt2": "Fixed amount",
  "Fixed per installment": "Fixed per installment",
  "Flags": "Flags",
  "Flat fee": "Flat fee",
  "Follow-up": "Follow-up",
  "Font & Style": "Font & Style",
  "Font Family": "Font Family",
  "Font family": "Font family",
  "Line height": "Line height",
  "Line height tooltip": "Multiple of the font size; 1 is single spacing.",
  "Fonts": "Fonts",
  "Custom fonts for letters, emails and templates (this tenant only)": "Custom fonts for letters, emails and templates (this tenant only).",
  "Fonts for all tenants (letters, emails, templates)": "Fonts for all tenants (letters, emails, templates).",
  "FontsSettingsConfirmDelete": "Really delete this font?",
  "FontsSettingsCreatedAt": "Uploaded at",
  "FontsSettingsDeleteError": "Error deleting font",
  "FontsSettingsDeleteSuccess": "Font deleted",
  "FontsSettingsDisplayName": "Display name",
  "FontsSettingsFileName": "File name",
  "FontsSettingsFontFamilyName": "Font family (CSS)",
  "FontsSettingsOnlyTtfOtf": "Only TTF and OTF files are allowed.",
  "FontsSettingsSelectFile": "Select file",
  "FontsSettingsUploadError": "Error uploading",
  "FontsSettingsUploading": "uploading",
  "FontsSettingsUploadFont": "Upload font",
  "FontsSettingsUploadHint": "Upload a TTF or OTF file. The font will then be available in letters, emails and templates.",
  "FontsSettingsUploadSuccess": "Font uploaded",
  "FontsSettingsUploadHintAdmin": "Upload a TTF or OTF file. The font will then be available for all tenants in letters, emails and templates.",
  "FontsSettingsDropHint": "Drag & drop font file(s) here or click",
  "FontsSettingsFilesSelected": "{0} file(s) selected",
  "FontsSettingsUploadSuccessMultiple": "{0} fonts uploaded.",
  "FontsSettingsUploadBackgroundSingle": "Font is being uploaded in the background. In case of errors see Settings → Logs.",
  "FontsSettingsUploadBackgroundMultiple": "{0} fonts are being uploaded in the background. In case of errors see Settings → Logs.",
  "FontsSettingsUploadBackgroundAdminSingle": "Font is being uploaded in the background. In case of errors see Admin → System Logs.",
  "FontsSettingsUploadBackgroundAdminMultiple": "{0} fonts are being uploaded in the background. In case of errors see Admin → System Logs.",
  "FontsSettingsRefreshMetadata": "Update metadata",
  "FontsSettingsRefreshMetadataSuccess": "Display name and font family have been extracted from the font files.",
  "FontsSettingsRefreshMetadataSuccessCount": "{0} font(s) updated.",
  "Footer Text": "Footer Text",
  "For": "For",
  "For members": "For members",
  "For non-members": "For non-members",
  "For direct debits: run date and remittance info for matching on the bank statement": "For direct debits: run date and remittance info for matching on the bank statement",
  "For relative fee (Enrollment Fee), a number > 0 must be entered": "For relative fee (Enrollment Fee), a number > 0 must be entered",
  "For relative fee (Main Contract), a number > 0 must be entered": "For relative fee (Main Contract), a number > 0 must be entered",
  "For relative fee (Proportional Fee), a number > 0 must be entered": "For relative fee (Proportional Fee), a number > 0 must be entered",
  "For SEPA direct debits, e.g. DE98ZZZ…": "For SEPA direct debits, e.g. DE98ZZZ…",
  "Force Delete": "Force Delete",
  "Forgot password?": "Forgot password?",
  "Form of address (formal/informal)": "Form of address (formal/informal)",
  "Form of address is required": "Form of address is required",
  "Formal": "Formal",
  "Former__alt1": "Former",
  "Former__alt2": "Former",
  "free": "free",
  "free at end": "free at end",
  "Free": "Free",
  "Free__alt1": "Free",
  "Fri": "Fri",
  "Friday": "Friday",
  "From": "From",
  "Full name": "Full name",
  "Welcome card name": "Welcome card name",
  "Welcome display name format tooltip": "FirstName = first name only, FullName = first + last name, Email = email address.",
  "From:": "From:",
  "Full cancellation": "Full cancellation",
  "Future": "Future",
  "Future contributions": "Future contributions",
  "Gallery": "Gallery",
  "Gallery layout & icons (per user)": "Gallery layout & icons (per user)",
  "Gateway Address": "Gateway Address",
  "Gateway connection": "Gateway connection",
  "Gateway HTTP timeout (seconds)": "Gateway HTTP timeout (seconds)",
  "Gateway ping interval (minutes)": "Gateway ping interval (minutes)",
  "Gender": "Gender",
  "General": "General",
  "Generate": "Generate",
  "Generating code...": "Generating code...",
  "German": "German",
  "Get balance": "Get balance",
  "Global default (reference)": "Global default (reference)",
  "Go to dashboard": "Go to dashboard",
  "Go to existing lead": "Go to existing lead",
  "Go to person file": "Go to person file",
  "Good day": "Good day",
  "Green": "Green",
  "Group by": "Group by",
  "Group by customer": "Group by customer",
  "Group created.": "Group created.",
  "Group direct debits by person": "Group direct debits by person",
  "Group not available": "Group not available",
  "Group not found": "Group not found",
  "Group saved.": "Group saved.",
  "Grouping": "Grouping",
  "Growth": "Growth",
  "h": "h",
  "Hamburg": "Hamburg",
  "Handle overpayment": "Handle overpayment",
  "Header Text": "Header Text",
  "Hello": "Hello",
  "Hello + first name": "Hello + first name",
  "Hello + Mr./Ms. last name": "Hello + Mr./Ms. last name",
  "Here you define whether SEPA direct debit is used and which pain version is used to generate the XML file.": "Here you define whether SEPA direct debit is used and which pain version is used to generate the XML file.",
  "Here you manage SEPA bank details (tenant account) as well as additional bank accounts and their studio assignment.": "Here you manage SEPA bank details (tenant account) as well as additional bank accounts and their studio assignment.",
  "Hide diagnostics": "Hide diagnostics",
  "Hide": "Hide",
  "Hide__alt2": "Hide",
  "Historical contributions": "Historical contributions",
  "Historical contracts": "Historical contracts",
  "Historical wallets": "Historical wallets",
  "Historical article sales": "Historical article sales",
  "History": "History",
  "History only": "History only",
  "History title": "History title",
  "Holiday added": "Holiday added",
  "Holiday calendar": "Holiday calendar",
  "Holiday configuration duplicated.": "Holiday configuration duplicated.",
  "Holidays all studios scope already exists": "A scope for \"all studios\" already exists.",
  "Holidays studio already in another scope": "One or more selected studios are already assigned in another holiday scope.",
  "Holiday created": "Holiday created",
  "Holiday deleted": "Holiday deleted",
  "Holiday hidden": "Holiday hidden",
  "Holiday shown again": "Holiday shown again",
  "Holiday updated": "Holiday updated",
  "Failed to save holiday": "Failed to save holiday",
  "Holidays": "Holidays",
  "Home studio": "Home studio",
  "Home studio is required": "Home studio is required",
  "Home studio is required.": "Home studio is required.",
  "Home studio only": "Home studio only",
  "Hourly Distribution": "Hourly Distribution",
  "hour": "hour",
  "hours": "hours",
  "Hours": "Hours",
  "How far in advance can appointments be booked? Default: 90 days (approx. 3 months)": "How far in advance can appointments be booked? Default: 90 days (approx. 3 months)",
  "How long the test tab waits for a device ACK before stopping.": "How long the test tab waits for a device ACK before stopping.",
  "How many emails per tenant/studio setup should be sent at most per run.": "How many emails per tenant/studio setup should be sent at most per run.",
  "hrs": "hrs",
  "https://gateway.example.com": "https://m1gateway.mqorva.de",
  "I accept the ": "I accept the ",
  "I am": "I am",
  "IBAN": "IBAN",
  "IBAN (optional)": "IBAN",
  "Icons": "Icons",
  "If an account with this email address exists, a link to reset your password has been sent.": "If an account with this email address exists, a link to reset your password has been sent.",
  "If empty, the code is generated automatically. Appears in URL: /#/lead/{code}": "If empty, the code is generated automatically. Appears in URL: /#/lead/{code}",
  "If enabled, check-in will be blocked for persons with overdue items at this reminder level.": "If enabled, check-in will be blocked for persons with overdue items at this reminder level.",
  "If no duration is defined, no renewal may be defined either.": "If no duration is defined, no renewal may be defined either.",
  "If no studio is selected, the template applies to all studios.": "If no studio is selected, the template applies to all studios.",
  "If set: User gets a confirmation dialog and may create the appointment. If not set: No permission – appointment is refused.": "Allows creating appointments outside stored resource or staff availability.",
  "iFrame Code": "iFrame Code",
  "Image for booking widget header": "Image for booking widget header",
  "Image is too large (max 500KB). Please move closer or use file upload.": "Image is too large (max 500KB). Please move closer or use file upload.",
  "Image": "Image",
  "Image (Booking Widget)": "Image (Booking Widget)",
  "Image removed": "Image removed",
  "Image uploaded": "Image uploaded",
  "Image too large max 1 MB": "Image too large (max 1 MB).",
  "Drag & drop image here or click to upload": "Drag & drop image here or click to upload",
  "IMAP configured": "IMAP configured",
  "IMAP folders refreshed.": "IMAP folders refreshed.",
  "IMAP host": "IMAP host",
  "IMAP test failed.": "IMAP test failed.",
  "IMAP test successful.": "IMAP test successful.",
  "Import bank data": "Import bank data",
  "Import bank data from the German Bundesbank to get started.": "Import bank data from the German Bundesbank to get started.",
  "Import completed.": "Import completed.",
  "Import completed. Paths were adjusted.": "Import completed. Paths were adjusted.",
  "Import diagnostics (metafile conversion)": "Import diagnostics (metafile conversion)",
  "Import failed": "Import failed",
  "Import failed.": "Import failed.",
  "Import from Bundesbank": "Import from Bundesbank",
  "Import holidays": "Import holidays",
  "Import successful": "Import successful",
  "Import": "Import",
  "Import__alt1": "Import",
  "Import__alt2": "Import",
  "Imprint": "Imprint",
  "in": "in",
  "Inactive": "Inactive",
  "Inactive for months": "Inactive for months",
  "Inactive Members": "Inactive Members",
  "Inbox": "Inbox",
  "Open inbox": "Open inbox",
  "No incoming messages": "No incoming messages",
  "Inbox card description": "Incoming messages",
  "Inbox folder": "Inbox folder",
  "Inbox letter dispatch local": "Local (print)",
  "Inbox letter route": "Letter route",
  "Income": "Income",
  "Incoming (IMAP)": "Incoming (IMAP)",
  "Individual persons always have capacity 1": "Individual persons always have capacity 1",
  "Info": "Info",
  "Informal": "Informal",
  "Information": "Information",
  "Desktop downloads": "Download desktop app",
  "Download m1connect": "Download m1connect",
  "Initial": "Initial",
  "Initial balance": "Initial balance",
  "Initial notice": "Initial notice",
  "Initial Notice Period": "Initial Notice Period",
  "Insert variable…": "Insert variable…",
  "Formula part": "Formula/option",
  "Formula part placeholder": "Insert formula or option",
  "No formula at cursor": "No matching formula or option at the cursor",
  "Link text required": "Text for clickable output required",
  "No link at cursor": "No clickable variable at the cursor",
  "Link text could not be changed": "Text for clickable output could not be changed",
  "Formula option link": "as link",
  "Formula option link with text": "Clickable with text \"klick\"",
  "Formula option plus 1 day": "+ 1 day",
  "Formula option plus 3 days": "+ 3 days",
  "Formula option plus 1 week": "+ 1 week",
  "Formula option plus 3 weeks": "+ 3 weeks",
  "Formula option plus 1 month": "+ 1 month",
  "Formula option plus 1 year": "+ 1 year",
  "Formula option minus 1 day": "- 1 day",
  "Formula option minus 1 week": "- 1 week",
  "Formula option minus 1 month": "- 1 month",
  "Formula option minus 10 percent": "- 10%",
  "Formula option plus 10 percent": "+ 10%",
  "Formula option 10 percent of": "10% of",
  "Formula option plus 5": "+ 5",
  "Formula option minus 5": "- 5",
  "Formula option times 2": "* 2",
  "Formula option divided by 2": "/ 2",
  "Main term total amount": "Main term total amount",
  "Paid contract amount": "Paid contract amount",
  "Remaining contract amount": "Remaining contract amount",
  "Installment": "Installment",
  "Installment payments / payment plans": "Installment payments / payment plans",
  "Installment plan": "Installment plan",
  "Installment plan created": "Installment plan created",
  "Installment plans can only be created for open items, not contributions.": "Installment plans can only be created for open items, not contributions.",
  "installments": "installments",
  "Installments": "Installments",
  "Installments__alt1": "Installments",
  "Installments__alt3": "Installments",
  "Integration added": "Integration added",
  "Integration deleted": "Integration deleted",
  "Integration drawer title add": "New integration",
  "Integration drawer title edit": "Integration",
  "Integration Token": "Integration Token",
  "Integration type": "Integration type",
  "Integration type description": "Integration type description",
  "Integration updated": "Integration updated",
  "Integrations": "Integrations",
  "Interval (days)": "Interval (days)",
  "Interval (weeks)": "Interval (weeks)",
  "IBAN is required": "IBAN is required",
  "Invalid balance": "Invalid balance",
  "Invalid BIC": "Invalid BIC",
  "Invalid BIC__alt2": "Invalid BIC",
  "Invalid creditor ID": "Invalid creditor ID",
  "Invalid email": "Invalid email",
  "Invalid format": "Invalid format",
  "Invalid email address.": "Invalid email address.",
  "Invalid file type. Allowed: Images (JPG, PNG, GIF, WEBP), PDF, Text (TXT, CSV), Word (DOC, DOCX)": "Invalid file type. Allowed: Images (JPG, PNG, GIF, WEBP), PDF, Text (TXT, CSV), Word (DOC, DOCX)",
  "Invalid IBAN": "Invalid IBAN",
  "Invalid JSON": "Invalid JSON",
  "Invalid phone number": "Invalid phone number",
  "Invalid range (1-53)": "Invalid range (1-53)",
  "Invalid server response: token missing": "Invalid server response: token missing",
  "Invalid website URL": "Invalid website URL",
  "Items": "Items",
  "Join Date": "Join Date",
  "Keep contributions (no change)": "Keep contributions (no change)",
  "Key": "Key",
  "Key is required": "Key is required",
  "Keyword": "Keyword",
  "Keyword/text contains (any)": "Keyword/text contains (any)",
  "Label (optional)": "Label",
  "Language": "Language",
  "Large": "Large",
  "Last": "Last",
  "Last duration prefix": "last",
  "Last Check-In": "Last check-in",
  "Last checked in": "Last checked in",
  "Last name": "Last Name",
  "Last Name": "Last Name",
  "last name (sanitized), max. 12 characters": "last name (sanitized), max. 12 characters",
  "Last name is required": "Last name is required",
  "Last name, First name": "Last name, First name",
  "Last No-Show": "Last No-Show",
  "Last Run": "Last Run",
  "Last seen": "Last seen",
  "Last Updated": "Last Updated",
  "Last year": "Last year",
  "Lead": "Lead",
  "Lead closed.": "Lead closed.",
  "Lead created.": "Lead created.",
  "Lead deleted.": "Lead deleted.",
  "Lead details": "Lead details",
  "Lead compose requires linked person": "A linked person is required to send from the system.",
  "Lead history by": "by {0}",
  "Studio app module": "Studio app module",
  "Lead on Booking": "Lead on Booking",
  "Create lead on booking (when booking as non-member)": "Create lead when person is unknown",
  "Update person contact from booking": "Update person contact data from booking form",
  "Update person contact from booking (help)": "If off: confirmation and reminders use the form data for this booking only; person is not updated.",
  "Studio (for lead)": "Studio (for lead)",
  "Lead reports": "Lead reports",
  "Reports restrict to own data": "Reports restrict to own data",
  "Restrict reports to the user's assigned studios.": "Restrict reports to the user's assigned studios.",
  "Lead saved.": "Lead saved.",
  "Lead new badge": "New",
  "ICM import": "ICM import",
  "Lead since": "Lead since",
  "Lead source": "Lead source",
  "Lead home studio change warning": "The home studio will be changed to “{0}”. This may change responsibility, pipeline, and visibility. Employees without access to this studio may no longer be able to view or edit the contact.",
  "Lead phase": "Lead phase",
  "Lead source created": "Lead source created",
  "Lead source deleted": "Lead source deleted",
  "Lead source updated": "Lead source updated",
  "Lead times": "Lead times",
  "Lead widgets": "Lead widgets",
  "Lead widget": "Lead widget",
  "Lead-Widgets": "Lead-Widgets",
  "Manage online lead widgets and design presets": "Manage online lead widgets and design presets",
  "Leads": "Leads",
  "Leads & Sales Reports": "Leads & Sales Reports",
  "Leads Only": "Leads Only",
  "Leave empty = auto-generated (server)": "Leave empty = auto-generated (server)",
  "Leave empty for unlimited capacity": "Leave empty for unlimited capacity",
  "Leave empty to use data source": "Leave empty to use data source",
  "Legend": "Legend",
  "Letter": "Letter",
  "Letter (print)": "Letter (print)",
  "Letter sending": "Letter sending",
  "Level": "Level",
  "Liability": "Liability",
  "Light": "Light",
  "Limits": "Limits",
  "Limits/throttle for email sending": "Limits/throttle for email sending",
  "Link": "Link",
  "Link copied to clipboard": "Link copied to clipboard",
  "Link copied!": "Link copied!",
  "Link to booking edit/cancel page": "Link to booking edit/cancel page",
  "Linked User": "Linked User",
  "List": "List",
  "Load failed": "Load failed",
  "Load more": "Load more",
  "Loading calendar…": "Loading calendar…",
  "Loading history...": "Loading history...",
  "Loading items...": "Loading items...",
  "Loading resources and studios…": "Loading resources and studios…",
  "Loading resources…": "Loading resources…",
  "Loading...": "Loading...",
  "Loading…": "Loading…",
  "Loading…__alt2": "Loading…",
  "local": "local",
  "Lock": "Lock",
  "Lock person": "Lock person",
  "locked": "locked",
  "Manually locked": "manually locked",
  "Locked": "Locked",
  "Locked wallets cannot be used.": "Locked wallets cannot be used.",
  "Lock…": "Lock…",
  "Log": "Log",
  "Log call": "Log call",
  "Log contact": "Log contact",
  "Log details": "Log details",
  "Log details copied to clipboard": "Log details copied to clipboard",
  "Current plan": "Current plan",
  "Ends soon": "Ends soon",
  "Payment pending": "Payment pending",
  "Expired": "Expired",
  "No subscription": "No subscription",
  "Net plus VAT": "Net plus VAT",
  "Paid through": "Paid through",
  "Cancelled at period end": "Cancelled at period end",
  "Cancel subscription": "Cancel subscription",
  "No plan selected yet": "No plan selected yet",
  "Choose plan": "Choose plan",
  "Choose Plan": "Choose plan",
  "per studio and year": "per studio and year",
  "per studio and month": "per studio and month",
  "On request": "On request",
  "Request quote": "Request quote",
  "Enterprise inquiry": "Request quote",
  "individual prices": "individual prices",
  "Add address": "Add address",
  "Remove address?": "Remove address?",
  "Use for billing": "Use for billing",
  "Use for shipping": "Use for shipping",
  "Choose this plan": "Choose this plan",
  "Billing details": "Billing details",
  "Billing email": "Billing email",
  "Street and number": "Street and number",
  "Address addition": "Address addition",
  "VAT ID": "VAT ID",
  "Invoices": "Invoices",
  "Invoice number": "Invoice number",
  "Invoice date": "Invoice date",
  "Service period": "Service period",
  "Billing": "Billing",
  "Admin.BillingAndPaymentIntegration": "Plans & payments",
  "Seller data, VAT, payment providers and plan catalog": "Seller data, VAT, payment providers and plan catalog",
  "Plan catalog and payment providers": "Plan catalog and payment providers",
  "Invoice overview, sender data and invoice design": "Invoice overview, sender data and invoice design",
  "Seller and tax": "Seller and tax",
  "Seller data incomplete": "Seller data incomplete",
  "Without complete seller data no invoice can be created": "Without complete seller data no invoice can be created.",
  "Yearly discount percent": "Yearly discount percent",
  "Tax number": "Tax number",
  "Home country": "Home country",
  "Standard VAT rate": "Standard VAT rate",
  "Reverse charge for EU business customers": "Reverse charge for EU business customers",
  "Exempt outside the EU": "Exempt outside the EU",
  "Payment providers": "Payment providers",
  "Publishable key": "Publishable key",
  "Leave empty to keep": "Leave empty to keep",
  "Secret configured": "Secret configured",
  "No secret": "No secret",
  "Webhook configured": "Webhook configured",
  "One-time payments": "One-time payments",
  "Plans": "Plans",
  "Add-ons": "Add-ons",
  "Trial days": "Trial days",
  "Per studio": "Per studio",
  "Archived": "Archived",
  "Included in plans": "Included in plans",
  "Failed to load payment providers": "Payment providers could not be loaded.",
  "Failed to load billing policy": "Billing settings could not be loaded.",
  "Failed to save billing policy": "Billing settings could not be saved.",
  "Invoice design": "Invoice design",
  "Failed to load invoices": "Invoices could not be loaded.",
  "Failed to download invoice": "The invoice could not be downloaded.",
  "No invoices yet": "No invoices yet",
  "Log out": "Log out",
  "Subscription & billing": "Subscription & billing",
  "No invoices available yet": "No invoices available yet",
  "Login": "Login",
  "Web login": "Web login",
  "Online login allowed": "Online login allowed",
  "m1app access": "m1app access",
  "m1app access allowed": "m1app access allowed",
  "(required for m1app access)": "(required for m1app access)",
  "List as staff": "List as staff",
  "No change": "No change",
  "CenterCom only newly imported staff accounts": "Only for newly imported staff accounts",
  "Listed as staff": "Staff member",
  "Login failed": "Login failed",
  "LoginAccountDeactivated": "Account deactivated",
  "LoginFailedGeneric": "Login failed",
  "LoginInvalidCredentials": "Username or password is incorrect.",
  "LoginRateLimited": "Too many failed sign-in attempts. Please try again later.",
  "LoginTenantBackupRestoreInProgress": "A tenant data restore is currently running. Please try again later.",
  "LoginTenantImportInProgress": "A tenant data import is currently running. Please try again later.",
  "LoginTenantDeactivated": "Company is deactivated",
  "LoginTenantNotFound": "Company not found",
  "TenantBackupRestoreInProgress": "A tenant data restore is currently running. Please try again later.",
  "TenantImportCommitInProgress": "A tenant data import is currently running. Please try again later.",
  "E_SUBSCRIPTION_REQUIRED": "The plan has expired. Until it is renewed, everything is read-only.",
  "Logo": "Logo",
  "mQorva logo": "mQorva logo",
  "Logo (optional)": "Logo",
  "Logo removed": "Logo removed",
  "Logo uploaded": "Logo uploaded",
  "Logs": "Logs",
  "Logs & Information": "Logs & Information",
  "logs deleted.": "logs deleted.",
  "Longest Contracts": "Longest Contracts",
  "m1gateway": "m1gateway",
  "m1connect Registration": "m1connect Registration",
  "m1member – Business Console": "m1member – Business Console",
  "From the first contact to daily access.": "From the first contact to daily access.",
  "m1member – Platform administration": "m1member – Platform administration",
  "Mail from your sports club": "Mail from your sports club",
  "Main Contract": "Main Contract",
  "Male": "Male",
  "Manage access reader devices": "Manage access reader devices",
  "Manage and edit leads": "Manage and edit leads",
  "Manage and import global holidays by country & region": "Manage and import global holidays by country & region",
  "Manage appointment types, roles and calendar settings.": "Manage appointment types, roles and calendar settings.",
  "Manage appointments": "Edit appointments",
  "Edit appointments": "Edit appointments",
  "Manage availabilities": "Manage availabilities",
  "Manage background services & view logs": "Manage background services & view logs",
  "Manage email and SMS queue": "System queue for email and SMS delivery (technical)",
  "Manage global bank data & configure automatic updates": "Manage global bank data & configure automatic updates",
  "Manage lead sources": "Manage lead sources",
  "Manage open and overdue dues": "Manage open and overdue dues",
  "Manage payment methods for payments": "Manage payment methods for payments",
  "Manage reader devices": "Manage reader devices",
  "View reader devices": "View reader devices",
  "Manage report & table templates": "Manage report & table templates",
  "Manage roles": "Manage roles",
  "Manage SEPA direct debits": "Manage SEPA direct debits",
  "Manage users": "Manage users",
  "Manage version descriptions and automatic changelog entries": "Manage version descriptions and automatic changelog entries",
  "Mandate date": "Mandate date",
  "Mandate date__alt1": "Mandate date",
  "Mandate date is required": "Mandate date is required",
  "Mandate reference": "Mandate reference",
  "Mandate Reference": "Mandate Reference",
  "Mandate reference (optional)": "Mandate reference",
  "Mandate reference format": "Mandate reference format",
  "Mandate reference is required": "Mandate reference is required",
  "Mandate signed date": "Mandate signed date",
  "Mandate signed date is required": "Mandate signed date is required",
  "Mandate signed on": "Mandate signed on",
  "Manual bank transfers": "Manual bank transfers",
  "Manually cancelled": "Manually cancelled",
  "Manually cancelled (Admin)": "Manually cancelled (Admin)",
  "Manufacturer": "Manufacturer",
  "Mark task as done": "Mark task as done",
  "Marketing": "Marketing",
  "Master data": "Master data",
  "Matched against inbound text/notes/referral name.": "Matched against inbound text/notes/referral name.",
  "Max days in advance": "Max days in advance",
  "Max members": "Max members",
  "Max Mustermann": "Max Mustermann",
  "Max readers": "Max readers",
  "Max studios": "Max studios",
  "Max users": "Max users",
  "Max. 80 characters": "Max. 80 characters",
  "Max. Participants": "Max. Participants",
  "max@…": "max@…",
  "Maximum Capacity (Persons)": "Maximum Capacity (Persons)",
  "Medium ID": "Medium ID",
  "Medium": "Medium",
  "Medium__alt2": "Medium",
  "Member": "Member",
  "Allow usage for": "Allow usage for",
  "Member assignable": "Member assignable",
  "Member management": "Member management",
  "Studio cockpit": "Studio Cockpit",
  "Member Reports": "Member Reports",
  "Member reports": "Member reports",
  "Members": "Members",
  "Members are automatically checked out after this duration.": "Members are automatically checked out after this duration.",
  "Members Only": "Members Only",
  "Membership end date": "Membership end date",
  "Membership end date changed": "Membership end date changed",
  "Membership end date is required": "Membership end date is required",
  "Message": "Message",
  "Log message": "Message",
  "Message__alt2": "Message",
  "Method": "Method",
  "min": "min",
  "Min": "Min",
  "Min. 8 chars, upper/lowercase, digit, special char": "Min. 8 chars, upper/lowercase, digit, special char",
  "Min. Participants": "Min. Participants",
  "Min. time in advance": "Min. time in advance",
  "Min. time in advance (staff)": "Min. time in advance (Staff)",
  "Min. time in advance (online)": "Min. time in advance (Online)",
  "Cancellation deadline (minutes before start)": "Cancellation deadline (minutes before start)",
  "Cancellation deadline (staff)": "Cancellation deadline (Staff)",
  "Cancellation deadline (online)": "Cancellation deadline (Online)",
  "Minimum rest period (unit)": "Minimum rest period (unit)",
  "Minimum rest period (value)": "Minimum rest period (value)",
  "Minimum seconds between batches": "Minimum seconds between batches",
  "Minimum time between batches (seconds)": "Minimum time between batches (seconds)",
  "Minimum time is required": "Minimum time is required",
  "Minimum wait time in seconds between two batches (0-86400). 0 = no limit. Default: 0": "Minimum wait time in seconds between two batches (0-86400). 0 = no limit. Default: 0",
  "minutes": "minutes",
  "No messages": "no messages",
  "No calls": "no calls",
  "Mobile": "Mobile",
  "Mobile (optional)": "Mobile",
  "Mode": "Mode",
  "Modules": "Modules",
  "Mon": "Mon",
  "Monday": "Monday",
  "Month": "Month",
  "Quarter": "Quarter",
  "Monthly": "Monthly",
  "Monthly Churn Rate": "Monthly Churn Rate",
  "Monthly Fee": "Monthly Fee",
  "Monthly flat fee": "Monthly flat fee",
  "Monthly flat fee (optional)": "Monthly flat fee",
  "Monthly flat fee must be >= 0": "Monthly flat fee must be >= 0",
  "Months": "Months",
  "More colors": "More colors",
  "Most Popular Time": "Most Popular Time",
  "Move appointment": "Move appointment",
  "Mr.": "Mr.",
  "Ms.": "Ms.",
  "Multi-select creates a separate template per studio.": "Multi-select creates a separate template per studio.",
  "Multi-select creates the template for multiple studios.": "Multi-select creates the template for multiple studios.",
  "Must be >= 1": "Must be >= 1",
  "Name & QR Code": "Name & QR Code",
  "Name (e.g. Entrance)": "Name (e.g. Entrance)",
  "Name (e.g. Exit)": "Name (e.g. Exit)",
  "Name (from m1connect)": "Name (from m1connect)",
  "Name (optional)": "Name",
  "Name for this configuration": "Name for this configuration",
  "Name format": "Name format",
  "Name is required__alt1": "Name is required",
  "Name is required__alt2": "Name is required",
  "Name required": "Name required",
  "Name/first name…": "Name/first name…",
  "Name/Title": "Name/Title",
  "Name/title": "Name/title",
  "Name/Title is required": "Name/Title is required",
  "Name/title is required": "Name/title is required",
  "Name: The Name field is required": "Name: The Name field is required",
  "Name__alt1": "Name",
  "national": "national",
  "National": "National",
  "nearest": "nearest",
  "Negative": "Negative",
  "Negative = before, 0 = on day, Positive = after": "Negative = before, 0 = on day, Positive = after",
  "Net": "Net",
  "Net Cashflow": "Net Cashflow",
  "Net Growth": "Net Growth",
  "Never Checked In": "Never Checked In",
  "New": "New",
  "new": "new",
  "New admin": "New admin",
  "New appointment": "New appointment",
  "New Appointment Type": "New Appointment Type",
  "New Booking": "New Booking",
  "New Calendar Role": "New Calendar Role",
  "New Cancellation Model": "New Cancellation Model",
  "New Cancellation Reason": "New Cancellation Reason",
  "New category": "New category",
  "New configuration": "New configuration",
  "New Contract Template": "New Contract Template",
  "New debt collection agency": "New debt collection agency",
  "New PriceAdjustment": "New price adjustment",
  "New price adjustment": "New price adjustment",
  "New Group": "New Group",
  "New lead": "New lead",
  "New Lead Source": "New Lead Source",
  "New leads": "New leads",
  "New Members": "New Members",
  "New Members__alt1": "New Members",
  "New password": "New password",
  "New password saved (server) and filled into the field.": "New password saved (server) and filled into the field.",
  "New Payment Cancellation Reason": "New payment reversal reason",
  "New Rest Period Reason": "New Rest Period Reason",
  "New payment method": "New payment method",
  "New Payment Plan": "New Payment Plan",
  "New person": "New person",
  "New pipeline": "New pipeline",
  "New reader device": "New reader device",
  "New reminder": "New reminder",
  "New reminder level": "New reminder level",
  "New Resource": "New Resource",
  "New rest period model": "New rest period model",
  "New rest period template": "New rest period template",
  "New role": "New role",
  "New rule": "New rule",
  "New run": "New run",
  "New Scenario": "New Scenario",
  "New Studio": "New Studio",
  "New Template": "New Template",
  "New template": "New template",
  "New tenant": "New tenant",
  "New unavailability reason": "New unavailability reason",
  "New user": "New user",
  "New zone": "New zone",
  "Next": "Next",
  "Next 30 Days": "Next 30 Days",
  "Next 60 Days": "Next 60 Days",
  "Next 90 Days": "Next 90 Days",
  "Next reminder level": "Next reminder level",
  "Reminder channel": "Channel",
  "Reminder channel suggest failed": "Could not determine the channel.",
  "Reminder level routing at least one rule": "Configure at least one template routing rule.",
  "Reminder level routing templates required": "Select the template for the preferred channel for each rule; with fallback, also set channel and second template completely.",
  "Reminder level routing channels must differ": "Preferred and fallback channel must be different.",
  "Reminder level routing fallback partial": "Fallback channel and template must be set together.",
  "Reminder template routing": "Template routing",
  "Payment methods for rule": "Payment methods",
  "Payment methods for rule tooltip": "Empty means all payment methods not covered by more specific rules.",
  "Payment methods for rule placeholder": "All if empty",
  "Reset reminder level scope hint": "All reminded items in this reminder dispatch will be reset:",
  "Take back reminder fee": "Take back reminder fee",
  "ReminderResetFeeSettled": "The reminder fee has already been settled and can no longer be taken back.",
  "No reminder fee in this dispatch": "No reminder fee was charged for this dispatch.",
  "Delivery failed": "Delivery failed",
  "To dispatch": "To dispatch",
  "Attempts": "Attempts",
  "Document created": "Document created",
  "Delivery retry policy": "Delivery retries",
  "Delivery retry policy description": "Applies to all delivery queues. On a temporary failure the message stays queued and is retried with growing delays.",
  "Delivery max attempts": "Attempts",
  "Delivery retry base minutes": "Base delay (minutes)",
  "Reset reminder level": "Reset reminder level",
  "Reset reminder level confirm": "Reminder level and reminder fee are taken back.",
  "Reminder level reset.": "Reminder level reset.",
  "Reminder level reset status": "reset",
  "ReminderLevelReset": "Reminder level reset",
  "Reminder reasons for rule": "Reminder reasons",
  "Reminder reasons for rule tooltip": "Each reminder reason can belong to only one rule. Empty covers all remaining reasons; for a mixed case, an explicit assignment takes precedence over the empty rule.",
  "Reminder reasons for rule placeholder": "All remaining if empty",
  "All remaining reminder reasons": "All remaining reminder reasons",
  "Reminder routing only one fallback rule": "Only one routing rule may have empty reminder reasons.",
  "Reminder routing reason only once": "Each reminder reason may belong to only one routing rule.",
  "ReminderRoutingFallbackDuplicate": "Only one routing rule may have empty reminder reasons.",
  "ReminderRoutingReasonDuplicate": "Each reminder reason may belong to only one routing rule.",
  "All reminder reasons": "All reminder reasons",
  "Routing rule priority hint": "Explicit reminder reasons take precedence over the empty rule. If multiple explicit rules match a mixed case, their order decides.",
  "Regular open item": "Regular open item",
  "Legacy reminder routing conversion required": "This reminder level still filters by payment method. Assign its rules to reminder reasons and save the reminder level.",
  "Reminder reason": "Reminder reason",
  "Regular open amount": "Regular open amount",
  "Chargeback open amount": "Open chargeback amount",
  "Chargeback fee open amount": "Open chargeback fees",
  "Preferred channel": "Preferred channel",
  "Fallback channel": "Fallback channel",
  "Reminder template": "Reminder template",
  "Reminder template required": "Please select a reminder template.",
  "Remove routing rule": "Remove rule",
  "Add routing rule": "Add rule",
  "Reminder template routing inkasso hint": "This level first sends a regular reminder; the debt collection handover follows only after the payment deadline. Template and channel apply to that regular reminder.",
  "Reminder escalation after this level": "After this reminder level",
  "Templates for debt collection handover": "Templates for debt collection handover",
  "Debt collection template handover": "Handover letter template",
  "Debt collection template payment notice": "Payment notification template",
  "Debt collection template cancellation notice": "Cancellation notification template",
  "Debt collection handover letter template": "Handover letter template",
  "Debt collection handover letter hint": "The handover letter goes to the debt collection agency, not to the member.",
  "Debt collection transmissions": "Notifications to the agency",
  "Debt collection transmission kind submission": "Handover",
  "Debt collection transmission kind payment": "Payment notification",
  "Debt collection transmission kind cancellation": "Cancellation notification",
  "Debt collection transmission status pending": "Pending",
  "Debt collection transmission status sent": "Sent",
  "Debt collection transmission status failed": "Failed",
  "Debt collection transmission status manual": "To be sent manually",
  "Debt collection transmission resend": "Resend",
  "Debt collection transmission none": "No notification recorded for this case.",
  "Comment (optional)": "Comment (optional)",
  "Reminder block action": "Reminder block",
  "Reminder block set": "Reminder block set",
  "Reminder block released": "Reminder block released",
  "Reminder blocked tag": "Reminders paused",
  "Reminder blocked until": "Paused until",
  "Manage reminder block": "Manage reminder block",
  "Set reminder block": "Set reminder block",
  "Release reminder block": "Release reminder block",
  "Active reminder blocks": "Existing reminder blocks",
  "Reminder block saved.": "Reminder block saved.",
  "Reminder block released.": "Reminder block released.",
  "Reminder block person wide": "Pause for the whole person",
  "Reminder block person wide tooltip": "Pauses reminders for all contracts of this person, not only the selected ones.",
  "Reminder block limited": "Limited",
  "Reminder block until required": "Please choose a date until when reminders are paused.",
  "Reminder block unlimited": "Unlimited",
  "Reminder block expired": "Expired",
  "Reminder block scope": "Scope",
  "Reminder block scope persons": "{0} persons",
  "Reminder block reason placeholder": "e.g. instalment plan agreed",
  "Reminder block keeps cases listed": "Paused cases stay in the due list and remain visible — they are simply not reminded.",
  "Reminder block without contract hint": "This selection has no contract reference — reminders are paused for the whole person.",
  "Reminder block mixed scope hint": "Items without a contract reference in this selection are paused person-wide.",
  "ReminderBlocked": "Reminders are paused for this case.",
  "ReminderBlockContractMismatch": "The contract does not belong to this person.",
  "Reminder escalation none": "No further reminder level",
  "Reminder escalation completed tag": "Escalation completed",
  "Reminder escalation none hint": "No further reminder is sent after this level. The open items stay in the due list, marked as escalation completed.",
  "Reminder escalation none skips existing level": "Level {0} ({1}) exists but is not used for this studio scope.",
  "Reminder escalation follow level": "Further reminder level",
  "Reminder escalation derived next level": "Automatically followed by level",
  "Reminder escalation derived no next level": "No further level follows — escalation ends here. The open items stay in the due list, marked as escalation completed.",
  "Reminder escalation inkasso": "Debt collection",
  "Reminder escalation inkasso agency": "Debt collection agency",
  "Reminder escalation select agency required": "Please select a debt collection agency.",
  "ReminderLevelEscalationModeInvalid": "Unknown escalation option for this reminder level.",
  "ReminderLevelDebtCollectionAgencyRequired": "A debt collection agency is required for the handover.",
  "Fallback channel optional placeholder": "optional",
  "OnlineBrief24 integration": "OnlineBrief24",
  "Text template channel label": "{0}",
  "Reminder level number": "Level number",
  "Reminder level number required": "Level number is required.",
  "Reminder level number min": "Level number must be at least 1.",
  "Payment deadline days": "Payment deadline (days)",
  "no": "no",
  "No": "No",
  "No access media": "No access media",
  "No access – You have read-only or no access to this studio.": "No access – You have read-only or no access to this studio.",
  "No active SEPA group available. Please create a SEPA group.": "No active SEPA group available. Please create a SEPA group.",
  "No assignment reader configured": "No assignment reader configured",
  "No appointments available": "No appointments available",
  "No slot available": "No slot available",
  "No slot available for this week. Try another week.": "No slot available for this week. Try another week.",
  "Next week": "Next week",
  "Previous week": "Previous week",
  "Selected slot": "Selected slot",
  "No assignment": "No assignment",
  "No bank data available": "No bank data available",
  "No camera found.": "No camera found.",
  "No cancellation reasons available. Please create some in settings.": "No cancellation reasons available. Please create some in settings.",
  "No chargeback": "No chargeback",
  "No chip detected. Please present the chip to the reader again.": "No chip detected. Please present the chip to the reader again.",
  "No column settings available": "No column settings available",
  "No content to export": "No content to export",
  "No content.": "No content.",
  "No contract blocks in package.": "No contract blocks in package.",
  "No contract blocks in this package.": "No contract blocks in this package.",
  "No contributions found for selected months.": "No contributions found for selected months.",
  "No editable holidays in this scope.": "No editable holidays in this scope.",
  "No email address on file.": "No email address on file.",
  "No entries yet.": "No entries yet.",
  "No events yet.": "No events yet.",
  "no ext.": "no ext.",
  "No fee": "No fee",
  "No flags available": "No flags available",
  "No groups available": "No groups available",
  "No history available.": "No history available.",
  "No notes yet": "No notes yet",
  "No holidays for this location yet. Global holidays are managed in the Admin area.": "No holidays for this location yet. Global holidays are managed in the Admin area.",
  "Holidays list empty hint": "Country and state above define the holiday calendar. Custom holidays are optional – you can add some if needed.",
  "No image": "No image",
  "No items found": "No items found",
  "No letter sending integration configured. Please configure an integration in settings.": "No letter sending integration configured. Please configure an integration in settings.",
  "No logs to copy": "No logs to copy",
  "No matches": "No matches",
  "No next phase configured (end phase).": "No next phase configured (end phase).",
  "No one checked in yet.": "No one checked in yet.",
  "No open items found for installment plan.": "No open items found for installment plan.",
  "No open items found for installment plan. Installments are only available for open items (not contributions).": "No open items found for installment plan. Installments are only available for open items (not contributions).",
  "No open items found.": "No open items found.",
  "No password to copy.": "No password to copy.",
  "No payments": "No payments",
  "No permission": "No permission",
  "PermissionDenied": "No permission",
  "InvoiceLogoFileRequired": "Please choose an image file",
  "InvoiceLogoNotFound": "No logo has been set",
  "InvoiceLogoSizeInvalid": "The logo may not exceed 5 MB",
  "InvoiceLogoFormatInvalid": "Allowed logo formats are PNG, JPEG, and WebP",
  "InvoiceLogoKeyInvalid": "The logo changed in the meantime; please reload the page",
  "InvoiceDesignInvalid": "The invoice design contains invalid values",
  "InvoicePreviewInvalid": "The preview is missing invoice sender details",
  "PriceAdjustmentManualFieldsRequired": "Manual price adjustment requires name, type, value, and cycle",
  "IntegrationTypeRequired": "IntegrationType is required",
  "DisplayNameRequired": "Display name is required",
  "DisplayNameMaxLength": "Display name may have at most 255 characters",
  "BaseUrlMaxLength": "Base URL may have at most 500 characters",
  "UnknownIntegrationType": "Unknown IntegrationType",
  "IntegrationTypeNotAllowed": "This integration type is not enabled for the tenant",
  "IntegrationConfigInvalid": "The configuration is invalid. Please check all fields",
  "InvalidCapability": "Invalid capability",
  "CapabilityDisabled": "This module is not enabled. Existing data can still be viewed but not changed.",
  "BalanceRetrievalFailed": "Balance could not be retrieved",
  "Request entity too large": "The file is too large (upload limit). Please use a smaller file or increase the server/proxy limit (e.g. nginx client_max_body_size).",
  "Server returned error page": "The server returned an error page. Please try again later.",
  "PersonHasNoEmail": "The document was created and filed, but could not be delivered by email: the person has no email address.",
  "StudioAccessDenied": "No access to the selected studio.",
  "AdminOnly": "Administrators only.",
  "No permission (CompanyAdmin)": "No permission (CompanyAdmin)",
  "No permission to book outside availability.": "No permission to book appointments outside availability.",
  "No permission to create appointments.": "No permission to create appointments.",
  "No permission to book over capacity.": "No permission to book appointments despite overlap or insufficient capacity.",
  "No permissions": "No permissions",
  "No permissions available": "No permissions available",
  "No person selected.": "No person selected.",
  "No phases yet. Click „Add phase“.": "No phases yet. Click „Add phase“.",
  "No pipelines yet.": "No pipelines yet.",
  "Document file not found.": "Document file not found.",
  "Document preview could not be loaded.": "Document preview could not be loaded.",
  "No preview available for this file type.": "No preview available for this file type.",
  "PDF preview could not be loaded.": "PDF preview could not be loaded.",
  "PDF reset zoom": "Reset PDF zoom",
  "PDF optimal zoom": "fit",
  "PDF zoom in": "Zoom PDF in",
  "PDF zoom out": "Zoom PDF out",
  "Preview reset zoom": "Reset preview zoom",
  "Preview zoom in": "Zoom preview in",
  "Preview zoom out": "Zoom preview out",
  "No protocol for this automation type": "No protocol for this automation type.",
  "No recipients added. Click 'Add person' or 'Add email address'.": "No recipients added. Click 'Add person' or 'Add email address'.",
  "No recipients found": "No recipients found",
  "No resource available": "No resource available",
  "No resource is available at this time (or no availability entered). Create appointment anyway?": "No resource is available at this time (or no availability entered). Create appointment anyway?",
  "No resource is available at this time.": "No resource is available at this time.",
  "No resources are set up or no availability has been entered. Create appointment anyway?": "No resources are set up or no availability has been entered. Create appointment anyway?",
  "No resources available.": "No resources available.",
  "No resources available. Please create resources in settings.": "No resources available. Please create resources in settings.",
  "No resources created": "No resources created",
  "No resources in calendar": "No resources in calendar",
  "No response from server": "No response from server",
  "No results.": "No results.",
  "No selection = for all studios": "No selection = for all studios",
  "No slots": "No slots",
  "No slots defined yet": "No slots defined yet",
  "No sub-contracts": "No sub-contracts",
  "No sub-devices synced yet": "No sub-devices synced yet",
  "No default template selected": "No default template selected",
  "No templates available": "No templates available",
  "No valid link. Please request a new reset link.": "No valid link. Please request a new reset link.",
  "No-show": "No-show",
  "No-Show Count": "No-Show Count",
  "No-Show Rate": "No-Show Rate",
  "None (global settings)": "None (global settings)",
  "None__alt1": "None",
  "None__alt2": "None",
  "not allowed": "not allowed",
  "Not available": "Not available",
  "Not Found": "Not Found",
  "This booking code does not exist.": "This booking code does not exist.",
  "Booking form unavailable title": "Appointment booking unavailable",
  "Booking widget: week from": "Week of",
  "Booking widget: date range separator": " to ",
  "Booking form unavailable message": "This booking form is unavailable. Please contact the sports club directly.",
  "Booking form load failed title": "Appointment booking could not be loaded",
  "Booking form load failed message": "Please reload the form.",
  "Not found": "Not found",
  "Not implemented yet": "Not implemented yet",
  "Not interested": "Not interested",
  "Not reached": "Not reached",
  "Not required (registered)": "Not required (registered)",
  "Not set": "Not set",
  "not set": "not set",
  "Note (optional)": "Note",
  "Contract package note": "Contract package note",
  "Contract package note (optional)": "Contract package note",
  "Note: At least one embedded image could not be converted server-side to a browser-friendly format (e.g. EMF/WMF).": "Note: At least one embedded image could not be converted server-side to a browser-friendly format (e.g. EMF/WMF).",
  "Note: You can set a monthly fee and/or weekly dues. If both are empty, the rest period is free.": "Note: You can set a monthly fee and/or weekly dues. If both are empty, the rest period is free.",
  "Note": "Note",
  "Note__alt1": "Note",
  "Notes__alt1": "Notes",
  "Notifications": "Notifications",
  "Appointment notification template": "Appointment notification template",
  "Nth weekday of month (e.g. 1st Monday)": "Nth weekday of month (e.g. 1st Monday)",
  "Number format (Locale)": "Number format (Locale)",
  "Number must be > 0": "Number must be > 0",
  "Number of contracts for multiple transactions": "Number of contracts for multiple transactions",
  "Number of contributions": "Number of contributions",
  "Number of dues (optional)": "Number of dues",
  "Number of dues must be >= 0": "Number of dues must be >= 0",
  "Number of emails sent per batch (1-500). Default: 10": "Number of emails sent per batch (1-500). Default: 10",
  "Number of fees": "Number of fees",
  "Number of fees is required": "Number of fees is required",
  "Number of installments": "Number of installments",
  "Number of installments__alt2": "Number of installments",
  "Number of recipients": "Number of recipients",
  "Number of weekly dues (optional)": "Number of weekly dues",
  "of": "of",
  "of month": "of month",
  "in month": "in month",
  "of month__alt2": "of month",
  "Offline": "Offline",
  "Offset (days)": "Offset (days)",
  "OK": "OK",
  "Oldest Entry": "Oldest Entry",
  "Once": "Once",
  "One or more selected studios are already in another entry. Each studio may only have one entry. Please choose different studios or edit the existing entry.": "One or more selected studios are already in another entry. Each studio may only have one entry. Please choose different studios or edit the existing entry.",
  "One or more studios are already assigned in another entry.": "One or more studios are already assigned in another entry.",
  "One-time": "One-time",
  "Online": "Online",
  "Online booking created": "Online booking created",
  "Online booking deleted": "Online booking deleted",
  "Online booking saved": "Online booking saved",
  "Online bookings": "Online bookings",
  "Online lead": "Online lead",
  "Online leads": "Online leads",
  "Preset name": "Preset name",
  "Reader device status offline": "offline",
  "Reader device status online": "online",
  "Online login cannot be disabled for the primary account": "Online login cannot be disabled for the primary account",
  "Online payments via PayPal": "Online payments via PayPal",
  "Only add history entry (no status/phase change)": "Only add history entry (no status/phase change)",
  "Only company administrators can edit priceAdjustments.": "Only company administrators can edit price adjustments.",
  "Only company administrators can edit price adjustments.": "Only company administrators can edit price adjustments.",
  "Only company administrators can edit payment plans.": "Only company administrators can edit payment plans.",
  "Only CompanyAdmin can edit categories.": "Only CompanyAdmin can edit categories.",
  "Only CompanyAdmin can edit payment methods.": "Only CompanyAdmin can edit payment methods.",
  "Only CompanyAdmin can edit rest period templates.": "Only CompanyAdmin can edit rest period templates.",
  "Only lowercase letters, digits and hyphens": "Only lowercase letters, digits and hyphens",
  "Only one source allowed": "Only one source allowed",
  "Only these appointment types are bookable in this online booking.": "Only these appointment types are bookable in this online booking.",
  "open": "open",
  "Open amount": "Open amount",
  "Open Contributions": "Open Contributions",
  "Open Design Editor": "Open Design Editor",
  "Open details": "Open details",
  "Open appointment": "Open appointment",
  "Open door": "Open door",
  "Open in person management": "Open in person management",
  "Open item": "Open item",
  "Open items": "Open items",
  "Open Items": "Open items",
  "Open items (overdue)": "Open items (overdue)",
  "Open items payment multiple persons": "Only items for one person can be paid at a time. Please adjust the selection.",
  "Open items payment no payable rows in selection": "None of the selected items can be used for a payment (e.g. already in a SEPA run or not open).",
  "Open items payment requires flat list": "Recording a payment is only available when customer grouping is turned off.",
  "Open items payment select payable rows first": "Please select at least one payable open item in the list.",
  "Open items debt collection marker column": "Debt collection",
  "Open items in debt collection filter": "in debt collection",
  "Open items reminder level status": "Reminder level",
  "Open items column paid": "Paid",
  "Open items column open": "Open",
  "Open person file": "Open person file",
  "Open test: max wait time (seconds)": "Open test: max wait time (seconds)",
  "Open test: polling interval (ms)": "Open test: polling interval (ms)",
  "Open": "Open",
  "Open (status)": "Open",
  "Open item status debt collected": "In debt collection",
  "Open item status open": "Open",
  "Open item status paid": "Paid",
  "Open item status cancelled": "Cancelled",
  "openItems.cancel.button": "Cancel item",
  "openItems.cancel.title": "Cancel item",
  "openItems.cancel.confirm": "Cancel",
  "openItems.cancel.reasonLabel": "Cancellation reason",
  "openItems.cancel.hintPaid": "Since this item has already been paid, the cancellation amount will be credited to the wallet.",
  "openItems.cancel.hintOpen": "The open item and any related charges will be set to cancelled.",
  "openItems.cancel.successWithWallet": "Cancellation posted. {0} credited to wallet.",
  "openItems.cancel.successWithoutWallet": "Cancellation posted.",
  "openItems.cancel.error": "Cancellation failed: {0}",
  "Contribution calendar status pending": "Pending",
  "Contribution calendar status due": "Due",
  "Contribution calendar status overdue": "Overdue",
  "Contribution calendar status reserved": "Reserved",
  "Contribution calendar status debt collection": "In debt collection",
  "Payment method sepa": "SEPA direct debit",
  "Payment method transfer": "Bank transfer",
  "Payment method cash": "Cash",
  "Payment method card": "Card",
  "Payment method voucher": "Voucher",
  "Payment method paypal": "PayPal",
  "Payment method debt collection": "Debt collection",
  "Payment method standing order": "Standing order",
  "Payment method other": "Other",
  "Open__alt1": "Open",
  "Optional": "Optional",
  "optional": "optional",
  "Optional description": "Optional description",
  "Optional note or description for the document": "Optional note or description for the document",
  "Optional properties of this payment method": "Optional properties of this payment method",
  "Optional, e.g. „Automation: Inactive“": "Optional, e.g. „Automation: Inactive“",
  "Optional: Amount per month during the rest period. If flat fee and number of dues are empty, the rest period is free.": "Optional: Amount per month during the rest period. If flat fee and number of dues are empty, the rest period is free.",
  "Optional: Cancellation model used as default for this contract package.": "Optional: Cancellation model used as default for this contract package.",
  "Optional: Custom name (e.g. 'Entrance'). If empty, 'QR1' will be used.": "Optional: Custom name (e.g. 'Entrance'). If empty, 'QR1' will be used.",
  "Optional: Custom name (e.g. 'Exit'). If empty, 'QR2' will be used.": "Optional: Custom name (e.g. 'Exit'). If empty, 'QR2' will be used.",
  "Optional: English description": "Optional: English description",
  "Optional: Link a user from the system": "Optional: Link a user from the system",
  "Optional: Number of dues during the rest period. If flat fee and number of dues are empty, the rest period is free.": "Optional: Number of dues during the rest period. If flat fee and number of dues are empty, the rest period is free.",
  "Optional: Reference or note": "Optional: Reference or note",
  "Options": "Options",
  "Orange": "Orange",
  "Order": "Order",
  "Order saved": "Order saved",
  "Organization & Users": "Organization & Users",
  "Other__alt1": "Other",
  "Other__alt2": "Other",
  "Other payment methods": "Other payment methods",
  "Outbox": "Outbox",
  "Outbound tab system queue": "System queue",
  "Outcome": "Outcome",
  "Overdue": "Overdue",
  "Overdue Amount": "Overdue Amount",
  "Overdue Items": "Overdue Items",
  "overdue only": "overdue only",
  "Open items search placeholder": "Search person or description…",
  "Overdue open items (subject to reminders)": "Overdue open items (subject to reminders)",
  "Overlap or insufficient availability": "Overlap or insufficient availability",
  "Overview": "Overview",
  "Overwrite": "Overwrite",
  "Package": "Package",
  "Paid": "Paid",
  "Paid (status)": "paid",
  "Paid__alt1": "Paid",
  "pain version": "pain version",
  "pain version (XML)": "pain version (XML)",
  "pain version required": "pain version required",
  "Partial cancellation": "Partial cancellation",
  "Partial cancellation is not yet supported. Full cancellation will be performed.": "Partial cancellation is not yet supported. Full cancellation will be performed.",
  "Partially paid": "Partially paid",
  "Participants": "Participants",
  "Password": "Password",
  "Password (optional)": "Password",
  "Password changed": "Password changed",
  "Password copied to clipboard.": "Password copied to clipboard.",
  "Password is required": "Password is required",
  "Password remains unchanged (leave empty)": "Password remains unchanged (leave empty)",
  "Password reset": "Password reset",
  "OTP login": "OTP login",
  "OTP code (6 digits)": "OTP code (6 digits)",
  "Password too short (min. 8)": "Password too short (min. 8)",
  "Password will be cleared when saving.": "Password will be cleared when saving.",
  "Passwords": "Passwords",
  "Passwords do not match": "Passwords do not match",
  "Path": "Path",
  "Pattern": "Pattern",
  "Pattern for mandate references (e.g. MU-{LN12}-{ID8}).": "Pattern for mandate references (e.g. MU-{LN12}-{ID8}).",
  "Pattern is required": "Pattern is required",
  "Paused": "Paused",
  "Pay contributions": "Pay contributions",
  "Payment": "Payment",
  "Payment amount": "Payment amount",
  "Payment cancellation reason created": "Payment cancellation reason created",
  "Payment cancellation reason deleted": "Payment cancellation reason deleted",
  "Payment cancellation reason updated": "Payment cancellation reason updated",
  "Payment cancellation reasons": "Payment cancellation reasons",
  "Payment cancelled.": "Payment cancelled.",
  "Payment cycle": "Payment cycle",
  "Payment cycle is missing for the primary tariff block.": "Payment cycle is missing for the primary tariff block.",
  "Payment date": "Payment date",
  "Payment date is required": "Payment date is required",
  "Payment date must not be in the future": "Payment date must not be in the future",
  "Payment cancellation date": "Cancellation date",
  "Payment cancellation date is required": "Cancellation date is required",
  "Payment cancellation date must not be in the future": "Cancellation date must not be in the future",
  "Booking date must not be in the future": "Actual execution date must not be in the future",
  "Actual execution date must not be in the future": "Actual execution date must not be in the future",
  "Payment Deadline (Days)": "Payment Deadline (Days)",
  "Payment for multiple contributions": "Pay multiple contributions",
  "Payment method": "Payment method",
  "Payment Method": "Payment Method",
  "Payment method deleted.": "Payment method deleted.",
  "Payment method for overpayment": "Payment method for overpayment",
  "Payment method is required": "Payment method is required",
  "Payment method type is required": "Payment method type is required",
  "Payment method saved.": "Payment method saved.",
  "Payment method drawer info title": "Edit payment method",
  "Payment method drawer info description": "Set a name and assign the matching payment method type (SEPA, Cash, Card, etc.). Only one definition per type is allowed.",
  "Payment methods can no longer be created manually.": "Payment methods can no longer be created manually.",
  "payment paused": "payment paused",
  "Payment plan": "Payment plan",
  "Payment plan not found": "Payment plan not found",
  "Payment plans": "Payment plans",
  "Payment recorded.": "Payment recorded.",
  "Payment saved.": "Payment saved.",
  "Payment type": "Payment type",
  "Payment(s) recorded.": "Payment(s) recorded.",
  "Payment amount must not exceed the outstanding amount.": "The payment amount must not exceed the outstanding amount.",
  "The payment amount could not be fully allocated. Select more items or transfer the overpayment to a credit wallet.": "The payment amount could not be fully allocated. Select more items or transfer the overpayment to a credit wallet.",
  "Payments": "Payments",
  "Payments & Billing": "Payments & Billing",
  "Payments recorded.": "Payments recorded.",
  "PayPal": "PayPal",
  "Pay…": "Pay…",
  "PDF (compact)": "PDF (compact)",
  "PDF (detailed)": "PDF (detailed)",
  "Peak Day": "Peak Day",
  "Peak Hour": "Peak Hour",
  "Peak Time": "Peak Time",
  "Peak Times (Weekday × Hour)": "Peak Times (Weekday × Hour)",
  "Pending": "Pending",
  "pending": "pending",
  "People": "People",
  "Person deleted.": "Person deleted.",
  "per day": "per day",
  "per month": "per month",
  "Per studio, exactly one default template can be set per channel.": "Per studio, exactly one default template can be set per channel.",
  "per week": "per week",
  "per year": "per year",
  "Percent": "Percent",
  "Percent of total": "Percent of total",
  "Percentage priceAdjustment cannot exceed 100%": "Percentage reduction cannot exceed 100%",
  "Percentage reduction cannot exceed 100%": "Percentage reduction cannot exceed 100%",
  "Percentage": "Percentage",
  "Public (online)": "Public (online)",
  "Internal (at the counter)": "Internal (at the counter)",
  "Both": "Both",
  "Delivery": "Delivery",
  "No signing profile is enabled for internal use.": "No signing profile is enabled for internal use.",
  "Set a profile's channel to internal or both in the settings.": "Set a profile's channel to internal or both in the settings.",
  "I want to start training before the withdrawal period ends and understand that my right of withdrawal expires once the service has been fully provided.": "I want to start training before the withdrawal period ends and understand that my right of withdrawal expires once the service has been fully provided.",
  "Please agree to starting before the withdrawal period ends.": "Please agree to starting before the withdrawal period ends.",
  "Withdrawal period until": "Withdrawal period until",
  "Offer as tariff feature when signing": "Offer as tariff feature when signing",
  "Proof required": "Proof required",
  "Proof validity (months)": "Proof validity (months)",
  "Proof validity is required": "Please provide a validity period, otherwise no follow-up is created",
  "Tariff features": "Tariff features",
  "A tariff feature is a permanent tariff based on a personal attribute — not a time-limited promotion.": "A tariff feature is a permanent tariff based on a personal attribute — not a time-limited promotion.",
  "Right of withdrawal": "Right of withdrawal",
  "Withdrawal policy": "Withdrawal policy",
  "Sample withdrawal form": "Sample withdrawal form",
  "Required for public online signing. Place it in the contract document template where it should appear.": "Required for public online signing. Place it in the contract document template where it should appear.",
  "Close contract (new)": "Close contract",
  "New signing engine — runs in parallel with the existing wizard": "Experience form for contract closing",
  "Sales promotions permission help": "Create and maintain sales promotions. They are assigned to an offer in the signing forms.",
  "Option groups permission help": "Create and maintain additional offers (add-ons and bundles).",
  "Tariff feature proofs": "Tariff feature proofs",
  "Proofs that expired or expire soon": "Proofs that expired or expire soon",
  "Expiring soon": "Expiring soon",
  "Sales promotion": "Sales promotion",
  "Offer": "Offer",
  "Add offer": "Add offer",
  "An offer combines a contract package with an optional promotion and add-on options. The same package can appear several times with different promotions.": "An offer combines a contract package with an optional promotion and additional offers. The same package can appear several times with different promotions.",
  "Sales promotions": "Sales promotions",
  "Sales models": "Sales models",
  "Sales model": "Sales model",
  "Sales model term": "Sales model term",
  "Sales models permission help": "Allows viewing or editing regular term and price variants of contract packages.",
  "Select sales model": "Select sales model",
  "Select at least one sales model": "Select at least one sales model",
  "Base package": "Base package",
  "Specific service bundle": "Specific service bundle",
  "Entire selection": "Entire selection",
  "Regular term and price variants of a contract package": "Regular term and price variants of a contract package",
  "New sales model": "New sales model",
  "Create sales model": "Create sales model",
  "Edit sales model": "Edit sales model",
  "Delete sales model": "Delete sales model",
  "Sellability": "Sellability",
  "Sellable": "sellable",
  "Sales model has conflicts": "Sales model has conflicts",
  "Contract signing: selection": "Review selection",
  "Sales model conflict: modelInactive": "The sales model is inactive.",
  "Sales model conflict: packageInactive": "The contract package is no longer active.",
  "Sales model conflict: termInactive": "The term is no longer active.",
  "Sales model conflict: studioScopeConflict": "The dependent studio scopes no longer cover the complete sales model.",
  "Sales model conflict: componentConflict": "The package components or their conditions no longer match the sales model.",
  "Sales model conflict: paymentPlanConflict": "At least one payment plan is no longer allowed or active.",
  "Sales model conflict: bundleConflict": "At least one service bundle is no longer compatible or active.",
  "Sales model conflict: pricingCycleConflict": "A bundle price cannot be allocated unambiguously across different payment cycles.",
  "Service bundles": "Service bundles",
  "Service bundle revenue": "Service bundle revenue",
  "Service bundle benefit": "Service bundle benefit",
  "Sales promotion effects": "Sales promotion effects",
  "Signing form": "Signing form",
  "Signing channel": "Signing channel",
  "Component conditions": "Component conditions",
  "Regular price": "Regular price",
  "Cycle value": "Cycle value",
  "Cycle unit": "Cycle unit",
  "Lifetime rule": "Lifetime rule",
  "Follows sales model": "Follows sales model",
  "Own duration": "Own duration",
  "Allowed payment plans": "Allowed payment plans",
  "Default payment plan": "Default payment plan",
  "Available service bundles": "Available service bundles",
  "Service bundle": "Service bundle",
  "Included": "Included",
  "Bundle price override": "Bundle price override",
  "Service start": "Service start",
  "Training start": "Training start",
  "Weeks": "Weeks",
  "Years": "Years",
  "Time-limited offers applied when a contract is signed": "Time-limited offers applied when a contract is signed",
  "New sales promotion": "New sales promotion",
  "Create sales promotion": "Create sales promotion",
  "Edit sales promotion": "Edit sales promotion",
  "Delete sales promotion": "Delete sales promotion",
  "Free period": "Free period",
  "Free period mode": "Free period mode",
  "Free period as duration": "As a duration",
  "Fixed contract start": "Fixed contract start",
  "Round contract start": "Round contract start",
  "No rounding": "No rounding",
  "Next first of month": "Next first of month",
  "Price benefit": "Price benefit",
  "Benefit duration": "Benefit duration",
  "Benefit starts": "Benefit starts",
  "From contract start": "From contract start",
  "From training start": "From training start",
  "Sales window": "Sales window",
  "Sellable from": "Sellable from",
  "Sellable until": "Sellable until",
  "Maximum redemptions": "Maximum redemptions",
  "Redemptions": "Redemptions",
  "Promotion code": "Promotion code",
  "Code required": "Code required",
  "The promotion only appears after the code has been entered.": "The promotion only appears after the code has been entered.",
  "Presentation": "Presentation",
  "Public title": "Public title",
  "Public subtitle": "Public subtitle",
  "Badge text": "Badge text",
  "Public description": "Public description",
  "Charge setup fee at training start": "Charge setup fee at training start",
  "Cancellable during free period": "Cancellable during the free period",
  "Restore quota on revocation": "Restore quota on revocation",
  "Combinable with other discounts": "Combinable with other discounts",
  "Effect": "Effect",
  "Contribution-free start": "Contribution-free start",
  "Early service start": "Early service start",
  "Reduced price": "Reduced price",
  "Early start and reduced price": "Early start and reduced price",
  "Early service start mode": "Early service start mode",
  "Select an effect": "Select an effect.",
  "No effect selected": "No effect selected yet.",
  "Action summary": "Promotion summary",
  "Training immediately, contract from {0}": "Training immediately, contract starts on {0}",
  "Training immediately, contract starts after {0} {1}": "Training immediately, contract starts after {0} {1}",
  "First {0} {1} contribution-free": "First {0} {1} contribution-free",
  "Reduced price: {0} for {1} {2}": "Price benefit {0} for {1} {2}",
  "Only redeemable with a promotion code": "Only redeemable with a promotion code",
  "Promotion code is required": "Promotion code is required",
  "Limit the number of redemptions": "Limit the number of redemptions",
  "Contract from": "Contract from",
  "Option groups": "Service bundles",
  "Option group": "Service bundle",
  "Offer reusable option groups in this contract package — included or bookable on top.": "Offer reusable additional offers in this contract package — included or bookable on top.",
  "No option groups available (Settings → Option groups).": "No additional offers available (Settings → Additional offers).",
  "Add option group": "Add additional offer",
  "Price override": "Price for this package",
  "Optional (customer decides)": "Optional (customer decides)",
  "Included (not deselectable)": "Included (not deselectable)",
  "Preselected": "Preselected",
  "A price override replaces the group's quantity tiers.": "A price override replaces the group's quantity tiers.",
  "Add-on options": "Additional offers",
  "Included in the package": "Included in the package",
  "Select at least {0}": "Select at least {0}",
  "Select at most {0}": "Select at most {0}",
  "instead of {0}": "instead of {0}",
  "Book all or nothing": "Book all or nothing",
  "Bundles and add-on options within contract packages": "Bundles and additional offers within contract packages",
  "New option group": "New service bundle",
  "Create option group": "Create service bundle",
  "Edit option group": "Edit service bundle",
  "Delete option group": "Delete service bundle",
  "Bundle (all or nothing)": "Bundle (all or nothing)",
  "Choice (n of m)": "Choice (n of m)",
  "Bundle": "Bundle",
  "Choice": "Choice",
  "Selection": "Selection",
  "Offer type": "Bundle type",
  "Components": "Components",
  "Select at least one component": "Select at least one component",
  "Sum of components": "Sum of components",
  "Total price": "Total price",
  "Percentage off": "Percentage off",
  "Amount off": "Amount off",
  "A total price requires all components to share the same payment cycle.": "A total price requires all components to share the same payment cycle.",
  "Quantity tiers": "Quantity tiers",
  "From count": "From count",
  "Add tier": "Add tier",
  "Remove tier": "Remove tier",
  "Bundle price": "Bundle price",
  "Bundle price type": "Price type",
  "Fixed price": "Fixed price",
  "Discount in percent": "Discount in percent",
  "Individual price total": "Individual price total",
  "Permanent bundle advantage": "Permanent bundle advantage",
  "Minimum": "Minimum",
  "Maximum": "Maximum",
  "Target price": "Target price",
  "Target price cannot be negative": "The target price cannot be negative",
  "Price adjustment": "Price adjustment",
  "Price adjustment is required": "Price adjustment is required",
  "Price adjustment name placeholder": "e.g. student discount or yearly surcharge",
  "Price adjustments": "Price adjustments",
  "Percentage__alt1": "Percentage",
  "Percentage__alt3": "Percentage",
  "Fixed amount": "Fixed amount",
  "Fixed amount__fixer-betrag": "Fixed amount",
  "Period": "Period",
  "Period range": "Period",
  "Period__alt1": "Period",
  "Period__alt2": "Period",
  "Permissions": "Permissions",
  "Permissions & roles": "Permissions & roles",
  "Person": "Person",
  "Person (Employee, Trainer)": "Person (Employee, Trainer)",
  "Person added": "Person added",
  "Person created.": "Person created.",
  "Person entities": "Person entities",
  "Person file": "Person file",
  "Person locked.": "Person locked.",
  "Person search failed": "Person search failed",
  "Person unlocked.": "Person unlocked.",
  "Person's name (last name, first name)": "Person's name (last name, first name)",
  "Persons": "Persons",
  "Persons & person pools": "Persons & person pools",
  "Persons, pools, equipment & rooms": "Persons, pools, equipment & rooms",
  "Phase": "Phase",
  "Phase (for new leads)": "Phase (for new leads)",
  "Phase completed.": "Phase completed.",
  "Phase created": "Phase created",
  "Phase deleted": "Phase deleted",
  "Delete phase and reset leads warning": "{0} leads will be reset to the start phase. Delete phase anyway?",
  "Phase updated": "Phase updated",
  "Phone": "Phone",
  "Phone (optional)": "Phone",
  "Phone or Mobile": "Phone or Mobile",
  "Phone or mobile is required": "Please enter a phone or mobile number.",
  "Photo saved.": "Photo saved.",
  "PIN, login & studio assignment": "PIN, login & studio assignment",
  "Ping failed": "Ping failed",
  "Ping successful!": "Ping successful!",
  "Pipeline": "Pipeline",
  "Pipeline created": "Pipeline created",
  "Pipeline deleted": "Pipeline deleted",
  "Pipeline updated": "Pipeline updated",
  "Pipelines & phases": "Pipelines & phases",
  "Plan": "Plan",
  "Please accept": "Please accept",
  "(Privacy policy text can be configured in settings)": "(Privacy policy text can be configured in settings)",
  "(Terms can be configured in settings)": "(Terms can be configured in settings)",
  "Please add at least one recipient.": "Please add at least one recipient.",
  "Please confirm password": "Please confirm password",
  "Please confirm…": "Please confirm…",
  "Please enter a name.__alt1": "Please enter a name.",
  "Please enter a name.__alt2": "Please enter a name.",
  "Please enter a password (for the test).": "Please enter a password (for the test).",
  "Please enter a password.": "Please enter a password.",
  "Please enter a reason": "Please enter a reason",
  "Please enter an abbreviation.": "Please enter an abbreviation.",
  "Please enter an amount": "Please enter an amount",
  "Please enter an amount.": "Please enter an amount.",
  "Please enter an email address.": "Please enter an email address.",
  "Please enter current password": "Please enter current password",
  "Please enter Device ID and QR ID": "Please enter Device ID and QR ID",
  "Please enter end time": "Please enter end time",
  "Please enter host and port.": "Please enter host and port.",
  "Please enter host, port and username.": "Please enter host, port and username.",
  "Please enter password": "Please enter password",
  "Please enter sender email.": "Please enter sender email.",
  "Please enter start time": "Please enter start time",
  "Please enter the number of installments": "Please enter the number of installments",
  "Please enter your abbreviation (as stored in the user profile).": "Please enter your abbreviation (as stored in the user profile).",
  "Please enter your email/username.": "Please enter your email/username.",
  "Please enter your password.": "Please enter your password.",
  "Please fill in both fields before testing the connection.": "Please fill in both fields before testing the connection.",
  "Please fill in Studio, Name, and Manufacturer first before the registration code is generated.": "Please fill in Studio, Name, and Manufacturer first before the registration code is generated.",
  "Please fix the following errors:": "Please fix the following errors:",
  "Please select": "Please select",
  "Please select a chargeback reason": "Please select a chargeback reason",
  "Please select a contract package": "Please select a contract package",
  "Please select a contract package first to view included items.": "Please select a contract package first to view included items.",
  "Please select a contribution handling option.": "Please select a contribution handling option.",
  "Please select a customer first.": "Please select a customer first.",
  "Please select a customer to continue.": "Please select a customer to continue.",
  "Please select a handling method": "Please select a handling method",
  "Please select a handling method for the overpayment.": "Please select a handling method for the overpayment.",
  "Please select a home studio.": "Please select a home studio.",
  "Please select a pain version": "Please select a pain version",
  "Please select a payment plan": "Please select a payment plan",
  "Please select a period.": "Please select a period.",
  "Please select a person…": "Please select a person…",
  "Please select a pipeline first": "Please select a pipeline first",
  "Please select a reader device to manage assignments.": "Please select a reader device to manage assignments.",
  "Please select a studio.": "Please select a studio.",
  "Check-in no studios hint": "Check-in requires at least one studio. Please set up a studio in settings first.",
  "Open studio settings": "Open studio settings",
  "Please select a template": "Please select a template",
  "Please select a template first": "Please select a template first",
  "Please select a template if you want to send a confirmation.": "Please select a template if you want to send a confirmation.",
  "Please select a type": "Please select a type",
  "Please select a user": "Please select a user",
  "Please select a wallet product": "Please select a wallet product",
  "Please select a wallet.": "Please select a wallet.",
  "Please select an open item": "Please select an open item",
  "Please select at least one appointment type.": "Please select at least one appointment type.",
  "Please select a delivery channel.": "Please select a delivery channel.",
  "Please select at least one delivery channel.": "Please select at least one delivery channel.",
  "Please select at least one resource.": "Please select at least one resource.",
  "Please select at least one studio.": "Please select at least one studio.",
  "Please select at least one payment to cancel.": "Please select at least one payment to cancel.",
  "Select at least one payment above to cancel.": "Please select at least one payment above to cancel.",
  "Select payments to cancel": "Select payments to cancel",
  "No payments available to cancel.": "No payments available to cancel.",
  "Please select contract package.": "Please select contract package.",
  "Please select customer.": "Please select customer.",
  "Please select number of installments.": "Please select number of installments.",
  "Please specify target range": "Please specify target range",
  "Please use contract packages (manual adding is currently disabled).": "Please use contract packages (manual adding is currently disabled).",
  "point": "point",
  "Points": "Points",
  "Pool Members (Users)": "Pool Members (Users)",
  "Port": "Port",
  "Positive": "Positive",
  "Possible duplicate": "Possible duplicate",
  "Member since": "Member since",
  "Member care trigger new member": "New member",
  "Member care trigger inactive": "No visits",
  "Member care trigger open item": "Open item",
  "Member care trigger wallet balance": "Wallet balance low",
  "Member care trigger wallet unused": "Wallet unused",
  "Member care trigger contract start": "Contract start",
  "Member care trigger contract end": "Contract end",
  "Member care trigger contract cancelled": "Cancellation",
  "Member care trigger rest period end": "Rest period ending",
  "No check-in during rest period": "No check-in",
  "Person account tab": "Account",
  "Person history tab": "History",
  "Remaining contributions": "Remaining contributions",
  "Cancellation equal contribution summary": "{0} × {1} = {2}",
  "Cancellation mixed contribution summary": "{0} contributions, total {1}",
  "Cancellation no remaining contributions": "{0} – no contributions outstanding",
  "Cancellation no dropped contributions": "{0} – no contributions dropped",
  "Dropped contributions": "Dropped contributions",
  "Rest period summary fee": "Fee: {0}",
  "Rest period summary contributions": "{0} contributions",
  "More details": "More details",
  "Fewer details": "Fewer details",
  "Possible duplicate exists": "Possible duplicate exists",
  "PossiblePersonDuplicate": "possible duplicate",
  "Possible person duplicate help": "Similar records already exist. The same number can belong to more than one person, for example a parent and child — please check whether this is the same person.",
  "Create anyway": "Create anyway",
  "Use this person": "Use this person",
  "Post": "Post",
  "Post direct debit run": "Post direct debit run",
  "Posting": "Posting",
  "Posting direct debit run": "Posting direct debit run",
  "Posting failed": "Posting failed",
  "Posted": "Posted",
  "Preparing appointment…": "Preparing appointment…",
  "Present the chip to a m1connect reader. The chip will be assigned to the current person immediately.": "Present the chip to a m1connect reader. The chip will be assigned to the current person immediately.",
  "Preset created": "Preset created",
  "Present the chip to a m1connect reader. The chip will be assigned to the current user immediately.": "Present the chip to a m1connect reader. The chip will be assigned to the current user immediately.",
  "Preset deleted": "Preset deleted",
  "Preset updated": "Preset updated",
  "Prevents the spooler from sending batches too frequently for the same tenant.": "Prevents the spooler from sending batches too frequently for the same tenant.",
  "Preview": "Preview",
  "Data": "Data",
  "Done": "Done",
  "Preview and adjust design visually": "Preview and adjust design visually",
  "Preview booking group": "Preview booking group",
  "Base price": "Base price",
  "Price": "Price",
  "Price editable on sale": "Price editable on sale",
  "Price changeable on create": "Price changeable on create",
  "Price changes are disabled for this contract package at closing.": "Price changes are disabled for this contract package at closing.",
  "Price is fixed in contract package.": "Price is fixed in contract package.",
  "Price is fixed in the contract package.": "Price is fixed in the contract package.",
  "Price is missing for the primary tariff block.": "Price is missing for the primary tariff block.",
  "Price per installment": "Price per installment",
  "Price Settings": "Price Settings",
  "Primary": "Primary",
  "Primary Color": "Primary Color",
  "Primary color": "Primary color",
  "Primary admin role cannot be changed": "The primary administrator account's role cannot be changed.",
  "Color buttons and accents": "Buttons, accents and borders",
  "Color buttons and accents tooltip": "Color for „Next“ and „Book“ buttons, step indicator, company name in header, card borders (studio/appointment type), week and day selector, selected time slots.",
  "Color availability indicator": "Availability indicator",
  "Color availability indicator tooltip": "Color of the dot on days that have free slots (otherwise grey).",
  "Page": "Page",
  "Page background (outside widget)": "Page background (outside card)",
  "General text color": "Standard text color (fallback)",
  "General text color tooltip": "Used as fallback for many headings, card texts and body text when an area has no own color. Individual areas (header, steps, cards, etc.) can have their own colors.",
  "Print": "Print",
  "Print preview": "Print preview",
  "Print preview is only available in letter view": "Print preview is only available in letter view",
  "Copy first page to following pages": "Copy first page to following pages",
  "Copy first page to following pages confirmation": "Do you want to copy the first page layout to the following pages? Existing blocks on following pages will be replaced.",
  "First page copied to following pages": "First page copied to following pages",
  "Reset zoom": "Reset zoom",
  "Fit to page": "Fit to page",
  "Remove block confirmation": "Do you really want to remove this block from the document?",
  "Format block": "Format block",
  "Labels": "Labels",
  "Values": "Values",
  "Table headings": "Table headings",
  "Table values": "Table values",
  "Privacy": "Privacy",
  "Privacy Policy": "Privacy Policy",
  "Privacy policy: Text": "Privacy policy: Text",
  "Privacy policy: URL": "Privacy policy: URL",
  "Privacy policy text": "Privacy policy text",
  "Terms: Text": "Terms: Text",
  "Terms: URL": "Terms: URL",
  "Terms and conditions text": "Terms and conditions text",
  "Imprint: Text": "Imprint: Text",
  "Imprint: URL": "Imprint: URL",
  "Imprint text": "Imprint text",
  "Privacy Policy Text": "Privacy Policy Text",
  "Last version": "Last version",
  "Legal texts": "Legal texts",
  "Privacy, terms, imprint": "Privacy, terms, imprint",
  "Privacy, terms, imprint – assign in app, leads, booking, contract signing": "Privacy, terms and imprint can be assigned centrally in the app, leads, booking and contract signing",
  "Use legal texts from settings": "Use legal texts from settings",
  "None – use fields below": "None – use fields below",
  "Edit legal texts": "Edit legal texts",
  "New legal texts": "New legal texts",
  "e.g. Standard, Studio Nord": "e.g. Standard, Studio North",
  "Privacy Policy URL": "Privacy Policy URL",
  "Proceed with import": "Proceed with import",
  "Processing": "Processing",
  "Product": "Product",
  "Products & Contracts": "Products & Contracts",
  "Profile": "Profile",
  "Pronouns": "Pronouns",
  "Proportional Calculation": "Proportional Calculation",
  "Proportional Fee": "Proportional Fee",
  "Prorated fee editable": "Prorated fee editable",
  "Prospect": "Prospect",
  "Prospect female": "Prospect",
  "Prospects": "Prospects",
  "Purple": "Purple",
  "QR": "QR",
  "Reverse-QR": "Reverse-QR",
  "QR Code 1": "QR Code 1",
  "QR Code 1 and QR Code 2 must not be identical": "QR Code 1 and QR Code 2 must not be identical",
  "QR Code 2": "QR Code 2",
  "QR ID": "QR ID",
  "Queue and sending status": "Queue and sending status",
  "Rate": "Rate",
  "Rate %": "Rate %",
  "Rate is required": "Rate is required",
  "Rate must be between 0 and 100": "Rate must be between 0 and 100",
  "Raw": "Raw",
  "Reader": "Reader",
  "Reader device": "Reader device",
  "Reader device created.": "Reader device created.",
  "Reader device deleted.": "Reader device deleted.",
  "Reader device saved.": "Reader device saved.",
  "Reader devices": "Reader devices",
  "Reader devices (with flags)": "Reader devices (with flags)",
  "Readers": "Readers",
  "Really delete this account?": "Really delete this account?",
  "Really delete this configuration?": "Really delete this configuration?",
  "Really delete this entry?": "Really delete this entry?",
  "Really delete this payment method?": "Really delete this payment method?",
  "Really delete this preset?": "Really delete this preset?",
  "Really delete this unavailability reason?": "Really delete this unavailability reason?",
  "Really delete this unavailability?": "Really delete this unavailability?",
  "Really delete this VAT setting?": "Really delete this VAT setting?",
  "Really delete this widget?": "Really delete this widget?",
  "Really delete?": "Really delete?",
  "Studio app config delete hint": "Deleting this configuration also deletes all associated images (logo and slot images).",
  "Really lock this person? (No access/check-in possible.)": "Really lock this person? (No access/check-in possible.)",
  "Really unlock this person?": "Really unlock this person?",
  "Reason": "Reason",
  "Classification reason": "Classification reason",
  "Reasons for cancellations": "Reasons for cancellations",
  "Reasons for payment cancellations": "Reasons for payment cancellations",
  "Reversal reasons": "Reversal reasons",
  "Reasons for payment and contribution cancellations": "Reasons for payment and contribution cancellations",
  "every {0} {1}": "every {0} {1}",
  "Used in {0} contract packages": "Used in {0} contract packages",
  "Edit model": "Edit model",
  "Contract module template usage notice": "Used in {0} contract packages – changes apply to all packages; running contracts keep their values.",
  "Contract module template change notice": "Changes apply to all contract packages with this template; running contracts keep their values.",
  "A change applies to all of these contract packages.": "A change applies to all of these contract packages.",
  "Rest periods not allowed": "Rest periods not allowed",
  "Open model": "Open model",
  "Running sales promotions": "Running sales promotions",
  "until {0}": "until {0}",
  "Membership agreement from the contract data, the same for all contract packages": "Membership agreement from the contract data, the same for all contract packages",
  "Sold in contract signing widgets": "Sold in contract signing widgets",
  "Not offered in any contract signing widget": "Not offered in any contract signing widget",
  "Effect of signing today": "Effect of signing today",
  "Effect could not be calculated": "The effect could not be calculated.",
  "term until {0}": "term until {0}",
  "open-ended": "open-ended",
  "due once": "due once",
  "Total for the initial term": "Total for the initial term",
  "Saved state, without sales promotions and optional bookings": "saved state, without sales promotions and optional bookings",
  "Discard unsaved changes?": "Discard unsaved changes?",
  "The contract package has unsaved changes.": "The contract package has unsaved changes.",
  "Received and agree to privacy information": "Received and agree to privacy information",
  "Received at": "Received at",
  "Receiving is disabled.": "Receiving is disabled.",
  "Recent leads": "Recent leads",
  "Tasks": "Tasks",
  "Task": "Task",
  "Tasks column due at": "Due",
  "No tasks": "No tasks",
  "No new leads": "No new leads",
  "All tasks": "All tasks",
  "Recent tasks": "Recent tasks",
  "Open tasks": "Open tasks",
  "Contact data change request": "Master data change request",
  "Adress-/Kontaktdaten-Änderungswunsch": "Address/contact data change request",
  "Bankdaten-Änderungswunsch": "Bank details change request",
  "Stammdaten-Änderungswunsch": "Master data change request",
  "New task": "New task",
  "Manual": "Manual",
  "Google Calendar": "Google Calendar",
  "Google Calendar description": "Tasks and calendar from Google. Connect an account and assign one or more studios per calendar. Enable \"Use tasks from calendar\" so tasks appear in the task list.",
  "Google Calendar setup guide title": "How to set up Google Calendar",
  "Google Calendar setup integration title": "Create integration",
  "Google Calendar setup integration text": "If you don't have a \"Google Calendar\" integration yet, click \"Add\" in the list above, choose type \"Google Calendar\", enter a name, and save.",
  "Google Calendar setup integration connected title": "Integration and connection",
  "Google Calendar setup integration connected text": "The integration is set up and connected to Google.",
  "Google Calendar setup connect with google title": "Connect with Google",
  "Google Calendar connect step title": "Connect with Google",
  "Google Calendar setup connect with google text": "Click \"Connect with Google\" below, sign in to Google, and allow access to your calendars. You will be redirected back here and the calendar list will load.",
  "Google Calendar setup enable tasks title": "Enable tasks",
  "Google Calendar setup enable tasks text": "",
  "Google Calendar column use for tasks": "Use for tasks",
  "Google Calendar setup assign calendars to studios title": "Assign calendars to studios",
  "Google Calendar setup assign calendars to studios text": "For each detected calendar: choose calendar and studios in the selection boxes, then check „Tasks“ below.",
  "Google Calendar setup save title": "Save",
  "Google Calendar setup save text": "Click \"Save\". Setup is complete.",
  "Google Calendar where to get credentials": "Where do I get the Client ID and secret?",
  "Google Calendar credentials help": "An administrator must create a project in the Google Cloud Console (console.cloud.google.com), enable the \"Google Calendar API\", and under \"APIs & Services\" → \"Credentials\" create an OAuth 2.0 Client ID (type \"Web application\"). Add as authorized redirect URI e.g.: https://your-api-domain/api/v1/integrations/google-calendar/callback (use your actual API base URL). The client ID and secret are configured on the server (e.g. appsettings), not in m1member.",
  "Google Calendar credentials link prefix": "For admins: Create client ID and secret",
  "Google Calendar credentials link": "in the Google Cloud Console",
  "Google Calendar credentials help short": "Redirect URI: …/api/v1/integrations/google-calendar/callback (configure on server).",
  "Google Calendar setup connect with google connected": "Connected with Google. You can reconnect if needed.",
  "Google Calendar start setup": "Start setup",
  "Google Calendar connect hint": "Connect with Google to load and assign calendars.",
  "Connect with Google": "Connect with Google",
  "Reconnect with Google": "Reconnect with Google",
  "Use tasks from calendar": "Use tasks from calendar",
  "Use calendar (coming soon)": "Use calendar (coming soon)",
  "Assign calendar to studio(s)": "Assign calendar to studio(s)",
  "Google Calendar calendars and studios": "Calendars & studios",
  "Google Calendar connected": "Google Calendar connected.",
  "Google Calendar connection failed": "Google Calendar connection failed.",
  "Google Calendar not configured admin hint": "The Google connection is not yet set up for this system. Enter ClientId and ClientSecret (from the Google Cloud Console) in the backend configuration: in appsettings.json under \"GoogleCalendar\" (ClientId, ClientSecret) or as environment variables GoogleCalendar__ClientId and GoogleCalendar__ClientSecret.",
  "Google Calendar OAuth application": "OAuth application (Google Cloud)",
  "Google Calendar OAuth application hint": "Enter the credentials of your OAuth application. In the Google Cloud Console, create a project, enable the \"Google Calendar API\", and under \"APIs & Services\" → \"Credentials\" create an OAuth 2.0 Client ID (type \"Web application\"). Add as authorized redirect URI: {0}",
  "Google Calendar OAuth client id": "Client ID",
  "Google Calendar OAuth client id placeholder": "e.g. …apps.googleusercontent.com",
  "Google Calendar OAuth client secret": "Client secret",
  "Google Calendar OAuth client secret placeholder": "Secret from Google Cloud Console",
  "Google Calendar OAuth callback base url": "Callback base URL (for redirect_uri)",
  "Google Calendar OAuth callback base url placeholder": "e.g. https://api.example.com – only if redirect_uri_mismatch",
  "Google Calendar OAuth redirect base url": "Redirect base URL",
  "Google Calendar connection test": "Google Calendar connection test",
  "Google Calendar connection test success": "Connection successful. {0} calendar(s) found.",
  "Google Calendar not configured tenant hint": "OAuth not set up yet. When editing the integration, under \"OAuth application\", enter your Client ID and secret from the Google Cloud Console and save.",
  "Google Calendar connection expired hint": "The connection has expired or is invalid. Please reconnect with Google so calendars and tasks are available again.",
  "Google Calendar disconnect connection": "Disconnect",
  "Google Calendar disconnect confirm": "Really disconnect the Google connection? Calendar assignments remain saved; you can reconnect later.",
  "Google Calendar admin setup required": "Google Calendar not set up yet",
  "Google Calendar admin setup required description": "An administrator must configure the OAuth application (Client ID and secret from the Google Cloud Console) once under Admin → Settings → Google Calendar. After that, tenants only use \"Connect with Google\".",
  "Google Calendar redirect uri for Google": "Redirect URI to add in Google",
  "Admin Google Calendar settings title": "Google Calendar",
  "Admin Google Calendar settings description": "One platform-wide OAuth application. After setup, all tenants can use \"Connect with Google\" under Settings → Integrations without entering Client ID or secret.",
  "Admin Google Calendar API settings title": "Google Calendar API",
  "Admin Google Calendar API card title": "Google Calendar API",
  "Admin Google Calendar API card description": "OAuth application (Client ID and secret) for all tenants",
  "Admin integrations settings card description": "APIs and connections for the admin tenant (e.g. letter dispatch, WhatsApp, lead import).",
  "Admin Google Calendar settings card description": "Configure OAuth once – tenants then only connect their Google account",
  "Admin Google Calendar redirect uri label": "Add this redirect URI in Google",
  "Admin Google Calendar callback base url": "Callback base URL",
  "Admin Google Calendar callback base url placeholder": "e.g. https://api.example.com – only if host differs",
  "Admin Google Calendar configured hint": "OAuth is configured. Tenants can use \"Connect with Google\" under Settings → Integrations → Google Calendar API.",
  "Google Calendar connected successfully": "Connected with Google. You can now select calendars and assign studios.",
  "Google Calendar connection error": "Connection with Google failed.",
  "Create manual task": "Create manual task",
  "Task title": "Task title",
  "Due date (optional)": "Due date",
  "Due time (optional)": "Time",
  "Person (optional)": "Person",
  "Change request drawer title": "Change request",
  "Change request close": "Close",
  "Change request apply": "Apply",
  "Change request discard": "Discard",
  "Change request apply confirm": "Apply this change request?",
  "Change request apply confirm detail": "The requested data will be saved to the person and the task will be completed.",
  "Change request discard confirm": "Discard this change request?",
  "Change request discard confirm detail": "The request will be rejected and the task completed. Person data will remain unchanged.",
  "Request discarded.": "Request discarded.",
  "Contact data before": "Current (before)",
  "Contact data after": "Requested (after)",
  "Contact data changed": "changed",
  "Tasks filter": "Show",
  "Open tasks only": "Open only",
  "Completed tasks only": "Completed only",
  "Withdrawn": "Withdrawn",
  "Dashboard contents": "Dashboard contents",
  "Dashboard contents description": "Configure which sections are shown on the dashboard.",
  "Apply dashboard configuration": "Apply dashboard configuration",
  "Recent Payments": "Recent Payments",
  "Recipient name": "Recipient name",
  "Recipients": "Recipients",
  "Record payment": "Record payment",
  "Recurrence": "Recurrence",
  "Recurring": "Recurring",
  "Recurring debit": "Recurring debit",
  "Red": "Red",
  "Redemption of vouchers/credits": "Redemption of vouchers/credits",
  "Reference (optional)": "Reference",
  "Reference": "Reference",
  "Reference__alt1": "Reference",
  "Reference__bezugspunkt": "Reference",
  "Referrer": "Referrer",
  "Recommended by": "Recommended by",
  "Referrer name (if not a member)": "Referrer name (if not a member)",
  "Referring member": "Referring member",
  "Refresh": "Refresh",
  "Refund": "Refund",
  "Refund method": "Refund method",
  "Please select a refund method": "Please select a refund method",
  "Refundable": "Refundable",
  "Regenerate": "Regenerate",
  "Regenerate booking code?": "Regenerate booking code?",
  "Regenerate mandate reference?": "Regenerate mandate reference?",
  "Region": "Region",
  "regional": "regional",
  "Regional": "Regional",
  "Relative amount": "Relative amount",
  "Reload": "Reload",
  "Reminder": "Reminder",
  "Reminder & confirmation (lead times, email/SMS, templates)": "Reminder & confirmation (lead times, channels, templates)",
  "Reminder created.": "Reminder created.",
  "Reminder level": "Reminder level",
  "Reminder level created.": "Reminder level created.",
  "Reminder level saved.": "Reminder level saved.",
  "Reminder Levels": "Reminder Levels",
  "Reminder fee": "Reminder fee",
  "Reminder levels & collection agencies": "Reminder levels & collection agencies",
  "Reminders__alt2": "Reminders",
  "Reminders view due": "Due",
  "Reminders view pending": "Preview",
  "Reminders bulk success all": "All selected reminders were processed.",
  "Reminders bulk partial": "Partially completed; some rows were skipped or failed.",
  "Reminders bulk failed": "No reminder could be processed.",
  "Reminder bulk drawer title": "Create reminders",
  "Reminder bulk preview failed": "The selected reminder cases could not be checked.",
  "Reminder bulk blocked title": "Execution is not available yet",
  "Reminder bulk blocked description": "At least one reminder case needs clarification. No reminder is created until the complete selection can be executed.",
  "Reminder bulk clarification required": "This reminder case must be checked individually before execution.",
  "Reminder bulk status created": "Created",
  "Reminder bulk status failed": "Failed",
  "Reminder bulk status clarification": "Clarification required",
  "Reminder bulk letter per level": "Letter per reminder level",
  "Reminder bulk concrete delivery and template required": "Select a specific delivery channel and reminder template for each reminder level.",
  "Automatic (per reminder rule)": "Automatic (per reminder rule)",
  "Debt collection handover without delivery selection": "Handover to debt collection — no delivery channel or template to select.",
  "Reminder cases": "Reminder cases",
  "No studio": "No studio",
  "Reminders group by person": "Group by person",
  "Reminders group multiple studios": "Multiple studios",
  "Reminders group level varied": "Different levels",
  "Reminders group due varied": "Different due dates",
  "Reminders create action": "Create",
  "Reminder include case open items": "Include all due open items in this reminder case",
  "Open items count": "Open items count",
  "Debt collection handover": "Debt collection handover",
  "Debt collection prepared": "Debt collection prepared",
  "Debt collection handover mode": "Debt collection handover",
  "Debt collection handover immediate": "Submit now (final)",
  "Debt collection handover prepare": "Two-step: case without id, complete later",
  "Debt collection finalize": "Finalize handover",
  "Debt collection case status active": "Active",
  "Debt collection case status closed": "Closed",
  "Debt collection case status prepared": "Prepared",
  "Debt collection case status cancelled": "Cancelled",
  "Debt collection cancel action": "cancel",
  "Debt collection list all cases": "All cases",
  "Debt collection list by person": "By person",
  "Debt collection cases count": "Case count",
  "Debt collection case items": "Items",
  "Debt collection manual payments": "Manual payments",
  "Debt collection payment reported at": "Payment reported at",
  "Debt collection cancellation reported at": "Cancellation reported at",
  "Debt collection payment report title": "Report debt collection payment",
  "Debt collection payment report action": "Report payment",
  "Debt collection payment report hint":
    "The payment is recorded as a manual payment on the debt collection case and marked for provider reporting. The case remains active; contributions and open items are not posted as paid.",
  "Debt collection create manual": "Create debt collection case",
  "Debt collection submit manual": "Submit now",
  "Debt collection manual create hint":
    "The selected open items are assigned to a new debt collection case, moved to debt collection, and given a submission ID. No payment record is created.",
  "Debt collection agency is required.": "Debt collection agency is required.",
  "Debt collection payment confirm title": "Register payment?",
  "Debt collection payment confirm text":
    "The payment will be recorded as a manual payment on the debt collection case and marked for provider reporting. The case remains active.",
  "Debt collection cancel confirm title": "Cancel debt collection case?",
  "Debt collection cancel confirm text":
    "The entire debt collection case will be cancelled, the assigned open items will be reopened, and the cancellation will be marked for provider reporting. Depending on the provider, cancellation fees may apply.",
  "Last submission": "Last submission",
  "Debt collection prepare only": "Two-step: create case without transmission id",
  "Debt collection prepare only hint":
    "Unchecked: immediate handover with transmission id and completion as usual. Checked: case and items are created; transmission id and final internal completion happen later via “Finalize now” in the case list.",
  "Debt collection open items select placeholder": "Pick items, or leave empty for all…",
  "Debt collection open items select hint":
    "If you leave this field empty, all open items for the selected person are included. You can pick individual rows in the list.",
  "Debt collection case selection multiple persons": "Multiple persons selected in the case list: please pick the person in the form.",
  "Debt collection case prepared": "Debt collection case prepared.",
  "Debt collection case finalized": "Debt collection case finalized.",
  "Debt collection payment registered": "Debt collection case payment reported.",
  "Debt collection case cancelled": "Debt collection case cancelled.",
  "DebtCollectionCasePaymentNotAllowed": "The payment cannot be posted for this debt collection case.",
  "DebtCollectionCaseCancellationNotAllowed": "This debt collection case cannot be cancelled.",
  "External reference (optional)": "External reference",
  "Remittance info for multiple contracts": "Remittance info for multiple contracts",
  "Remittance info for single transaction": "Remittance info for single transaction",
  "Remittance Information": "Remittance Information",
  "Purpose": "Purpose",
  "Remove": "Remove",
  "Enlarge image": "Enlarge image",
  "Select another image": "Select another image",
  "Remove assignment": "Remove assignment",
  "Remove contributions (from end date)": "Remove contributions (from end date)",
  "Removed.": "Removed.",
  "Renewal": "Renewal",
  "Renewal notice": "Renewal notice",
  "Renewal Notice Period": "Renewal Notice Period",
  "Reply": "Reply",
  "Reply sent to queue": "Reply sent to queue",
  "Reply to": "Reply to",
  "Reply-to": "Reply-to",
  "Report": "Report",
  "Report preview": "Report preview",
  "Report templates": "Report templates",
  "Reports": "Reports",
  "Require Customer Type": "Require Customer Type",
  "Require full periods only": "Require full periods only",
  "Required fields": "Required fields",
  "Required Fields": "Required Fields",
  "Required fields missing": "Required fields missing",
  "Required or specify duration": "Required or specify duration",
  "Required Resources__alt1": "Required Resources",
  "Required Resources__alt2": "Required Resources",
  "Required__alt1": "Required",
  "Required__alt3": "Required",
  "Required__alt4": "Required",
  "Resend email": "Resend email",
  "Resend letter": "Resend letter",
  "Reserved": "Reserved",
  "Reset filter": "Reset filter",
  "Reset password": "Reset password",
  "Reset password?": "Reset password?",
  "Reset password__alt1": "Reset password",
  "Reset selection": "Reset selection",
  "Related data": "Related data",
  "Reset to default": "Reset to default",
  "Reset to default hint": "The stored template is removed. The next level applies afterwards: studio, then tenant, then the shipped default.",
  "Reset units?": "Reset units?",
  "Delete units?": "Delete units?",
  "Units delete confirmation": "Saved settings will be removed.",
  "Units deleted.": "Units deleted.",
  "Copy units to scope": "Copy units to scope",
  "Reset": "Reset",
  "Remove color": "Remove color",
  "No custom color": "No custom color",
  "No color": "No color",
  "Reset.": "Reset.",
  "Reset__alt1": "Reset",
  "Reset__zurücksetzen": "Reset",
  "Resource": "Resource",
  "Resource created": "Resource created",
  "Resource deleted": "Resource deleted",
  "Resource pro studio": "per studio",
  "Resource pro studio tooltip": "Can be booked simultaneously per studio.",
  "Resource updated": "Resource updated",
  "Resource bookable simultaneously in each studio": "Resource bookable simultaneously in each studio",
  "Delete resource in use title": "Resource is assigned to appointment types",
  "Delete resource in use intro": "This resource is still assigned to the following appointment types:",
  "Delete resource in use effect": "Deleting it will remove the resource from these appointment types and from existing appointments.",
  "Resources": "Resources",
  "Rest period": "Rest period",
  "Rest period request type": "Rest period type",
  "Rest period extension": "Rest period extension",
  "New rest period": "New rest period",
  "Derived from previous rest period": "derived from previous rest period",
  "Rest period confirmation": "Rest period confirmation",
  "Confirmation sent": "Confirmation sent",
  "Confirmation open": "Confirmation open",
  "Confirmation unclear": "Confirmation unclear",
  "Rest period confirmation cannot be sent in this context":
    "The rest period will be saved, but the confirmation cannot be sent in this context.",
  "Cancellation confirmation cannot be sent in this context":
    "The cancellation will be saved, but the confirmation cannot be sent in this context.",
  "Default rest period document": "Default rest period document",
  "Rest period edit prior confirmation hint":
    "A confirmation was already sent for this rest period. If you change dates or conditions, review contributions/open items and notify the member if needed (e.g. correction letter).",
  "Rest period confirmation already sent": "Rest period confirmation already sent",
  "Rest period resend confirmation question":
    "A confirmation has already been sent for this rest period. Send another confirmation when saving?",
  "Send again": "Send again",
  "Rest period info: contributions recalculated":
    "The contribution calendar was recalculated. Please review open items and payments.",
  "Rest period warning: contribution calendar failed":
    "The contribution calendar could not be fully recalculated. Please review the contract package and contributions.",
  "Rest period warning: retroactive correction failed":
    "Retroactive counter bookings could not be created completely. Please review the affected contributions.",
  "Rest period warning: inform member outdated confirmation":
    "A previous rest period confirmation exists; changes were saved without a new send. Please notify the member if required.",
  "Rest period warning: letter send failed":
    "The requested letter/email send failed. The rest period was still saved.",
  "Rest period preview cancelled at": "cancelled at",
  "Rest period preview assignment changed": "assignment changed",
  "Rest period preview send confirmation": "Send confirmation",
  "Rest period preview bookings": "Bookings and receivables",
  "Rest period preview wallet movements": "Wallet transactions",
  "Rest period preview further changes": "Further changes",
  "Rest period preview follow-up actions": "Follow-up actions",
  "Rest period preview review confirmation": "Open confirmation for review before sending",
  "Rest period preview history action": "Record the change in the history",
  "Rest period preview fee cycle": "Fee cycle",
  "Rest period preview cycle count": "Cycle length",
  "Rest period preview calculation method": "Proration",
  "Rest period preview extension days": "Extension days",
  "Rest period preview billing model": "Contribution model",
  "Rest period preview current period only": "correct current contribution period only",
  "Rest period preview regular end": "Regular contract end",
  "Rest period preview original end": "Original contract end",
  "Rest period preview period start": "Period start",
  "Rest period preview period end": "Period end",
  "Rest period preview rest link": "Rest period assignment",
  "Rest period preview submitted": "Submitted for direct debit",
  "Rest period preview original booking": "Original booking",
  "Rest period preview original amount": "Original amount",
  "Rest period preview correction amount": "Correction amount",
  "Rest period preview allocated booking": "Payment allocation",
  "Rest period preview cancelled amount": "Cancelled amount",
  "Rest period preview reversal": "Reversal",
  "Rest period preview year proration": "by days in year",
  "Rest period preview month30 proration": "by 30 days per month",
  "Rest period preview actual proration": "by actual days per month",
  "Valid to": "Valid to",
  "Cancellation effective date": "Cancellation effective date",
  "Rest period billing model keep extending description": "Affected contributions are adjusted proportionally. The rest period extends the contract term.",
  "Rest period custom configuration hint": "Choose Custom to change the model settings.",
  "E_RestPeriodFeeChangeBlocked": "The fee change is blocked by a manual booking, an active direct debit run or debt collection.",
  "RestPeriodRetroactiveBlockedBySepa":
    "The rest period cannot be reversed because a related correction booking is included in an active SEPA run. Please book or reset the SEPA run.",
  "RestPeriodOutsideContractPackage":
    "The rest period must not start after the contract has ended. On ended contracts the start can be at most today or the contract end.",
  "Rest period suspended contributions": "Suspended contributions",
  "Rest period costs": "Rest period costs",
  "Request channel": "Channel",
  "Request channel desk": "Desk",
  "Request channel phone": "Phone",
  "Request channel email": "Email",
  "Request channel app": "App",
  "Request channel letter": "Letter",
  "Rest period impact preview title": "Effects after saving",
  "Rest period preview change": "Change",
  "Rest period preview before value": "previously {0}",
  "Rest period preview requires complete input": "Please enter a contract package and complete period.",
  "Rest period preview row changed": "changed",
  "Rest period preview row new": "new",
  "Rest period preview row removed": "removed",
  "Rest period preview row unchanged": "unchanged",
  "Rest period preview more rows": "{0} more change(s)",
  "Rest period preview unavailable": "The preview could not be calculated.",
  "Next contribution after saving": "Next contribution after saving",
  "Contract end after saving": "Corrected contract end",
  "Contribution correction": "Contribution correction",
  "Contribution changes after saving": "Contribution changes after saving",
  "Rest period preview changed contributions count": "Contributions with changes: {0}",
  "Rest period preview no contribution changes": "No contribution changes",
  "Contributions after saving": "Corrected contribution calendar",
  "No open contributions": "No open contributions",
  "No end date": "No end date",
  "Rest period save follow-up title": "Rest period saved – notes",
  "Rest period end date": "Rest period end date",
  "Rest period ending": "Rest period ending",
  "Rest period model": "Rest period model",
  "Rest period model (optional)": "Rest period model",
  "Rest period models": "Rest period models",
  "Rest period monthly fee": "Rest period monthly fee",
  "Rest period total fee amount": "Rest period total fee amount",
  "Rest period next contribution due date": "Next contribution due date",
  "Rest period next contribution amount": "Next contribution amount",
  "Rest period note": "Rest period note",
  "Rest period reason": "Rest period reason",
  "Rest period reason created": "Rest period reason created",
  "Rest period reason deleted": "Rest period reason deleted",
  "Rest period reason updated": "Rest period reason updated",
  "Rest period reasons": "Rest period reasons",
  "Select rest period reason…": "Select rest period reason…",
  "Rest period request date": "Rest period request date",
  "Rest period saved.": "Rest period saved.",
  "Rest period start date": "Rest period start date",
  "Rest period starting": "Rest period starting",
  "Rest period template": "Rest period template",
  "Rest period template name": "Rest period template name",
  "Rest period templates": "Rest period templates",
  "Rest period weeks count": "Rest period weeks count",
  "Rest periods": "Rest periods",
  "Reasons for rest periods": "Reasons for rest periods",
  "Result": "Result",
  "Result/status templates": "Result/status templates",
  "Retake": "Retake",
  "Retries": "Retries",
  "Revenue": "Revenue",
  "Revenue (Year)": "Revenue (Year)",
  "Revenue (€)": "Revenue (€)",
  "Revoke": "Revoke",
  "Revoke cancellation": "Revoke cancellation",
  "Role": "Role",
  "Role created": "Role created",
  "Role deleted": "Role deleted",
  "Role is required": "Role is required",
  "Role is required for the primary account": "Role is required for the primary account",
  "Role saved": "Role saved",
  "Roles": "Roles",
  "Roles (Reverse-QR)": "Roles (Reverse-QR)",
  "Roles (access)": "Roles (access)",
  "Room": "Room",
  "Room (Course room, Area)": "Room (Course room, Area)",
  "Rooms": "Rooms",
  "Round down": "Round down",
  "Round up": "Round up",
  "Rounded": "Rounded",
  "Rounding": "Rounding",
  "Rounding (optional)": "Rounding",
  "Rounding: Ending must be < Step": "Rounding: Ending must be < Step",
  "Rounding: Step must be > 0": "Rounding: Step must be > 0",
  "Rule": "Rule",
  "Rule created": "Rule created",
  "Rule deleted": "Rule deleted",
  "Rule updated": "Rule updated",
  "Rules": "Rules",
  "Run ID not found": "Run ID not found",
  "Run": "Run",
  "Run__alt2": "Run",
  "Sales & Leads": "Sales & Leads",
  "Sales pipelines and phases": "Sales pipelines and phases",
  "Sales": "Sales",
  "Sales__alt1": "Sales",
  "Sales__alt2": "Sales",
  "Salutation": "Salutation",
  "Salutation is required": "Salutation is required",
  "Sat": "Sat",
  "Saturday": "Saturday",
  "Apply": "Apply",
  "Select template": "Select template",
  "Save": "Save",
  "Save entitlement sources": "Save entitlement sources",
  "Save failed": "Save failed",
  "Save failed__alt1": "Save failed",
  "Save failed see console": "Save failed. See browser console (F12) for details.",
  "Saved": "Saved",
  "Saved settings will be removed.": "Saved settings will be removed.",
  "Saved.": "Saved.",
  "Scheduled": "Scheduled",
  "Scheduled for": "Scheduled for",
  "Schedules": "Schedules",
  "Scope": "Scope",
  "Add scope": "Add scope",
  "All scopes already configured.": "All scopes are already configured.",
  "Save to scope": "Save to scope",
  "Select scope to add:": "Select scope to add:",
  "Select at least one scope.": "Please select at least one scope.",
  "Select at least one studio.": "Please select at least one studio.",
  "Scopes": "Scopes",
  "Units add scopes tooltip": "Select one or more studios to create settings for. Empty = tenant default (applies to all studios).",
  "Units add scope studios tooltip": "Empty = create tenant default (all studios); otherwise selected studios. Each studio only once.",
  "Units add scope placeholder": "Select studios or leave empty for tenant default",
  "Units duplicate target tooltip": "Empty = tenant default (all studios); otherwise selected studio. Each studio only once.",
  "Units duplicate target placeholder": "Empty = tenant default (all studios)",
  "Units default scope already exists": "A \"tenant default\" (all studios) scope already exists.",
  "Script Code": "Script Code",
  "Search by mandate reference...": "Search by mandate reference...",
  "Search by name...": "Search by name...",
  "Search columns...": "Search columns...",
  "Search failed__alt1": "Search failed",
  "Search failed__alt2": "Search failed",
  "Search name/email/phone": "Search name/email/phone",
  "Search people (name or email)...": "Search people (name or email)...",
  "Search permissions…": "Search permissions…",
  "Search person...": "Search person...",
  "Search person: name, email, phone …": "Search person: name, email, phone …",
  "Search person or user: name, email, phone …": "Search person or user: name, email, phone …",
  "Search person: name, email, phone…": "Search person: name, email, phone…",
  "Search person…": "Search person…",
  "Search results": "Search results",
  "Search": "Search",
  "Search__alt1": "Search",
  "Searching…": "Searching…",
  "Secondary Color": "Secondary Color",
  "Secondary color": "Secondary color",
  "Security Warning": "Security Warning",
  "Select": "Select",
  "Select years": "Select years",
  "Select a booking group to preview": "Select a booking group to preview",
  "Preview will appear when a widget is loaded": "Preview will appear when a widget is loaded",
  "Select account": "Select account",
  "Select an Appointment": "Select an Appointment",
  "Select an Appointment Type": "Select an Appointment Type",
  "Select Appointment": "Select Appointment",
  "Select an assignment reader to start scanning.": "Select an assignment reader to start scanning.",
  "Select appointment types": "Select appointment types",
  "Select assignment reader": "Select assignment reader",
  "Select booking group": "Select booking group",
  "Select resources first": "Select resources first",
  "Select bank account (optional)": "Select bank account",
  "Select calendar first": "Select calendar first",
  "Select cancellation model": "Select cancellation model",
  "Select cancellation reason…": "Select cancellation reason…",
  "Select capabilities": "Select capabilities",
  "Select category": "Select category",
  "Select channel": "Select channel",
  "Select chargeback reason...": "Select chargeback reason...",
  "Select columns to display and drag them to change the order.": "Select columns to display and drag them to change the order.",
  "Select contract": "Select contract",
  "Select contract package": "Select contract package",
  "Select contract block": "Select contract block",
  "Contracts without contract package": "Contracts without a contract package",
  "Select contribution handling…": "Select contribution handling…",
  "Select date": "Select date",
  "Select date (optional)": "Select date",
  "Select date and time": "Select date and time",
  "Select direct debit group(s)": "Select direct debit group(s)",
  "Select priceAdjustment": "Select price adjustment",
  "Select price adjustment": "Select price adjustment",
  "Select price adjustment or configure individually…": "Select price adjustment or configure individually…",
  "Price adjustment designation": "Designation",
  "Price adjustment model": "Price adjustment model",
  "Manual price adjustment requires customize permission": "Missing permission for manual price adjustments.",
  "Manual price adjustment name is required": "Manual price adjustment name is required",
  "Manual price adjustment name placeholder": "e.g. goodwill discount",
  "Select end date": "Select end date",
  "Select end or enter duration": "Select end or enter duration",
  "Select handling…": "Select handling…",
  "Select integration": "Select integration",
  "Select manufacturer...": "Select manufacturer...",
  "Select next phase:": "Select next phase:",
  "Select payment method type": "Select payment method type",
  "Select payment method…": "Select payment method…",
  "Change payment method (open contributions)": "Change payment method",
  "No open contributions to change payment method": "No open contributions to change payment method",
  "Payment method changed for contributions": "Payment method changed for {0} contributions",
  "Affected contributions count": "{0} open contributions affected",
  "Select payment method… (optional)": "Select payment method…",
  "Select person": "Select person",
  "Select persons...": "Select persons...",
  "Select plan": "Select plan",
  "Select product": "Select product",
  "Select reader device...": "Select reader device...",
  "Select reason": "Select reason",
  "Select reason (e.g. vacation, sick)": "Select reason (e.g. vacation, sick)",
  "Select recurrence rule": "Select recurrence rule",
  "Select resource": "Select resource",
  "Select resources (optional)": "Select resources",
  "Select resources...": "Select resources...",
  "Select rest period model": "Select rest period model",
  "Select start and end month. All contributions in this period will be considered.": "Select start and end month. All contributions in this period will be considered.",
  "Select studio": "Select studio",
  "Select phase (optional)": "Select phase",
  "Select studio(s)": "Select studio(s)",
  "Select studios...": "Select studios...",
  "Select studio…": "Select studio…",
  "Select target": "Select target",
  "Select target phase": "Select target phase",
  "Select target scope:": "Select target scope:",
  "Select template (optional)": "Select template",
  "Select template or configure individually…": "Select template or configure individually…",
  "Select template...": "Select template...",
  "Select template/variant": "Select template/variant",
  "Select template…": "Select template…",
  "Select tenant...": "Select tenant...",
  "Select the persons to be assigned to this calendar.": "Select the persons to be assigned to this calendar.",
  "Select the resources required for this appointment type. Capacity will be checked during booking.": "Select the resources required for this appointment type. Capacity will be checked during booking.",
  "Select type": "Select type",
  "Select type...": "Select type...",
  "Select user": "Select user",
  "Select user(s)...": "Select user(s)...",
  "Select user:": "Select user:",
  "Select VAT setting (optional)": "Select VAT setting",
  "Select tax setting (optional)": "Select tax setting",
  "Select wallet…": "Select wallet…",
  "Select week": "Select week",
  "Select week__alt2": "Select week",
  "Select weekday": "Select weekday",
  "Select which fields must be filled in during booking.": "Select which fields must be filled in during booking.",
  "selected": "selected",
  "Selected contributions": "Selected contributions",
  "Selected person": "Selected person",
  "Selected studios only": "Selected studios only",
  "Selected template unavailable": "Selected template unavailable",
  "Selection failed": "Selection failed",
  "Send a single email (e.g. to one person).": "Send a single email (e.g. to one person).",
  "Send a single letter (PDF/DOCX, print/export).": "Send a single letter (PDF/DOCX, print/export).",
  "Reminder text variant": "Reminder text variant",
  "Debt collection handover text variant": "Debt collection handover text variant",
  "Email templates": "Email templates",
  "Attach letter to email": "Attach letter PDF to the email",
  "Attach letter to email tooltip": "Where the email carries the letter itself, the PDF is an extra for the member’s records. For contract documents it is always attached — there the attachment is the point of the message. The PDF is archived either way.",
  "Card": "Card",
  "Payment methods": "Payment methods",
  "SEPA direct debit": "SEPA direct debit",
  "Text set": "Template",
  "Select text set…": "Select template…",
  "Please select a text set": "Please select a template",
  "Please select a text set first": "Please select a template first",
  "Bulk dispatch result: {0} sent, {1} skipped": "Bulk send: {0} sent, {1} skipped",
  "Bulk send too many recipients": "Too many recipients for one run (max. {0}). Please narrow the selection.",
  "BulkSendTooManyRecipients": "Too many recipients for one run. Please narrow the selection.",
  "SystemDocumentNeedsOneSurface": "The template needs at least one output: letter or email.",
  "Send confirmation": "Send confirmation",
  "Send email": "Send email",
  "Send email__alt1": "Send email",
  "Send email__alt2": "Send email",
  "Send via integration": "Send via {integrationName}",
  "Send emails or letters to selected recipients": "Send emails or letters to selected recipients",
  "Send email…": "Send email…",
  "Send letter/email": "Send letter/email",
  "Send letter…": "Send letter…",
  "Send link": "Send link",
  "Send messages": "Send messages",
  "Send": "Send",
  "Send reminder": "Send reminder",
  "Send__alt2": "Send",
  "Send__alt3": "Send",
  "Send__versand": "Send",
  "Sender email": "Sender email",
  "Sender name": "Sender name",
  "sending": "sending",
  "Sending (SMTP)": "Sending (SMTP)",
  "Sending is disabled.": "Sending is disabled.",
  "Sending": "Sending",
  "Sending__alt1": "Sending",
  "Sending__versand": "Sending",
  "Sent": "Sent",
  "Sent__gesendet": "sent",
  "Sent__alt2": "Sent",
  "sent__alt2": "sent",
  "SEPA": "SEPA",
  "SEPA direct debit active": "SEPA direct debit active",
  "SEPA direct debit is disabled. Create/download is blocked (Settings → SEPA → Direct debit export).": "SEPA direct debit is disabled. Create/download is blocked (Settings → SEPA → Direct debit export).",
  "SEPA file downloaded": "SEPA file downloaded",
  "SEPA file not yet generated": "SEPA file not yet generated",
  "SEPA report available after download or posting": "The report becomes available once the SEPA file has been downloaded or the run has been posted.",
  "Post available after SEPA file download": "Posting is possible once the SEPA file has been downloaded or submitted outside m1member.",
  "SEPA file was submitted outside m1member": "SEPA file was submitted outside m1member",
  "SEPA group": "SEPA group",
  "SEPA groups": "SEPA groups",
  "SEPA Report": "SEPA Report",
  "SEPA Share": "SEPA Share",
  "Server time: ": "Server time: ",
  "Server/host": "Server/host",
  "Service": "Service",
  "Service products": "Service products",
  "Services": "Services",
  "set": "set",
  "Set as default": "Set as default",
  "Set new password": "Set new password",
  "Set password": "Set password",
  "Settings": "Settings",
  "Settings saved": "Settings saved",
  "Settings saved.": "Settings saved.",
  "Shape": "Shape",
  "Short code for the studio (e.g. for mandate reference pattern {STUDIO})": "Short code for the studio (e.g. for mandate reference pattern {STUDIO})",
  "Short name": "Short name",
  "Short Name": "Short Name",
  "Show": "Show",
  "show (field column)": "show",
  "required (field column)": "required",
  "Show again": "Show again",
  "Show all": "Show all",
  "Show Appointment Type Icons": "Show Appointment Type Icons",
  "Show diagnostics": "Show diagnostics",
  "Show expired contracts": "Show expired contracts",
  "Show past": "Show past",
  "Show Prices": "Show Prices",
  "Show Privacy Policy": "Show Privacy Policy",
  "Show Step Indicator": "Show Step Indicator",
  "Show Terms & Conditions": "Show Terms & Conditions",
  "Sign in": "Sign in",
  "Sign in__alt2": "Sign in",
  "Signature (text template)": "Signature (text template)",
  "Signing date": "Signing date",
  "Simulates without sending": "Simulates without sending",
  "Since start of day": "Since start of day",
  "Size": "Size",
  "Skipped": "Skipped",
  "Slot (min)": "Slot (min)",
  "Slot Duration (Minutes)": "Slot Duration (Minutes)",
  "Slots": "Slots",
  "Small": "Small",
  "Smaller number = higher up": "Smaller number = higher up",
  "SMS": "SMS",
  "SMS cannot be combined with other channels.": "SMS cannot be combined with other channels.",
  "SMS details": "SMS details",
  "SMS text (max. 160 characters recommended). Variables: {{variable}}": "SMS text (max. 160 characters recommended). Variables: {{variable}}",
  "SMS text (max. 160 chars recommended)": "SMS text (max. 160 chars recommended)",
  "WhatsApp": "WhatsApp",
  "WhatsApp cannot be combined with other channels.": "WhatsApp cannot be combined with other channels.",
  "WhatsApp cannot be combined with SMS.": "WhatsApp cannot be combined with SMS.",
  "WhatsApp available": "Has WhatsApp",
  "No WhatsApp": "No WhatsApp",
  "Webhook recipient number (for inbound)": "Webhook recipient number (for inbound)",
  "Webhook number placeholder": "e.g. +491771234567",
  "Webhook number must be international format": "Number must be in international format (e.g. +491771234567)",
  "Phone number that receives inbound SMS/WhatsApp. Used to route webhook to this tenant.": "Phone number that receives inbound SMS/WhatsApp. Used to route webhook to this tenant.",
  "SMTP host": "SMTP host",
  "Delivery route": "Delivery route",
  "Own SMTP server": "Own SMTP server",
  "A relay carries only the provider login. The sender address stays with this account, so several accounts can share one relay.": "A relay carries only the provider login. The sender address stays with this account, so several accounts can share one relay with their own sender.",
  "SMTP test failed.": "SMTP test failed.",
  "SMTP test successful (test email was sent).": "SMTP test successful (test email was sent).",
  "Sort order": "Sort order",
  "Source": "Source",
  "Check-in source manual": "Manual",
  "Check-in reader reception": "Front desk",
  "Check-in source reader": "Reader",
  "Check-in source app": "App",
  "Check-in source system": "System",
  "Source and target must be different.": "Source and target must be different.",
  "Source and target must have the same number of studios and resources.": "Source and target must have the same number of studios and resources.",
  "Sources": "Sources",
  "Specify end date": "Specify end date",
  "Spooler": "Spooler",
  "Square": "Square",
  "SSL": "SSL",
  "Stack trace": "Stack trace",
  "Start date": "Start date",
  "Start date is required": "Start date is required",
  "Price adjustment starts in the past warning": "Warning: the new price adjustment starts in the past.",
  "Start date is required.": "Start date is required.",
  "Start Date__alt1": "Start Date",
  "Start Date__alt2": "Start Date",
  "Start is required": "Start is required",
  "Start is required.": "Start is required.",
  "Start page": "Start page",
  "Start page after login": "Start page after login",
  "Start": "Start",
  "Start__alt1": "Start",
  "State": "State",
  "State/Region": "State/Region",
  "Status": "Status",
  "Status (Member/Lead/Former)": "Status (Member/Lead/Former)",
  "Status updated": "Status updated",
  "Status: New · Click opens lead manager": "Status: New · Click opens lead manager",
  "Step": "Step",
  "Step is required": "Step is required",
  "Stored per user (key:": "Stored per user (key:",
  "Street": "Street",
  "Street (optional)": "Street",
  "Studio (optional)": "Studio",
  "Studio already assigned": "Studio already assigned",
  "Studio created": "Studio created",
  "Studio deleted": "Studio deleted",
  "Studio display": "Studio display",
  "Studio is required.": "Studio is required.",
  "Studio is required": "Studio is required",
  "Studio is required__alt1": "Studio is required",
  "Studio updated": "Studio updated",
  "Studio(s)": "Studio(s)",
  "Studio:": "Studio:",
  "Studio__alt1": "Studio",
  "Studios": "Studios",
  "Studios (usage)": "Studios (usage)",
  "Sub Device": "Sub Device",
  "Sub-devices are synced from m1connect-service after registration. Then you can configure allowed actions per sub-device here.": "Sub-devices are synced from m1connect-service after registration. Then you can configure allowed actions per sub-device here.",
  "Subject": "Subject",
  "Subject is required": "Subject is required",
  "Submission deadline": "Submission deadline",
  "Submit request": "Submit request",
  "Successful": "Successful",
  "Successfully saved": "Successfully saved",
  "Summary": "Summary",
  "Summary__alt1": "Summary",
  "Summary__kurzbeschreibung": "Summary",
  "Sun": "Sun",
  "Sunday": "Sunday",
  "Surcharge": "Surcharge",
  "Surcharge Type": "Surcharge Type",
  "Switch duration (ms)": "Switch duration (ms)",
  "Switch light or dark": "Switch light or dark",
  "Switch duration must be >= 0": "Switch duration must be >= 0",
  "System": "System",
  "System email templates": "System email templates",
  "System error notifications": "System error notifications",
  "System error recipient": "System error recipient",
  "Email address to receive system error notifications in release mode.": "Email address to receive system error notifications in release mode.",
  "System Logs": "System Logs",
  "System role": "System role",
  "Table": "Table",
  "Table columns": "Table columns",
  "Table header": "Header",
  "Table cells": "Cells",
  "Table total": "Total",
  "Insert table": "Insert table",
  "Remove table from layout": "Remove table from workspace",
  "Reset table appearance": "Reset table appearance",
  "Reset table appearance confirmation": "The saved table appearance for this channel will be reset to the default. The sample table remains in the workspace.",
  "Take photo": "Take photo",
  "Target": "Target",
  "Target phase": "Target phase",
  "Target pipeline status": "Target pipeline status",
  "Target scope": "Target scope",
  "Tariff": "Tariff",
  "Tariff Blocks": "Tariff Blocks",
  "Tariff: For „Selected studios only“, studios must be selected.": "Tariff: For „Selected studios only“, studios must be selected.",
  "Task completed.": "Task completed.",
  "Tax Rate (%)": "Tax Rate (%)",
  "Team/Pool": "Team/Pool",
  "Team/Pool (Group of persons)": "Team/Pool (Group of persons)",
  "Teams/Pools": "Teams/Pools",
  "Telefon": "Phone",
  "template": "template",
  "Template categories": "Template categories",
  "Template could not be loaded.": "Template could not be loaded.",
  "Template created": "Template created",
  "Template deleted": "Template deleted",
  "Template deleted.": "Template deleted.",
  "Template is required": "Template is required",
  "Template saved.": "Template saved.",
  "Template updated": "Template updated",
  "Template": "Template",
  "Template__alt2": "Template",
  "Template__vorlage": "Template",
  "Templates & variants (packages)": "Templates & variants (packages)",
  "Templates apply per studio (sender = studio).": "Templates apply per studio (sender = studio).",
  "Tenant": "Tenant",
  "Tenant default: {0}": "Tenant default: {0}",
  "Open user account menu": "Open user account menu",
  "Open window menu": "Open window menu",
  "Minimize window": "Minimize window",
  "Maximize window": "Maximize window",
  "Restore window": "Restore window",
  "Close window": "Close window",
  "Tenant (default)": "Tenant (default)",
  "Tenant cannot be deleted": "Tenant cannot be deleted",
  "Tenant created": "Tenant created",
  "Tenant deleted": "Tenant deleted",
  "Tenant integrations access all": "all integration types (including future types)",
  "Tenant integrations access mode label": "allowed integration types",
  "Tenant integrations access selected": "selected types only",
  "Tenant integrations allowed types label": "select types",
  "Tenant modules access all": "all modules (including future modules)",
  "Tenant modules access mode label": "enabled modules",
  "Tenant modules access selected": "selected modules only",
  "Tenant modules allowed label": "select modules",
  "Tenant modules section title": "Modules",
  "Tenant modules select at least one": "Select at least one module.",
  "Tenant modules all active tag": "All modules",
  "Tenant integrations section title": "Integrations",
  "Tenant integrations select at least one": "Select at least one integration type.",
  "Tenant ID": "Tenant ID",
  "Tenant name": "Tenant name",
  "Tenant name is required": "Tenant name is required",
  "Tenants": "Tenants",
  "Tenants__alt1": "Tenants",
  "Tenant data": "Copy/delete data",
  "Tenant data card description": "Copy templates, master data and configuration between tenants, or delete by group",
  "Tenant data additive copy description": "Configuration and template files are added to the target. Existing data in the target remain untouched.",
  "Tenant data allow copy template deletion": "Explicitly allow deletion in copy-template tenant",
  "Tenant data automatic dependency tag": "auto (dependency)",
  "Tenant data available count": "available",
  "Tenant data changed reload preview": "Data has changed. Please reload the preview.",
  "Tenant data confirm tenant name label": "Type the tenant name exactly to confirm",
  "Tenant data copy action": "Copy",
  "Tenant data copy complete": "Copy complete",
  "Tenant data copy failed": "Copy failed",
  "Tenant data copy modal title": "Copy tenant data",
  "Tenant data copy selection help": "Uncheck individual entries to skip them when copying.",
  "Tenant data copy tab": "Copy data",
  "Tenant data copy template warning": "Warning: tenant is marked as copy template.",
  "Tenant data create preview action": "Create preview",
  "Tenant data delete permanently action": "Delete permanently",
  "Tenant data delete tab": "Delete data",
  "Tenant data delete target first help": "Selected groups in the target will be deleted completely before copying.",
  "Tenant data delete target first label": "Delete in target first (replace mode)",
  "Tenant data deletion complete": "Deletion complete",
  "Tenant data deletion failed": "Deletion failed",
  "Tenant data deletion preview title": "These data will be deleted",
  "Tenant data deletion selection help": "Uncheck individual entries to skip them when deleting.",
  "Tenant data deletion warning": "Deletion irreversibly removes templates, master data and configuration. Persons, contracts, payments and appointments are kept.",
  "Tenant data excluded label": "excluded",
  "Tenant data files copied": "files copied",
  "Tenant data files removed": "files deleted",
  "Tenant data groups label": "Groups",
  "Tenant data of count": "of",
  "Tenant data preview action": "Preview",
  "Tenant data preview failed": "Preview failed",
  "Tenant data remaining rows": "remaining rows",
  "Tenant data replace mode data loss": "Existing data of the selected groups in the target will be lost.",
  "Tenant data replace mode warning": "Replace mode: Selected groups in the target will be deleted first and replaced by the source.",
  "Tenant data select source tenant": "Select source tenant",
  "Tenant data select target tenant": "Select target tenant",
  "Tenant data select tenant": "Select tenant",
  "Tenant data source label": "Source",
  "Tenant data source preview title": "Source tenant preview",
  "Tenant data start copy action": "Start copy",
  "Tenant data target label": "Target",
  "Tenant data target rows": "rows in target",
  "Tenant data target state title": "State in target tenant",
  "Tenant data tenant label": "Tenant",
  "Tenant data tenant name mismatch": "Tenant name does not match.",
  "Tenant data tenants load failed": "Tenants could not be loaded",
  "Tenant data transfer description": "Copy templates, master data and configuration between tenants, or delete groups. Persons, contracts, payments and appointments are excluded.",
  "Mandantendaten": "Copy/delete data",
  "Daten kopieren": "Copy data",
  "Daten loeschen": "Delete data",
  "Vorlagen, Stamm- und Konfigurationsdaten zwischen Mandanten kopieren oder gruppenweise loeschen. Personen, Vertraege, Zahlungen und Termine sind ausgeschlossen.": "Copy templates, master data and configuration between tenants, or delete groups. Persons, contracts, payments and appointments are excluded.",
  "Quelle": "Source",
  "Ziel": "Target",
  "Quell-Mandant waehlen": "Select source tenant",
  "Ziel-Mandant waehlen": "Select target tenant",
  "Mandant waehlen": "Select tenant",
  "Vorschau": "Preview",
  "Vorschau erstellen": "Create preview",
  "Vorschau Quell-Mandant": "Source tenant preview",
  "Vorschau fehlgeschlagen": "Preview failed",
  "Stand im Ziel-Mandant": "State in target tenant",
  "Mandantendaten kopieren": "Copy tenant data",
  "Konfigurationsdaten und zugehoerige Vorlage-Dateien (Templates, Logos, Schriften) werden additiv ins Ziel kopiert. Bestehende Daten im Ziel bleiben erhalten.": "Configuration and template files (templates, logos, fonts) are added to the target. Existing data in the target remain untouched.",
  "Kopieren": "Copy",
  "Kopieren starten": "Start copy",
  "Kopie abgeschlossen": "Copy complete",
  "Kopie fehlgeschlagen": "Copy failed",
  "Datensaetze im Ziel": "rows in target",
  "Dateien kopiert": "files copied",
  "Dateien entfernt": "files deleted",
  "Restzeilen": "remaining rows",
  "von": "of",
  "verfuegbar": "available",
  "Ausgeschlossen": "Excluded",
  "Einzelne Eintraege per Checkbox abwaehlen, um sie nicht zu kopieren.": "Uncheck individual entries to skip them when copying.",
  "Einzelne Eintraege per Checkbox abwaehlen, um sie nicht zu loeschen.": "Uncheck individual entries to skip them when deleting.",
  "entity.ContractTemplate": "Contract templates",
  "entity.ContractPackageTemplate": "Contract package templates",
  "entity.Plan": "Plans",
  "entity.TermDefinition": "Terms",
  "entity.RestPeriodTemplate": "Rest period templates",
  "entity.CancellationModelTemplate": "Cancellation models",
  "entity.PaymentPlan": "Payment plans",
  "entity.PriceAdjustment": "Price adjustments",
  "entity.ReportTemplate": "Report templates",
  "entity.AvailabilityTemplate": "Availability templates",
  "entity.WhatsAppMetaTemplate": "WhatsApp templates",
  "entity.Studio": "Studios",
  "entity.AppointmentType": "Appointment types",
  "entity.AppointmentGroup": "Booking groups",
  "entity.AppointmentOutcome": "Appointment outcomes",
  "entity.AppointmentNotificationSettings": "Appointment notifications",
  "entity.Resource": "Resources",
  "entity.ReaderDevice": "Reader devices",
  "entity.ReaderDeviceQrCode": "Reader QR codes",
  "entity.ReaderDeviceHardware": "Reader hardware",
  "entity.HolidayConfig": "Holiday configs",
  "entity.Holiday": "Holidays",
  "entity.LeadSource": "Lead sources",
  "entity.LeadPipeline": "Lead pipelines",
  "entity.LeadPhase": "Lead phases",
  "entity.Article": "Articles",
  "entity.PersonTag": "Person tags",
  "entity.BankAccount": "Bank accounts",
  "entity.SepaGroup": "SEPA groups",
  "entity.SepaSettings": "SEPA settings",
  "entity.PaymentMethodDefinition": "Payment methods",
  "entity.WalletProduct": "Wallet products",
  "entity.ReminderLevel": "Reminder levels",
  "entity.DebtCollectionAgency": "Debt collection agencies",
  "entity.VatSettings": "VAT settings",
  "entity.AccountingDefaults": "Accounting defaults",
  "entity.AccountingAccount": "Accounting accounts",
  "entity.MemberAppSettings": "Studio app settings",
  "entity.MemberAppAsset": "Studio app assets",
  "entity.BookingWidgetSettings": "Booking widget settings",
  "entity.LeadWidget": "Lead widgets",
  "entity.WidgetDesignTemplate": "Public form design templates",
  "entity.ContractSigningWidget": "Contract signing widgets",
  "entity.ContractSigningWidgetTemplate": "Widget-template links",
  "entity.DashboardConfig": "Dashboard configurations",
  "entity.AppearanceSettings": "Appearance",
  "entity.UnitsSettings": "Units/localization",
  "entity.EmailProcessingSettings": "Email processing",
  "entity.OutboundMessageSettings": "Outbound message settings",
  "entity.LegalTextSettings": "Legal texts/T&C",
  "entity.ApiIntegration": "API integrations",
  "entity.CommunicationRule": "Communication rules",
  "entity.UserRole": "User roles",
  "entity.CalendarSettings": "Calendar settings",
  "Diese Daten werden geloescht": "These data will be deleted",
  "Loeschung entfernt Vorlagen, Stamm- und Konfigurationsdaten unwiderruflich. Personen, Vertraege, Zahlungen und Termine bleiben unangetastet.": "Deletion irreversibly removes templates, master data and configuration. Persons, contracts, payments and appointments are kept.",
  "Zur Bestaetigung den Mandantennamen exakt eingeben": "Type the tenant name exactly to confirm",
  "Mandantenname passt nicht.": "Tenant name does not match.",
  "Mandant": "Tenant",
  "Endgueltig loeschen": "Delete permanently",
  "Loeschung abgeschlossen": "Deletion complete",
  "Loeschung fehlgeschlagen": "Deletion failed",
  "Daten haben sich geaendert. Bitte Vorschau erneut laden.": "Data has changed. Please reload the preview.",
  "Tenants konnten nicht geladen werden": "Tenants could not be loaded",
  "Abbrechen": "Cancel",
  "Vorlagen": "Templates",
  "Stammdaten": "Master data",
  "Zahlungs-Konfiguration": "Payment configuration",
  "App- & Widget-Konfiguration": "App & widget configuration",
  "rows": "rows",
  "Entity": "Entity",
  "Gruppen": "Groups",
  "automatisch (Abhaengigkeit)": "auto (dependency)",
  "Im Ziel zuerst loeschen (Replace-Mode)": "Delete in target first (replace mode)",
  "Vor dem Kopieren werden die ausgewaehlten Gruppen im Ziel komplett geloescht.": "Selected groups in the target will be deleted completely before copying.",
  "Replace-Mode: Im Ziel werden die ausgewaehlten Gruppen ZUERST geloescht und dann durch die Quelle ersetzt.": "Replace mode: Selected groups in the target will be deleted FIRST and replaced by the source.",
  "Bestehende Daten der gewaehlten Gruppen im Ziel gehen verloren.": "Existing data of the selected groups in the target will be lost.",
  "Konfigurationsdaten und zugehoerige Vorlage-Dateien werden additiv ins Ziel kopiert. Bestehende Daten im Ziel bleiben erhalten.": "Configuration and template files are added to the target. Existing data in the target remain untouched.",
  "Achtung: Mandant ist als Kopiervorlage markiert.": "Warning: tenant is marked as copy template.",
  "Loeschung im Kopiervorlage-Mandanten ausdruecklich erlauben": "Explicitly allow deletion in copy-template tenant",
  "Term": "Term",
  "Termination Dates": "Termination Dates",
  "Terms & Conditions": "Terms & Conditions",
  "Terms Text": "Terms Text",
  "Terms and Conditions Text": "Terms and Conditions Text",
  "Terms URL": "Terms URL",
  "URL placeholder": "https://…",
  "Test API integration": "Test API integration",
  "Test connection": "Test connection",
  "Test failed. Please check settings.": "Test failed. Please check settings.",
  "Test IMAP": "Test IMAP",
  "Test mode": "Test mode",
  "Test Open": "Test Open",
  "Test Ping": "Test Ping",
  "Test SMTP": "Test SMTP",
  "Test successful! Connection works.": "Test successful! Connection works.",
  "Test": "Test",
  "Test__alt1": "Test",
  "Text Color": "Text Color",
  "Text color": "Text color",
  "Text alignment": "Text alignment",
  "Company and studio": "Company with studio contact",
  "Bold": "Bold",
  "Italic": "Italic",
  "Underline": "Underline",
  "Widget & steps": "Widget & steps",
  "Widget background": "Widget background (booking card)",
  "Widget background tooltip": "Background of the card that contains the entire booking form.",
  "Week bar background": "Week bar background",
  "Week bar background tooltip": "Background of the „Week X“ bar with the navigation arrows.",
  "Week bar text color": "Week bar text color",
  "Week bar text color tooltip": "Text color in the „Week X“ bar.",
  "Day selector background": "Day selector background",
  "Day selector background tooltip": "Background of the area with the day tiles (Mon, Tue, …).",
  "Day selector text color": "Day selector text color",
  "Day selector text color tooltip": "Text color on the day tiles (date, weekday).",
  "Day tile background (unselected)": "Day tile background (unselected)",
  "Day tile background (selected)": "Day tile background (selected)",
  "Text is required": "Text is required",
  "Text processing": "Text processing",
  "Text templates": "Text templates",
  "Thank you for your booking!": "Thank you for your booking!",
  "Thank you for your request!": "Thank you for your request!",
  "The account (including stored credentials) will be deleted.": "The account (including stored credentials) will be deleted.",
  "The booking group could not be found.": "The booking group could not be found.",
  "The lead widget could not be found.": "The lead widget could not be found.",
  "These texts are displayed in the Studio app (Datenschutz & AGB & Impressum). Full text is embedded; no external links.": "These texts are displayed in the Studio app (privacy policy, terms, imprint). Full text is embedded; no external links.",
  "The email spooler processes outgoing emails from the queue. These settings control how many emails are sent per batch and how much time must elapse between batches.": "The email spooler processes outgoing emails from the queue. These settings control how many emails are sent per batch and how much time must elapse between batches.",
  "The final mandate reference should be max. 35 characters.": "The final mandate reference should be max. 35 characters.",
  "The following sub-contracts will also be deleted:": "The following sub-contracts will also be deleted:",
  "The following wallets will also be deleted:": "The following wallets will also be deleted:",
  "The membership end date has been changed. What should happen to the contributions?": "The membership end date has been changed. What should happen to the contributions?",
  "What should happen to the contributions for this cancellation?": "What should happen to the contributions for this cancellation?",
  "The cancellation preview could not be loaded.": "The cancellation preview could not be loaded.",
  "The minimum time between batches helps comply with provider limits (e.g., max. X emails per minute).": "The minimum time between batches helps comply with provider limits (e.g., max. X emails per minute).",
  "The old link will become invalid.": "The old link will become invalid.",
  "The password is generated automatically and shown once.": "The password is generated automatically and shown once.",
  "The password is shown only here once.": "The password is shown only here once.",
  "The payment method for the overpayment can differ from the main payment. If nothing is selected, the main payment method will be used.": "The payment method for the overpayment can differ from the main payment. If nothing is selected, the main payment method will be used.",
  "The primary administrator account cannot be deactivated.": "The primary administrator account cannot be deactivated.",
  "The primary administrator account cannot be deleted.": "The primary administrator account cannot be deleted.",
  "The primary administrator account must have an email address.": "The primary administrator account must have an email address.",
  "The role of the primary account cannot be changed": "The role of the primary account cannot be changed",
  "The role of the primary account cannot be changed.": "The role of the primary account cannot be changed.",
  "The spooler checks the queue every 30 seconds.": "The spooler checks the queue every 30 seconds.",
  "Theme": "Theme",
  "Theme JSON": "Theme JSON",
  "Themes": "Themes",
  "There are overlaps or resource capacity is insufficient. Book anyway?": "There are overlaps or resource capacity is insufficient. Book anyway?",
  "These values are prefilled automatically when creating new people.": "These values are prefilled automatically when creating new people.",
  "This action cannot be undone.": "This action cannot be undone.",
  "This contribution is already included in a SEPA direct debit run and cannot be paid manually": "This contribution is already included in a SEPA direct debit run and cannot be paid manually",
  "This device is already connected to m1connect. A registration code is not required.": "This device is already connected to m1connect. A registration code is not required.",
  "This device is already registered. A new registration code will disconnect the existing connection. The device must register again. Do you want to continue?": "This device is already registered. A new registration code will disconnect the existing connection. The device must register again. Do you want to continue?",
  "This DeviceId is already in use": "This DeviceId is already in use",
  "This feature is planned but not available yet.": "This feature is planned but not available yet.",
  "This field can be edited directly. Cursor can append entries automatically.": "This field can be edited directly. Cursor can append entries automatically.",
  "This field is fixed in studio accounts.": "This field is fixed in studio accounts.",
  "This page does not exist (anymore).": "This page does not exist (anymore).",
  "This pattern is used when creating mandate references in person records.": "This pattern is used when creating mandate references in person records.",
  "This person has no email address.": "This person has no email address.",
  "This QR code is already in use": "This QR code is already in use",
  "This system role always has full access.": "This system role always has full access.",
  "This template does not allow overrides on creation — items are taken from the package and shown here for review only.": "This template does not allow overrides on creation — items are taken from the package and shown here for review only.",
  "This template will be available in these studios.": "This template will be available in these studios.",
  "This time is already booked in another studio.": "This time is already booked in another studio.",
  "This time range overlaps an existing entry.": "This time range overlaps an existing entry.",
  "This widget currently accepts contact requests only. Appointment booking is not set up.": "This widget currently accepts contact requests only. Appointment booking is not set up.",
  "Thu": "Thu",
  "Thursday": "Thursday",
  "Time range": "Time range",
  "Time Slots": "Time Slots",
  "Time zone": "Time zone",
  "Time": "Time",
  "Time__alt2": "Time",
  "Timeout: Device did not respond in time": "Timeout: Device did not respond in time",
  "Timeouts": "Timeouts",
  "Times, settings & holidays": "Times, settings & holidays",
  "Timestamp": "Timestamp",
  "Title": "Title",
  "Title__alt1": "Title",
  "TLS/SSL": "TLS/SSL",
  "To contract end": "To contract end",
  "To end of month": "To end of month",
  "To end of quarter": "To end of quarter",
  "To login": "To login",
  "To renewal end": "To renewal end",
  "To:__alt1": "To:",
  "To:__alt2": "To:",
  "To person": "To person",
  "To": "To",
  "Until": "Until",
  "Until__time": "until",
  "Please check the highlighted fields.": "Please check the highlighted fields.",
  "To__alt2": "To",
  "Good morning": "Good morning",
  "Good afternoon": "Good afternoon",
  "Good evening": "Good evening",
  "Today": "Today",
  "Token invalid or expired": "Token invalid or expired",
  "Token missing. Please use the link from the email.": "Token missing. Please use the link from the email.",
  "Tokens:": "Tokens:",
  "Total": "Total",
  "Total amount": "Total amount",
  "Total Amount": "Total Amount",
  "Total Appointments": "Total Appointments",
  "Total Cancellations": "Total Cancellations",
  "Total Chargeback Amount": "Total Chargeback Amount",
  "Total Check-ins": "Total Check-ins",
  "Total Contracts": "Total Contracts",
  "Total Leads": "Total Leads",
  "Total New Members": "Total New Members",
  "Total No-Shows": "Total No-Shows",
  "Total Revenue": "Total Revenue",
  "Total Slots": "Total Slots",
  "Total Transactions": "Total Transactions",
  "Trainer": "Trainer",
  "Training start date is required": "Training start date is required",
  "Training start is required": "Training start is required",
  "Training start is required.": "Training start is required.",
  "Standing order": "Standing order",
  "Transfer": "Transfer",
  "Transfer to credit wallet": "Transfer to credit wallet",
  "Transitions": "Transitions",
  "Transitions saved": "Transitions saved",
  "Trial": "Trial",
  "Trial period": "Trial period",
  "Trial Period": "Trial Period",
  "Trial Period Cancellation Fee": "Trial Period Cancellation Fee",
  "Trigger": "Trigger",
  "TTL (ms, optional)": "TTL (ms, optional)",
  "Tue": "Tue",
  "Tuesday": "Tuesday",
  "Type": "Type",
  "Type is required": "Type is required",
  "Type to search (name or email); up to 50 results per search.": "Type to search (name or email); up to 50 results per search.",
  "Type to search or no results": "Type to search or no results",
  "Type__alt1": "Type",
  "Type__art": "Type",
  "Types": "Types",
  "Types of appointments": "Types of appointments",
  "Unavailabilities": "Unavailabilities",
  "Unavailabilities & configurable reasons (e.g. vacation, sick)": "Unavailabilities & configurable reasons (e.g. vacation, sick)",
  "Unavailability created": "Unavailability created",
  "Unavailability deleted": "Unavailability deleted",
  "Unavailability reason created": "Unavailability reason created",
  "Unavailability reason deleted": "Unavailability reason deleted",
  "Unavailability reason updated": "Unavailability reason updated",
  "Unavailability reasons": "Unavailability reasons",
  "Unavailability entries": "Entries",
  "Unavailability updated": "Unavailability updated",
  "Uncategorized": "Uncategorized",
  "Underpayment": "Underpayment",
  "Active members": "Active members",
  "Unique Members": "Unique Members",
  "Unit": "Unit",
  "Units": "Units",
  "Units duplicated.": "Units duplicated.",
  "Units reset.": "Units reset.",
  "Units saved.": "Units saved.",
  "Units – Default (my settings)": "Units – Default (my settings)",
  "Unknown": "Unknown",
  "Unknown error": "Unknown error",
  "Unlimited": "Unlimited",
  "unlimited": "unlimited",
  "Unlock": "Unlock",
  "Unlock device": "Unlock device",
  "Unlock person": "Unlock person",
  "Unlock…": "Unlock…",
  "Unnamed contract package": "Unnamed contract package",
  "Unnamed sub-contract": "Unnamed sub-contract",
  "Unnamed wallet": "Unnamed wallet",
  "up": "up",
  "Update interval (days)": "Update interval (days)",
  "Update time": "Update time",
  "Upload": "Upload",
  "Upload document": "Upload document",
  "Upload failed": "Upload failed",
  "Upload logo": "Upload logo",
  "Uploading...": "Uploading...",
  "Replace logo": "Replace logo",
  "Save first to upload logo": "Please save first to upload a logo.",
  "Save configuration first to add reader device assignments": "Please save the configuration first to add reader device assignments.",
  "Transaction history": "Transaction history",
  "Upload image": "Upload image",
  "URL": "URL",
  "Usage history": "Usage history",
  "Usage limit": "Usage limit",
  "Usage purposes": "Usage purposes",
  "Usage Reports": "Usage Reports",
  "Usage reports": "Usage reports",
  "Usage__alt2": "Usage",
  "Usage__verwendung": "Usage",
  "Use check-in": "Use check-in",
  "Use normal availabilities": "Use normal availabilities",
  "Use sending": "Use sending",
  "Used as default when assigning to contract packages and when manually creating for persons.": "Used as default when assigning to contract packages and when manually creating for persons.",
  "Used by": "Used by",
  "Used when multiple contracts for a person are grouped together.": "Used when multiple contracts for a person are grouped together.",
  "Used when only one transaction per person is created.": "Used when only one transaction per person is created.",
  "User availabilities": "User availabilities",
  "User availability": "User availability",
  "User created": "User created",
  "User deleted.": "User deleted.",
  "User ID": "User ID",
  "User templates": "User templates",
  "Username / email": "Username / email",
  "Username is required": "Username is required",
  "Username or password is incorrect.": "Username or password is incorrect.",
  "User": "User",
  "Username__alt1": "Username",
  "Users": "Users",
  "Users (staff) belonging to this pool.": "Users (staff) belonging to this pool.",
  "Users__alt2": "Users",
  "Users__alt3": "Users",
  "Utilization": "Utilization",
  "Utilization %": "Utilization %",
  "Valid from": "Valid from",
  "Valid from is required": "Valid from is required",
  "Valid until": "Valid until",
  "Valid until (optional)": "Valid until",
  "Valid until:": "Valid until:",
  "Validity": "Validity",
  "Pre-training period": "Pre-training period",
  "Value": "Value",
  "Value account products": "Value account products",
  "Value accounts": "Value accounts",
  "Value accounts with balance grant member status": "Value accounts with balance grant member status",
  "Value must be between 0 and 86400": "Value must be between 0 and 86400",
  "Value must be between 1 and 500": "Value must be between 1 and 500",
  "Variables": "Variables",
  "Variables: {{resetLink}}, {{displayName}}": "Variables: {{resetLink}}, {{displayName}}",
  "VAT": "VAT",
  "VAT setting created.": "VAT setting created.",
  "VAT setting deleted.": "VAT setting deleted.",
  "VAT setting saved.": "VAT setting saved.",
  "Version": "Version",
  "All rights reserved": "All rights reserved.",
  "Contact (m1member)": "m1member@mqorva.de",
  "Version added": "Version added",
  "Version deleted": "Version deleted",
  "Version updated": "Version updated",
  "Versions / Changelog": "Versions / Changelog",
  "View": "View",
  "View logs": "View logs",
  "View logs description": "Log menu (top right) and access to tenant logs.",
  "View appointments": "View appointments",
  "View change history": "View change history",
  "Block/unblock access": "Block/unblock access",
  "View contracts": "View contracts",
  "View dashboard": "View dashboard",
  "View digital file": "View documents",
  "View rest periods": "View rest periods",
  "Edit rest periods": "Edit rest periods",
  "View priceAdjustments": "View price adjustments",
  "Edit priceAdjustments": "Edit price adjustments",
  "View tasks": "View tasks",
  "View email queue": "View email queue",
  "View inbox": "View inbox",
  "View finances": "View finances",
  "View leads": "View leads",
  "View open items": "View open items",
  "View payments": "View payments",
  "View people": "View people",
  "View reminder levels": "View reminder levels",
  "View reminders": "View reminders",
  "View roles": "View roles",
  "View SEPA direct debits": "View SEPA direct debits",
  "View settings": "View settings",
  "View system logs": "View system logs",
  "View templates": "View templates",
  "View users": "View users",
  "Visits": "Visits",
  "Voucher": "Voucher",
  "Waiting for chip…": "Waiting for chip…",
  "Waiting for device...": "Waiting for device...",
  "Wallet": "Wallet",
  "Wallet added.": "Wallet added.",
  "WalletPaymentMethodRequired": "Please select a payment method.",
  "WalletCannotBeDeletedAlreadyBooked": "Wallet cannot be deleted (already has bookings).",
  "Wallet created": "Wallet created",
  "Wallet created (points)": "topped up",
  "Wallet created (currency)": "credited",
  "Wallet Product": "Wallet Product",
  "Wallet product": "Wallet product",
  "Wallet product__alt2": "Wallet product",
  "Wallet Products": "Wallet Products",
  "Wallet products": "Wallet products",
  "Wallet products__alt2": "Wallet products",
  "Wallet saved.": "Wallet saved.",
  "Wallet updated": "Wallet updated",
  "Wallets": "Wallets",
  "WARNING: Delete direct debit run with downloaded SEPA file?": "WARNING: Delete direct debit run with downloaded SEPA file?",
  "Warnings": "Warnings",
  "Webcam": "Webcam",
  "Webcam is only available over HTTPS or localhost.": "Webcam is only available over HTTPS or localhost.",
  "Website": "Website",
  "Wed": "Wed",
  "Wednesday": "Wednesday",
  "week": "week",
  "Week of month": "Week of month",
  "Week": "Week",
  "Week__alt1": "Week",
  "Weekday": "Weekday",
  "Weekday Rule": "Weekday Rule",
  "Weekly": "Weekly",
  "weekly dues": "weekly dues",
  "Weekly dues must be >= 0": "Weekly dues must be >= 0",
  "Weekly planning & templates": "Weekly planning & templates",
  "Welcome to our booking system": "Welcome to our booking system",
  "We will get back to you shortly.": "We will get back to you shortly.",
  "When enabled, all open items for a person are combined into a single direct debit transaction.": "When enabled, all open items for a person are combined into a single direct debit transaction.",
  "When enabled: Persons with active value account (Balance > 0) are considered members, even without an active contract.": "When enabled: Persons with active value account (Balance > 0) are considered members, even without an active contract.",
  "When enabled, a lead is created when a person logs in via OTP for the first time (if they do not already have one).": "When enabled, a lead is created when a person logs in via OTP for the first time (if they do not already have one).",
  "When the customer books as a lead (customerType = lead), a lead is created. Set default source and studio here.": "When the customer books as a lead (customerType = lead), a lead is created. Set default source and studio here.",
  "Widget created": "Widget created",
  "Widget deleted": "Widget deleted",
  "Widget updated": "Widget updated",
  "Widget URL": "Widget URL",
  "Widget preview": "Widget preview",
  "Lead widget preview": "Lead widget preview",
  "Color hex placeholder": "#1677ff",
  "Time placeholder": "1:00",
  "Widget UI": "Widget UI",
  "Header style": "Header style",
  "Day selector style": "Day selector style",
  "Element alignment": "Alignment",
  "Align left": "Left",
  "Align center": "Center",
  "Align right": "Right",
  "Time slots style": "Time slots style",
  "Tiles": "Tiles",
  "Pills": "Pills",
  "Boxed": "Boxed",
  "Tabs": "Tabs",
  "Premium": "Premium",
  "Minimal": "Minimal",
  "Time slots columns (mobile)": "Time slots columns (mobile)",
  "Time slots columns (desktop)": "Time slots columns (desktop)",
  "Will be displayed as label in the digital file. Variables like {{person.firstName}} will be replaced.": "Will be displayed as label in the documents. Variables like {{person.firstName}} will be replaced.",
  "with extension": "with extension",
  "Withdrawal": "Withdrawal",
  "Withdrawal & Trial Period": "Withdrawal & Trial Period",
  "Withdrawal Period": "Withdrawal Period",
  "without extension": "without extension",
  "Word file exported.": "Word file exported.",
  "Word file imported.": "Word file imported.",
  "Wrong confirmation text": "Wrong confirmation text",
  "xxxx-xxxx-xxxx-xxxx-xxxx-xxxx-xxxx-xxxx": "xxxx-xxxx-xxxx-xxxx-xxxx-xxxx-xxxx-xxxx",
  "Year": "Year",
  "Yearly": "Yearly",
  "yearly": "yearly",
  "Yes": "Yes",
  "Yes, book anyway": "Yes, book anyway",
  "Yes, change home studio": "Yes, change home studio",
  "Yes, create": "Yes, create",
  "Yes, create appointment": "Yes, create appointment",
  "Yes, delete": "Yes, delete",
  "Yes, regenerate": "Yes, regenerate",
  "you (accusative)": "you (accusative)",
  "you (dative)": "you (dative)",
  "you (nominative)": "you (nominative)",
  "You are not allowed to open this page.": "You are not allowed to open this page.",
  "You can copy or edit table column settings between users here.": "You can copy or edit table column settings between users here.",
  "You can copy templates between users here. The copy is independent of the original.": "You can copy templates between users here. The copy is independent of the original.",
  "You__alt1": "You",
  "You__alt2": "You",
  "your (feminine)": "your (feminine)",
  "your (masculine)": "your (masculine)",
  "Your abbreviation for confirmation (e.g. MK)": "Your abbreviation for confirmation (e.g. MK)",
  "Your reply": "Your reply",
  "Your booking has been confirmed...": "Your booking has been confirmed...",
  "Your booking is confirmed": "Your booking is confirmed",
  "Booking step appointment": "Appointment type",
  "Booking step data": "Details",
  "Booking step confirm": "Confirm",
  "Booking step date": "Date & time",
  "Booking step done": "Done",
  "Booking step studio": "Studio",
  "Select a studio": "Select a studio",
  "Choose your preferred location": "Choose your preferred location",
  "Your Contact Details": "Your Contact Details",
  "Your Details": "Your Details",
  "Your password has been changed successfully. You can now sign in.": "Your password has been changed successfully. You can now sign in.",
  "Your privacy policy text...": "Your privacy policy text...",
  "Your imprint text...": "Your imprint text...",
  "Your terms and conditions...": "Your terms and conditions...",
  "Your terms...": "Your terms...",
  "ZIP": "ZIP",
  "Zoom": "Zoom",
  "Zip": "Zip",
  "ZIP (optional)": "ZIP",
  "Zone created": "Zone created",
  "Zone deleted": "Zone deleted",
  "Zone updated": "Zone updated",
  "Zones saved": "Zones saved",
  "–": "–",
  "—": "—",
  "— (not specified) —": "— (not specified) —",
  "…": "…",
  "⚠️ IMPORTANT: This direct debit has already been posted. Cancellation will cancel the associated payment.": "⚠️ IMPORTANT: This direct debit has already been posted. Cancellation will cancel the associated payment.",
  "⚠️ IMPORTANT: This direct debit run has already been posted! All associated payments will be cancelled and open items will be reopened.": "⚠️ IMPORTANT: This direct debit run has already been posted! All associated payments will be cancelled and open items will be reopened.",
  "⚠️ IMPORTANT: This posting cannot be undone!": "⚠️ IMPORTANT: This posting cannot be undone!",
  "🇩🇪 German": "🇩🇪 German",
  "🇬🇧 English": "🇬🇧 English",
  "(Global - all studios)": "(Global - all studios)",
  "Account active": "Account active",
  "ActingAccountConfirmationRequired": "Please confirm with your abbreviation.",
  "AccountAbbreviationAlreadyTaken": "This abbreviation is already taken.",
  "AccountEmailAlreadyTaken": "This email address is already taken.",
  "AccountEmailCollidesWithUsername": "This email address conflicts with an existing username.",
  "AccountUserIdentifiersConflict": "Email, abbreviation, or username is already taken.",
  "AccountUsernameAlreadyTaken": "This username is already taken.",
  "AccountUsernameCollidesWithEmail": "This username conflicts with an existing email address.",
  "All": "All",
  "Appointment Utilization": "Appointment Utilization",
  "At least one usage purpose must be selected": "At least one usage purpose must be selected",
  "City": "City",
  "Company": "Company",
  "Company name is required": "Company name is required",
  "Confirmation (on booking)": "Confirmation (on booking)",
  "Confirmation SMS": "Confirmation SMS",
  "Confirmation by Email": "Confirmation by Email",
  "Confirmation by SMS": "Confirmation by SMS",
  "Confirmation by WhatsApp": "Confirmation by WhatsApp",
  "Confirmation WhatsApp": "Confirmation WhatsApp",
  "Content (HTML)": "Content (HTML)",
  "Create": "Create",
  "anlegen": "Create",
  "erweiterte Suche": "Advanced search",
  "neue Person": "New person",
  "Preisanpassung hinzufügen": "Add price adjustment",
  "Ratenzahlung anlegen": "Create installment plan",
  "suchen": "Search",
  "Vertragspaket hinzufügen": "Add contract package",
  "Zahlung bearbeiten": "Edit payment",
  "Zahlung erfassen": "Record payment",
  "Zahlung für mehrere Beiträge": "Payment for multiple contributions",
  "Zahlung stornieren": "Cancel payment",
  "Create Contract Template": "Create contract template",
  "Create email signature": "Create email signature",
  "Create email template": "Create email template",
  "Delete signature": "Delete signature",
  "Description": "Description",
  "Detail": "Detail",
  "Edit email signature": "Edit email signature",
  "Edit email template": "Edit email template",
  "e.g. Standard signature": "e.g. Standard signature",
  "Email content": "Email content",
  "Email content is required": "Email content is required",
  "Email subject (may contain variables)": "Email subject (may contain variables)",
  "Email template confirmation": "Email template confirmation",
  "Email template reminder": "Email template reminder",
  "Error loading data": "Error loading data",
  "For email + mobile: send both channels": "For email + mobile: send both channels",
  "Former": "Former",
  "Former members": "Former members",
  "Lead Sources": "Lead Sources",
  "Lead time SMS (days, hrs, min)": "Lead time SMS (days, hrs, min)",
  "Lead time WhatsApp (days, hrs, min)": "Lead time WhatsApp (days, hrs, min)",
  "Lead time email (days, hrs, min)": "Lead time email (days, hrs, min)",
  "Member Frequency": "Member Frequency",
  "Name": "Name",
  "Name is required": "Name is required",
  "Max 255 characters": "Max. 255 characters",
  "New Contracts": "New Contracts",
  "New signature": "New signature",
  "No signature": "No signature",
  "No text templates available. Please create text templates under 'Templates' first.": "No text templates available. Please create text templates under 'Templates' first.",
  "No-shows": "No-shows",
  "None (default)": "None (default)",
  "Notes": "Notes",
  "Notes label": "Notes label",
  "Open person": "Open person",
  "Person data is managed in Persons": "Person data is managed in Persons",
  "Optional: Assign to a studio. If empty, the account is global for all studios.": "Optional: Assign to a studio. If empty, the account is global for all studios.",
  "Other": "Other",
  "Origin and assignment": "Origin and assignment",
  "Outgoing (SMTP)": "Outgoing (SMTP)",
  "Password Delivery": "Password Delivery",
  "Please enter a name.": "Please enter a name.",
  "Please enter password (for the test).": "Please enter password (for the test).",
  "Popular Appointments": "Popular Appointments",
  "Reminder (before appointment)": "Reminder (before appointment)",
  "Reminder by Email": "Reminder by Email",
  "Reminder by SMS": "Reminder by SMS",
  "Reminder by WhatsApp": "Reminder by WhatsApp",
  "Reminder Email": "Reminder Email",
  "Reminder letter document not found": "The letter for this reminder was not found.",
  "Reminder SMS": "Reminder SMS",
  "Reminder WhatsApp": "Reminder WhatsApp",
  "Reminders": "Reminders",
  "Required": "Required",
  "Required (checkbox label)": "required",
  "Resource must be available": "must be available",
  "SMS template confirmation": "SMS template confirmation",
  "SMS template reminder": "SMS template reminder",
  "Suppress reminder if confirmation is inside reminder window": "do not send a reminder if the confirmation is inside the reminder window",
  "WhatsApp template confirmation": "WhatsApp template confirmation",
  "WhatsApp template reminder": "WhatsApp template reminder",
  "Sales Performance": "Sales Performance",
  "Standard templates": "Standard templates",
  "Studio": "Studio",
  "Studio app": "Studio app",
  "Studio app design": "Studio app design",
  "Studio app audience former": "Former member",
  "Studio app features": "Studio app features",
  "Colors for the Studio app (headers, buttons, backgrounds).": "Colors for the Studio app (headers, buttons, backgrounds).",
  "FinTS (bank connection)": "FinTS (bank connection)",
  "TAN method": "TAN method",
  "Select TAN method": "Select TAN method",
  "Test FinTS connection": "Test FinTS connection",
  "FinTS configuration valid.": "FinTS configuration valid.",
  "FinTS test failed.": "FinTS test failed.",
  "Save credentials for next time (no need to enter them again for connection test)": "Save credentials for next time",
  "You can save them so you are not asked again next time (TAN may still be required).": "You can save them so you are not asked again next time (TAN may still be required).",
  "Credentials saved. You will not be asked again for the connection test.": "Credentials saved. You will not be asked again for the connection test.",
  "Credentials could not be saved.": "Credentials could not be saved.",
  "Save anyway": "Save anyway",
  "FinTS bank URL": "FinTS bank URL",
  "FinTS version": "FinTS version",
  "FinTS version 3.0": "FinTS 3.0",
  "FinTS version HBCI 2.2": "HBCI 2.2",
  "Bank code (BLZ)": "Bank code (BLZ)",
  "Bank code (BLZ) is required for FinTS": "Bank code (BLZ) is required for FinTS.",
  "Bank code must be exactly 8 digits": "Bank code must be exactly 8 digits.",
  "First run connection test": "First run connection test",
  "First run connection test (with credentials) to see available methods.": "First run connection test (with credentials) to see available methods.",
  "Online banking user ID": "Online banking user ID",
  "Run test": "Run test",
  "FinTS bank URL is required for connection test": "FinTS bank URL is required for the connection test.",
  "User ID and PIN are required for the connection test.": "User ID and PIN are required for the connection test.",
  "Enter your online banking credentials for the connection test. They are not stored.": "Enter your online banking credentials for the connection test. They are not stored.",
  "PIN": "PIN",
  "Online connections": "Online connections",
  "Add online connection": "Add online connection",
  "Edit online connection": "Edit online connection",
  "Online connection saved.": "Online connection saved.",
  "Online connection deleted.": "Online connection deleted.",
  "Online connection disabled.": "Online connection disabled.",
  "Online connections could not be loaded.": "Online connections could not be loaded.",
  "List data could not be loaded.": "List data could not be loaded.",
  "Online bank connections are not enabled for this tenant.": "Online bank connections are not enabled for this tenant.",
  "All bank accounts already have an online connection.": "All bank accounts already have an online connection.",
  "No online bank connection configured. Set up FinTS in Settings → Bank → Online connections.": "No online bank connection configured. Set up FinTS in Settings → Bank → Online connections.",
  "Please select a bank account.": "Please select a bank account.",
  "Bank account for online connection": "Bank account",
  "Select bank account for online connection": "Select bank account",
  "Connection type": "Connection type",
  "Credentials": "Credentials",
  "stored": "stored",
  "not stored": "not stored",
  "ready": "ready",
  "incomplete": "incomplete",
  "not configured": "not configured",
  "Set up": "Set up",
  "Disable online connection?": "Disable online connection?",
  "Delete online connection?": "Delete online connection?",
  "The bank account remains unchanged. Only the online connection will be disabled.": "The bank account remains unchanged. Only the online connection will be disabled.",
  "The bank account remains unchanged. Only the online connection will be deleted.": "The bank account remains unchanged. Only the online connection will be deleted.",
  "Disable": "Disable",
  "Enter online banking credentials": "Enter online banking credentials",
  "FinTS steps": "FinTS steps",
  "Last tested": "Last tested",
  "Save the online connection before running the connection test.": "Save the online connection before running the connection test.",
  "Studio app settings card description": "App design and settings per tenant.",
  "Studio app settings": "App settings (member app)",
  "Studio app settings label": "Label",
  "Studio app brand name": "Brand name (login)",
  "Studio app brand name placeholder": "e.g. mQorva Fitness, GRAZIÖS Sportclub",
  "Studio app settings label placeholder": "e.g. Main app, Studio North",
  "Studio app settings edit title": "Edit app setting",
  "Studio app settings basic": "Label and tenant",
  "Distribution and updates": "Distribution and updates",
  "Distribution and updates description": "Store identities are maintained once per base app. Optional and mandatory updates take effect automatically once store availability is confirmed.",
  "Save app configuration before distribution": "Save the base app first so its distribution can be assigned.",
  "Android": "Android",
  "Android package ID": "Android package ID",
  "Closed test link": "Closed test link",
  "iPhone and iPad": "iPhone and iPad",
  "iOS bundle ID": "iOS bundle ID",
  "App Store ID": "App Store ID",
  "TestFlight invitation link": "TestFlight invitation link",
  "Approve app release": "Approve app release",
  "Create app release": "Create app release",
  "Create release draft": "Create release draft",
  "Advance app release": "Advance app release",
  "Release": "Release",
  "Release state": "Release state",
  "Production available": "Production available",
  "Enforce update": "Enforce update",
  "Store verification reference": "Store availability evidence",
  "Save release state": "Save release state",
  "Release history": "Release history",
  "Enforced": "Enforced",
  "Platform": "Platform",
  "Build number": "Build number",
  "Release channel": "Release channel",
  "Production": "Production",
  "Closed test": "Closed test",
  "Update type": "Update type",
  "Optional update": "Optional update",
  "Mandatory update": "Mandatory update",
  "Await store availability": "Await store availability",
  "AppRelease.apps": "Apps",
  "AppRelease.applicationId": "Package/bundle ID",
  "AppRelease.createConnection": "Create store account",
  "AppRelease.assignmentCoverage": "Assigned apps",
  "AppRelease.confirmTest": "Confirm test availability",
  "app_release_test_confirmation_invalid": "Test confirmation requires an unpublished test build with a configured testing link.",
  "AppRelease.releases": "App updates",
  "AppRelease.deliveries": "Deliveries",
  "AppRelease.connections": "Store accounts",
  "AppRelease.policy": "App update",
  "AppRelease.mandatory": "Mandatory update",
  "AppRelease.mandatoryEnforces": "Older app versions will be blocked as soon as this build is available.",
  "AppRelease.updateKind": "Update type",
  "AppRelease.mandatoryUpdate": "Mandatory",
  "AppRelease.optionalUpdate": "Optional",
  "AppRelease.internalNote": "Internal note",
  "AppRelease.storeBinding": "Store configuration",
  "AppRelease.storeAvailability": "Store availability",
  "AppRelease.confirmedAvailability": "Confirmed store availability",
  "AppRelease.storeBuild": "Store build",
  "AppRelease.buildMissing": "Build not assigned yet",
  "AppRelease.testPending": "Test confirmation pending",
  "AppRelease.testConfirmed": "Test availability confirmed",
  "AppRelease.testLinkMissing": "Add the testing link in this app's store configuration.",
  "AppRelease.noAccountRequired": "No credentials required",
  "AppRelease.channelReset": "Changing the channel removes previous availability confirmations and the enforcement based on them for this update. Builds must be confirmed again for the new channel.",
  "AppRelease.noStoreBindings": "No app has store configuration for these platforms yet.",
  "app_release_channel_conflict": "Another assignment of this store version or build number already exists for one of the apps in the selected channel.",
  "AppRelease.technicalVersion": "Technical release",
  "AppRelease.platforms": "Platforms",
  "AppRelease.connection": "Store account",
  "AppRelease.store": "Store",
  "AppRelease.credentials": "Credentials",
  "AppRelease.configured": "Configured",
  "AppRelease.notConfigured": "Not configured",
  "AppRelease.serviceEmail": "Google service account email",
  "AppRelease.issuerId": "Apple issuer ID",
  "AppRelease.keyId": "Apple key ID",
  "AppRelease.privateKey": "Private key (PEM)",
  "AppRelease.keyUnchanged": "Leave blank to retain the stored key. Enter the matching key again when changing the account identity.",
  "AppRelease.delivery": "Store delivery",
  "AppRelease.storeVersion": "Store version",
  "AppRelease.availability": "Store availability",
  "AppRelease.lastCheck": "Last check",
  "AppRelease.checkError": "Check result",
  "AppRelease.notChecked": "Not checked yet",
  "AppRelease.notAvailable": "Not available yet",
  "AppRelease.available": "Available",
  "AppRelease.checkFailed": "Check failed",
  "AppRelease.loadFailed": "App release management could not be loaded.",
  "AppRelease.checkNone": "No errors",
  "AppRelease.checkConfiguration": "The store assignment or credentials are missing or invalid. Please check the configuration.",
  "AppRelease.checkAuthentication": "Store authentication was rejected. Please check the credentials.",
  "AppRelease.checkPermission": "The store account cannot access this app. Please check permissions.",
  "AppRelease.checkUnreachable": "The store is temporarily unreachable. Please try again later.",
  "AppRelease.checkResponse": "The store response could not be processed.",
  "AppRelease.connectionSuccessful": "Store access for this app is working.",
  "AppRelease.testConnection": "Test connection",
  "AppRelease.publishedImmutable": "The identity of a published delivery cannot be changed.",
  "AppRelease.storeDistribution": "Store distribution",
  "AppRelease.country": "Store country (country code)",
  "AppRelease.checkMethod": "Version check",
  "AppRelease.publicVersion": "Public version lookup",
  "AppRelease.authenticatedBuild": "Exact build check with store account",
  "app_store_configuration_invalid": "Please provide valid store identifiers and credentials.",
  "app_store_connection_missing": "The selected store account no longer exists.",
  "app_store_private_key_required": "A matching private key is required for this store account.",
  "app_store_private_key_invalid": "The private key is invalid or does not match the store.",
  "app_store_connection_in_use": "This store account is assigned to an app and cannot be deleted.",
  "app_store_public_version_ambiguous": "Multiple builds use the same store version. Use exact build verification or assign a unique store version.",
  "app_release_configuration_invalid": "Please provide a valid version, platforms and update type.",
  "app_release_version_exists": "This technical release already exists for the channel.",
  "app_release_identity_in_use": "This assignment is already in use. Its delivery identity cannot be changed or deleted.",
  "app_release_platform_disabled": "The technical release does not apply to the selected platform.",
  "app_release_delivery_exists": "This build or technical release is already assigned to the app.",
  "Mandatory update reason": "Mandatory update reason",
  "Security": "Security",
  "Authentication": "Authentication",
  "API compatibility": "API compatibility",
  "Data integrity": "Data integrity",
  "Native runtime": "Native runtime",
  "Dependency security": "Dependency security",
  "Approve release": "Approve release",
  "Studio app settings description": "Central list: tenant (branded or standard) and studio scope; one row with tenant „Standard (mQorva)“ for tenants without their own branding.",
  "Studio app settings add title": "Add app settings",
  "Studio app settings default tenant": "Standard (mQorva)",
  "Studio app settings delete confirm title": "Delete app setting?",
  "Studio app settings studio scope": "Studio scope",
  "Studio app settings tenant extra": "Empty = standard (mQorva) for tenants without their own branding.",
  "Studio app settings tenant placeholder": "Select tenant or default",
  "Studio app settings duplicate default hint": "Default row cannot be duplicated (only one allowed).",
  "Studio app settings edit design and config": "Edit design and settings",
  "Duplicate failed": "Duplicate failed",
  "Scope, appointments & access": "Scope, appointments & access",
  "Features & profile": "Features & profile",
  "Logo & design": "Logo & design",
  "Logo and images": "Logo and images",
  "Logo and images intro": "Logo and slot images for the member app. Save the configuration first, then upload.",
  "Studio app preview Home": "Home",
  "Studio app preview Contracts": "Contracts",
  "Studio app preview Bookings": "Bookings",
  "Studio app preview Wallets": "Wallets",
  "Studio app preview Open items": "Open items",
  "Studio app preview Payments": "Payments",
  "Studio app preview Check-in history": "Check-in history",
  "Studio app preview Studios": "Studios",
  "Studio app preview Welcome name": "Max",
  "Studio app preview Welcome name full": "Max Mustermann",
  "Studio app preview Welcome name email": "max@example.com",
  "Studio app preview Primary": "Primary",
  "Studio app preview Secondary": "Secondary",
  "Studio app preview Sample text color": "Sample text in text color",
  "Studio app preview Sample input": "Sample input",
  "Studio app preview Sample link": "Sample link",
  "Studio app preview Your contracts": "Your contracts",
  "Studio app preview My appointments": "My appointments",
  "Studio app preview Appointments": "Appointments and reservations",
  "Studio app preview Value accounts": "Value accounts",
  "Studio app preview Points and balance": "Points & balance",
  "Studio app preview Dashboard open items": "Open items",
  "Studio app preview Outstanding amounts": "Outstanding amounts",
  "Studio app preview Payment history": "Payment history",
  "Studio app preview My visits": "My visits",
  "Studio app preview Visit history subtitle": "Visit history and activity",
  "Studio app preview Studios and contact": "Studios and contact",
  "Studio app preview Active until …": "Active until …",
  "Studio app preview Active": "Active",
  "Studio app preview Appointment type 1": "Yoga",
  "Studio app preview Tomorrow 10:00": "Tomorrow 10:00",
  "Studio app preview Appointment type 2": "Fitness",
  "Studio app preview In 3 days": "In 3 days",
  "Studio app preview Wallet product": "Training credits",
  "Studio app preview 5 units": "5 units",
  "Studio app preview Open item 1": "Monthly fee March",
  "Studio app preview 50,00 €": "50.00 €",
  "Studio app preview Payment 1": "March 2025",
  "Studio app preview Paid": "Paid",
  "Studio app preview Paid on": "Paid on",
  "Studio app preview Visit history": "Visit history",
  "Studio app preview Last 6 weeks": "Last 6 weeks",
  "Studio app preview Visit chart placeholder": "Chart: visits per week",
  "Studio app preview Recent visits": "Recent visits",
  "Studio app page contracts": "Contracts",
  "Studio app page bookings": "Appointments",
  "Studio app page wallets": "Value accounts",
  "Studio app page open items": "Open items",
  "Studio app page payments": "Payments",
  "Studio app page checkin history": "My visits",
  "Studio app page studios": "Locations",
  "Studio app card contracts": "Contracts",
  "Studio app card contracts subtitle": "Your contracts",
  "Studio app card bookings": "My appointments",
  "Studio app card bookings subtitle": "Appointments and reservations",
  "Studio app card wallets": "Value accounts",
  "Studio app card wallets subtitle": "Points & balance",
  "Studio app card open items": "Open items",
  "Studio app card open items subtitle": "Outstanding contributions",
  "Studio app card payments": "Payments",
  "Studio app card payment methods": "Payment methods",
  "Studio app card payment methods subtitle": "Bank account and payment details",
  "Studio app card payments subtitle": "Payment history",
  "Studio app card staff schedule": "Staff schedule",
  "Studio app card staff schedule subtitle": "Shifts at a glance",
  "Studio app card checkin history": "My visits",
  "Studio app card checkin history subtitle": "Visit history and activity",
  "Studio app card studios": "Locations",
  "Studio app card studios subtitle": "Studios and contact",
  "Studio app preview Ends on": "Ends on",
  "Studio app preview Contract ended": "Ended",
  "Studio app preview Contract active": "active",
  "Studio app preview One-time item": "Starter package",
  "Studio app preview Trainer name": "A. Schmidt",
  "Studio app preview New appointment": "New appointment",
  "Studio app preview Next appointment": "Next appointment",
  "Studio app preview Tomorrow": "tomorrow",
  "Studio app preview This week": "This week",
  "Studio app preview Next week": "Next week",
  "Studio app preview places free": "places free",
  "Studio app preview Balance": "Balance",
  "Studio app preview points": "points",
  "Studio app preview Total amount": "Total",
  "Studio app preview Due": "Due",
  "Studio app preview Open item generic": "Open contribution",
  "Studio app preview Payment generic": "Payment",
  "Studio app preview Payment method transfer": "Bank transfer",
  "Studio app preview Average visits": "On average",
  "Studio app preview visits per week": "visits per week",
  "Studio app preview Heatmap none": "None",
  "Studio app preview Studio name 2": "Studio South",
  "Bottom bar over limit": "The app shows five slots. Further entries stay saved and move up once you remove an icon above them or one of those does not apply to an account.",
  "Bottom bar primary": "highlighted",
  "Bottom bar scan needs reader": "only visible when a reverse QR reader is assigned",
  "Bottom bar order tooltip": "Five slots. Only what is assigned here appears — if an entry does not apply to an account, the next assigned one moves up. The highlighted entry appears as a round button in the middle and moves there automatically.",
  "QR check-in": "QR check-in",
  "Bottom bar entry beyond limit": "Currently not shown in the app – it sits behind the last available slot.",
  "Studio app preview Studio name": "Main studio",
  "Studio app preview Address": "Address",
  "Studio app preview Sample address": "Example Street 1, 12345 Sample City",
  "Studio app preview Sample city": "Sample City",
  "Welcome": "Welcome",
  "Images": "Images",
  "Save configuration first to upload images": "Save configuration first to upload images",
  "Save configuration first to upload logo and images": "Save the configuration first to upload logo and images.",
  "No images uploaded yet.": "No images uploaded yet.",
  "No image set.": "No image set.",
  "Image set": "Image set.",
  "Click image to use as slot image": "Click image to use as slot image.",
  "Image catalog": "Image catalog",
  "Ideal size": "Ideal size",
  "Recommended format": "Recommended format",
  "Choose from catalog": "Choose from catalog",
  "No catalog images yet.": "No catalog images yet.",
  "Move back to catalog": "Move back to catalog",
  "Assign to slot": "Assign to slot",
  "Upload to catalog": "Upload to catalog",
  "Load sample images": "Load sample images",
  "Load sample images tooltip": "Adds up to 10 indoor fitness/studio images (CC0/PD from Wikimedia Commons) in random order to the catalog. The AuthBackground slot is filled at random if empty.",
  "Library": "Library",
  "Adopt": "Adopt",
  "Studio app standard template": "Studio app standard template",
  "Standard template for Studio app": "Standard template for Studio app",
  "Standard image (read-only)": "System",
  "New tenant configurations copy design and use these images as fallback. Tenants can override with their own images.": "New tenant configurations copy design and use these images as fallback. Tenants can override with their own images.",
  "Default design and images for the Studio app (used when tenants create new configurations)": "Default design and images for the Studio app (used when tenants create new configurations)",
  "Order updated": "Order updated",
  "Home hero image": "Home hero image",
  "Auth background image": "Auth background image",
  "Empty state image": "Empty state image",
  "Card image: Contracts": "Card image: Contracts",
  "Card image: Appointments": "Card image: Appointments",
  "Card image: Bookings": "Card image: Bookings",
  "Card image: Wallets": "Card image: Wallets",
  "Card image: Open items": "Card image: Open items",
  "Card image: Payment methods": "Card image: Payment methods",
  "Card image: Payments": "Card image: Payments",
  "Card image: Staff schedule": "Card image: Staff schedule",
  "Card image: Check-in history": "Card image: Check-in history",
  "Card image: Studios": "Card image: Studios",
  "Shown on the dashboard. Recommended: wide (16:9) and high contrast.": "Shown on the dashboard. Recommended: wide (16:9) and high contrast.",
  "Shown on login / onboarding screens. Recommended: portrait and subtle.": "Shown on login / onboarding screens. Recommended: portrait and subtle.",
  "Shown when lists are empty. Recommended: clean and optimistic.": "Shown when lists are empty. Recommended: clean and optimistic.",
  "Image above the Contracts card on the dashboard. Optional.": "Image above the Contracts card on the dashboard. Optional.",
  "Image above the Appointments card. Optional.": "Image above the Appointments card. Optional.",
  "Image above the Wallets card. Optional.": "Image above the Wallets card. Optional.",
  "Image above the Open items card. Optional.": "Image above the Open items card. Optional.",
  "Image above the Payment methods card. Optional.": "Image above the Payment methods card. Optional.",
  "Image above the Payments card. Optional.": "Image above the Payments card. Optional.",
  "Image above the Staff schedule card. Optional.": "Image above the Staff schedule card. Optional.",
  "Image above the Check-in history card. Optional.": "Image above the Check-in history card. Optional.",
  "Image above the Studios card. Optional.": "Image above the Studios card. Optional.",
  "Removed": "Removed.",
  "Reverse QR (check-in/out)": "Reverse QR (check-in/out)",
  "Reverse QR reader for app": "Reverse QR reader for app",
  "Reverse QR reader assignments for app": "Reverse QR reader assignments for app",
  "Add reader assignment": "Add reader assignment",
  "Sub device (QR code)": "Sub device (QR code)",
  "Actions on scan": "Actions on scan",
  "No actions available": "No actions available",
  "No actions available for selected device": "No actions available for selected device",
  "If set, only this reader device accepts scans from the app. Empty = any Reverse-QR device.": "If set, only this reader device accepts scans from the app. Empty = any Reverse-QR device.",
  "Studio scope in app": "Studio scope in app",
  "Studio app config studios": "Studios",
  "HomeStudioOnly = show only home studio. AllStudios = show all studios.": "HomeStudioOnly = show only home studio. AllStudios = show all studios.",
  "Advanced": "Advanced",
  "All studios": "all studios",
  "All studios (default)": "all studios (default)",
  "Active studio scope": "active studio scope",
  "Global studio scope aria": "Studio scope for lists and dashboard",
  "Global studio scope count": "{0} studios",
  "Search all studios": "Search all studios",
  "No matches in studio scope": "No matches in “{0}”",
  "Few matches in studio scope": "Only {0} matches in “{1}”",
  "Manual check-in computer studio": "Studio for manual check-in on this computer",
  "Manual check-in computer studio placeholder": "Choose studio",
  "Manual check-in computer studio missing":
    "no studio for manual check-in on this computer is configured – please set it at the top of Check-in",
  "Set manual check-in computer studio": "Set",
  "Manual check-in computer studio saved toast": "Studio for manual check-in on this computer saved.",
  "Check-in icon locked": "Locked",
  "Bank name": "Bank name",
  "Booking": "Booking",
  "Button": "Button",
  "Check-in & Access": "Check-in & Access",
  "Show password": "Show password",
  "Hide password": "Hide password",
  "Change plan": "Change plan",
  "Legal": "Legal",
  "The document could not be loaded.": "The document could not be loaded.",
  "Close": "Close",
  "Member area": "Member area",
  "Profile fields": "Profile fields",
  "Requires studio approval": "Requires studio approval",
  "Self-editable": "Self-editable",
  "Show Imprint": "Show Imprint",
  "AllStudios (default)": "AllStudios (default)",
  "Profile self-editable fields": "Profile self-editable fields",
  "Comma-separated: firstName,lastName,phone,mobile,street,zip,city,country,bankAccountHolder,iban,bic,bankName. Empty = all allowed.": "Comma-separated: firstName,lastName,phone,mobile,street,zip,city,country,bankAccountHolder,iban,bic,bankName. Empty = all allowed.",
  "Profile requires approval fields": "Profile requires approval fields",
  "Comma-separated: Fields that require studio approval. Changes are rejected.": "Comma-separated: Fields that require studio approval. Changes are rejected.",
  "Booking overview": "Booking overview",
  "Booking widget for app": "Booking widget for app",
  "Appointments (App)": "Appointments (App)",
  "Select studios, resources and appointment types – these will be bookable in the app under \"Appointments\". With \"Home studio only\", only home studio appointments are shown.": "Select studios, resources and appointment types – these will be bookable in the app under \"Appointments\". With \"Home studio only\", only home studio appointments are shown.",
  "Booking widget for members": "Booking widget for members",
  "Booking widget for non-members": "Booking widget for non-members",
  "Online booking group for members in the Studio app": "Online booking group for members in the Studio app",
  "Online booking group for non-members in the Studio app": "Online booking group for non-members in the Studio app",
  "Online booking group used in the Studio app for appointments": "Online booking group used in the Studio app for appointments",
  "Contract overview": "Contract overview",
  "Check-in history": "Check-in history",
  "Edit data": "Edit data",
  "Pause request": "Pause request",
  "News": "News",
  "Opening hours": "Opening hours",
  "Opening hours block label": "Block label (e.g. Trainer times, Sauna)",
  "Add opening hours block": "Add opening hours block",
  "Remove block": "Remove block",
  "Move block up": "Move block up",
  "Move block down": "Move block down",
  "Move up": "Move up",
  "Move down": "Move down",
  "Duplicate day to next": "Duplicate day to next",
  "Add time range": "Add time range",
  "Studio info": "Studio info",
  "Features and profile intro": "These options control which areas and features are visible in the member app.",
  "Dashboard card order": "Dashboard card order",
  "Dashboard card order help": "Order of cards on the home screen. Drag to reorder.",
  "New row": "New row",
  "Profile card order": "Profile card order",
  "Profile card order help": "Order of cards on the app profile screen (Personal data, Settings). Drag and drop to reorder.",
  "Personal data": "Personal data",
  "Enable at least one dashboard card in the sections above.": "Enable at least one dashboard card in the sections above.",
  "Dashboard cards": "Home screen cards",
  "Dashboard cards help": "The check mark turns the card on in the app, dragging changes the order. Unchecked cards keep their position.",
  "More features without a card": "More features without a card",
  "No dashboard cards available for this audience.": "No cards are available for this audience.",
  "Appointment scope needs a tenant": "Studios, resources and appointment types belong to a tenant. Select a tenant above to preset them.",
  "Studio app brand name required": "The brand name is required. Without it the app shows \"m1app\" and the store handover fails.",
  "Activate": "Activate",
  "Deactivate": "Deactivate",
  "Bottom bar icons": "Bottom bar icons",
  "Bottom bar": "Bottom bar",
  "Bottom bar background": "Bottom bar background",
  "Bottom bar icon color": "Bottom bar icon color",
  "Bottom bar selected icon color": "Bottom bar selected icon color",
  "Bottom bar colors": "Bottom bar colors",
  "Bottom bar label home": "Home",
  "Bottom bar label contracts": "Contracts",
  "Bottom bar label bookings": "Appointments",
  "Bottom bar label wallets": "Wallets",
  "Bottom bar label openItems": "Fees",
  "Bottom bar label payments": "Payments",
  "Bottom bar label paymentMethods": "Payment methods",
  "Bottom bar label checkinHistory": "Visits",
  "Bottom bar label profile": "Profile",
  "Bottom bar label settings": "Settings",
  "Bottom bar label studios": "Locations",
  "Bottom bar label restPeriods": "Rest periods",
  "Bottom bar label cancellation": "Cancellation",
  "Bottom bar label staffSchedule": "Staff schedule",
  "Bottom bar label scan": "Check-in",
  "Bottom bar empty hint": "Without assigned icons the app shows no bottom bar.",
  "Bottom bar primary icon color": "Primary icon color",
  "Bottom bar primary button background": "Primary button background",
  "Icon order": "Icon order",
  "Max 4 icons when QR check-in reader is connected.": "Max 4 icons when QR check-in reader is connected.",
  "Max 5 icons when no QR check-in reader; with reader, max 4.": "Max 5 icons when no QR check-in reader; with reader, max 4.",
  "Max 5 icons without QR check-in reader.": "Max. 5 icons without QR check-in reader.",
  "Comma-separated: home, contracts, bookings, wallets, openItems, payments, paymentMethods, checkinHistory, profile, settings, studios, restPeriods, cancellation. Empty = defaults from feature flags.": "Comma-separated: home, contracts, bookings, wallets, openItems, payments, paymentMethods, checkinHistory, profile, settings, studios, restPeriods, cancellation. Empty = defaults from feature flags.",
  "Min. app version": "Min. app version",
  "Minimum app version for update check (e.g. 1.2.0)": "Minimum app version for update check (e.g. 1.2.0)",
  "Design JSON": "Design JSON",
  "Optional JSON for colors and styles (primaryColor, secondaryColor, etc.).": "Optional JSON for colors and styles (primaryColor, secondaryColor, etc.).",
  "Enable or disable features shown in the Studio app. These settings apply tenant-wide.": "Enable or disable features shown in the Studio app. These settings apply tenant-wide.",
  "Lead on first login": "Lead on first login",
  "Studio for leads created on login": "Studio for leads created on login",
  "Feature selection, lead on login, privacy policy, terms, imprint": "Feature selection, lead on login, privacy policy, terms, imprint",
  "Subject required": "Subject required",
  "T": "T",
  "Template loaded, but the editor did not apply the content.": "Template loaded, but the editor did not apply the content.",
  "Templates": "Templates",
  "Templates for Cancellations": "Templates for Cancellations",
  "Templates for notifications": "Templates for notifications",
  "Templates for Reminders": "Templates for Reminders",
  "Text template category: contract confirmation": "Templates for contract confirmation",
  "Templates for Rest Periods": "Templates for Rest Periods",
  "Trainer Utilization": "Trainer Utilization",
  "Username": "Username",
  "Start time": "Start time",
  "End time": "End time",
  "What should this email account be used for?": "What should this email account be used for?",
  "Who can book": "Who can book",
  "e.g. Cancellation confirmation email": "e.g. Cancellation confirmation email",
  "e.g. Contact": "e.g. Contact",
  "e.g. m1member Studio LLC": "e.g. m1member Studio LLC",
  "e.g. 09:00": "e.g. 09:00",
  "e.g. 18:00": "e.g. 18:00",
  "e.g. Standard Sales": "e.g. Standard Sales",
  "sent": "sent",
  "An error occurred": "An error occurred",
  "Error details": "Error details",
  "Error cause": "Error cause",
  "Error ID support hint": "Give this ID to support.",
  "Copy error details": "Copy error details",
  "Copy full error report": "Copy full error report",
  "Copy support info": "Copy support info",
  "Copy technical details": "Copy technical details",
  "Full error report copied to clipboard": "Full error report copied to clipboard.",
  "Support info copied": "Support info copied to clipboard.",
  "Technical details copied": "Technical details copied to clipboard.",
  "API": "API",
  "Body text preview": "bodyText (first 2000 chars)",
  "Component stack": "Component stack",
  "Error properties": "Error properties",
  "Error report URL": "URL",
  "Error report user agent": "User agent",
  "Error source": "Error source",
  "React error decoder": "React error decoder",
  "Decode React error": "Decode React error",
  "Shows full message": "shows full message",
  "Probable source (app code)": "Probable source (app code)",
  "Copy error info": "Copy error info",
  "Error info copied": "Error info copied",
  "Error message": "Error message",
  "The person could not be loaded.": "The person could not be loaded.",
  "No details available.": "No details available.",
  "Critical startup error": "Critical startup error",
  "Database is being checked…": "Database is being checked…",
  "Database is being updated…": "Database is being updated…",
  "Database migration failed": "Database migration failed",
  "Migration failure support instruction": "m1member cannot start. Please contact {0}. The application will reload automatically after the issue has been resolved.",
  "Developer information": "Developer information",
  "Error location": "Error location",
  "Line": "Line",
  "Page where error occurred": "Page where error occurred",
  "module of this page": "module of this page",
  "Error ID (for support):": "Error ID (for support):",
  "Request ID (for support):": "Request ID (for support):",
  "Collapse main sidebar": "Collapse sidebar",
  "Collapse section": "Collapse section",
  "Expand main sidebar": "Expand sidebar",
  "Expand section": "Expand section",
  "m1member": "m1member",
  "Page could not be loaded": "Page could not be loaded",
  "Page could not be loaded after update":
    "The page could not be loaded: part of the app failed to load. This may happen after a release, but also due to network issues, browser cache, ad blockers, or an upstream proxy/CDN serving the wrong response. Try a hard reload (Ctrl+F5) or inspect the failing .js URL in the network tab (status code; body should be JavaScript, not HTML).",
  "Page could not be loaded reload": "Page could not be loaded. Please reload the page (F5).",
  "Please wait a moment.": "Please wait a moment.",
  "Please wait a moment. During this time, the application may be temporarily unavailable.": "Please wait a moment. During this time, the application may be temporarily unavailable.",
  "Reload page": "Reload page",
  "Server is still starting…": "Server is still starting…",
  "Stack": "Stack",
  "The application is currently in maintenance mode. Please inform an administrator.": "The application is currently in maintenance mode. Please inform an administrator.",
  "The application is currently under maintenance. Please reload. If the problem persists, please inform an administrator.": "The application is currently under maintenance. Please reload. If the problem persists, please inform an administrator.",
  "The application is currently in maintenance mode. Please contact support.": "The application is currently in maintenance mode. Please contact {0}.",
  "The database could not be updated. Please contact support so the migration can be checked.": "The database could not be updated. Please contact {0} so the migration can be checked.",
  "The page could not be loaded. You can navigate to another page or reload this page.": "The page could not be loaded. You can navigate to another page or reload this page.",
  "Unhandled error. See details below; reload the page or go to dashboard.": "An unhandled error occurred. See details below; reload the page or go to dashboard.",
  "This can happen after an update. Please reload the page (F5).": "This can happen after an update. Please reload the page (F5).",
  "Booking group not found": "Booking group not found",
  "This booking page does not exist or is not available.": "This booking page does not exist or is not available.",
  "Booking successful!": "Booking successful!",
  "Booking number": "Appointment number",
  "Please keep your booking number. You have received a confirmation by email.": "Please keep your appointment number. You have received a confirmation by email.",
  "1. Select appointment type": "1. Select appointment type",
  "Please select an appointment type": "Please select an appointment type",
  "2. Select appointment": "2. Select appointment",
  "3. Your details": "3. Your details",
  "Please enter": "Please enter",
  "Please enter a valid email": "Please enter a valid email",
  "Notes (optional)": "Notes",
  "Book now (binding)": "Book now (binding)",
  "Login account created": "Login account created",
  "Password is only shown here once.": "Password is only shown here once.",
  "Selected studios": "Selected studios",
  "Sum (selected)": "Sum (selected)",
  "Selected payments__alt": "Selected payments",
  "No permission.": "No permission.",
  "New login account": "New login account",
  "Edit login account": "Edit login account",
  "Create login account": "Create login account",
  "Studio access": "Studio access",
  "Please select studios": "Please select studios",
  "Password is only shown when creating.": "Password is only shown when creating.",
  "e.g. MANDATE-REF-12345": "e.g. MANDATE-REF-12345",
  "e.g. 1:00 for one hour": "e.g. 1:00",
  "e.g. 1:00 for one hour, 0:30 for 30 minutes": "e.g. 1:00 for one hour, 0:30 for 30 minutes",
  "e.g. 49.00": "e.g. 49.00",
  "System Default": "System Default",
  ".booking-widget { /* your styles */ }": ".booking-widget { /* your styles */ }",
  "Studio assignment": "Studio assignment",
  "House No.": "House No.",
  "Delete reminder level": "Delete reminder level",
  "Edit reminder level": "Edit reminder level",
  "Create reminder level": "Create reminder level",
  "e.g. 14": "e.g. 14",
  "e.g. 1. reminder": "e.g. \"1. Reminder\"",
  "(no further escalation)": "(no follow-up level)",
  "(no debt collection)": "(no debt collection)",
  "e.g. noreply@company.com": "e.g. noreply@company.com",
  "e.g. imap.gmail.com": "e.g. imap.gmail.com",
  "e.g. sepa": "e.g. sepa",
  "e.g. B": "e.g. B",
  "Regenerate password": "Regenerate password",
  "Select role...": "Select role...",
  "pain.008.001.08": "pain.008.001.08",
  "pain.008.001.02": "pain.008.001.02",
  "YYYYMMDD": "YYYYMMDD",
  "--:--": "--:--",
  "None (without installments)": "None (without installments)",
  "Delete contract module": "Delete contract module",
  "Select locations…": "Select locations…",
  "Default term (optional)": "Default term",
  "Default renewal (optional)": "Default renewal",
  "Default payment method": "Default payment method",
  "{0} → {1} from {2}": "{0} → {1} from {2}",
  "remains {0}": "remains {0}",
  "Payment method fixed": "Payment method fixed",
  "Payment method fixed hint": "A change of the payment profile does not change the payment method of this component, e.g. for a cash-only rate.",
  "Default direct debit group": "Default direct debit group",
  "None": "None",
  "Default payment cycle (optional)": "Default payment cycle",
  "Payment cycle: every {0} {1}": "every {0} {1}",
  "Default usage limit (optional)": "Default usage limit",
  "Please choose…": "Please choose…",
  "Installments (min/max)": "Installments (min/max)",
  "Contributions {DUE_DATE} ({CONTRACT_COUNT} contracts)": "Contributions {DUE_DATE} ({CONTRACT_COUNT} contracts)",
  "Tomorrow": "Tomorrow",
  "First of next month": "First of next month",
  "e.g. Premium membership": "e.g. Premium membership",
  "Start preset": "Start preset",
  "Initial value": "Initial value",
  "Loading context data …": "Loading context data …",
  "Basic": "Basic",
  "m1access M1AU-RQR.R01": "m1access M1AU-RQR.R01",
  "m1connect": "m1connect",
  "One-time (this year only)": "One-time (this year only)",
  "Yearly on the same date": "Yearly on the same date",
  "Yearly on X. weekday of month": "Yearly on X. weekday of month",
  "1.": "1.",
  "2.": "2.",
  "3.": "3.",
  "4.": "4.",
  "1st": "1st",
  "2nd": "2nd",
  "3rd": "3rd",
  "4th": "4th",
  "last": "last",
  "Min.": "Min.",
  "Max.": "Max.",
  "Preview mode: submission disabled": "Preview mode: submission disabled.",
  "Lead widget: thank you title": "Thank you!",
  "Lead widget: thank you subtitle": "We will get back to you shortly.",
  "Lead widget: accept privacy policy": "I accept the privacy policy",
  "Lead widget: privacy policy link": "Privacy policy",
  "Lead widget: privacy acceptance required": "Please accept the privacy policy.",
  "Lead widget: accept terms": "I accept the terms and conditions",
  "Lead widget: terms link": "Terms and conditions",
  "Lead widget: terms acceptance required": "Please accept the terms and conditions.",
  "Lead widget: accept impressum": "I accept the imprint",
  "Lead widget: impressum acceptance required": "Please confirm the imprint.",
  "Lead widgets: create": "Create lead widget",
  "Lead widgets: code tooltip": "Optional. If empty, a code will be generated automatically.",
  "Lead widgets: regenerate code": "Regenerate code",
  "Lead widgets: embed hint": "Save the widget to generate embed code.",
  "Design name": "Design name",
  "Background": "Background",
  "Font": "Font",
  "Show privacy policy": "Show privacy policy",
  "Require privacy acceptance": "Require privacy acceptance",
  "Privacy policy URL": "Privacy policy URL",
  "Show terms": "Show terms and conditions",
  "Require terms acceptance": "Require terms acceptance",
  "Compatible reader devices (assign with checkbox, set flags)": "Compatible reader devices: assign with checkbox, set flags.",
  "Select icons (order = display order)": "Select icons (order = display order)",
  "Reverse QR enables members to check in and out via the app by scanning the reader device QR code.": "Reverse QR enables members to check in and out via the app by scanning the reader device QR code.",
  "Add icon": "Add icon",
  "No icons selected. Use Add icon to add items.": "No icons selected. Use Add icon to add items.",
  "Studio App": "Studio App",
  "Content area": "Content area",
  "Primary button": "Primary button",
  "App title": "App title",
  "Company name": "Company name",
  "Your company or studio name": "Your company or studio name",
  "Cards": "Cards",
  "Card border radius": "Border radius",
  "Card elevation": "Elevation",
  "Card border color": "Border color",
  "Card border width": "Card border width",
  "Inputs, divider & links": "Inputs, divider & links",
  "Input background color": "Input background color",
  "Input border color": "Input border color",
  "Input text color": "Input text color",
  "Input border radius": "Input border radius",
  "Divider color": "Divider color",
  "Divider thickness": "Divider thickness",
  "Card text color (title)": "Text color (title)",
  "Card subtitle color": "Subtitle color",
  "Card background color": "Background color",
  "Header background (logo area)": "Header background (logo area)",
  "Header text and icon color": "Header text and icon color",
  "Secondary text color (meta)": "Secondary text color (meta)",
  "Colors": "Colors",
  "Design colors and surfaces": "Design: colors and surfaces",
  "Accent color (header)": "Accent color (header)",
  "Accent color (buttons, header)": "Accent color (buttons, header)",
  "Secondary accent": "Secondary accent",
  "Buttons": "Buttons",
  "Button colors, border, shadow": "Button colors, border, shadow",
  "Primary button background": "Primary button background",
  "Primary button text color": "Primary button text color",
  "Primary button border color": "Primary button border color",
  "Button border radius": "Button border radius",
  "Button border color": "Button border color",
  "Button border width": "Button border width",
  "Button elevation": "Button elevation",
  "Secondary button border color": "Secondary button border color",
  "Secondary button text color": "Secondary button text color",
  "Secondary button background": "Secondary button background",
  "Tertiary button text color": "Tertiary button text color",
  "Background color where logo and app title are shown": "Background color of the area where the logo and app title are displayed (leave default or set to match your branding).",
  "Shadows and corners": "Shadows and corners",
  "Login overlay": "Login overlay",
  "Overlay style": "Overlay style",
  "Darken": "Darken",
  "Lighten": "Lighten",
  "Overlay opacity": "Overlay opacity",
  "Text and icon color on overlay": "Text and icon color on overlay",
  "Design texts": "Texts",
  "Card border radius tooltip": "e.g. 12",
  "Card elevation tooltip": "0 = no shadow",
  "Show QR reader in preview": "Show QR reader in preview",
  "QR-Scanner": "QR-Scanner",
  "Usage": "Usage",
  "Leads & Sales": "Leads & Sales",
  "Member stock development": "Member stock development",
  "Member stock development over time": "Member stock development over time",
  "New acquisitions": "New acquisitions",
  "Analysis of new members and contracts": "Analysis of new members and contracts",
  "Cancellation analysis and churn rate": "Cancellation analysis and churn rate",
  "Inactive members": "Inactive members",
  "Retention: members without check-ins": "Retention: members without check-ins",
  "Contract distribution": "Contract distribution",
  "Distribution by tariff and term": "Distribution by tariff and term",
  "Term analysis": "Term analysis",
  "Contract terms and renewals": "Contract terms and renewals",
  "Expiring contracts": "Expiring contracts",
  "Contracts ending soon": "Contracts ending soon",
  "Revenue overview": "Revenue overview",
  "Total revenue and trend": "Total revenue and trend",
  "Open and overdue items analysis": "Open and overdue items analysis",
  "Chargebacks and failure rate": "Chargebacks and failure rate",
  "Cashflow analysis": "Cashflow analysis",
  "Cash in and out over time": "Cash in and out over time",
  "Revenue by tariff": "Revenue by tariff",
  "Revenue distribution by tariff/product": "Revenue distribution by tariff/product",
  "Check-in analysis": "Check-in analysis",
  "Check-ins over time and per studio": "Check-ins over time and per studio",
  "Peak times": "Peak times",
  "Utilization by time of day and weekday": "Utilization by time of day and weekday",
  "Studio utilization": "Studio utilization",
  "Studio usage comparison": "Studio usage comparison",
  "Member frequency": "Member frequency",
  "Visit frequency distribution": "Visit frequency distribution",
  "Visit frequency per member": "Visit frequency per member",
  "Appointment utilization": "Appointment utilization",
  "Appointments and classes utilization": "Appointments and classes utilization",
  "No-show analysis": "No-show analysis",
  "Missed appointments": "Missed appointments",
  "Trainer utilization": "Trainer utilization",
  "Utilization per trainer/resource": "Utilization per trainer/resource",
  "Popular appointments": "Popular appointments",
  "Most booked appointments and times": "Most booked appointments and times",
  "Lead sources": "Lead sources",
  "Lead origin and distribution": "Lead origin and distribution",
  "Conversion rate": "Conversion rate",
  "Lead to member conversion": "Lead to member conversion",
  "Pipeline analysis": "Pipeline analysis",
  "Leads by status and phase": "Leads by status and phase",
  "Sales performance": "Sales performance",
  "Sales per employee": "Sales per employee",
  "WhatsApp templates and phone onboarding": "WhatsApp setup",
  "WhatsApp Meta templates": "WhatsApp Meta templates",
  "Sync from Meta": "Sync from Meta",
  "Submit template": "Submit template",
  "Phone number onboarding": "Phone number onboarding",
  "Country code (e.g. 49)": "Country code (e.g. 49)",
  "Phone number (without +)": "Phone number (without +)",
  "Display name at Meta": "Display name at Meta",
  "Add phone number": "Add phone number",
  "Request verification code": "Request verification code",
  "Code delivery": "Code delivery",
  "Voice": "Voice",
  "2-step verification PIN": "2-step verification PIN",
  "Register phone number": "Register phone number",
  "Phone number registered successfully": "Phone number registered successfully",
  "Template name (lowercase, underscores)": "Template name (lowercase, underscores)",
  "Language code": "Language code",
  "Components (JSON, Meta format)": "Components (JSON, Meta format)",
  "Error loading templates": "Error loading templates",
  "WhatsApp templates synced": "WhatsApp templates synced",
  "Template submitted to Meta": "Template submitted to Meta",
  "Body preview": "Body preview",
  "Verification code sent. Enter code and 2-step PIN to register.": "Verification code sent. Enter code and 2-step PIN to register.",
  "Contract document": "Contract document",
  "Skip": "Skip",
  "Generate and send contract document": "Generate and send contract document",
  "Generate contract document and send via the selected channels?": "Generate contract document and send via the selected channels?",
  "Send by email": "Send by email",
  "Contract document generated and sent.": "Contract document generated and sent.",
  "Integration": "Integration",
  "Signature and send": "Signature and send",
  "Close contract wizard: contract for": "Contract for",
  "Close contract wizard: read then sign hint": "Please read the contract above, then sign below.",
  "Capture signature": "Capture signature",
  "Without signature": "Without signature",
  "With signature (tablet)": "With signature (tablet)",
  "Contract will be created and the contract document will be generated from the selected template.": "Contract will be created and the contract document will be generated from the selected template.",
  "Contract will be created without generating a contract document.": "Contract will be created without generating a contract document.",
  "Sign here (finger or stylus). The contract document will be generated with your signature and can be sent immediately.": "Sign here (finger or stylus). The contract document will be generated with your signature and can be sent immediately.",
  "Close contract wizard: no contract document template": "Please select a contract document template if the contract should be signed or delivered.",
  "Contract document template": "Contract document template",
  "Please select a contract document template.": "Please select a contract document template.",
  "Contract document could not be generated after contract closing.": "The contract was created, but the contract document could not be generated.",
  "Signature": "Signature",
  "Signature (appended to email)": "Signature (appended to email)",
  "Signature content": "Signature content",
  "Signature created": "Signature created",
  "Signature updated": "Signature updated",
  "Signatures": "Signatures",
  "Close contract with signature": "Close contract with signature",
  "Please sign in the signature field before submitting.": "Please sign in the signature field before submitting.",
  "Online contracts": "Online contracts",
  "Contract widget": "Contract widget",
  "Contract widget: widget not found or not available": "Widget not found or not available.",
  "Contract widget: please select a template": "Please select a contract template.",
  "Contract widget: signature required": "Signature is required.",
  "Contract widget: SEPA mandate title": "SEPA direct debit mandate",
  "Contract widget: SEPA mandate info": "This membership is paid by direct debit. Please enter the bank details and confirm the SEPA direct debit mandate.",
  "Contract widget: mandate reference generated": "The mandate reference is created automatically on submission and stored in the master data.",
  "Contract widget: SEPA mandate acceptance": "I authorize the studio to collect payments from my account by SEPA direct debit. I also instruct my payment service provider to honor the direct debits drawn on my account by the studio.",
  "Contract widget: SEPA mandate acceptance required": "The SEPA direct debit mandate must be confirmed.",
  "Account holder is required": "Account holder is required.",
  "Contract widget: error submitting": "An error occurred while submitting.",
  "Contract widget: email required": "Email is required.",
  "Contract widget: first name required": "First name is required.",
  "Contract widget: last name required": "Last name is required.",
  "Contract widget: first or last name required": "Please enter a first or last name.",
  "Contract widget: date of birth required": "Date of birth is required.",
  "Contract widget: phone required": "Phone number is required.",
  "Contract widget: mobile required": "Mobile number is required.",
  "Contract widget: phone or mobile required": "Phone or mobile number is required.",
  "Contract widget: address required": "Address is required.",
  "Contract widget: notes required": "Notes are required.",
  "Contract widget: signature": "Signature",
  "Contract preview unavailable before signing": "The contract is filed as a document once concluded. There is no preview beforehand.",
  "Contract widget: next step book appointment": "Next step: book an appointment",
  "Contract widget: steps": "Steps",
  "Contract signing widgets: contract package templates label": "Contract package templates",
  "Contract signing widgets: embed": "Embed",
  "Contract signing widgets: embed code": "Embed code",
  "Contract signing widgets: saved": "Saved.",
  "Contract signing widgets: created": "Created.",
  "Contract signing widgets: edit": "Edit contract widget",
  "Contract signing widgets: colors": "Colors",
  "Contract signing widgets": "Contract signing widgets",
  "Public widgets for online contract signing": "Public widgets for online contract signing",
  "Contract signing widgets: add": "Add experience contract widget",
  "Contract signing widgets: tab basis": "Basis",
  "Contract signing widgets: tab display": "Display",
  "Contract signing widgets: tab content": "Content",
  "Contract signing widgets: promotion target": "Applies to",
  "Contract signing widgets: promotion start scope": "Starts with",
  "Contract signing widgets: images": "Images",
  "Contract signing widgets: tab form fields": "Form fields",
  "Contract signing widgets: tab success": "Success and follow-up",
  "Contract signing widgets: headline": "Headline",
  "Contract signing widgets: preview fallback widget name": "Sign contract online",
  "Updated at": "Updated at",
  "Accent color": "Accent colour",
  "Contract widget: default widget name": "Online membership",
  "Contract widget: default headline": "Start your membership",
  "Contract widget: preview no offer configured": "No contract package selected yet — the preview only shows what is configured here.",
  "Contract signing widgets: contract packages hint": "The contract packages this form sells. The order is the order of the tiles; term and prices come from the package. Sales promotions belong to the package because they advertise its price.",
  "Contract signing widgets: service bundles hint": "Services that can be bought in addition. They apply to every contract package of this form and are chosen in a separate step. Whatever a contract package already contains is not offered again there.",
  "Contract signing widgets: contract packages": "Contract packages",
  "Contract signing widgets: service bundles": "Service bundles",
  "Contract signing widgets: add contract package": "Add contract package",
  "Contract signing widgets: add service bundle": "Add service bundle",
  "Contract signing widgets: select contract package": "Select contract package",
  "Contract signing widgets: select service bundle": "Select service bundle",
  "Contract signing widgets: no sales promotion yet": "No sales promotion available.",
  "Contract signing widgets: apply promotions to all packages": "Apply promotions to all contract packages",
  "Contract signing widgets: bundle price": "Price in this form",
  "Contract signing widgets: bundle start": "Start",
  "Contract signing widgets: bundle exceptions": "Exceptions per contract package",
  "Contract signing widgets: add exception": "Add exception",
  "Contract signing widgets: bundle offered with own price": "Offered, own price",
  "Contract signing widgets: bundle unavailable": "Not offered here",
  "Contract signing widgets: preselect not allowed online": "In the public form a paid add-on must not be preselected (German Civil Code section 312a(3)). At the counter, preselection is the employee's recommendation.",
  "Contract signing widgets: draft banner": "Draft — not published yet.",
  "Contract signing widgets: cannot activate": "Something is still missing before this can be activated.",
  "Contract term": "Contract term",
  "Status draft": "Draft",
  "E_ContractSigningAvailability_NoInternalWidget": "No signing experience is released for the internal channel. In Settings > Signing experiences > Basics, tick \"Internal (at the counter)\".",
  "E_ContractSigningAvailability_WidgetInactive": "The internal signing experience is not active. Open it in the settings — the banner states what is missing.",
  "E_ContractSigningAvailability_NoContractPackage": "The internal signing experience has no active contract package.",
  "E_ContractSigningAvailability_NoStudio": "No reachable studio is active for the internal signing experience.",
  "E_ContractWidget_NoOffer": "No contract package assigned.",
  "E_ContractWidget_PackageWithoutComponents": "An assigned contract package has no active component.",
  "E_ContractWidget_PublicWithoutContractDocument": "A contract package has no contract document; online signing is not possible without it.",
  "E_ContractWidget_NoStudio": "No active studio is reachable for this form.",
  "ContractWidgetInvalidCode": "The widget code contains invalid characters or is already taken.",
  "ContractWidgetNameRequired": "Please enter a name.",
  "ContractWidgetDuplicateContractPackage": "The same contract package is listed twice in this form.",
  "ContractWidgetDuplicateAddon": "The same service bundle is listed twice in this form.",
  "ContractWidgetPromotionTargetMissing": "The promotion targets a service bundle this contract package does not offer.",
  "ContractOptionGroupIncomplete": "The service bundle has no sellable components.",
  "ContractOptionGroupCycleConflict": "A total price across different payment cycles cannot be determined.",
  "ImageTooLarge": "The image is too large (max 4 MB).",
  "ImageTypeNotAllowed": "Only JPG, PNG, GIF and WebP are allowed.",
  "Contract signing widgets: no contract package yet": "No contract package assigned yet.",
  "Contract signing widgets: no service bundle yet": "No service bundle assigned yet.",
  "Contract signing widgets: manage contract packages": "Manage contract packages",
  "Contract signing widgets: manage option groups": "Manage service bundles",
  "Contract signing widgets: manage sales promotions": "Manage sales promotions",
  "Contract widget: default header text": "Choose the right option, add your details, and secure your start at the studio.",
  "Contract widget: default confirmation title": "Welcome to training",
  "Contract widget: default confirmation message": "Your membership is set up. We will send your documents by email and look forward to your start.",
  "Contract widget: preview template name": "Flex membership",
  "Contract widget: preview template subtitle": "Start flexibly and stay free",
  "Contract widget: preview template description": "Ideal when you want to start right away and keep your training flexible.",
  "Contract widget: preview highlight ready": "Ready to start right away",
  "Contract widget: preview highlight classes": "Classes and training included",
  "Contract widget: preview highlight monthly": "Monthly flexibility",
  "Contract widget: choose membership": "Choose your membership",
  "Contract widget: choose membership subtitle": "Compare the options and choose the model that fits your training.",
  "Contract widget: step studio": "Studio",
  "Contract widget: step offer": "Contract",
  "Contract widget: step details": "Your details",
  "Contract widget: step finish": "Finish",
  "Contract widget: document label": "Your documents",
  "Contract widget: email note": "We will send your documents by email after completion.",
  "ContractSigningStartAppointmentExpired": "The start appointment reservation has expired.",
  "Calendar: held during contract signing": "held – contract signing in progress",
  "Contract signing: early start consent": "I request that training starts before the withdrawal period ends. If I withdraw, I will pay for the share of the service used until then.",
  "Contract signing: step start": "Start appointment",
  "Contract signing: start appointment": "Start appointment",
  "Contract signing: start today": "without appointment – start today",
  "Contract signing: start without appointment": "without appointment – set start freely",
  "Contract signing: minutes {0}": "{0} min",
  "Contract signing: previous week": "‹ previous week",
  "Contract signing: next week": "next week ›",
  "Contract signing: no free slots this week": "Nothing is available this week.",
  "Contract signing: start appointment unavailable": "Appointments cannot be loaded right now. You can continue without an appointment.",
  "Contract signing: start appointment booked": "Your start appointment is booked. The confirmation will arrive by email.",
  "ContractSigningStartAppointmentUnavailable": "The chosen start appointment is no longer available. Please choose another one.",
  "Contract widget: SEPA mandate text generic": "I authorise the studio to collect payments from my account by direct debit. At the same time, I instruct my bank to honour the direct debits drawn on my account by the studio. Note: I can request a refund of the debited amount within eight weeks of the debit date. The conditions agreed with my bank apply. The creditor ID and mandate reference will be sent to me with the contract confirmation.",
  "Contract widget: preview submit disabled": "Nothing is signed in the preview.",
  "Contract signing: start": "Start",
  "Contract signing: minimum term": "Minimum term",
  "Contract signing: until {0}": "until {0}",
  "Contract signing: open-ended": "open-ended",
  "Contract signing: renews by {0}": "then renews by {0} each time",
  "Contract signing: ends automatically": "ends automatically",
  "Contract signing: notice period": "Notice period",
  "Contract signing: notice {0} before term end": "{0} before the term ends",
  "Contract signing: after renewal {0}": "after renewal {0}",
  "Contract signing: notice end of month": "only at month end",
  "Contract signing: notice end of quarter": "only at quarter end",
  "Contract signing: notice end of half year": "only at half-year end",
  "Contract signing: notice end of year": "only at year end",
  "Contract signing: starts {0}": "Starts {0}",
  "Contract signing: minimum term until {0}": "Minimum term until {0}",
  "Contract signing: withdrawal form": "Model withdrawal form",
  "Contract signing: creditor id missing": "No creditor ID could be resolved for the selected studio.",
  "Contract widget: SEPA mandate text {0} {1}": "I authorise {0} (creditor ID {1}) to collect payments from my account by direct debit. At the same time, I instruct my bank to honour the direct debits drawn on my account by {0}. Note: I can request a refund of the debited amount within eight weeks of the debit date. The conditions agreed with my bank apply. The mandate reference will be sent to me with the contract confirmation.",
  "ContractSigningMinorNotAllowed": "Only adults can sign a contract online. Please visit the studio with a parent or guardian.",
  "ContractSigningDateOfBirthInvalid": "Please check the date of birth.",
  "Contract signing: privacy document": "privacy policy",
  "Contract signing: terms document": "terms and conditions",
  "Contract signing: privacy consent {0}": "I have read the {0}.",
  "Contract signing: terms consent {0}": "I accept the {0}.",
  "Contract signing: imprint consent {0}": "I have read the {0}.",
  "Contract signing: step contract data": "Contract details",
  "Contract widget: step payment": "Payment",
  "Contract signing: existing mandate {0}": "Existing mandate {0} will be reused",
  "Contract signing: grant SEPA mandate": "I grant the SEPA direct debit mandate for the bank account provided.",
  "Contract signing: choose or enter a person": "Please choose an existing person or enter a new one.",
  "Contract widget: book bundle": "Book bundle",
  "Contract signing: existing person": "Existing person",
  "Contract signing: no person found": "No person found",
  "Contract signing: other person": "Other person",
  "Contract signing: or new person": "Or enter a new person",
  "Contract signing: no email address": "No email address on file",
  "Contract signing: no delivery": "Do not deliver",
  "Contract signing: open person": "Open person",
  "Contract widget: change offer": "Change",
  "Contract widget: read full contract": "Read full contract",
  "Contract widget: collapse contract": "Collapse contract",
  "Contract signing widgets: preview desktop": "Desktop view",
  "Contract signing widgets: preview mobile": "Mobile view",
  "Contract signing widgets: open as customer": "Open as customer",
  "Contract signing widgets: style": "Color preset",
  "Widget design: form style": "Form style",
  "Widget design: form style standard": "Standard",
  "Widget design: form style elegant": "Elegant",
  "Contract signing widgets: style dark": "Dark",
  "Contract signing widgets: style light": "Light",
  "Contract signing widgets: button contrast low": "The button text is hard to read on the primary color.",
  "Contract signing widgets: fix button text": "Adjust button text",
  "Contract signing widgets: text contrast low": "The text is hard to read on the page background.",
  "Contract signing widgets: fine tuning": "Fine tuning",
  "Contract signing widgets: page background": "Page background",
  "Contract signing widgets: texts": "Texts",
  "Contract widget: sent to email": "Your documents were sent to {{email}}.",
  // Wording from Art. 8(2) of the Consumer Rights Directive, the English counterpart of the
  // § 312j Abs. 3 BGB requirement.
  "Contract widget: submit": "order with obligation to pay",
  "This offer includes an action": "This offer includes a promotion",
  "Total price for the initial term of {0}": "Total price for the initial term of {0}",
  "Recurring contributions": "Recurring contributions",
  "One-off items": "One-off items",
  "Contract signing widgets: background image": "Background image",
  "Contract signing widgets: background image help": "This image is used as the dimmed public widget background.",
  "Contract signing widgets: logo": "Logo",
  "Contract signing widgets: logo help": "The logo appears in the public widget header.",
  "Contract signing widgets: no asset": "No image has been stored yet.",
  "Contract signing widgets: public presentation": "Public presentation",
  "Contract signing widgets: public presentation hint": "These contents appear in the option cards of the experience contract widget.",
  "Contract signing widgets: public title": "Public title",
  "Contract signing widgets: public subtitle": "Subtitle",
  "Contract signing widgets: public description": "Description",
  "Contract signing widgets: highlights": "Highlights",
  "Contract signing widgets: add highlight": "Add highlight",
  "Contract signing widgets: highlight placeholder": "e.g. Studio access included",
  "Contract signing widgets: highlight required": "Please enter highlight text.",
  "Contract signing widgets: badge text": "Badge text",
  "Contract signing widgets: option image": "Contract option image",
  "Contract signing widgets: option image empty": "Without an image, the card uses a modern graphic surface.",
  "Contract signing widgets: save package before image": "Please save the template before uploading an image.",
  "Contract signing widgets: save studio before image": "Please save the studio before uploading an image.",
  "Legal details for business letters": "Legal details for business letters",
  "Legal details hint": "These details appear in the footer of generated letters and emails. Empty fields are omitted — a sole proprietorship has neither a register entry nor legal representatives.",
  "Legal company name": "Legal company name",
  "Legal company name tooltip": "Full name including legal form. Leave empty if the studio name is already complete.",
  "Commercial register court": "Commercial register court",
  "Commercial register number": "Commercial register number",
  "e.g. HRB 12345": "e.g. HRB 12345",
  "VAT identification number": "VAT identification number",
  "Correspondence logo": "Logo for letters and emails",
  "Correspondence logo hint": "Appears in the letterhead of generated documents and at the top of emails. Deliberately separate from the widget image, because a letterhead needs a different picture.",
  "Save studio before uploading the logo": "Please save the studio before uploading a logo.",
  "Left": "Left",
  "Right": "Right",
  "System documents": "Letter and email templates",
  "Variant": "Variant",
  "Base case": "Base case",
  "Add text set": "Add template",
  "Add text set hint": "One template per case. Without a variant it is the base case; a variant can cover a rejection, for example.",
  "Variant name tooltip": "Shown in the selection when sending.",
  "Empty = base case": "empty = base case",
  "Delete text set?": "Delete template?",
  "Delete text set hint": "The next level applies afterwards: studio, then tenant, then the shipped default.",
  "Insert variable": "Insert variable",
  "Introduction": "Introduction",
  "Main text": "Main text",
  "Modern contract signing widgets with tenant assets": "Modern contract widgets with tenant-owned images",
  "View experience contract widgets": "View experience contract widgets",
  "Edit experience contract widgets": "Edit experience contract widgets",
  "Contract signing widgets: primary color": "Primary colour",
  "Contract signing widgets: confirmation email": "Confirmation email",
  "Contract signing widgets: confirmation email template": "Email template",
  "Contract signing widgets: confirmation email template placeholder": "Select template (optional) …",
  "Contract signing widgets: linked booking widget select placeholder": "Select booking widget",
  "Contract signing widgets: linked booking widget label": "Booking widget",
  "Contract signing widgets: enable subsequent booking": "Enable subsequent appointment booking",
  "Contract signing widgets: regenerate link?": "Regenerate widget link?",
  "Contract signing widgets: regenerate link hint": "The previous link will become invalid. A new link will be generated and copied to the clipboard.",
  "Contract signing widgets: link regenerated": "Link has been regenerated.",
  "Contract signing widgets: save first to get widget link": "Please save first to get the widget link.",
  "Contract signing widgets: v2 widget link label": "Experience contract widget link",
  "Contract signing widgets: confirmation email template hint": "No templates from the „Contract confirmation“ group. In Settings → Text template categories, create a category with „Templates for contract confirmation“ and assign email templates to it.",
  "Contract signing widgets: confirmation email template optional hint": "Optional. The confirmation email is sent from the selected template; without a template, you can save and no confirmation email is sent.",
  "Contract signing widgets: edit email templates": "Edit templates",
  "Contract signing widgets: privacy policy": "Privacy policy",
  "Contract signing widgets: require privacy": "Acceptance required",
  "Contract signing widgets: terms and conditions": "Terms and conditions",
  "Contract signing widgets: require terms": "Acceptance required",
  "Contract signing widgets: require impressum": "Impressum must be confirmed.",
  "Contract signing widgets: preview": "Preview",
  "Contract signing widgets: preview live hint": "Changes to colors and texts are reflected live in the preview.",
  "Contract signing widgets: preview after save": "Preview after first save",
  "Contract signing widgets: preview after save description": "Save the widget once to get a link. The live preview will then appear here and reflect your design changes.",
  "Contract signing widgets: lead on completion": "Lead on completion",
  "Contract signing widgets: create lead on completion": "Create lead when contract is signed",
  "Display options": "Display options",
  "Error loading embed code": "Failed to load embed code.",
  "Copy failed": "Copy failed.",
  "Copy": "Copy",
  "Copied": "Copied",
  "Uploaded": "uploaded",
  "{0} is required": "{0} is required",
  "Not reached ({0})": "Not reached ({0})",
  "Contact: {0}": "Contact: {0}",
  "{0} log entries copied to clipboard": "{0} log entries copied to clipboard",
  "Permanently delete \"{0}\" ({1})? This action cannot be undone.": "Do you really want to permanently delete \"{0}\" ({1})? This action cannot be undone!",
  "Error saving (HTTP {0})": "Error saving (HTTP {0})",
  "Error deleting (HTTP {0})": "Error deleting (HTTP {0})",
  "SEPA file cannot be downloaded ({0} errors)": "SEPA file cannot be downloaded ({0} errors)",
  "Deadline tight: only {0} day(s) until execution. File must be submitted to bank by {1}.": "Deadline is tight! Only {0} day(s) until execution date. File must be submitted to the bank by {1}.",
  "Submit by {0} ({1} days remaining)": "Submit by {0} ({1} days remaining)",
  "Fix errors: {0}": "Error details: {0}",
  "Send via {0}": "Send via {0}",
  "Error (HTTP {0})": "Error (HTTP {0})",
  "Transitions from \"{0}\"": "Transitions from \"{0}\"",
  "Time of day (optional)": "Time of day",
  "Text (label)": "Text",
  "Document (label)": "Document",
  "Document is required": "Document is required",
  "{0}–{1} characters": "{0}–{1} characters",
  "{0} characters": "{0} characters",
  "Channel (label)": "Channel",
  "Type (label)": "Type",
  "{0} on {1} – really delete?": "{0} on {1} – really delete?",
  "Error: {0}": "Error: {0}",
  "every 1 min.": "every 1 min.",
  "every {0} min.": "every {0} min.",
  "daily {0}": "daily {0}",
  "every {0} days, {1}": "every {0} days, {1}",
  "daily (interval)": "daily",
  "every {0} days": "every {0} days",
  "Last Error": "Last Error",
  "Configure": "Configure",
  "Run (action)": "Run",
  "Configuration saved": "Configuration saved",
  "every {0} weeks ({1})": "every {0} weeks ({1})",
  "Schedule {0}": "Schedule {0}",
  "Availabilities will be copied to {0} week(s).": "Availabilities will be copied to {0} week(s).",
  "Copy weeks open range hint": "Leaving fields empty uses the current week. If only one field is set, exactly that week is used.",
  "Reset weeks to default": "Reset weeks to default",
  "Reset explicit week availabilities so the default for all weeks applies again.": "Deletes only explicitly set week availabilities. Default availabilities are kept and apply again afterwards.",
  "Reset weeks open range hint": "Leaving fields empty uses the current week. If only one field is set, exactly that week is used.",
  "Weeks reset to default.": "Weeks reset to default.",
  "Contract component name placeholder": "Contract component name (e.g. \"GRAZIOES 12 Months\")",
  "Contract package name placeholder": "Contract package name (e.g. \"BASIS Package\")",
  "Due date format placeholder": "Due date in format DD.MM.YY (e.g. \"05.01.26\")",
  "Amount format placeholder": "Amount in format XXXX.XX (e.g. \"35.99\")",
  "Note: For multiple contracts you can use different formats.": "Note: For multiple contracts, you can use different formats, e.g. \"Contributions {DUE_DATE}\" for a summary or multiple lines with \"{DUE_DATE} {CONTRACT_NAME} {AMOUNT} €\" each for detailed listings.",
  "Inactive ≥ {0} months": "Inactive ≥ {0} months",
  "Lead status New": "New",
  "Lead status Contacted": "Contacted",
  "Lead status Appointment": "Appointment",
  "Lead status Showed up": "Showed up",
  "Lead status Closed won": "Closed won",
  "Lead status Closed lost": "Closed lost",
  "To confirm, type the tenant ID: {0}": "To confirm, type the tenant ID: {0}",
  "Type {0} to confirm": "Type {0} to confirm.",
  "Installment payment ({0})": "Installment payment ({0})",
  "Number of installments must be between {0} and {1}.": "Number of installments must be between {0} and {1}.",
  "Min. {0} / Max. {1}": "Min. {0} / Max. {1}",
  "Last consent: {0}": "Last consent: {0}",
  "{0}-{1} of {2}": "{0}-{1} of {2}",
  "Manage tenants and companies": "Manage tenants and companies",
  "Tenant administration card description": "Manage tenants, companies, and master data",
  "Tenant management": "Tenant management",
  "Tenant operations": "Tenant tools",
  "Tenant operations card description": "Run backups and forced deletion per tenant",
  "Tenant operations description": "Operational tools for selected tenants: backups, restore, and forced deletion.",
  "Tenant backup management": "Tenant backups",
  "Tenant backups card description": "Create and restore backups per tenant",
  "Tenant backups description": "Manage backups and restores for the selected tenant.",
  "Tenant force delete": "Force delete",
  "Tenant force delete card description": "Run forced deletion per tenant",
  "Tenant force delete description": "Run forced deletion for the selected tenant.",
  "Select tenant": "Select tenant",
  "Platform admin users": "Platform admin users",
  "Background services and scheduler": "Background services and scheduler",
  "Admin settings": "Admin settings",
  "View and export system logs": "View and export system logs",
  "Incidents": "Incidents",
  "Connections on hold": "Connections on hold",
  "Operations card description": "Disruptions, incidents and held tenant connections",
  "FailureSource_sms_send": "SMS dispatch",
  "FailureSource_whatsapp_send": "WhatsApp dispatch",
  "Outbound email queue (admin scope)": "Outbound email queue (admin scope)",
  "SEPA direct debit runs (admin)": "SEPA direct debit runs (admin)",
  "Really delete role \"{0}\"?": "Really delete role \"{0}\"?",
  "Column: {0}": "Column: {0}",
  "Table key: {0}": "Table: {0}",
  "Column settings for \"{0}\" copied successfully": "Column settings for \"{0}\" copied successfully",
  "Really delete column settings for \"{0}\"?": "Do you really want to delete the column settings for \"{0}\"?",
  "Capability: {0}": "Capability: {0}",
  "View master data": "View master data",
  "Edit master data": "Edit master data",
  "View member defaults": "View member defaults",
  "Edit member defaults": "Edit member defaults",
  "View check-in view settings": "View check-in view settings",
  "Edit check-in view settings": "Edit check-in view settings",
  "View contract packages": "View contract packages",
  "Edit contract packages": "Edit contract packages",
  "View contract components": "View contract components",
  "Edit contract components": "Edit contract components",
  "View payment plans": "View payment plans",
  "Edit payment plans": "Edit payment plans",
  "View wallet products": "View wallet products",
  "Edit wallet products": "Edit wallet products",
  "View cancellation reasons": "View cancellation reasons",
  "Edit cancellation reasons": "Edit cancellation reasons",
  "View cancellation models": "View cancellation models",
  "Edit cancellation models": "Edit cancellation models",
  "View accounting settings": "View accounting settings",
  "Edit accounting settings": "Edit accounting settings",
  "View bank account settings": "View bank account settings",
  "Edit bank account settings": "Edit bank account settings",
  "View default wallet payment settings": "View default wallet payment settings",
  "Edit default wallet payment settings": "Edit default wallet payment settings",
  "View payment methods settings": "View payment methods settings",
  "Edit payment methods settings": "Edit payment methods settings",
  "View payment cancellation reasons": "View payment cancellation reasons",
  "Edit payment cancellation reasons": "Edit payment cancellation reasons",
  "View debt management settings": "View debt management settings",
  "Edit debt management settings": "Edit debt management settings",
  "View lead sources settings": "View lead sources settings",
  "Edit lead sources settings": "Edit lead sources settings",
  "View lead pipelines settings": "View lead pipelines settings",
  "Edit lead pipelines settings": "Edit lead pipelines settings",
  "View lead widgets settings": "View lead widgets settings",
  "Edit lead widgets settings": "Edit lead widgets settings",
  "View contract signing widgets": "View contract signing widgets",
  "Edit contract signing widgets": "Edit contract signing widgets",
  "View lead automation settings": "View lead automation settings",
  "Edit lead automation settings": "Edit lead automation settings",
  "View email settings": "View email settings",
  "Edit email settings": "Edit email settings",
  "View auto communication settings": "View auto communication settings",
  "Edit auto communication settings": "Edit auto communication settings",
  "View appointment configuration": "View appointment configuration",
  "Edit appointment configuration": "Edit appointment configuration",
  "View appointment types": "View appointment types",
  "Edit appointment types": "Edit appointment types",
  "View resources settings": "View resources settings",
  "Edit resources settings": "Edit resources settings",
  "View unavailabilities settings": "View unavailabilities settings",
  "Edit unavailabilities settings": "Edit unavailabilities settings",
  "View appointment outcomes": "View appointment outcomes",
  "Edit appointment outcomes": "Edit appointment outcomes",
  "View booking widgets": "View booking widgets",
  "Edit booking widgets": "Edit booking widgets",
  "View appointment notifications": "View appointment notifications",
  "Edit appointment notifications": "Edit appointment notifications",
  "View member app settings": "View member app settings",
  "Edit member app settings": "Edit member app settings",
  "View units settings": "View units settings",
  "Edit units settings": "Edit units settings",
  "View default theme settings": "View default theme settings",
  "Edit default theme settings": "Edit default theme settings",
  "View user templates settings": "View user templates settings",
  "Edit user templates settings": "Edit user templates settings",
  "View integrations settings": "View integrations settings",
  "Edit integrations settings": "Edit integrations settings",
  "View backup and restore settings": "View backup and restore settings",
  "Edit backup and restore settings": "Edit backup and restore settings",
  "Template (column)": "Template",
  "Language (column)": "Language",
  "Subject (column)": "Subject",
  "Appointment created.": "Appointment created.",
  "Appointment saved.": "Appointment saved.",
  "Appointment start must not be in the past": "The appointment must not be in the past.",
  "Appointments in the past cannot be booked.": "Appointments in the past cannot be booked.",
  "Appointment start violates staff minimum advance": "This appointment type requires {0} minutes minimum advance for staff booking. Earliest possible start: {1}.",
  "Staff minimum advance hint": "Minimum advance for this appointment type: {0} minutes. Earliest possible start: {1}.",
  "Required resources": "Required resources",
  "Required resources not available": "Required resources not available",
  "Appointment type requires resources": "This appointment type requires: {0}.",
  "Selected appointment resources are not available.": "The required resources are not available for this time.",
  "Appointment availability check failed": "The resource availability could not be checked right now.",
  "Person resource option": "Person (one staff member, capacity 1)",
  "Team pool resource option": "Team/pool (multiple staff members, shared capacity)",
  "Online booking and staff schedule": "Online booking and staff schedule",
  "Limit online booking once the week is published": "Limit online booking once the week is published",
  "Limit online booking once the week is published hint": "Once the week is published in the staff schedule, online appointments are only offered in shifts with the matching activity.",
  "Limit online booking within lead time": "Limit online booking within the lead time",
  "Limit online booking within lead time hint": "When the appointment falls within the lead time, online appointments are only offered in shifts with the matching activity. With both options on, publication and lead time must apply.",
  "Internal calendar hide staff without availability hint": "In the calendar the resource always follows the staff schedule. The eye control in day and week view hides resources and employees without availability.",
  "Person resource linked user hint": "Assigns one staff member to this role. Capacity stays at 1.",
  "Team pool members hint": "Multiple staff members share this pool. Capacity controls how many appointments can be covered simultaneously.",
  "Resource assigned staff": "Staff member",
  "Resource assigned staff pool": "Staff members",
  "Resource staff section title": "assigned staff",
  "Required resources for booking": "Resource requirements",
  "Select required resources...": "Select resources...",
  "Resources per row": "Requirement / alternatives",
  "Select alternatives...": "Select resources...",
  "Remove requirement row": "Remove requirement row",
  "Add requirement row": "Add row",
  "Check resource availability for booking": "Check availability for booking",
  "Required for booking": "Required for booking",
  "Resource requirement": "Resource requirement",
  "Pool name": "Pool name",
  "Pool rule": "Pool rule",
  "Booking requirement": "Booking requirement",
  "AND pool (all)": "AND pool (all)",
  "OR pool (one)": "OR pool (one)",
  "All selected resources": "All selected resources",
  "One resource": "One resource",
  "Camera only available over HTTPS or localhost. Use file upload as fallback.": "Camera is only available over HTTPS or localhost. Please use file upload as fallback.",
  "Select format…": "Select format…",
  "Select time zone…": "Select time zone…",
  "Placeholder country code": "D",
  "Placeholder country code abbreviated": "DE…",
  "Placeholder country calling code": "49",
  "Placeholder ellipsis": "…",
  "Placeholder URL": "https://…",
  "Placeholder number 90": "90",
  "Placeholder number 30": "30",
  "Placeholder number 14": "14",
  "Placeholder number 1": "1",
  "Placeholder number 0": "0",
  "Placeholder number 1500": "1500",
  "Placeholder IBAN example": "DE89 3704 0044 0532 0130 00",
  "Placeholder email example": "e.g. info@company.com",
  "Placeholder bank code": "12345678",
  "Placeholder HBCI URL": "https://your-bank.com/hbci",
  "Placeholder my business name": "My Business",
  "6-digit PIN": "6-digit PIN",
  "Placeholder template key": "appointment_reminder",
  "Placeholder locale code": "de",
  "Placeholder phone number": "1712345678",
  "Placeholder JSON message template": "[{\"type\":\"BODY\",\"text\":\"Hello {{1}}\"}]",
  "Registration code generated: {0}": "Registration code generated: {0}",
  "Device could not be opened (Request-ID: {0})": "Device could not be opened (Request-ID: {0})",
  "Reader device assignments description": "Here you assign the reader device to contract blocks and value accounts. The flags control which actions (deduct points / unlock device / open door) this reader may perform on scan. Whether check-in & check-out are logged is configured on the reader itself via \"Check-in & Check-out\".",
  "{0} direct debit runs created successfully.": "{0} direct debit runs created successfully.",
  "Direct debit run created successfully.": "Direct debit run created successfully.",
  "Cleanup completed: {0} contribution calendar entries cleaned, {1} open items deleted": "Cleanup completed: {0} contribution calendar entries cleaned, {1} open items deleted",
  "WARNING: SEPA file already downloaded confirm": "WARNING: The SEPA file has already been downloaded and may have been submitted to the bank. Deleting this run may cause issues if the file has already been submitted to the bank.\n\nDo you really want to delete this direct debit run?",
  "SEPA file already generated not downloaded confirm": "The SEPA file has already been generated but not yet downloaded. Deleting this run is less critical as the file has not yet been submitted to the bank.\n\nDo you really want to delete this direct debit run?",
  "Error: {0} items have missing IBAN or mandate reference": "Error: {0} item(s) have missing IBAN or mandate reference",
  "{0} items with missing data found. Please fix the errors so the SEPA file can be generated.": "{0} item(s) with missing data found. Please fix the errors so the SEPA file can be generated.",
  "{0} customers with missing data found. Please fix the errors so the SEPA file can be generated.": "{0} direct debit item(s) with errors were found. Please review the details before continuing.",
  "{0} direct debit items with errors were found. Please review the details before continuing.": "{0} direct debit item(s) with errors were found. Please review the details before continuing.",
  "{0} direct debit items": "{0} direct debit items",
  "Only company administrators can edit rest period templates.": "Only company administrators can edit rest period templates.",
  "Rest period fee": "Rest period fee",
  "Rest period fee per cycle": "Rest period fee",
  "Rest period fee per cycle tooltip": "Fixed amount for the rest period. The unit next to it defines whether the amount is calculated per contribution period, day, week, month, or year. It is due at the beginning of the rest period.",
  "Rest period fee per cycle proportional tooltip": "The amount is calculated proportionally for the rest period. The unit next to it defines whether the base amount applies per contribution period, day, week, month, or year.",
  "Rest period fee unit": "Rest period fee per",
  "Rest period fee unit tooltip": "Time unit the rest period fee refers to. With proportional calculation, this amount is converted per day, week, month, or year.",
  "Rest period fee automatic calculation hint": "The prorated calculation is based on this unit automatically: per month by calendar month, per year by year, per contribution period by the actual contribution period.",
  "per contribution period": "per contribution period",
  "Rest period fee due": "Rest period fee due",
  "Rest period fee due (column)": "Due",
  "Rest period fee due tooltip": "One-time lump sum for the whole rest period, or the same rhythm as the member's payment cycle (e.g. monthly, every 2 weeks depending on contract).",
  "Rest period fee due one-time": "one-time lump sum",
  "Rest period fee due same as member": "like payment cycle",
  "Rest period billing model": "Billing model",
  "Rest period billing model tooltip": "Defines whether contribution due dates are shifted by the rest period or whether existing due dates remain and only affected periods are corrected.",
  "Rest period balance options": "Rest period compensation",
  "Recover rest period time": "Recover time",
  "Recover rest period at the end": "Recover rest period at the end",
  "Correct contributions": "Correct contributions",
  "Shift contribution due dates": "Shift due dates",
  "Keep contribution due dates": "Keep due dates",
  "Correct affected period only": "Correct affected period only",
  "Rest period billing model shift description": "No contribution credit; the paused time is balanced through later due dates.",
  "Rest period billing model recover time description": "The paused time is recovered later. Open contributions are corrected as needed; time already covered by payment is balanced through the recovery period.",
  "Rest period billing model keep description": "The contract term stays unchanged. Affected contributions are reduced or credited proportionally.",
  "Rest period billing model current period description": "Only the currently affected period is corrected; future planned contributions remain unchanged.",
  "Rest period contract options description": "Choose the business model first. The options below are limited accordingly.",
  "Rest period costs calculation description": "Define whether the rest period is free, has a separate rest period fee, or continues a fixed number of regular contributions.",
  "Rest period access restrictions description": "Controls whether check-ins remain allowed during the rest period.",
  "Rest period fee mode": "Rest period fee type",
  "Rest period fee mode none": "No rest period fee",
  "Rest period fee mode none description": "No additional rest period fee is charged during the rest period.",
  "Rest period fee mode amount": "Rest period fee",
  "Rest period fee mode amount description": "A fixed amount is calculated proportionally by the selected unit.",
  "Rest period fee mode contributions": "Number of contributions",
  "Rest period fee mode contributions description": "A fixed number of regular contributions continues during the rest period.",
  "due dates shifted": "due dates shifted",
  "Rest period fee cycle": "Rest period fee cycle",
  "Rest period fee cycle tooltip": "How often the rest period fee is due (e.g. monthly, every 2 weeks).",
  "Rest period fee cycle value": "Interval",
  "Rest period fee cycle value tooltip": "e.g. 2 with unit „week“ = every 2 weeks.",
  "One-time (whole rest period)": "one-time (whole rest period)",
  "Default from template": "Default from template",
  "Number of contributions tooltip": "Number of weekly contributions to be paid during the rest period.",
  "Rest period number of weekly contributions": "Number of contributions",
  "Rest period number of weekly contributions tooltip": "Number of contributions due during the rest period (in the member's payment cycle rhythm). E.g. 2 = two contributions become due.",
  "Rest period fee amount required": "Please enter a rest period fee greater than 0.",
  "Rest period fee unit required": "Please select a unit.",
  "Rest period contributions required": "Please enter a count greater than 0.",
  "Minimum rest period value required": "Please enter a value greater than 0.",
  "Minimum rest period unit required": "Please select a unit.",
  "Calculate proportionally tooltip": "When enabled, the amount per due date is calculated proportionally from the contract's base contribution. The billing cycle (below) determines when it is due.",
  "Calculation Method tooltip": "Method for proportional calculation based on the contract's base contribution.",
  "Extends contract tooltip": "The paused time is recovered later instead of counting as regular contract time.",
  "Continue payment tooltip": "Regular contributions continue during the rest period.",
  "Append to end tooltip": "The rest period is appended to the end of the contract and used free of charge there.",
  "Check-in allowed tooltip": "Check-ins remain allowed during the rest period.",
  "Require full periods only tooltip": "When enabled, only full periods are allowed. The unit is derived from the contract (e.g. monthly contract = full months).",
  "Rest period duration restrictions": "Duration and restrictions",
  "Rest period duration restrictions description": "Define whether rest periods are unrestricted, require a minimum duration, or only allow full periods.",
  "Rest period duration rule": "Duration rule",
  "Rest period duration rule none": "No minimum rule",
  "Rest period duration rule none description": "Rest periods can be entered without an additional duration restriction.",
  "Rest period duration rule minimum": "Minimum rest period",
  "Rest period duration rule minimum description": "Rest periods must have at least the specified duration.",
  "Rest period duration rule full periods": "Full periods only",
  "Rest period duration rule full periods description": "Rest periods are possible only in full periods of the contract.",
  "time recovered": "time is recovered",
  "no time recovery": "no time recovery",
  "Minimum rest period value tooltip": "Minimum duration of the rest period.",
  "Minimum rest period unit tooltip": "Unit for the minimum rest period.",
  "Really delete entity \"{0}\" ({1})?": "Do you really want to permanently delete \"{0}\" ({1})?\n\nThis will also delete all related data (payments, bookings, etc.).\n\nThis action cannot be undone!",
  "Do you really want to delete the integration \"{0}\"?": "Do you really want to delete the integration \"{0}\"?",
  "HTTP warning password unencrypted": "⚠️ WARNING: This page is loaded over HTTP. Passwords are transmitted unencrypted!\n\nPlease use HTTPS in production.\n\nContinue?",
  "Do you really want to delete the admin \"{0}\"? This action cannot be undone.": "Do you really want to delete the admin \"{0}\"? This action cannot be undone.",
  "Do you really want to delete the tenant \"{0}\"? This action cannot be undone.": "Do you really want to delete the tenant \"{0}\"? This action cannot be undone.",
  "Tenant language change confirm": "The default tenant language will be changed from {0} to {1}.\n\nTo confirm, type the tenant ID: {2}",
  "Do you really want to delete the version \"{0}\"?": "Do you really want to delete the version \"{0}\"?",
  "Admin units description": "Date, time, timezone and currency for your view in the admin area. These settings are saved per user.",
  "Service \"{0}\" executed successfully": "Service '{0}' executed successfully",
  "{0} holidays imported": "{0} holidays imported",
  "Date and name required": "Date and name required",
  "Region (optional)": "Region",
  "All regions": "All regions",
  "Automatic holiday import": "Automatic holiday import",
  "Which holiday calendars automatic": "Which holiday calendars should be fetched automatically? Select the countries by checkbox.",
  "Direct debit run cancelled. {0} items and {1} payments affected.": "Direct debit run cancelled. {0} items and {1} payments affected.",
  "Really delete setting for \"{0}\"?": "Really delete setting for \"{0}\"?",
  "Really delete rule for \"{0}\"?": "Really delete rule for \"{0}\"?",
  "Template \"{0}\" copied successfully": "Template \"{0}\" copied successfully",
  "Do you really want to delete the template \"{0}\"?": "Do you really want to delete the template \"{0}\"?",
  "Copied from {0} to {1}.": "Copied from {0} to {1}.",
  "Lead phase transitions description": "A lead in this phase can move to the following phases. You can define multiple transitions per trigger (e.g. \"when contact logged\") with different target phases – the label (e.g. \"Scheduled\", \"Lost\") is the outcome the user selects when logging. This allows e.g. \"Call → scheduled → Trial\" and \"Call → lost → Lost\".",
  "Phase transition trigger manual": "manual",
  "Phase transition trigger appointment created": "when appointment created",
  "Phase transition trigger appointment removed": "when no appointment (anymore)",
  "Phase transition trigger appointment conducted": "when appointment conducted",
  "Phase transition trigger appointment completed": "when appointment completed",
  "Phase transition trigger appointment not completed": "when appointment not completed",
  "Phase transition trigger contact logged": "when contact logged",
  "Phase transition trigger task done": "when task done",
  "When to switch": "When to switch?",
  "Contact outcome (phase)": "Outcome (next phase)",
  "Contact outcome placeholder": "e.g. Scheduled → Trial or Lost",
  "Task outcome (phase)": "Task outcome (next phase)",
  "Appointment phase („Termin gemacht“)": "Appointment phase (\"appointment made\")",
  "Lead pipeline appointment phase description": "Only appointments with one of the selected appointment types count as \"appointment made\". When set: lead moves to \"phase when appointment exists\" when such an appointment exists; to \"phase when no appointment\" when none (or no longer) exists.",
  "Appointment group (relevance)": "Appointment group (relevance)",
  "Select appointment type": "Select appointment type",
  "Email message (body)": "Message",
  "Write your email here …": "Write your email here …",
  "Send email from system": "Send email from system",
  "Email queued for sending": "Email has been queued for sending.",
  "Email subject placeholder": "e.g. Your appointment request",
  "Phase when appointment exists": "Phase when appointment exists",
  "Phase when no appointment": "Phase when no appointment",
  "Failed to load events (HTTP {0})": "Failed to load events (HTTP {0}).",
  "Failed to load events": "Failed to load events.",
  "Only administrators can edit entries.": "Only administrators can edit entries.",
  "How far in advance can appointments be booked? Default: 90 days.": "How far in advance can appointments be booked? Default: 90 days.",
  "Level {0} cannot be created because level {1} does not exist yet. Please create level {1} first.": "Level {0} cannot be created because level {1} does not exist yet. Please create level {1} first.",
  "Level {0} cannot be set because level {1} does not exist yet. Please create level {1} first.": "Level {0} cannot be set because level {1} does not exist yet. Please create level {1} first.",
  "Level {0} cannot be created because level {1} does not exist yet.": "Level {0} cannot be created because level {1} does not exist yet.",
  "Level {0} cannot be set because level {1} does not exist yet.": "Level {0} cannot be set because level {1} does not exist yet.",
  "Bulk send to {0} recipients is being prepared (feature in development)": "Bulk send to {0} recipients is being prepared (feature in development)",
  // --- i18n-check batch (missing tr/text keys) ---
  "Application is loading…": "Application is loading…",
  "Application update in progress": "Application update in progress",
  "New version deploying wait hint": "A new version is being deployed. Please wait…",
  "Signature deleted": "Signature deleted",
  "UI deploy reload failed hint": "Reload failed. Tap \"Reload\" to try again.",
  "e.g. ops@company.com": "e.g. ops@company.com",
  "2-step PIN required": "2-step PIN required",
  "Action": "Action",
  "Approve": "Approve",
  "Approved": "Approved",
  "Are you sure you want to delete {0}?": "Are you sure you want to delete {0}?",
  "Attachment file name": "Attachment file name",
  "Attachment object key": "Attachment object key",
  "Body format": "Body format",
  "Add phone failed": "Add phone failed",
  "Apply payment reversal": "Apply payment reversal",
  "Attendance sessions": "Attendance sessions",
  "BLZ / BIC / Bank name": "BLZ / BIC / Bank name",
  "Check-In": "Check-in",
  "Check-out": "Check-out",
  "Consent": "Consent",
  "Contract block name": "Contract block name",
  "Contract package display name": "Contract package display name",
  "Contract package name required": "Contract package name required",
  "Critical": "Critical",
  "Delete user": "Delete user",
  "Design style text": "Design style text",
  "Drag & drop or click": "Drag & drop or click",
  "Document title": "Document title",
  "Einreichungsdatum": "Submission date",
  "EUR": "EUR",
  "Edit admin": "Edit admin",
  "Edit contract package": "Edit contract package",
  "Edit contract package and block": "Package and block",
  "Empty = all studios. Each studio can only be assigned once.": "Empty = all studios. Each studio can only be assigned once.",
  "End date is required (or specify duration)": "End date is required (or specify duration)",
  "Error saving.": "Error saving.",
  "Full URL with https:// and path. Example HypoVereinsbank (verified): https://hbci-01.hypovereinsbank.de/bank/hbci. If your program shows port 3000, use https://host:3000/path. Key file not needed for PIN/TAN.": "Full URL with https:// and path. Example HypoVereinsbank (verified): https://hbci-01.hypovereinsbank.de/bank/hbci. If your program shows port 3000, use https://host:3000/path. Key file not needed for PIN/TAN.",
  "Go to wallets tab": "Go to wallets tab",
  "HTML": "HTML",
  "Immediate payment": "Immediate payment",
  "Import contribution paid override field amount": "Import contribution paid override field amount",
  "Import contribution paid override field contract_id": "Import contribution paid override field contract_id",
  "Import contribution paid override field contract_name": "Import contribution paid override field contract_name",
  "Import contribution paid override field contract_package_id": "Import contribution paid override field contract_package_id",
  "Import contribution paid override field due_date": "Import contribution paid override field due_date",
  "Import contribution paid override field entry_type": "Import contribution paid override field entry_type",
  "Import contribution paid override field person_id": "Import contribution paid override field person_id",
  "Import contribution paid override field plan_name": "Import contribution paid override field plan_name",
  "Import contribution paid override field status": "Import contribution paid override field status",
  "Import run commit db committed with post processing issues": "Import run commit db committed with post processing issues",
  "Import run commit errors more": "Import run commit errors more",
  "Import run commit errors more suffix": "more",
  "Import run commit errors ungrouped": "General",
  "Import run commit post processing detail intro": "Import run commit post processing detail intro",
  "Import run commit post processing errors title": "Import run commit post processing errors title",
  "Import run commit post processing issues toast": "Import run commit post processing issues toast",
  "Import run commit unknown error": "Import run commit unknown error",
  "Import run commit unknown state detail": "Import run commit unknown state detail",
  "Import run commit unknown state reload": "Import run commit unknown state reload",
  "Import run commit unknown state title": "Import run commit unknown state title",
  "Import run commit warnings detail intro": "Import run commit warnings detail intro",
  "Import run commit warnings title": "Import run commit warnings title",
  "Import run execute committed detail": "The import data has been committed. If the tenant database was restored to a point before this import, release the run for reimport via rollback/release.",
  "Import run execute committed title": "Import committed",
  "Import run execute rolled back detail": "The run is released for another import. Uploaded source files are kept.",
  "Import run execute rolled back title": "Import released",
  "Import run progress committing contribution calendar": "Writing contribution calendar …",
  "Import run progress committing contribution calendar detail": "Writing contribution calendar ({0} of {1})",
  "Import run progress committing contribution calendar sub": "{2} ({0} of {1})",
  "Import schema csv format delimiter comma": "Import schema csv format delimiter comma",
  "Import schema csv format delimiter label": "Import schema csv format delimiter label",
  "Import schema csv format delimiter pipe": "Import schema csv format delimiter pipe",
  "Import schema csv format delimiter semicolon": "Import schema csv format delimiter semicolon",
  "Import schema csv format delimiter tab": "Import schema csv format delimiter tab",
  "Import schema csv format encoding label": "Import schema csv format encoding label",
  "Import schema csv format encoding utf8": "Import schema csv format encoding utf8",
  "Import schema csv format encoding win1252": "Import schema csv format encoding win1252",
  "Import schema csv format fixup disabled": "Import schema csv format fixup disabled",
  "Import schema csv format fixup enabled": "Import schema csv format fixup enabled",
  "Import schema csv format fixup label": "Import schema csv format fixup label",
  "Import schema csv format hint": "Import schema csv format hint",
  "Import schema csv format title": "Import schema csv format title",
  "Import schema mapping add source button": "Import schema mapping add source button",
  "Import schema mapping checkins issue missing created_at source": "Import schema mapping checkins issue missing created_at source",
  "Import schema mapping checkins issue missing id source": "Import schema mapping checkins issue missing id source",
  "Import schema mapping checkins issue missing person source": "Import schema mapping checkins issue missing person source",
  "Import schema mapping checkins summary": "Import schema mapping checkins summary",
  "Import schema mapping fk check badge error": "Import schema mapping fk check badge error",
  "Import schema mapping fk check badge warning": "Import schema mapping fk check badge warning",
  "Import schema mapping fk check issue direct key mismatch": "{0}: source column \"{1}\" does not match expected key \"{2}\".",
  "Import schema mapping fk check issue manual source": "{0}: manual source — foreign key cannot be verified.",
  "Import schema mapping fk check issue missing own key source": "Target entity \"{0}\" is referenced by [{1}] but has no key source of its own (no imported id field and no reference mapping).",
  "Import schema mapping fk check issue missing reference source": "{0}: no imported target for entity \"{1}\" (neither import nor reference mapping). Enable the target table \"{1}\" in the data selection, or configure a reference mapping for it.",
  "Import schema mapping fk check issue missing relation path": "{0}: source path \"{1}\" does not match the expected key source \"{2}\".",
  "Import schema mapping fk check issue missing source": "{0}: source table or source column missing.",
  "Import schema mapping fk check issue missing target entity": "{0}: target entity missing.",
  "Import schema mapping fk check issue relation path end mismatch": "{0}: relation path ends at \"{1}\", expected \"{2}\".",
  "Import schema mapping fk check issue relation path start mismatch": "{0}: relation path starts at \"{2}\", expected \"{1}\".",
  "Import schema mapping fk check more issues": "Import schema mapping fk check more issues",
  "Import schema mapping fk check summary": "Import schema mapping fk check summary",
  "Import schema mapping lookup assistant path prepend row": "Import schema mapping lookup assistant path prepend row",
  "Import schema mapping lookup assistant path start mismatch": "Import schema mapping lookup assistant path start mismatch",
  "Import schema mapping remove source button": "Import schema mapping remove source button",
  "Import schema mapping skip row on enum miss": "Import schema mapping skip row on enum miss",
  "Import schema mapping source check badge error": "Import schema mapping source check badge error",
  "Import schema mapping source check badge warning": "Import schema mapping source check badge warning",
  "Import schema mapping source check issue column not found": "Import schema mapping source check issue column not found",
  "Import schema mapping enum miss required field warning": "{0}: Unmapped source values ({1}) will block the import. Map all values or enable \"Skip row on missing mapping\".",
  "Import schema mapping enum check pending": "{0}: Source data still loading — check pending.",
  "Import schema mapping source check issue missing column": "{0}: source column not assigned.",
  "Import schema mapping source check issue missing table": "Import schema mapping source check issue missing table",
  "Import schema mapping source check issue table not found": "Import schema mapping source check issue table not found",
  "Import schema mapping source check more issues": "Import schema mapping source check more issues",
  "Import schema mapping source check summary": "Import schema mapping source check summary",
  "Import schema mapping source preview empty": "Import schema mapping source preview empty",
  "Import schema mapping source preview loading": "Import schema mapping source preview loading",
  "Import schema mapping source preview tooltip": "Import schema mapping source preview tooltip",
  "Import schemas column target model": "Import schemas column target model",
  "Import schemas target model outdated tag": "Import schemas target model outdated tag",
  "Invalid JSON in components": "Invalid JSON in components",
  "Invalid duration": "Invalid duration",
  "Invalid start date": "Invalid start date",
  "Max": "Max",
  "Max 4 icons (5th slot is QR when a reader is assigned).": "Max 4 icons (5th slot is QR when a reader is assigned).",
  "Studio app preview Open item 2": "Studio app preview Open item 2",
  "Studio app preview Open item 3": "Studio app preview Open item 3",
  "No icons selected. Use 'Add icon'.": "No icons selected. Use 'Add icon'.",
  "Online-Buchungen": "Online bookings",
  "Payload JSON": "Payload JSON",
  "Plain text": "Plain text",
  "Open item is paid or in SEPA run": "Open item is paid or in SEPA run",
  "Optional fee booked as open item when this reminder is sent.": "Optional fee booked as open item when this reminder is sent.",
  "Other reader device actions": "Other reader device actions",
  "Password too short (min. 4)": "Password too short (min. 4)",
  "Payment fully reversed": "Payment fully reversed",
  "Payment rebooked": "Rebooked",
  "Payment partially voided": "Payment partially voided",
  "Payment refund": "Payment refund",
  "Payment reversal line": "Payment reversal line",
  "Payment reversal reason": "Payment reversal reason",
  "Payment status reversed": "Payment status reversed",
  "Person defaults": "Person defaults",
  "Person profile photo enlarged alt": "Person profile photo enlarged alt",
  "Phone Number ID": "Phone Number ID",
  "Phone number added. Request verification code.": "Phone number added. Request verification code.",
  "Platform admin at least one must stay active": "Platform admin at least one must stay active",
  "Platform admin cannot deactivate self": "Platform admin cannot deactivate self",
  "Please select at least one open item": "Please select at least one open item",
  "Previous": "Previous",
  "Quantity": "Quantity",
  "Regenerate password confirm message": "Regenerate password confirm message",
  "Register failed": "Register failed",
  "Recipient": "Recipient",
  "Report events stacked by action": "Report events stacked by action",
  "Report heatmap attendance subtitle": "Report heatmap attendance subtitle",
  "Resetting…": "Resetting…",
  "Saving…": "Saving…",
  "Request code failed": "Request code failed",
  "Retry": "Retry",
  "Back to CenterCom imports": "Back to adapter imports",
  "CenterCom action back": "back",
  "CenterCom import": "CenterCom import",
  "CenterCom imports": "Adapter imports",
  "CenterCom imports group card description": "Dedicated CenterCom import flow with upload, analysis, special rules, control checks and commit.",
  "CenterCom import analysis pending": "Upload saved. Start step 2: check and analysis.",
  "CenterCom import analysis error": "Analysis could not be refreshed.",
  "CenterCom import analysis refreshed": "Analysis refreshed.",
  "CenterCom import analyze button": "Refresh analysis",
  "CenterCom import column name": "Name",
  "CenterCom import column uploaded": "CSV / files",
  "CenterCom import commit": "Commit import",
  "CenterCom import already committed": "This run has already been imported.",
  "CenterCom import already running": "This import is already running or was interrupted before completion.",
  "CenterCom import commit confirm content": "The CenterCom import will now write persons, contracts, open items, payments and articles selected by special rules into the target tenant.",
  "CenterCom base import commit confirm content": "This step imports base data and staff accounts. Persons, actual contracts, payments, and other person-related data are not imported yet.",
  "CenterCom person import commit confirm content": "This step imports all persons and their related contract, finance, document, and access data from the current CenterCom export.",
  "CenterCom import commit confirm title": "Commit CenterCom import?",
  "CenterCom import commit error": "CenterCom import could not be committed.",
  "CenterCom import commit failed detail": "The import did not complete. It either failed because of a system error or was interrupted by a restart. Details are available in the system log.",
  "CenterCom import commit success": "CenterCom import committed.",
  "CenterCom import commit summary": "CenterCom import completed",
  "Adapter import column adapter": "Adapter",
  "Adapter import create button": "New import",
  "Adapter import create title": "New import",
  "Adapter import action edit": "Edit",
  "Adapter import action duplicate": "Duplicate",
  "Adapter import action reset status": "Reset status",
  "Adapter import action rollback": "Run rollback",
  "Adapter import action clear uploads": "Clear uploaded files",
  "Adapter import action delete": "Delete import",
  "Adapter import edit title": "Edit adapter import",
  "Adapter import edit display name label": "Display name",
  "Adapter import maintenance section title": "Maintenance",
  "Adapter import maintenance section hint": "These actions take effect immediately on the selected import run.",
  "Adapter import save success": "Adapter import saved.",
  "Adapter import adapter required": "Please select an adapter.",
  "Adapter import confirm duplicate": "Duplicate this adapter import?",
  "Adapter import confirm duplicate detail": "Configuration is copied, uploaded files are not.",
  "Adapter import duplicate success": "Adapter import duplicated.",
  "Adapter import duplicate error": "Could not duplicate adapter import.",
  "Adapter import confirm reset status": "Reset import run?",
  "Adapter import confirm reset status detail": "The run is reset so that mapping, precheck and import can be run again. Uploaded files, mapping decisions and the analysis result are kept; the stored precheck result is discarded. For an already imported run the imported records stay in the database — use \"Run rollback\" for that.",
  "Adapter import reset status success": "Status reset.",
  "Adapter import reset status error": "Could not reset status.",
  "Adapter import confirm rollback": "Run rollback?",
  "Adapter import confirm rollback detail": "Records created by this import will be deleted. This operation is not reversible.",
  "Adapter import rollback success": "Rollback completed.",
  "Adapter import rollback error": "Rollback failed.",
  "Adapter import rollback progress": "Rollback: {0}",
  "Adapter import rollback phase download": "loading backup",
  "Adapter import rollback phase verify": "verifying backup",
  "Adapter import rollback phase import": "preparing restore",
  "Adapter import rollback phase databaseDelete": "removing imported data",
  "Adapter import rollback phase databaseImport": "restoring database",
  "Adapter import rollback phase files": "restoring files",
  "Adapter import rollback phase promote": "activating files",
  "Adapter import rollback phase commit": "finalizing restore",
  "Adapter import rollback phase cleanup": "removing temporary restore data",
  "Adapter import confirm clear uploads": "Delete uploaded files?",
  "Adapter import confirm clear uploads detail": "All uploads of this run will be removed from storage. Assignments are kept.",
  "Adapter import clear uploads success": "Uploaded files deleted.",
  "Adapter import clear uploads error": "Could not delete uploaded files.",
  "Adapter import clear uploads job started": "Deleting uploaded files was started.",
  "Import adapter centercom": "CenterCom",
  "Import adapter icm": "ICM",
  "ICM import created": "ICM import created.",
  "ICM import display name placeholder": "e.g. ICM import May 2026",
  "ICM import load error": "The ICM import could not be loaded.",
  "Adapter import run load error": "The import run could not be loaded.",
  "Import adapter status Committed": "Committed",
  "Import adapter status Committing": "Running",
  "Import adapter status ClearingUploads": "Clearing upload",
  "Import adapter status Draft": "Draft",
  "Import adapter status Failed": "Failed",
  "Import adapter status Prechecking": "Precheck running",
  "Import adapter status PrecheckFailed": "Precheck failed",
  "Import adapter status Ready": "Ready",
  "Import adapter status RolledBack": "rolled back",
  "Import adapter status UploadProcessing": "Processing upload",
  "Import adapter status Uploaded": "Uploaded",
  "Import adapter step upload": "Upload",
  "Import adapter step verify": "Check and analyze",
  "Import adapter step decisions": "Assignments",
  "Import adapter step precheck": "Precheck",
  "Import adapter step import": "Import",
  "Import adapter action back": "back",
  "Import adapter continue verify": "Go to check",
  "Import adapter continue decisions": "continue to assignments",
  "Import adapter continue precheck": "continue",
  "Import adapter save and continue precheck": "Save and continue",
  "Import adapter continue import": "continue to import",
  "Import adapter decisions title": "Assign",
  "Import adapter decision area selector": "Assignment area",
  "Import adapter decision next area": "Next assignment area",
  "Import adapter decision previous area": "Previous assignment area",
  "Import adapter decision invalid assignments": "{0} assignments point to target objects that no longer exist. Correct the affected selections or set them to \"import as new\"/\"ignore\".",
  "Import adapter unsaved changes": "Unsaved changes",
  "Import adapter unsaved changes blocking": "Save or discard open changes first.",
  "Import adapter save selection": "Save",
  "Import adapter discard changes": "Discard changes",
  "Import adapter selection saved": "Saved.",
  "Import adapter changes discarded": "Changes were discarded.",
  "Import adapter no issues": "No issues.",
  "Import adapter run precheck": "Run precheck",
  "Import adapter precheck not run": "Precheck has not been run for this state yet.",
  "Import adapter commit": "Commit import",
  "Import adapter upload title": "Upload",
  "Import adapter upload button": "Upload files",
  "Import adapter upload committed run title": "This import is complete",
  "Import adapter upload committed run detail": "Files can be deleted and re-uploaded. Another import replaces the backup that rollback points to.",
  "Import adapter verify title": "Check and analyze data",
  "Import adapter verify missing analysis": "No checked data is available yet. Start check and analysis.",
  "Import adapter workflow status upload": "Upload files. The check follows afterwards.",
  "Import adapter workflow status import committed": "Import was committed.",
  "Import adapter workflow status import rolled back": "Import was rolled back. Imported data was removed.",
  "Import adapter progress server processing": "Upload complete, server is processing files",
  "Import adapter progress prechecking": "Running precheck",
  "Import adapter progress committing": "Running import",
  "Import adapter progress clearing uploads": "Deleting uploaded files",
  "Import adapter progress working": "Operation running",
  "Import adapter target tenant": "Target tenant",
  "Import adapter rollback confirm": "The complete tenant is restored to the backup taken immediately before this import step. All changes made afterwards are lost as well. Continue?",
  "Import adapter commit confirm": "Run the import now? A tenant backup is created before the import.",
  "Import adapter confirm delete": "Really delete this import and all uploaded files?",
  "Import adapter deleted": "Import deleted.",
  "Import adapter delete error": "Import could not be deleted.",
  "Import adapter created": "Import created.",
  "Import adapter select tenant": "Select tenant",
  "Import adapter tenant required": "Select a tenant.",
  "Import adapter display name": "Name",
  "Import adapter display name placeholder": "e.g. import May 2026",
  "Import adapter column name": "Name",
  "Import adapter column uploaded": "Items / files",
  "Import adapter column import mode": "Scope",
  "Import adapter commit error": "Import could not be started.",
  "Import adapter precheck error": "Precheck could not be started.",
  "Import adapter upload error": "Upload could not be started.",
  "Import adapter configuration download": "Download configuration",
  "Import adapter configuration upload": "Upload configuration",
  "Import adapter configuration downloaded": "Configuration downloaded.",
  "Import adapter configuration uploaded": "Configuration uploaded.",
  "Import adapter configuration upload invalid": "Select a valid import configuration file.",
  "ICM import person run": "CenterCom import with persons",
  "ICM import person run required": "Select a completed CenterCom import that includes persons.",
  "ICM import person run placeholder": "Select a completed CenterCom import",
  "ICM import person run hint": "Persons come from a completed CenterCom import of the same tenant — full import or remaining data.",
  "ICM import person run empty": "This tenant has no completed CenterCom import with persons. Finish CenterCom as a full import or with remaining data (persons and transactions) first.",
  "ICM import person run empty short": "no matching CenterCom import",
  "ICM import person run load error": "The CenterCom imports could not be loaded.",
  "ICM import mode none": "Leads and appointments",
  "ICM step upload": "Files",
  "ICM step scope": "Scope",
  "ICM step decisions": "Assignments",
  "ICM step precheck": "Precheck",
  "ICM step import": "Import",
  "ICM import upload step hint": "Upload ICM studio ZIP packages here.",
  "ICM import upload hint": "Drop ICM studio ZIP packages here.",
  "ICM import analysis summary": "{0} packages, {1} leads, {2} future appointments, {3} past skipped, {4} empty appointments.",
  "ICM import package": "Package",
  "ICM import webtenant": "webtenant",
  "ICM package scope lead": "Leads",
  "ICM package scope kalender": "Appointments",
  "ICM import scope": "Contents",
  "ICM import leads": "Leads",
  "ICM import appointments": "Appointments",
  "ICM import future appointments": "Future appointments",
  "ICM import scope leads": "Import leads",
  "ICM import scope appointments": "Import appointments",
  "ICM import from date": "Appointments from",
  "ICM import from date hint": "Appointments that end before this day are skipped.",
  "ICM import past appointments": "Past",
  "ICM decision kind leadStudio": "Lead studio (MandantID)",
  "ICM decision kind calendarStudio": "Calendar studio (webtenant)",
  "ICM decision kind appointmentType": "Appointment types",
  "ICM decision kind studio": "Studio",
  "ICM decision kind leadStatus": "Lead pipeline",
  "ICM decision kind leadPipeline": "Lead pipeline",
  "ICM lead pipeline placeholder": "Select a lead pipeline",
  "ICM import person run unnamed": "CenterCom import without a name",
  "ICM decision kind appointmentStatus": "Appointment status",
  "ICM decision source": "Source",
  "ICM decision target": "Target",
  "ICM decision skip": "Do not import",
  "ICM import run precheck": "Run precheck",
  "ICM import precheck ready": "Precheck has no blockers.",
  "ICM import precheck blocked": "Precheck still has gaps.",
  "ICM import precheck counts": "{0} leads importable, {1} already present, {2} appointments importable, {3} past skipped, {4} without a person.",
  "ICM skipped appointments": "Appointments without a person or not imported",
  "ICM appointment skip outcome": "Import",
  "ICM appointment skip importable": "will be imported",
  "ICM appointment skip omitted": "will not be imported",
  "ICM appointment skip reason without_person": "without a person",
  "ICM appointment skip reason unresolved_person": "person could not be resolved",
  "ICM appointment skip reason type_skipped": "appointment type skipped",
  "ICM appointment skip reason type_unmapped": "appointment type not assigned",
  "ICM appointment skip reason studio_skipped": "studio skipped",
  "ICM appointment skip reason studio_unmapped": "studio not assigned",
  "ICM appointment skip reason status_unmapped": "status not assigned",
  "ICM verify hint": "Check packages, leads and appointments.",
  "ICM statistic packages": "Packages",
  "ICM gap s3nr": "S3Nr",
  "ICM gap kind": "Kind",
  "ICM gap reason": "Reason",
  "ICM gap count": "Count",
  "ICM import confirm commit": "Run the ICM import now?",
  "ICM import action commit": "Import",
  "ICM import rollback snapshot confirm": "A tenant backup is created before import. Rolling back restores that snapshot; later changes on the tenant are lost.",
  "ICM import commit summary": "{0} leads created, {1} appointments created, {2} before the cutoff skipped.",
  "IcmCenterComPersonRunRequired": "Select a completed CenterCom import with persons of the same tenant.",
  "IcmCenterComPersonRunModeInvalid": "The selected CenterCom import does not include persons.",
  "CenterCom import control comparisons": "Control comparison",
  "CenterCom import control reports": "Control exports",
  "CenterCom import confirm delete": "Really delete this CenterCom import and all uploaded files?",
  "CenterCom import create": "Create CenterCom import",
  "CenterCom import created": "CenterCom import created.",
  "CenterCom import mode": "Import scope",
  "CenterCom import mode changed": "Import scope saved. Assignments are preserved; please run the precheck again.",
  "CenterComImportModeLocked": "The import scope cannot be changed during processing, after import or for a follow-up import.",
  "CenterCom import mode required": "Select the import scope.",
  "CenterCom import mode Full": "full import",
  "CenterCom import mode BaseDataAndStaff": "base data and staff",
  "CenterCom import mode PersonsAndDependentData": "remaining data (persons and transactions)",
  "CenterComImportModeUnsupported": "The selected CenterCom import scope is invalid.",
  "CenterComBaseRunHasFollowUps": "Delete the follow-up runs before deleting the base-data run.",
  "CenterComPersonFollowUpUnavailable": "Full import could not be enabled for this completed base-data run.",
  "ImportAdapterPrecheckRequired": "Run the precheck without blockers first.",
  "ImportAdapterAlreadyCommitted": "This run has already been imported.",
  "ImportAdapterAlreadyRunning": "This import is already running or was interrupted before completion.",
  "ImportAdapterRollbackUnavailable": "No automatic backup is stored for this import.",
  "CenterComFollowUpMustBeRolledBackFirst": "Delete or roll back the later import stage first.",
  "CenterCom base import ready title": "Base data and staff have been imported",
  "CenterCom base import ready detail": "Set the import scope to “remaining data” to continue this run with the existing data and assignments. The wizard then opens the “Upload” step so you can add a fresh export.",
  "CenterCom upload committed run title": "This import is complete",
  "CenterCom upload committed run detail": "Files can be deleted and re-uploaded. As long as the scope is not set to “remaining data”, another import covers the same scope as the completed run. The backup that rollback points to is replaced by the one taken for the next import.",
  "CenterCom upload stored files": "{0} files in storage, {1} of them source tables.",
  "CenterCom import data selection": "Data selection",
  "CenterCom import delete error": "CenterCom import could not be deleted.",
  "CenterCom import deleted": "CenterCom import deleted.",
  "CenterCom import display name": "Name",
  "CenterCom import display name placeholder": "e.g. CenterCom import May 2026",
  "CenterCom import issues": "Issues",
  "CenterCom import no issues": "No issues.",
  "CenterCom issue centercom.analysis.person_table_missing": "No obvious CenterCom person table was detected. Expected STAMMDATEN or IDENTITAET.",
  "CenterCom issue centercom.analysis.contract_history_missing": "No VERTHIST table was detected. Contract planning will be incomplete.",
  "CenterCom issue centercom.analysis.payments_without_invoices": "Payment data was detected without invoice data. Payment reconciliation may need a balance strategy.",
  "CenterCom issue centercom.knowledge.no_mapping_source": "No existing CenterCom mapping schema was found. The adapter will use built-in defaults and run-specific special rules.",
  "CenterCom issue centercom.knowledge.relations_parse_failed": "Source relations for mapping schema \"{0}\" could not be read as CenterCom knowledge: {1}",
  "CenterCom issue centercom.knowledge.schema_parse_failed": "Mapping schema \"{0}\" could not be read as CenterCom knowledge: {1}",
  "CenterCom issue centercom.plan.person_table_missing": "STAMMDATEN or IDENTITAET is required for the CenterCom import.",
  "CenterCom issue centercom.plan.person_follow_up_missing_base_run": "No completed base-data run is linked to this person import.",
  "CenterCom issue centercom.plan.person_follow_up_invalid_base_run": "The linked base-data run is missing, belongs to another tenant, or is no longer committed.",
  "CenterCom issue centercom.plan.person_follow_up_mapping_missing": "The base-data run's ID mapping is missing, so inherited assignments cannot be verified safely.",
  "CenterCom issue centercom.plan.unused_source_tables": "These recognized CenterCom tables are not imported by this adapter flow: {0}.",
  "CenterCom issue centercom.person.missing_id": "{0} person rows were skipped because no person key was found.",
  "CenterCom issue centercom.person.duplicate_id": "{0} duplicate person keys were skipped.",
  "CenterCom issue centercom.cancellation_model.skipped": "{0} KUENDTARIFE rows were skipped because id or name data was missing.",
  "CenterCom issue centercom.rest_period_template.skipped": "{0} RUHEZEITGRUND rows were skipped because id or name data was missing.",
  "CenterCom issue centercom.rest_period_reason.skipped": "{0} RUHEZEITGRUND rows were skipped because id or name data was missing.",
  "CenterCom issue centercom.contract.skipped": "{0} VERTHIST rows were skipped because person, contract id or start date data was missing.",
  "CenterCom issue centercom.contract.name_ignored": "{0} VERTHIST rows were ignored by hard-coded contract name exclusions.",
  "CenterCom issue centercom.contract.exclusion_ignored": "{0} VERTHIST rows were ignored by exclusion decisions.",
  "CenterCom issue centercom.contract.ignored": "{0} VERTHIST rows were ignored by contract position rules.",
  "CenterCom issue centercom.contract.article_missing": "{0} VERTHIST rows match an article rule without a target article.",
  "CenterCom issue centercom.contract_template.accounting_account_conflict": "{0} contract templates had invoice positions with multiple accounting accounts. The most frequently used account was set as the initial assignment.",
  "CenterCom issue centercom.contract.package_primary_missing": "{0} VERTHIST rows belong to contract package groups where no primary contract was found or selected from the source.",
  "CenterCom issue centercom.contract.cancellation_model_combination_missing": "{0} VERTHIST rows have different effective notice periods in initial term and renewal, but no matching cancellation model assignment. The contracts are still imported with their CenterCom term and renewal data; only the optional cancellation model snapshot remains empty.",
  "CenterCom issue centercom.contract.template_missing": "{0} VERTHIST rows have no resolved contract template. This is not a blocking error; rerun the precheck with the current adapter logic.",
  "CenterCom issue centercom.invoice.skipped": "{0} RECHNUNG rows were skipped because person, invoice id or due date data was missing.",
  "CenterCom issue centercom.invoice.ignored": "{0} RECHNUNG rows were ignored by exclusion decisions.",
  "CenterCom issue centercom.special_payment.skipped": "{0} SONDERZAHLUNG rows were skipped because contract, person or date data was missing.",
  "CenterCom issue centercom.special_payment.ignored": "{0} SONDERZAHLUNG rows were ignored by special rules.",
  "CenterCom issue centercom.special_payment.article_missing": "{0} SONDERZAHLUNG rows match an article rule without a target article.",
  "CenterCom issue centercom.special_payment.package_missing": "{0} SONDERZAHLUNG rows are configured as contract components but no VERTHIST package with primary contract could be resolved.",
  "CenterCom issue centercom.special_payment.contract_template_missing": "{0} SONDERZAHLUNG rows have no resolved contract template. This is not a blocking error; rerun the precheck with the current adapter logic.",
  "CenterCom issue centercom.payment.skipped": "{0} ZAHLUNG rows were skipped because person, payment id or paid date data was missing.",
  "CenterCom issue centercom.payment.unlinked": "{0} ZAHLUNG rows were imported without an open-item link because no usable invoice or open item could be resolved.",
  "CenterCom issue centercom.payment.unlinked_skipped": "{0} ZAHLUNG rows were skipped because no usable invoice or open-item link could be resolved.",
  "CenterCom issue centercom.plausibility.payment_zero_amount_with_date": "{0} ZAHLUNG rows have a payment date but amount 0.",
  "CenterCom issue centercom.plausibility.sepa_payment_zero_amount_with_date": "{0} ZAHLUNG rows have a payment date and amount 0 while the linked contribution is assigned to direct debit.",
  "CenterCom issue centercom.plausibility.submitted_sepa_open_item_already_paid": "{0} contribution open items are assigned to an active direct debit run and already fully paid.",
  "CenterCom issue centercom.rest_period.skipped": "{0} RUHEZEIT rows were skipped because no importable contract with package, person or date could be resolved.",
  "CenterCom issue centercom.rest_period.ignored": "{0} RUHEZEIT rows were ignored by confirmed exclusion decisions.",
  "CenterCom issue centercom.rest_period.cancelled_imported": "{0} cancelled RUHEZEIT rows were imported as cancelled rest periods.",
  "CenterCom issue centercom.wallet.skipped": "{0} LEISTUNG rows were skipped because person or wallet id data was missing.",
  "CenterCom issue centercom.wallet_transaction.skipped": "{0} LEISTUNGSNUTZUNG rows for imported wallets were skipped because transaction id or timestamp was missing.",
  "CenterCom issue centercom.sepa_run.skipped": "{0} RECHNUNGSLAUFAUFTRAG rows were skipped because required run data was missing.",
  "CenterCom issue centercom.sepa_item.skipped": "{0} direct debit items were skipped because person, run id or due date data was missing.",
  "CenterCom issue centercom.sepa_item.run_missing": "{0} direct debit items were skipped because the related direct debit run was not imported.",
  "CenterCom issue centercom.sepa_item.open_item_missing": "{0} direct debit items were imported without an open-item link because no imported open item could be resolved.",
  "CenterCom issue centercom.access_media.skipped": "{0} KARTENNUMMER rows were skipped because card data was missing, the person exists but was not imported, or the medium id was duplicated.",
  "CenterCom issue centercom.access_media.person_missing": "{0} KARTENNUMMER rows were skipped because the referenced person does not exist in the CenterCom person tables.",
  "CenterCom issue centercom.staff_member.access_media_skipped": "{0} KARTENNUMMER rows were skipped because the person was detected as staff and is not imported as a member.",
  "CenterCom issue centercom.checkin.skipped": "{0} LEISTUNGSNUTZUNG rows were skipped for check-ins because person or timestamp data was missing.",
  "CenterCom issue centercom.checkin.checkout_finalized": "{0} synthetic check-out events were added so imported CenterCom history does not leave persons actively checked in.",
  "CenterCom issue centercom.person_note.skipped": "{0} NOTIZ rows were skipped because person or text data was missing.",
  "CenterCom issue centercom.person_document.skipped": "{0} DOKUMENTE rows were skipped because document id, person or file reference data was missing, or the person was not imported.",
  "CenterCom issue centercom.staff_member.person_document_skipped": "{0} DOKUMENTE rows were skipped because the person was detected as staff and is not imported as a member.",
  "CenterCom issue centercom.person_document.file_missing": "{0} DOKUMENTE rows were skipped because the referenced file was not found in the uploaded document archive.",
  "CenterCom issue centercom.person_document.kept_without_file": "{0} DOKUMENTE rows were imported without a file because the referenced file was not found in the uploaded document archive.",
  "CenterCom issue centercom.person_document.file_shared": "{0} DOKUMENTE rows reference a file that is also used by other rows. The file was not attached because the source does not say which row it belongs to.",
  "CenterCom issue centercom.contract_price_adjustment.skipped": "{0} VERTRAGSPREISANPASSUNG rows were skipped because contract, id or date data was missing.",
  "CenterCom issue centercom.payment_cancellation_reason.skipped": "{0} STORNOGRUND rows were skipped because id or name data was missing.",
  "CenterCom issue centercom.cancellation_reason.skipped": "{0} KUENDIGUNGSGRUND rows were skipped because id or name data was missing.",
  "CenterCom issue centercom.reminder_level.skipped": "{0} MAHNSTUFE rows were skipped because id or level data was missing.",
  "CenterCom issue centercom.reminder.skipped": "{0} MAHNUNG rows were skipped because open item, reminder level or date data was missing.",
  "CenterCom issue centercom.reminder.document_linked": "{0} MAHNUNG rows were linked to imported DOKUMENTE rows.",
  "CenterCom issue centercom.debt_collection_agency.skipped": "{0} EXTERNERZAHLUNGSVERFOLGER rows were skipped because id or name data was missing.",
  "CenterCom issue centercom.debt_collection_case.skipped": "{0} EXTERNEZAHLUNGSVERFOLGUNG rows were skipped because person or case data was missing.",
  "CenterCom issue centercom.debt_collection_case_item.skipped": "{0} EXTERNEZAHLUNGSVERFOLGUNGRECHNUNG rows were skipped because case or open item data was missing.",
  "CenterCom issue centercom.open_item_correction.skipped": "{0} RECHNUNGKORREKTURRECHNUNG rows were skipped because original or correction open item data was missing.",
  "CenterCom issue centercom.open_item_correction.auto_linked": "{0} CenterCom open item cancellation pairs were linked and neutralized by fallback matching.",
  "CenterCom issue centercom.vat_settings.skipped": "{0} STEUERSCHLUESSEL rows were skipped because id, name or rate data was missing.",
  "CenterCom issue centercom.accounting_account.skipped": "{0} BUCHUNGSKONTO rows were skipped because id, account number or name data was missing.",
  "CenterCom issue centercom.accounting_account.duplicate_number_reused": "{0} BUCHUNGSKONTO rows used an already planned account number and were linked to the first planned account.",
  "CenterCom issue centercom.accounting_account.duplicate_planned_number": "{0} accounting account assignments would create multiple new accounting accounts with the same account number or reuse an existing account number.",
  "CenterCom issue centercom.accounting_account.planned_number_missing": "{0} planned accounting accounts could not be created because no account number is set.",
  "CenterCom issue centercom.accounting_account.type_defaulted": "{0} BUCHUNGSKONTO rows used unknown account types and were imported as revenue accounts.",
  "CenterCom issue centercom.article.skipped": "{0} ARTIKEL rows were skipped because id or name data was missing.",
  "CenterCom issue centercom.article.ignored": "{0} ARTIKEL rows were ignored by exclusion decisions.",
  "CenterCom issue centercom.article.exclusion_available": "ARTIKEL rows can still be excluded through source table or row-level ignore decisions.",
  "CenterCom issue centercom.article.price_missing": "{0} ARTIKEL rows had no matching ARTIKELPREIS row and were imported with price 0.",
  "CenterCom issue centercom.article.account_missing": "{0} ARTIKELPREIS rows referenced no imported BUCHUNGSKONTO. Articles were imported without accounting account.",
  "CenterCom issue centercom.staff_member.contract_skipped": "{0} VERTHIST rows were skipped because the person was detected as staff and is not imported as a member.",
  "CenterCom issue centercom.staff_member.invoice_skipped": "{0} RECHNUNG rows were skipped because the person was detected as staff and is not imported as a member.",
  "CenterCom issue centercom.staff_member.wallet_skipped": "{0} LEISTUNG rows were skipped because the person was detected as staff and is not imported as a member.",
  "CenterCom issue centercom.staff_member.person_skipped": "{0} person rows were skipped because they were detected as staff and are not imported as members.",
  "CenterCom issue centercom.staff.accounts_imported_without_access": "{0} CenterCom staff/user rows are planned as new m1member accounts. Passwords and CenterCom rights are not imported; roles come from the new-account role selection or fall back to ImportedStaff.",
  "CenterCom issue centercom.staff.user_personal_match": "CenterCom USER/PERSONAL matching uses USER.Trainernummer -> PERSONAL.Personalnummer ({0} matched USER rows, {1} USER-only rows, {2} PERSONAL-only rows).",
  "CenterCom issue centercom.audit.crm": "CenterCom CRM source tables were detected but are audit-only in this adapter version.",
  "CenterCom issue centercom.audit.staff": "CenterCom staff source tables were detected but are audit-only in this adapter version.",
  "CenterCom issue centercom.open_item.external_duplicate": "{0} CenterCom open items already exist in the target tenant. Commit is blocked to keep the import idempotent.",
  "CenterCom issue centercom.references.studio_missing": "{0} mapped studio references do not exist in the target tenant.",
  "CenterCom issue centercom.references.package_template_missing": "{0} mapped package templates do not exist in the target tenant.",
  "CenterCom issue centercom.references.contract_template_missing": "{0} mapped contract templates do not exist in the target tenant.",
  "CenterCom issue centercom.references.article_missing": "{0} mapped articles do not exist in the target tenant.",
  "CenterCom control comparison csv only": "The control report was detected, but only CSV reports can be compared automatically in this import.",
  "CenterCom control comparison count matches": "The control report row count matches the planned import count.",
  "CenterCom control comparison count differs": "The control report row count differs from the planned import count ({0} vs. {1}).",
  "CenterCom control comparison count amount matches": "The control report matches the planned import count and amount.",
  "CenterCom control comparison count amount differs": "The control report differs from the planned import (count {0} vs. {1}, amount {2} vs. {3}).",
  "CenterCom precheck decision column": "Decision",
  "CenterCom precheck decision required": "decide",
  "CenterCom precheck decision ignore": "Do not import",
  "CenterCom precheck ignore confirm title": "Do not import affected data?",
  "CenterCom precheck ignore confirm content": "This writes an exclusion/ignore rule into the assignment configuration. Save afterwards and run the precheck again.",
  "CenterCom precheck ignore confirm action": "Do not import",
  "CenterCom precheck decision open packages": "Open customer contracts",
  "CenterCom precheck decision open special payments": "Open special payments",
  "CenterCom precheck decision open studios": "Open studios",
  "CenterCom precheck decision open articles": "Open articles",
  "CenterCom import not found": "CenterCom import not found.",
  "CenterCom import plan counts": "Import plan",
  "CenterCom import precheck": "Run precheck",
  "CenterCom import precheck completed": "Precheck completed.",
  "CenterCom import precheck cancelled": "Precheck cancelled.",
  "CenterCom import precheck error": "Precheck could not be run.",
  "CenterCom import save selection": "Save",
  "CenterCom import discard changes": "Discard changes",
  "CenterCom import changes discarded": "Changes were discarded.",
  "CenterCom import select tenant": "Select tenant",
  "CenterCom import selection saved": "Data selection saved.",
  "CenterCom import source tables": "Detected primary data",
  "CenterCom import hidden source tables": "{0} other source tables are hidden here because the CenterCom adapter does not import them in this flow.",
  "CenterCom import status Committed": "Committed",
  "CenterCom import status Committing": "Running",
  "CenterCom import status ClearingUploads": "Clearing upload",
  "CenterCom import status Draft": "Draft",
  "CenterCom import status Failed": "Failed",
  "CenterCom import status Prechecking": "Precheck running",
  "CenterCom import status PrecheckFailed": "Precheck failed",
  "CenterCom import status Ready": "Ready",
  "CenterCom import status RolledBack": "rolled back",
  "CenterCom import status UploadProcessing": "Processing upload",
  "CenterCom import status Uploaded": "Uploaded",
  "CenterCom import tenant required": "Select a tenant.",
  "CenterCom target tenant": "Target tenant",
  "CenterCom target tenant change title": "Change target tenant?",
  "CenterCom target tenant change confirm": "This run will be switched to {0}. Assignments are checked again afterwards and precheck must be run again.",
  "CenterCom target tenant change action": "Change target tenant",
  "CenterCom target tenant changed": "Target tenant changed.",
  "CenterCom target tenant unsaved changes": "Save or discard open changes first.",
  "CenterCom configuration download": "Download configuration",
  "CenterCom configuration upload": "Upload configuration",
  "CenterCom configuration downloaded": "Configuration downloaded.",
  "CenterCom configuration uploaded": "Configuration uploaded.",
  "CenterCom configuration upload invalid": "Select a valid CenterCom configuration file.",
  "CenterCom import upload button": "Upload files",
  "CenterCom import upload hint": "Drop a CenterCom ZIP or CenterCom primary data here.",
  "CenterCom import server progress count": "{0} of {1} files",
  "CenterCom import server upload progress": "Server processing upload",
  "CenterCom import upload failed": "Files could not be uploaded.",
  "CenterCom import upload file unreadable": "The browser cannot read file \"{0}\". Select the file again and check that it is available locally.",
  "CenterCom import upload network error": "The upload could not be started. The request did not reach the server. Select the files again and check that they are available locally.",
  "CenterCom import upload no readable files": "No readable files selected for upload.",
  "CenterCom import upload timeout": "Server-side upload processing is taking too long. Reload the run and check the progress.",
  "CenterCom import upload success": "Files uploaded.",
  "CenterCom import upload title": "Upload",
  "CenterCom statistic csv": "CSV",
  "CenterCom statistic files": "Files",
  "CenterCom step analysis": "Analysis",
  "CenterCom step commit": "Commit",
  "CenterCom step decisions": "Assignments",
  "CenterCom step import": "Import",
  "CenterCom step precheck": "Precheck",
  "CenterCom step selection": "Selection",
  "CenterCom step upload": "Upload",
  "CenterCom step verify": "Check and analyze",
  "CenterCom table column confidence": "Confidence",
  "CenterCom table column report type": "Report type",
  "CenterCom file role ControlData": "Control data",
  "CenterCom file role PrimaryData": "Primary data",
  "CenterCom file role RegressionCase": "Regression case",
  "CenterCom file role Unknown": "Unknown",
  "CenterCom source role AccessCard": "Access card",
  "CenterCom source role BankAccount": "Bank account",
  "CenterCom source role ContractHistory": "Contract history",
  "CenterCom source role Document": "Document",
  "CenterCom source role ImportSupplement": "Supplemental import data",
  "CenterCom source role Invoice": "Invoice",
  "CenterCom source role Other": "Other",
  "CenterCom source role Payment": "Payment",
  "CenterCom source role Person": "Person",
  "CenterCom source role RestPeriod": "Rest period",
  "CenterCom source role SepaMandate": "SEPA mandate",
  "CenterCom source role SpecialPayment": "Special payment",
  "CenterCom issue severity filter": "Filter by severity",
  "CenterCom issue clipboard more details": "... (+{0} more examples not copied)",
  "CenterCom issue clipboard truncated": "... Clipboard output truncated.",
  "CenterCom issue details": "Examples",
  "CenterCom issue detail field": "Field",
  "CenterCom issue detail value": "Value",
  "CenterCom issue details show all": "Show all {0} examples",
  "CenterCom issue message": "Message",
  "CenterCom issue severity": "Severity",
  "CenterCom issue severity Blocking": "blocking",
  "CenterCom issue severity Error": "error",
  "CenterCom issue severity Info": "info",
  "CenterCom issue severity Warning": "warning",
  "CenterCom data selection": "Assign",
  "CenterCom data selection hint": "Recognized CenterCom primary tables are used automatically. The remaining assignments are run-specific.",
  "CenterCom data selection automatic hint": "Recognized CenterCom primary tables are used automatically. Raw files are no longer selected one by one here.",
  "CenterCom data selection no primary tables": "No known CenterCom primary tables were detected. Check the upload.",
  "CenterCom include control reports": "Include control exports in precheck",
  "CenterCom control reports detected hint": "Control reports were detected. Select only the reports that should be checked against the planned import in precheck.",
  "CenterCom control reports select placeholder": "Select control reports for precheck",
  "CenterCom control report type balanceSnapshot": "Balance check",
  "CenterCom control report type contractSnapshot": "Contract check",
  "CenterCom control report type memberSnapshot": "Member check",
  "CenterCom control report type openItemSnapshot": "Open item check",
  "CenterCom control report type paymentSnapshot": "Payment check",
  "CenterCom control report type restPeriodSnapshot": "Rest period check",
  "CenterCom control report type sepaMandateSnapshot": "SEPA check",
  "CenterCom control report type unknown": "Control report",
  "CenterCom upload step hint": "Upload CenterCom primary data or a CenterCom archive here.",
  "CenterCom continue verify": "Go to check",
  "CenterCom verify title": "Check and analyze data",
  "CenterCom verify hint": "Check upload, issues and detected primary tables.",
  "CenterCom verify missing analysis": "No checked data is available yet. Start check and analysis.",
  "CenterCom verify refresh": "Refresh check",
  "CenterCom verify start": "Start check and analysis",
  "CenterCom source tables title": "Detected primary tables",
  "CenterCom continue decisions": "continue to assignments",
  "CenterCom continue precheck": "continue",
  "CenterCom save and continue precheck": "Save and continue",
  "CenterCom precheck title": "Precheck",
  "CenterCom precheck hint": "The precheck validates saved assignments before import.",
  "CenterCom precheck simulation switch": "Run import simulation",
  "CenterCom precheck not run": "Precheck has not been run for this state yet.",
  "CenterCom precheck stale": "The previous precheck no longer matches this state. Run the precheck again.",
  "CenterCom precheck invalid assignments": "{0} invalid assignments must be corrected before precheck.",
  "CenterCom precheck current phase": "Current: {0}",
  "CenterCom precheck waiting for progress": "Precheck is starting. Phases appear as soon as the server reports progress.",
  "CenterCom precheck phase configuration": "Load configuration and adapter knowledge",
  "CenterCom precheck phase source tables": "Load source tables",
  "CenterCom precheck phase target mappings": "Check target system and assignments",
  "CenterCom precheck phase persons": "Prepare persons, studios and bank data",
  "CenterCom precheck phase contracts": "Plan customer contracts, contract components and articles",
  "CenterCom precheck phase invoices": "Check invoices, payments and open items",
  "CenterCom precheck phase wallets": "Check wallets and transactions",
  "CenterCom precheck phase sepa": "Resolve direct debit runs and direct debit groups",
  "CenterCom precheck phase documents": "Check notes, documents and access media",
  "CenterCom precheck phase reminders": "Check cancellations, reminders and debt collection",
  "CenterCom precheck phase control reports": "Check control reports and plausibility",
  "CenterCom precheck phase save result": "Save precheck result",
  "CenterCom continue import": "continue to import",
  "CenterCom import needs precheck": "A valid precheck is required before import.",
  "CenterCom back to precheck": "Back to precheck",
  "CenterCom progress working": "Operation running",
  "CenterCom progress loading run": "Loading CenterCom run",
  "CenterCom progress loading committed verification": "Loading verification views",
  "CenterCom progress uploading": "Uploading files ({0}%)",
  "CenterCom progress server processing": "Upload complete, server is processing files",
  "CenterCom progress server processing count": "Server processing files: {0} of {1}",
  "CenterCom progress current package": "Current package: {0}",
  "CenterCom progress current file": "Current file: {0}",
  "CenterCom progress verifying": "Step 2: Checking and analyzing files",
  "CenterCom progress saving decisions": "Saving",
  "CenterCom progress changing tenant": "Changing target tenant and checking assignments",
  "CenterCom progress exporting configuration": "Downloading configuration",
  "CenterCom progress importing configuration": "Uploading and checking configuration",
  "CenterCom progress prechecking": "Running precheck",
  "CenterCom progress committing": "Running import",
  "CenterCom import reset commit state": "Reset import status",
  "CenterCom import reset commit state success": "Import status was reset.",
  "CenterCom import reset commit state error": "Import status could not be reset.",
  "CenterCom progress deleting": "Deleting import run",
  "CenterCom progress clearing uploads": "Deleting uploaded files",
  "CenterCom workflow status upload": "Upload files. The check follows afterwards.",
  "CenterCom workflow status verify missing": "No checked data is available yet. Start the check.",
  "CenterCom workflow status verify ready": "Data is checked.",
  "CenterCom workflow status verify index ready": "{0} business-relevant CenterCom primary tables detected. Continue with assignments.",
  "CenterCom workflow status decisions": "Review and save customer contracts, special payments, studios, wallets, payment methods, cancellation reasons, debt collection and direct debit groups.",
  "CenterCom workflow status precheck missing": "Changes are saved. Run precheck for this state.",
  "CenterCom workflow status precheck failed": "Precheck contains blocking issues. Go back to assignments.",
  "CenterCom workflow status precheck ready": "Precheck is valid. The import can be committed.",
  "CenterCom workflow status import ready": "Precheck is valid. Commit the import when this state is reviewed.",
  "CenterCom workflow status import failed": "The import did not complete because of a system error or restart.",
  "CenterCom workflow status import committed": "Import was committed.",
  "CenterCom workflow status import rolled back": "Import was rolled back. Imported data was removed.",
  "CenterCom import report title": "Import report",
  "CenterCom import rollback report title": "Import rolled back",
  "CenterCom import rollback danger hint": "The complete tenant is restored to the backup taken immediately before this import step. Later changes are lost as well.",
  "CenterCom import rollback snapshot confirm": "The complete tenant is restored to the backup taken immediately before this import step. All changes made afterwards are lost as well. Continue?",
  "CenterCom import planned counts": "planned data ({0})",
  "CenterCom import committed counts": "imported data ({0}) · {1}",
  "CenterCom import no committed counts": "No imported records in the report.",
  "CenterCom import count table item": "Area",
  "CenterCom import entity Persons": "Persons",
  "CenterCom import entity VatSettings": "VAT settings",
  "CenterCom import entity AccountingAccounts": "Accounting accounts",
  "CenterCom import entity Accounts": "User accounts",
  "CenterCom import entity AccountStudios": "User studio assignments",
  "CenterCom import entity AccountAvailabilities": "User availabilities",
  "CenterCom import entity PaymentMethodDefinitions": "Payment methods",
  "CenterCom import entity Articles": "Articles",
  "CenterCom import entity SepaGroups": "Direct debit groups",
  "CenterCom import entity CancellationReasons": "Cancellation reasons",
  "CenterCom import entity ContractTemplates": "Contract components",
  "CenterCom import entity ContractPackageTemplates": "Tariff templates",
  "CenterCom import entity ContractPackageTemplateComponents": "Tariff template components",
  "CenterCom import entity CancellationModels": "Cancellation models",
  "CenterCom import entity RestPeriodTemplates": "Rest period templates",
  "CenterCom import entity RestPeriodReasons": "Rest period reasons",
  "CenterCom import entity ContractPackageCancellationModelSnapshots": "Package cancellation models",
  "CenterCom import entity ContractPackageRestPeriodSnapshots": "Package rest period models",
  "CenterCom import entity ContractPackages": "Customer contracts",
  "CenterCom import entity Contracts": "Contract components",
  "CenterCom import entity ArticleSales": "Article sales",
  "CenterCom import entity ArticleSaleItems": "Article sale items",
  "CenterCom import entity OpenItems": "Open items",
  "CenterCom import entity Payments": "Payments",
  "CenterCom import entity ContributionCalendar": "Contributions",
  "CenterCom import entity ContributionCalendars": "Contributions",
  "CenterCom import entity RestPeriods": "Rest periods",
  "CenterCom import entity WalletProducts": "Wallet products",
  "CenterCom import entity Wallets": "Wallets",
  "CenterCom import entity WalletTransactions": "Wallet transactions",
  "CenterCom import entity SepaDirectDebitRuns": "Direct debit runs",
  "CenterCom import entity SepaDirectDebitItems": "Direct debit items",
  "CenterCom import entity AccessMedia": "Access media",
  "CenterCom import entity Checkins": "Check-ins",
  "CenterCom import entity PersonNotes": "Notes",
  "CenterCom import entity PersonDocuments": "Documents",
  "CenterCom import entity PriceAdjustments": "Price adjustment templates",
  "CenterCom import entity ContractPriceAdjustments": "Price adjustments",
  "CenterCom import entity PaymentCancellationReasons": "Payment reversal reasons",
  "CenterCom import entity ReminderLevels": "Reminder levels",
  "CenterCom import entity Reminders": "Reminders",
  "CenterCom import entity DebtCollectionAgencies": "Debt collection agencies",
  "CenterCom import entity DebtCollectionCases": "Debt collection cases",
  "CenterCom import entity DebtCollectionCaseItems": "Debt collection case items",
  "CenterCom import entity OpenItemCorrections": "Open item corrections",
  "CenterCom stock assignment": "Assignments",
  "CenterCom exclusions": "Exclusions",
  "CenterCom import block fallback": "Area",
  "CenterCom import block enabled": "Import {0}",
  "CenterCom import block source tables": "Source tables: {0}",
  "CenterCom position decisions": "Positions",
  "CenterCom position all actions": "All assignments",
  "CenterCom position action filter placeholder": "Show assignment",
  "CenterCom position visible positions": "{0} of {1} positions visible",
  "CenterCom source grouped positions hint": "Positions are grouped by source table. VERTHIST and SONDERZAHLUNG are configured separately.",
  "CenterCom source group all": "All",
  "CenterCom package groups": "Customer contracts/special payments",
  "CenterCom package groups hint": "Configure customer contracts from VERTHIST and SONDERZAHLUNG once per source label. Matching labels are assigned together.",
  "CenterCom package groups empty": "No VERTHIST or SONDERZAHLUNG positions detected",
  "CenterCom person addressing": "Addressing",
  "CenterCom person addressing field": "Addressing mode for imported people",
  "CenterCom person addressing hint": "When using the CenterCom value, STAMMDATEN.Du-Sie is imported as Du/Sie; empty source values remain unknown.",
  "CenterCom person addressing source": "Use CenterCom value",
  "CenterCom person addressing all du": "set all to Du",
  "CenterCom person addressing all sie": "set all to Sie",
  "CenterCom import cleanup options": "Data cleanup",
  "CenterCom clean empty address data": "Clean empty address data",
  "CenterCom use payment date from remark": "Use payment date from remark",
  "CenterCom clean empty address data hint": "For persons, ZIP code and city are cleared only when the ZIP code is exactly 11111 and the city is exactly Unbekannt.",
  "CenterCom attach shared document files": "Attach shared files anyway",
  "CenterCom attach shared document files hint": "When several DOKUMENTE rows reference the same file, none of them receives it by default — the source does not say which record it belongs to. With this option every row of the group gets the same file.",
  "CenterCom keep shared document entries": "Import records with a shared file",
  "CenterCom keep shared document entries hint": "The record is created without a file; title, date and contract reference are kept. Without this option the rows are skipped.",
  "CenterCom keep missing document entries": "Import records without a file in the archive",
  "CenterCom keep missing document entries hint": "When the referenced file is missing from the document archive, the record is kept without a file. Without this option the rows are skipped.",
  "CenterCom package group person": "Person",
  "CenterCom package group bundle": "Contract no.",
  "CenterCom package group import": "Import",
  "CenterCom package group primary": "Primary contract",
  "CenterCom package group package name": "Customer contract name",
  "CenterCom package component name": "Name",
  "CenterCom package component article contract": "Article/contract name",
  "CenterCom package group models": "Models",
  "CenterCom package group cancellation model": "Cancellation model",
  "CenterCom package group rest period template": "Rest period template",
  "CenterCom rest period reasons hint": "Assign rest period reasons to existing reasons in the target tenant or create them during import.",
  "CenterCom rest period reasons empty": "No rest period reasons detected",
  "CenterCom package component import": "Import",
  "CenterCom package component role": "Assignment",
  "CenterCom special payments": "Special payments",
  "CenterCom special payments hint": "Configure SONDERZAHLUNG positions once per source position as contract, article, or exclusion.",
  "CenterCom studios hint": "Assign CenterCom locations to existing studios.",
  "CenterCom studios empty": "No studio assignments detected",
  "CenterCom all assignments": "All assignments",
  "CenterCom all assignments hint": "Shows all reference assignments detected by the adapter import, including assignments without a dedicated domain section.",
  "CenterCom all assignments empty": "No assignments detected",
  "CenterCom contract templates": "Contract components",
  "CenterCom contract templates hint": "Assign CenterCom contract types from VERTRAGSART to existing contract components or create them during import.",
  "CenterCom contract templates empty": "No contract component assignments detected",
  "CenterCom articles hint": "Assign CenterCom articles from ARTIKEL and ARTIKELPREIS to existing articles or create them during import.",
  "CenterCom articles empty": "No article assignments detected",
  "CenterCom staff accounts": "Staff and users",
  "CenterCom staff account placeholder": "Select staff",
  "CenterCom staff accounts empty": "No staff or user assignments detected",
  "CenterCom staff accounts role column": "User role",
  "CenterCom staff account rights column": "Staff rights",
  "CenterCom staff accounts role placeholder": "Select role",
  "CenterCom accounting accounts": "Accounting accounts",
  "CenterCom accounting assignments": "Account assignments",
  "CenterCom accounting assignment label": "Description",
  "CenterCom accounting assignment select": "Assign account",
  "CenterCom accounting assignments empty": "No import data for this assignment.",
  "CenterCom accounting assignment contract templates": "Contract components",
  "CenterCom accounting assignment contracts": "Membership contracts",
  "CenterCom accounting assignment article sales": "Article sales",
  "CenterCom accounting accounts empty": "No accounting account assignments detected",
  "CenterCom vat settings": "VAT settings",
  "CenterCom vat settings hint": "Assign CenterCom tax keys from STEUERSCHLUESSEL to existing VAT settings or create them during import.",
  "CenterCom vat settings empty": "No VAT assignments detected",
  "CenterCom wallets hint": "Assign LEISTUNG/LEISTUNGSART values to existing wallets.",
  "CenterCom wallets empty": "No wallet assignments detected",
  "CenterCom payment methods hint": "Assign CenterCom payment methods to existing payment methods or create them during import. The system payment method can be set separately.",
  "CenterCom payment methods empty": "No payment method assignments detected",
  "CenterCom payment method system type": "System payment method",
  "CenterCom payment method system type placeholder": "Select system payment method",
  "CenterCom price adjustments": "Price adjustments",
  "CenterCom price adjustments hint": "Assign contract price adjustments to existing price adjustment templates or create them during import.",
  "CenterCom price adjustments empty": "No price adjustment assignments detected",
  "CenterCom cancellations hint": "Assign cancellation reasons to existing reasons in the target tenant.",
  "CenterCom cancellations empty": "No cancellation reasons detected",
  "CenterCom cancellation models hint": "Assign CenterCom cancellation tariffs from KUENDTARIFE to existing cancellation models or create them during import.",
  "CenterCom cancellation models empty": "No cancellation model assignments detected",
  "CenterCom cancellation initial notice": "Initial term notice",
  "CenterCom cancellation renewal notice": "Renewal notice",
  "CenterCom cancellation source label": "CenterCom label",
  "CenterCom payment cancellations": "Payment void reasons",
  "CenterCom payment cancellations hint": "Assign payment void reasons to existing reasons in the target tenant.",
  "CenterCom payment cancellations empty": "No payment void reasons detected",
  "CenterCom debt collection": "Debt collection",
  "CenterCom debt collection hint": "Assign debt collection agencies and reminder levels to existing master data.",
  "CenterCom debt collection empty": "No debt collection or reminder assignments detected",
  "CenterCom reminder levels": "Reminder levels",
  "CenterCom reminder levels empty": "No reminder level assignments detected",
  "CenterCom debt collection agencies": "Debt collection agencies",
  "CenterCom debt collection agencies empty": "No debt collection agency assignments detected",
  "CenterCom sepa groups": "Direct debit groups",
  "CenterCom sepa groups hint": "Assign debit days and collection groups from VERTHIST to existing direct debit groups or create them during import.",
  "CenterCom sepa groups empty": "No direct debit group values detected",
  "CenterCom sepa group target": "Assign",
  "CenterCom sepa group name": "Name",
  "CenterCom sepa group create": "Create new",
  "CenterCom sepa group assignment": "Create/assign direct debit groups",
  "CenterCom target sepa group": "Direct debit group",
  "CenterCom target studio": "Studio",
  "CenterCom schema mapping": "Schema check",
  "CenterCom schema mapping empty": "No schema mappings detected",
  "CenterCom schema target entity": "Target table",
  "CenterCom schema source table": "Source table",
  "CenterCom schema note": "Note",
  "CenterCom schema classification implemented": "implemented",
  "CenterCom schema classification replacedBySourceDecision": "replaced by source assignment",
  "CenterCom schema classification referenceOnly": "reference only",
  "CenterCom schema classification notRelevant": "not relevant",
  "CenterCom schema classification gap": "gap",
  "CenterCom position source table placeholder": "Select position source",
  "CenterCom position source value placeholder": "Select position value from source",
  "CenterCom position source required": "Select source and column for the position.",
  "CenterCom position add": "Add position",
  "CenterCom article target not found": "Article not found",
  "CenterCom decision target area": "Target area",
  "CenterCom decision position": "Position",
  "CenterCom decision source value": "Source column value",
  "CenterCom decision source value placeholder": "Select value from detected source column",
  "CenterCom decision source value required": "Select a value from the source.",
  "CenterCom decision suggested target": "Suggestion",
  "CenterCom decision target": "Assign",
  "CenterCom decision invalid assignments": "{0} assignments point to target objects that no longer exist. Correct the affected selections or set them to \"import as new\"/\"ignore\".",
  "CenterCom decision ignore": "ignore",
  "CenterCom decision new import": "import as new",
  "CenterCom decision new import named": "import as new: {0}",
  "CenterCom decision planned target": "planned new target",
  "CenterCom decision planned target name": "New target name",
  "CenterCom decision planned target drawer title": "Edit new target",
  "CenterCom decision planned target edit": "Edit new target name",
  "CenterCom decision planned target hint": "This target will be created during import.",
  "CenterCom decision existing target hint": "This target will be assigned directly.",
  "CenterCom decision all target areas": "All target areas",
  "CenterCom decision all source tables": "All source tables",
  "CenterCom decision target area filter placeholder": "Show target area",
  "CenterCom decision source table filter placeholder": "Show source table",
  "CenterCom decision visible assignments": "{0} of {1} assignments visible",
  "CenterCom decision source key": "Key",
  "CenterCom decision target area placeholder": "Select target area",
  "CenterCom decision area selector": "Assignment area",
  "CenterCom decision previous area": "Previous assignment area",
  "CenterCom decision next area": "Next assignment area",
  "CenterCom decision target placeholder": "Select assignment",
  "CenterCom decision group target placeholder": "Select assignment for this group",
  "CenterCom decision apply group target": "Apply to group",
  "CenterCom decision no target options": "No target objects were loaded for this target area.",
  "CenterCom decision add stock assignment": "Add assignment",
  "CenterCom decision already exists": "This assignment already exists.",
  "CenterCom decision edit status title": "Changes to assignments and rules",
  "CenterCom decision edit status detail": "Changes in this step and new differences from schema, system data or source data are used by precheck and import only after they are saved.",
  "CenterCom decision unsaved changes": "Unsaved changes",
  "CenterCom decision saved changes": "No unsaved changes",
  "CenterCom stock assignment usage": "Assignment",
  "CenterCom stock assignment status confirmed": "assign",
  "CenterCom stock assignment status suggested": "do not assign",
  "CenterCom stock assignment status ignored": "do not assign",
  "CenterCom stock assignment status open": "open",
  "CenterCom stock assignment checkbox": "assign",
  "CenterCom decision target required for assignment": "Select a target object first.",
  "CenterCom decision status": "Status",
  "CenterCom decision table": "Table",
  "CenterCom decision column": "Column",
  "CenterCom decision condition": "Condition",
  "CenterCom decision examples": "Examples",
  "CenterCom decision action": "Assignment",
  "CenterCom exclusion effect": "Effect",
  "CenterCom exclusion usage": "Usage",
  "CenterCom exclusion visible exclusions": "{0} of {1} exclusions visible",
  "CenterCom exclusion add": "Add exclusion",
  "CenterCom exclusion source table placeholder": "Select source table",
  "CenterCom exclusion source column placeholder": "Select source column",
  "CenterCom exclusion effect placeholder": "Select effect",
  "CenterCom exclusion no manual sources": "This upload has no detected source areas where grouped manual exclusions make sense.",
  "CenterCom exclusion source required": "Select table and column for the exclusion.",
  "CenterCom exclusion value placeholder": "Value",
  "CenterCom exclusion value required": "Enter a value for the exclusion rule.",
  "CenterCom decision no stock assignments": "No assignments detected.",
  "CenterCom decision no exclusions": "No exclusions detected.",
  "CenterCom decision no positions": "No position groups detected.",
  "CenterCom decision status confirmed": "Use",
  "CenterCom decision status suggested": "Suggestion",
  "CenterCom decision status ignored": "Ignore",
  "CenterCom decision status open": "Open",
  "CenterCom exclusion status confirmed": "Exclude actively",
  "CenterCom exclusion status suggested": "do not use",
  "CenterCom exclusion status ignored": "Do not use",
  "CenterCom exclusion status open": "Open",
  "CenterCom reference kind AccountingAccount": "Accounting accounts",
  "CenterCom reference kind Account": "Staff accounts",
  "CenterCom reference kind Article": "Articles",
  "CenterCom reference kind CancellationReason": "Cancellation reasons",
  "CenterCom reference kind CancellationModel": "Cancellation models",
  "CenterCom reference kind ContractTemplate": "Contract components",
  "CenterCom reference kind DebtCollectionAgency": "Debt collection agencies",
  "CenterCom reference kind PaymentMethod": "Payment methods",
  "CenterCom reference kind PaymentCancellationReason": "Payment cancellation reasons",
  "CenterCom reference kind PriceAdjustment": "Price adjustments",
  "CenterCom reference kind ReminderLevel": "Reminder levels",
  "CenterCom source value prefix": "Source:",
  "CenterCom reference kind RestPeriodReason": "Rest period reasons",
  "CenterCom reference kind RestPeriodTemplate": "Rest period templates",
  "CenterCom reference kind SepaGroup": "Direct debit groups",
  "CenterCom reference kind Studio": "Studios",
  "CenterCom reference kind Unknown": "Unknown",
  "CenterCom reference kind VatSettings": "VAT settings",
  "CenterCom reference kind WalletProduct": "Wallets",
  "CenterCom exclusion effect excludeFromArticles": "Do not import as article",
  "CenterCom exclusion effect excludeFromContracts": "Do not import as contract",
  "CenterCom exclusion effect excludeFromOpenItems": "Do not import as open item",
  "CenterCom exclusion effect excludeFromRestPeriods": "Do not import as rest period",
  "CenterCom exclusion effect excludeFromWallets": "Do not import as wallet/service",
  "CenterCom exclusion effect ignore": "Ignore completely",
  "CenterCom exclusion effect technicalQuality": "Technical quality rule",
  "CenterCom exclusion target area articles": "Articles",
  "CenterCom exclusion target area contracts": "Contracts",
  "CenterCom exclusion target area import": "Import",
  "CenterCom exclusion target area openItems": "Open items",
  "CenterCom exclusion target area restPeriods": "Rest periods",
  "CenterCom exclusion target area technicalQuality": "Technical quality",
  "CenterCom exclusion target area wallets": "Wallets/services",
  "CenterCom exclusion operator contains": "Contains",
  "CenterCom exclusion operator equals": "Equals",
  "CenterCom exclusion operator is_empty": "Is empty",
  "CenterCom exclusion operator starts_with": "Starts with",
  "CenterCom contract position rules": "Position rules for VERTHIST",
  "CenterCom contract position rules hint": "Rules define whether a VERTHIST position is imported as a contract, as an article, or not at all.",
  "CenterCom contract position match placeholder": "Text contains, e.g. start package or *",
  "CenterCom contract position add rule": "Add VERTHIST rule",
  "CenterCom contract position action ignore": "Ignore",
  "CenterCom position show examples": "Show examples",
  "CenterCom special payment rules": "Position rules for special payments",
  "CenterCom special payment rules hint": "Rules match the CenterCom special payment text. Without a match, the position remains an open item on the contract.",
  "CenterCom special payment match placeholder": "Text contains, e.g. start package or *",
  "CenterCom special payment article placeholder": "Select article",
  "CenterCom special payment add rule": "Add position rule",
  "CenterCom special payment action contract open item": "Contract open item",
  "CenterCom special payment action ignore": "Ignore",
  "CenterCom file selected count": "{0} file(s) selected",
  "CenterCom plan count articles": "Article sales",
  "CenterCom plan count contract templates": "Contract components",
  "CenterCom plan count open items": "Open items",
  "CenterCom plan count packages": "Customer contracts",
  "CenterCom plan count payment method definitions": "Payment methods",
  "CenterCom plan count price adjustments": "Price adjustment templates",
  "CenterCom plan count accounts": "User accounts",
  "CenterCom plan count vat settings": "VAT settings",
  "CenterCom plan count accounting accounts": "Accounting accounts",
  "CenterCom plan count source articles": "Article master data",
  "CenterCom plan count wallet products": "Wallet products",
  "CenterCom plan count sepa items": "Direct debit items",
  "CenterCom staff assignment": "Staff",
  "CenterCom staff import contracts": "Import contracts",
  "CenterCom staff import member": "Import member",
  "CenterCom staff member imports": "Staff usage rights",
  "CenterCom staff member imports empty": "No people with staff usage rights found.",
  "CenterCom staff member imports select usage right": "Select a usage right.",
  "CenterCom staff skip member": "Not as member",
  "CenterCom staff usage right": "Usage right",
  "CenterCom staff usage right filter": "Select usage right",
  "CenterCom usage action source type": "Type",
  "CenterCom usage action row count": "Rows",
  "CenterCom usage action target": "Target action",
  "CenterCom usage action target check in": "Check-in",
  "CenterCom usage action target check out": "Check-out",
  "CenterCom usage action target deduct points": "Deduct points",
  "CenterCom usage action target ignore": "Ignore",
  "CenterCom usage action target open door": "Open door",
  "CenterCom usage action target unlock device": "Unlock device",
  "CenterCom usage action terminal address": "Terminal address",
  "CenterCom usage action terminal info": "Terminal info",
  "CenterCom usage actions": "Usage actions",
  "CenterCom usage actions empty": "No usage actions derived from the source data.",
  "CenterCom usage checkout check in end": "From check-in end",
  "CenterCom usage checkout none": "No check-out",
  "CenterCom usage checkout source": "Automatic check-out",
  "CenterCom usage checkout source row": "From source timestamp",
  "CenterCom commit blocked by precheck": "Commit blocked: precheck contains errors.",
  "CenterCom comparison planned amount": "Planned amount",
  "CenterCom comparison planned count": "Planned count",
  "CenterCom comparison scope": "Source",
  "CenterCom comparison source amount": "Source amount",
  "CenterCom comparison source count": "Source count",
  "Select a template (Einstellungen → Rechtstexte). Then choose per section whether to show and require acceptance.": "Select a template (Einstellungen → Rechtstexte). Then choose per section whether to show and require acceptance.",
  "Send failed": "Send failed",
  "Actual items": "Actual items",
  "Actual total amount": "Actual total amount",
  "Direct debit run status booked": "booked",
  "Direct debit run status cancelled": "cancelled",
  "Direct debit runs": "Direct debit runs",
  "Force delete direct debit run confirm": "Force-delete direct debit run \"{0}\" ({1})? The run and its items will be removed. Open items are only detached from this run ID; open items and payments are not deleted. This action cannot be undone.",
  "Emails": "Emails",
  "In processing": "in processing",
  "Delete inbox": "Delete inbox",
  "Force delete inbound inbox confirm": "Permanently clear the inbox containing {0} emails? Messages, classifications, and attachments will be removed from m1member. Emails in the mailbox itself will not be deleted. Synchronization will then continue with newly arriving emails.",
  "Inbound inbox deleted success": "Inbox cleared. {0} emails were deleted.",
  "Item count differs": "Item count differs",
  "SEPA file": "SEPA file",
  "Stored items": "Stored items",
  "Stored total amount": "Stored total amount",
  "Test run": "Test run",
  "Submit": "Submit",
  "Submit failed": "Submit failed",
  "Sync failed": "Sync failed",
  "Tenant data import in progress": "We’re importing the data…",
  "Tenant data import in progress hint": "We’ll continue automatically after the import.",
  "Tenant data import progress pending": "starting",
  "ValidationError": "Validation error",
  "TemplateSelectionInvalid": "The selected template does not fit this process.",
  "ReminderRoutingTemplateInvalid": "The selected text template does not fit this reminder level.",
  "ReminderTemplateSelectionRequired": "This reminder rule needs a text template.",
  "Verlauf (FinTS-Schritte)": "History (FinTS steps)",
  "Voidable remaining": "Voidable remaining",
  "Warning": "Warning",
  "active": "active",
  "assigned": "assigned",
  "day": "day",
  "days": "days",
  "e.g. \"1st & 15th of month\"": "e.g. \"1st & 15th of month\"",
  "e.g. \"Main account\" or \"Studio Center\"": "e.g. \"Main account\" or \"Studio Center\"",
  "e.g. 1:00 for one hour, 0:30 for 30 minutes. Empty = cancel until start": "e.g. 1:00 for one hour, 0:30 for 30 minutes. Empty = cancel until start",
  "e.g. smtp.office365.com": "e.g. smtp.office365.com",
  "https://m1gateway.mqorva.de": "https://m1gateway.mqorva.de",
  "inactive": "inactive",
  "not assigned": "not assigned",
  "month": "month",
  "points": "points",
  "yes": "yes",

  // Staff scheduling
  "Staff": "Staff",
  "Staff schedule": "Staff scheduling",
  "This week": "This week",
  "Activity": "Activity",
  "Activity types": "Activity types",
  "Really delete this activity type?": "Really delete this activity type?",
  "Activity is required": "Activity is required",
  "New shift": "New shift",
  "Edit shift": "Edit shift",
  "Shift created": "Shift created",
  "Shift updated": "Shift updated",
  "Shift deleted": "Shift deleted",
  "Really delete this shift?": "Really delete this shift?",
  "Shift note": "Note",
  "Shift planned": "Planned",
  "Shift confirmed": "Confirmed",
  "Shift cancelled": "Cancelled",
  "Worked this week": "Worked this week",
  "Apply opening hours": "Apply opening hours",
  "Opening hours block": "Opening hours block",
  "Shifts created": "Shifts created",
  "Please select at least one employee": "Please select at least one employee",
  "Please select an opening hours block": "Please select an opening hours block",
  "View staff schedule": "View staff schedule",
  "Edit staff schedule": "Edit staff schedule",
  "View staff settings": "View staff settings",
  "Edit staff settings": "Edit staff settings",

  // Staff: absences & vacation
  "Absences": "Absences",
  "Absence types": "Absence types",
  "Vacation management": "Vacation management",
  "Counts as vacation": "Counts as vacation",
  "Requested": "Requested",
  "General entitlement": "General entitlement",
  "Pre-filled with the general entitlement — change it only if it differs for this year (e.g. pro rata in the year of joining).": "Pre-filled with the general entitlement — change it only if it differs for this year (e.g. pro rata in the year of joining).",
  "Vacation counts against the vacation entitlement, sick leave is counted separately, holidays identify holiday absence.": "Vacation counts against the vacation entitlement, sick leave is counted separately, holidays identify holiday absence.",
  "enter a different value only for this year (e.g. pro rata in the year of joining)": "enter a different value only for this year (e.g. pro rata in the year of joining)",
  "Holiday": "Holiday",
  "Working time": "Working time",
  "Weekly target hours are required for a monthly minimum wage": "Weekly target hours are required for a monthly minimum wage.",
  "Minimum wage": "Minimum wage",
  "Minimum hourly wage": "Minimum hourly wage",
  "Used for employees with the minimum wage option enabled": "Used for employees with the minimum wage option enabled",
  "Minimum wage rates": "Minimum wage rates",
  "Requires active time tracking": "Requires active time tracking",
  "Employment period": "Employment period",
  "Weekdays": "Weekdays",
  "Really delete this absence type?": "Really delete this absence type?",
  "This employee has legacy recurrence rules that must be resolved before the availabilities can be saved.": "This employee has legacy recurrence rules that must be resolved before the availabilities can be saved.",
  "Annual entitlement is required": "Annual entitlement is required",
  "Manual carry-over": "Manual carry-over",
  "Carry-over expiry": "Carry-over expiry",
  "View staff absences": "View staff absences",
  "Edit staff absences": "Edit staff absences",
  "View vacation management": "View vacation management",
  "Edit vacation management": "Edit vacation management",
  "Conflict: shift overlaps an absence": "Conflict: shift overlaps an absence",
  "Conflict: overlapping shifts": "Conflict: overlapping shifts",
  "Activity catalog for the staff schedule (counts as work time)": "Activity catalog for the staff schedule (counts as work time)",
  "Absence reason catalog (vacation, sick, …)": "Absence reason catalog (vacation, sick, …)",

  // Staff: payroll preparation & settings
  "June": "June",
  "Payroll preparation": "Payroll preparation",
  "Difference": "Difference",
  "Unresolved days": "Unresolved days",
  "View payroll preparation": "View payroll preparation",
  "Export payroll": "Export payroll",
  "Employee master data": "Employee master data",
  "Assignable studios": "Assignable studios",
  "Assignable studios tooltip": "Empty = all studios. These are the studios where this person is typically deployed.",
  "Target hours & employment period per employee": "Target hours & employment period per employee",
  "Staff schedule settings": "Staff schedule settings",
  "Time grid, working days & shared week plan links": "Time grid, working days & shared week plan links",
  "Grid start": "Grid start",
  "Grid end": "Grid end",
  "Grid resolution": "Grid resolution",
  "Planning advance period (days)": "Advance period (days)",
  "Working days": "Working days",
  "Allow booking against default plan": "Allow booking against default plan",
  "Appointments without staff coverage": "Appointments without staff coverage",
  "{0} appointments without staff": "{0} appointments without staff",
  "without staff": "without staff",
  "Understood": "Understood",
  "Shared week plan links": "Shared week plan links",
  "Week plan links": "Week plan links",
  "Schedule settings": "Schedule settings",
  "Share link scope": "Scope",
  "Copied to clipboard": "Copied to clipboard",
  "Week copied": "Week copied",
  "Confirm week": "Confirm week",
  "Week confirmed": "Week confirmed",
  "Publication": "Publication",
  "draft": "draft",
  "Publish": "Publish",
  "Publish all planned shifts of this week?": "Publish all planned shifts of this week?",
  "Confirm all planned shifts of this week?": "Confirm all planned shifts of this week?",
  "All shifts of the source week are copied to the target week (existing identical shifts are skipped).": "All shifts of the source week are copied to the target week (existing identical shifts are skipped).",
  "Back to Staff": "Back to Staff",
  "A FinTS connection test is already running.": "A FinTS connection test is already running.",
  "Automations": "Automations",
  "View automations": "View automations",
  "Manage automations": "Manage automations",
  "Operations": "Operations",
  "New automation": "New automation",
  "Edit automation": "Edit automation",
  "New member": "New member",
  "Inactive for days": "Inactive for days",
  "Open app/contact request": "Open app/contact request",
  "Overdue open item": "Overdue open item",
  "SEPA run due": "SEPA run due",
  "Chargeback recorded": "Chargeback recorded",
  "Contract ending soon": "Contract ending soon",
  "Repeated check-in denied": "Repeated check-in denied",
  "Access device problem": "Access device problem",
  "Create task": "Create task",
  "Send SMS": "Send SMS",
  "Send WhatsApp": "Send WhatsApp",
  "Prepare SEPA run": "Prepare SEPA run",
  "Prepare debt collection case": "Prepare debt collection case",
  "Internal notification": "Internal notification",
  "Waiting for approval": "Waiting for approval",
  "Succeeded": "Succeeded",
  "Approval": "Approval",
  "Live": "Live",
  "Direct": "Direct",
  "Offset days": "Offset days",
  "Limit": "Limit",
  "Last run": "Last run",
  "Executed at": "Executed at",
  "Text template": "Text template",
  "Automation is required": "Automation is required",
  "Text template is required": "Text template is required",
  "Execution time": "Execution time",
  "Execution time empty hint": "Leave empty if the automation should run on the next regular automation pass.",
  "Automation area": "Area",
  "Automation goal": "Goal",
  "Automation trigger": "Trigger",
  "Automation execution": "Execution",
  "All contract package templates": "All contract package templates",
  "Automation scenario member welcome": "Welcome message for membership start",
  "Automation scenario member birthday": "Birthday message",
  "Automation scenario member inactive": "Care task for inactivity",
  "Automation scenario finance overdue": "Dunning level for open item",
  "Automation scenario finance sepa": "Prepare SEPA run",
  "Automation scenario finance chargeback": "Follow-up after chargeback",
  "Automation scenario wallet balance low": "Action for low wallet balance",
  "Automation scenario wallet unused": "Action for unused wallet",
  "Automation scenario contract starting": "Contract start communication",
  "Automation scenario contract ending": "Task or message before contract end",
  "Automation scenario rest period ending": "Return from rest period",
  "Automation scenario check-in denied": "Repeated check-in denial",
  "New members from the last days": "New members from the last days",
  "Member recorded within days": "Days since membership was recorded",
  "Days before birthday": "Days before birthday",
  "Without check-in for days": "Without check-in for days",
  "Overdue for days": "Days after due date",
  "Due items up to days": "Due items up to days",
  "Chargebacks from the last days": "Chargebacks from the last days",
  "Chargeback recorded within days": "Days since chargeback",
  "Wallet balance below threshold": "Wallet balance below threshold",
  "Wallet threshold": "Threshold",
  "Wallet unused for days": "Days without wallet usage",
  "Wallet unused since days": "Wallet unused",
  "Contract starts in days": "Days before contract start",
  "Contract ends in days": "Days before contract end",
  "Rest period ends in days": "Days before rest period end",
  "Denied check-ins from the last days": "Denied check-ins from the last days",
  "Automation applies to": "Applies to",
  "When": "When",
  "Then": "Then",
  "Safety": "Safety",
  "Run in test mode": "Run in test mode",
  "Require approval before final execution": "Require approval before final execution",
  "Approval required hint": "The execution first creates a reviewable draft or approval entry.",
  "Run automations": "Run automations",
  "Approve automations": "Approve automations",
  "Member automations": "Member automations",
  "Finance automations": "Finance automations",
  "Contract automations": "Contract automations",
  "Operations automations": "Operations automations",
  "Please reload the page. If the error occurs repeatedly, contact support.": "Please reload the page. If the error occurs repeatedly, contact support.",
  "No data received from server": "No data received from server",
  "New user default name": "New user",
  "Contract modules": "Contract modules",
  "Contract module": "Contract module",
  "Contract module assignment description": "Assign and configure multiple contract modules (term, renewal, payment cycle, price, usage limit).",
  "No contract modules available": "No contract modules available (Settings -> Contract modules).",
  "Main contract": "Main contract",
  "Installment payment": "Installment payment",
  "Direct debit group": "Direct debit group",
  "Wallet assignment description": "Assign and configure multiple value accounts (initial value, validity, usage limit, access).",
  "No wallet products available": "No value account templates available (Settings -> Value accounts).",
  "Value account": "Value account",
  "Copy suffix": "Copy",
  "Copy suffix numbered": "Copy {0}",
  "Installments max min error": "Installments: max must be greater than or equal to min",
  "Default price must be non-negative": "Default price must be greater than or equal to 0",
  "Optional default rest period model for this contract package": "Optional default rest period model for this contract package.",
  "Allow rest periods": "Allow rest periods",
  "No rest period allowed": "No rest period allowed",
  "Utilization of appointments and courses": "Utilization of appointments and courses",
  "Utilization per trainer or resource": "Utilization per trainer or resource",
  "Home": "Home",
  "Queued": "Queued",
  "FinTS": "FinTS",
  "Lead widget: widget not found or not available": "Lead widget not found or not available",
  "Open item amount": "Open item amount",
  "Open item due date": "Open item due date",
  "Open item description": "Open item description",
  "Total open amount": "Total open amount",
  "Reminder level name": "Reminder level name",
  "Booking widget link": "Appointment form URL",
  "Booking widget as link": "Clickable appointment form",
  "Appointment booking link": "Book appointment URL",
  "Appointment booking as link": "Clickable book appointment",
  "Email as link": "Clickable email",
  "Website as link": "Clickable website",
  "Cancel booking as link": "Clickable cancel appointment",
  "Edit booking as link": "Clickable edit appointment",
  "Reset link as link": "Clickable password reset",
  "Email link text": "Write email",
  "Website link text": "Open website",
  "Cancel booking link text": "Cancel appointment",
  "Edit booking link text": "Edit appointment",
  "Booking widget link text": "Open appointment form",
  "Appointment booking link text": "Book appointment",
  "Reset link text": "Reset password",
  "CenterCom verification views title": "Verification views",
  "CenterCom verification views empty": "No verification views detected",
  "CenterCom verification status ok": "ok",
  "CenterCom verification status deviation": "Deviation",
  "CenterCom verification status not checkable": "not checkable",
  "CenterCom verification status unknown": "unknown",
  "CenterCom verification details": "Details",
  "CenterCom verification metric": "Metric",
  "CenterCom verification evaluated records": "Evaluated records",
  "CenterCom verification amount column": "Amount column",
  "CenterCom committed verification views title": "Post-import verification",
  "CenterCom committed verification refreshed": "The post-import verification has been refreshed.",
  "CenterCom committed verification refresh error": "The post-import verification could not be refreshed.",
  "Time restriction": "Time restriction",
  "Limit by time": "Limit by time",
  "Available time": "Available time",
  "No time restriction": "No time restriction",
  "Auth": "Auth",
  "Connect": "Connect",
  "OTP": "OTP",
  "ReaderDevices": "Reader devices",
  "TenantBackup": "Tenant backup",
  "More tabs": "More tabs",
  "Promotions & bonuses": "Promotions & bonuses",
  "Manage referrals, bonus cases and redemptions": "Manage referrals, bonus cases and redemptions",
  "Promotion templates": "Promotion templates",
  "Rules for referral bonuses and campaigns": "Rules for referral bonuses and campaigns",
  "Promotion template": "Promotion template",
  "Qualification": "Qualification",
  "New promotion template": "New promotion template",
  "Edit promotion template": "Edit promotion template",
  "Create promotion template": "Create promotion template",
  "Name is required.": "Name is required.",
  "Delete promotion template": "Delete promotion template",
  "Bonus type": "Bonus type",
  "Price adjustment only": "Price adjustment only",
  "Value account only": "Value account only",
  "Selectable when entering": "Selectable when entering",
  "Price adjustment type": "Price adjustment type",
  "Promotion amount per duration unit": "Amount per unit",
  "Contribution cycles": "Contribution cycles",
  "Start mode": "Start mode",
  "Next due date": "Next due date",
  "Fixed start date": "Fixed start date",
  "Contract end": "Contract end",
  "Before contract renewal": "Before contract renewal",
  "Append after contract end": "Append after contract end",
  "Qualification timing": "Qualification timing",
  "Immediately": "Immediately",
  "Fixed date": "Fixed date",
  "After referred contract start": "After referred contract start",
  "Qualification condition": "Qualification condition",
  "Promotion qualification condition tooltip": "This condition is checked per bonus case against the referred contract, meaning the contract package of the referred member, not just the person in general.",
  "Active on due date": "Active on due date",
  "No cancellation recorded": "No cancellation recorded",
  "No effective cancellation": "No effective cancellation",
  "Manual review": "Manual review",
  "Later cancellation behavior": "Later cancellation behavior",
  "Promotion later cancellation behavior tooltip": "Defines what happens if a cancellation is recorded or becomes effective on the referred contract after qualification.",
  "Ignore after qualification": "Ignore after qualification",
  "Block until redemption": "Block until redemption",
  "Revocable until benefit end": "Revocable until benefit end",
  "Value account product": "Value account product",
  "Credit amount": "Credit amount",
  "Offset": "Offset",
  "New bonus": "New bonus",
  "Edit bonus": "Edit bonus",
  "Create bonus": "Create bonus",
  "Referred member": "Referred member",
  "Referred contract package": "Contract of referred member",
  "Referral date": "Referral date",
  "Requested start date": "Requested start date",
  "Internal note": "Internal note",
  "Target contract package": "Target contract package",
  "Target contract": "Target contract",
  "Target value account": "Target value account",
  "Open price adjustment": "Open price adjustment",
  "Open value account booking": "Open value account booking",
  "qualified": "qualified",
  "redeemed": "redeemed",
  "rejected": "rejected",
  "cancelled": "cancelled",
  "review needed": "review needed",
  "Qualify": "Qualify",
  "Redeem": "Redeem",
  "Qualified.": "Qualified.",
  "Redeemed.": "Redeemed.",
  "Cancelled.": "Cancelled.",
  "Value account booking": "Value account booking",
  "Role in referral": "Role in referral",
  "Current person is referrer": "Current person is referrer",
  "Current person was referred": "Current person was referred",
  "Referral situation": "Referral",
  "This person referred a member": "This person referred a member",
  "This person was referred": "This person was referred",
  "Other person": "Other person",
  "Referral bonus": "Referral bonus",
  "Search person": "Search person",
  "Select promotion template": "Select promotion template",
  "Referrer is required.": "Referrer is required.",
  "Promotion template is required.": "Promotion template is required.",
  "View promotions and bonuses": "View promotions and bonuses",
  "Edit promotions and bonuses": "Edit promotions and bonuses",
  "Execute promotions and bonuses": "Execute promotions and bonuses",

  // Import merges
  "Merge imports": "Merge imports",
  "Merge imports group card description": "Consolidate multiple source exports before the adapter import",
  "Back to Merge imports": "Back to merge imports",
  "Merge import column name": "Name",
  "Merge import column sources": "Sources",
  "Merge import create button": "Create merge import",
  "Merge import create title": "Create merge import",
  "Merge import edit title": "Edit merge import",
  "Merge import name placeholder": "e.g. CenterCom branch merge",
  "Merge import tenant required": "Select a target tenant.",
  "Merge import created": "Merge import created",
  "Merge import save success": "Merge import saved",
  "Merge import confirm delete": "Delete merge import?",
  "Merge import confirm delete detail": "Sources, results, and reports for this merge import will be permanently deleted.",
  "Merge import deleted": "Merge import deleted",
  "Merge import delete error": "Merge import could not be deleted.",
  "Merge import detail title": "Merge import",
  "Merge import status Draft": "draft",
  "Merge import status Uploaded": "uploaded",
  "Merge import status Analyzed": "analyzed",
  "Merge import status Merged": "merged",
  "Merge import status Failed": "failed",
  "Merge import step upload": "Upload sources",
  "Merge import step analyze": "Check sources",
  "Merge import step mapping": "Map studios",
  "Merge import step merge": "Run merge",
  "Merge import step handover": "Hand over result",
  "Merge import overview title": "Overview",
  "Merge import upload title": "Upload sources",
  "Merge import upload hint": "Upload ZIP files or individual CenterCom files for each branch.",
  "Merge import upload drag text": "Drop files here or select them",
  "Merge import upload button": "Upload sources",
  "Merge import upload no files": "Select at least one file.",
  "Merge import upload failed": "Sources could not be uploaded.",
  "Merge import upload success": "Sources uploaded",
  "Merge import analyze button": "Check sources",
  "Merge import analyze success": "Sources checked",
  "Merge import analysis title": "Source check",
  "Merge import analysis issues": "Source check notes",
  "Merge import source": "Source",
  "Merge import table": "Table",
  "Merge import path": "Path",
  "Merge import rows": "Rows",
  "Merge import studio mapping title": "Studio mapping",
  "Merge import default studio placeholder": "Default studio for this source",
  "Merge import source studio value": "CenterCom studio",
  "Merge import target studio": "m1member studio",
  "Merge import no source studio values": "No studio values detected in this source.",
  "Merge import merge button": "Run merge",
  "Merge import merge success": "Merge completed",
  "Merge import report title": "Merge report",
  "Merge import result objects": "Result files",
  "Merge import duplicate persons": "potential duplicate persons",
  "Merge import duplicate key": "Duplicate key",
  "Merge import duplicate matches": "Matches",
  "Merge import download result": "Download result",
  "Merge import create import run": "Open as CenterCom import",
  "Merge import create import run failed": "CenterCom import could not be created from the merge result.",
  "Merge import create import run success": "CenterCom import created from merge result",
  "Merge import open import run": "Open CenterCom import",
  "Merge import result suffix": "import",
  "CenterCom merge result select title": "Select merge result",
  "CenterCom merge result select hint": "Instead of uploading files, you can hand over a finished CenterCom merge result to a new adapter import run.",
  "CenterCom merge result select placeholder": "Select merge result",
  "CenterCom merge result select empty": "No finished merge result available",
  "CenterCom merge result create import": "Create import run",
  "CenterCom merge result apply failed": "Merge result could not be applied to the import run.",
  "Preview values": "Preview",
  "Appointment start (date + time)": "Appointment start (date + time)",
  "Appointment end (date + time)": "Appointment end (date + time)",
  "Appointment date": "Appointment date",
  "Appointment time": "Appointment time",
  "Appointment name": "Appointment name",
  "Appointment type name": "Appointment type name",
  "Duration in minutes": "Duration in minutes",
  "Guest first name": "Guest first name",
  "Guest last name": "Guest last name",
  "One-time booking confirmation code (5 digits)": "One-time appointment confirmation code (5 digits)",
  "Document text": "Document text",
  "Privacy status": "Privacy status",
  "Privacy notice received": "Privacy notice received",
  "Document privacy notice": "Document privacy notice",
  "Erasure requested": "Erasure requested",
  "Erasure requested at": "Erasure requested at",
  "Anonymized at": "Anonymized at",
  "anonymized": "anonymized",
  "normal": "normal",
  "Mark erasure request": "Mark erasure request",
  "Mark erasure request?": "Mark erasure request?",
  "Mark erasure request text": "Only a privacy task is created. Master data is not changed yet.",
  "Mark request": "Mark request",
  "Complete anonymization": "Complete anonymization",
  "Complete anonymization?": "Complete anonymization?",
  "Complete anonymization text": "The person will now be anonymized. Direct contact data, photo, bank details, active access media, and other documents without a retention reason will be removed. The task will then be marked as done.",
  "Anonymization completed.": "Anonymization completed.",
  "Privacy task": "Privacy task",
  "Privacy task is open.": "Privacy task is open.",
  "Edit privacy task": "Edit privacy task",
  "No permission for privacy actions.": "No permission for privacy actions.",
  "Manage privacy": "Manage privacy",
  "Web": "Web",
  "Forgot password": "Forgot password?",
  "Email required": "Please enter your email address.",
  "Password required": "Please enter your password.",
  "Logging in...": "Signing in...",
  "PasswordResetDescription": "Enter the email address of your account. If an account exists, a reset link is sent.",
  "Request reset link": "Request reset link",
  "PasswordResetRequested": "Reset link requested",
  "PasswordResetEmailHint": "Check your email and open the password reset link.",
  "DevelopmentResetTokenHint": "Local development: the reset token is shown here.",
  "Password reset successful": "Password changed",
  "PasswordResetSuccessfulDescription": "Your password has been changed. You can sign in now.",
  "InvalidResetToken": "The reset link is invalid or has expired.",
  "PasswordMinLength": "The password must be at least 8 characters long.",
  "Please confirm your new password": "Please confirm your new password.",
  "No access": "No access",
  "Create permission level": "Create",
  "Manage": "Manage",
  "Dashboard permission help": "Allows access to the dashboard with KPIs and task overview.",
  "Check-in permission help": "Allows use of the check-in view and manual access workflows.",
  "Tasks permission help": "View tasks or create new tasks. Completing tasks is a separate extra permission.",
  "Complete tasks": "Complete tasks",
  "Complete tasks help": "Allows marking tasks as completed or finishing comparable task actions.",
  "People permission help": "View, edit, or create people. Risk actions remain separate extra permissions.",
  "Change home studio help": "Allows changing a person's home studio.",
  "Block check-in help": "Allows blocking or unblocking a person's check-in.",
  "Manage privacy help": "Allows privacy actions such as anonymization, export, and deletion of personal data.",
  "Digital file permission help": "Controls access to documents, photos, and a person's digital file.",
  "Change history": "Change history",
  "Change history permission help": "Allows viewing logged changes to person data.",
  "Promotions and bonuses": "Promotions and bonuses",
  "Promotions permission help": "View or edit promotions and bonus cases. Promotion templates are a separate settings permission.",
  "Absences and availabilities": "Absences & availabilities",
  "Accounting and cash registers": "Accounting & cash registers",
  "Cancel payments": "Cancel payments",
  "Cancellation models and reasons": "Cancellation models & reasons",
  "Dispatch settings": "Dispatch settings",
  "Payment and contribution cancellation reasons": "Cancellation reasons for payments and contributions",
  "Payroll and hour balance": "Payroll & hour balance",
  "Price adjustment models": "Price adjustment models",
  "Rest period models and reasons": "Rest period models & reasons",
  "Submit and book direct debit runs": "Submit and post direct debit runs",
  "Accounting exports permission help": "Create and download accounting exports. Chart of accounts and cash registers are a separate settings permission.",
  "Bank statement permission help": "Fetch bank statements, assign and post transactions.",
  "Close contract permission help": "Close new contracts and add contract packages. Sales promotions and option groups are applied, not maintained.",
  "Debt collection cases permission help": "Create and manage debt collection cases. Agencies and reminder levels are a separate settings permission.",
  "Execute promotions and bonuses help": "Allows executing promotions or bonus cases.",
  "Contracts permission help": "View or edit contracts. Closing, deleting and cancelling are separate permissions.",
  "Delete contracts": "Delete contracts",
  "Delete contracts help": "Allows deleting contracts or contract packages.",
  "Cancel contracts help": "Allows cancelling contracts with the normal cancellation rules.",
  "Rest periods permission help": "View or enter rest periods on contracts. Rest period models and reasons are a separate settings permission.",
  "Price adjustments permission help": "View or apply price adjustments on contracts. Price adjustment models are a separate settings permission.",
  "Customize price adjustments": "Customize price adjustments",
  "Customize price adjustments help":
    "Allows setting price adjustments without a model or editing existing manual price adjustments. Without this permission, only existing price adjustment models can be assigned (requires edit price adjustments).",
  "Leads permission help": "Allows viewing and editing sales leads.",
  "Delete leads help": "Allows deleting leads.",
  "Article sales permission help": "Allows viewing or recording article sales.",
  "Communication send permission help": "Allows manually sending emails or letters.",
  "Outbound communication": "Outbound communication",
  "Outbound communication permission help": "Controls prepared and review-required outbound communication.",
  "Review outbound communication": "Review outbound communication",
  "Review outbound communication help": "Allows approving review-required outbound communication.",
  "Review own outbound communication": "Review own outbound communication",
  "Review own outbound communication help": "Allows approving one's own review-required outbound communication.",
  "Skip outbound review": "Skip review",
  "Skip outbound review help": "Allows sending without approval review.",
  "Cancel outbound communication": "Cancel outbound communication",
  "Cancel outbound communication help": "Allows cancelling scheduled or prepared communication.",
  "Retry outbound communication": "Retry outbound communication",
  "Retry outbound communication help": "Allows retrying failed communication.",
  "Manage outbound settings": "Manage sending settings",
  "Manage outbound settings help": "Allows settings for outbound communication.",
  "Inbox permission help": "Allows viewing the communication inbox.",
  "Email queue": "Email queue",
  "Email queue permission help": "Allows viewing the technical email queue.",
  "Templates permission help": "View or edit letter and email texts, categories and SMS/WhatsApp templates.",
  "Appointments permission help": "Allows viewing or editing appointments.",
  "Availabilities permission help": "View or maintain availability templates and holidays for appointments.",
  "Staff absences": "Staff absences",
  "Staff schedule permission help": "Allows viewing or editing the staff schedule.",
  "Staff absences permission help": "View or edit staff absences and availabilities.",
  "Vacation management permission help": "Allows viewing or editing vacation management.",
  "Payroll permission help": "Allows viewing payroll preparation and the hour balance.",
  "Export payroll help": "Allows exporting payroll data and the hour balance.",
  "Staff settings": "Staff settings",
  "Staff settings permission help": "Allows staff settings only, even without the general settings permission.",
  "Finance permission help": "Allows viewing or editing central finance data.",
  "Open items permission help": "Allows viewing or editing open items.",
  "Agree installment plan help": "Allows agreeing installment plans for open items.",
  "Payments permission help": "Allows viewing or booking payments.",
  "SEPA direct debits": "SEPA direct debits",
  "SEPA direct debits permission help": "Allows viewing or managing SEPA direct debits.",
  "Reminder levels": "Reminder levels",
  "Reminders permission help": "Allows viewing or creating reminders.",
  "Reminder levels permission help": "Allows viewing or configuring reminder levels.",
  "Member reports permission help": "Allows member reports.",
  "Report lists permission help": "Allows custom report lists.",
  "Finance reports permission help": "Allows finance reports.",
  "Contract reports permission help": "Allows contract reports.",
  "Usage reports permission help": "Allows usage reports.",
  "Calendar reports permission help": "Allows calendar reports.",
  "Lead reports permission help": "Allows lead reports.",
  "Automations permission help": "Allows viewing or managing automations.",
  "Run automations help": "Allows manually running automations.",
  "Approve automations help": "Allows approving automations.",
  "Member automations help": "Allows automations for member workflows.",
  "Finance automations help": "Allows automations for finance workflows.",
  "Contract automations help": "Allows automations for contract workflows.",
  "Operations automations help": "Allows automations for operational workflows.",
  "Duplicate finder permission help": "Allows scanning for possible duplicates and, at manage level, merging them.",
  "Settings base permission help": "Allows access to the settings area. Without this permission, individual settings pages are not reachable.",
  "Users permission help": "Allows viewing or managing users.",
  "Roles permission help": "Allows viewing or managing roles and permissions.",
  "Master data permission help": "Allows viewing or editing master data.",
  "Member defaults": "Member defaults",
  "Member defaults permission help": "Allows viewing or editing member defaults.",
  "Check-in view settings": "Check-in view settings",
  "Check-in view settings permission help": "Allows viewing or editing the check-in view.",
  "Contract packages permission help": "Allows viewing or editing contract packages.",
  "Contract components permission help": "Allows viewing or editing contract components.",
  "Payment plans permission help": "Allows viewing or editing payment plans.",
  "Wallet products permission help": "Allows viewing or editing wallet products.",
  "Articles permission help": "Allows viewing or editing articles.",
  "Cancellation reasons permission help": "Allows viewing or editing cancellation reasons.",
  "Cancellation models permission help": "Allows viewing or editing cancellation models.",
  "Accounting settings": "Accounting settings",
  "Accounting settings permission help": "View or edit chart of accounts, tax rates, posting assignments and cash registers.",
  "Bank account settings": "Bank account settings",
  "Bank account settings permission help": "Allows viewing or editing bank accounts.",
  "Default wallet payment settings": "Default wallet payment settings",
  "Default wallet payment settings permission help": "Allows viewing or editing default wallet payment settings.",
  "Payment methods settings": "Payment methods settings",
  "Payment methods settings permission help": "Allows viewing or editing payment methods.",
  "Payment cancellation reasons permission help": "Allows viewing or editing payment cancellation reasons.",
  "Debt management settings": "Debt management settings",
  "Debt management settings permission help": "View or maintain reminder levels and debt collection agencies.",
  "Lead sources settings": "Lead sources settings",
  "Lead sources settings permission help": "Allows viewing or editing lead sources.",
  "Lead pipelines settings": "Lead pipelines settings",
  "Lead pipelines settings permission help": "Allows viewing or editing lead pipelines.",
  "Lead widgets settings": "Lead widgets settings",
  "Lead widgets settings permission help": "Allows viewing or editing lead widgets.",
  "Contract signing widgets permission help": "Allows viewing or editing contract signing widgets.",
  "Experience contract widgets": "Experience contract widgets",
  "Experience contract widgets permission help": "Allows viewing or editing experience contract widgets.",
  "Lead automation settings": "Lead automation settings",
  "Lead automation settings permission help": "Allows viewing or editing lead automation.",
  "Email settings": "Email settings",
  "Outer background": "Outer background",
  "Content background": "Content background",
  "Logo background": "Logo background",
  "Place footer outside content": "Place footer outside the content area",
  "Email settings permission help": "Allows viewing or editing email settings.",
  "Auto communication settings": "Auto communication settings",
  "Auto communication settings permission help": "Allows viewing or editing auto communication settings.",
  "Appointment configuration": "Appointment configuration",
  "Appointment configuration permission help": "Allows viewing or editing appointment configuration.",
  "Appointment types permission help": "Allows viewing or editing appointment types.",
  "Resources settings": "Resources settings",
  "Resources settings permission help": "Allows viewing or editing resources.",
  "Unavailabilities settings": "Unavailabilities settings",
  "Unavailabilities settings permission help": "Allows viewing or editing unavailabilities.",
  "Appointment outcomes permission help": "Allows viewing or editing appointment outcomes.",
  "Booking widgets permission help": "Allows viewing or editing booking widgets.",
  "Appointment notifications permission help": "Allows viewing or editing appointment notifications.",
  "Reader devices permission help": "Allows viewing or managing reader devices.",
  "Studio app settings permission help": "Allows viewing or editing member app settings.",
  "Units settings": "Units settings",
  "Units settings permission help": "Allows viewing or editing units.",
  "Default theme settings": "Default theme settings",
  "Default theme settings permission help": "Allows viewing or editing the default theme.",
  "User templates settings": "User templates settings",
  "User templates settings permission help": "Allows viewing or editing user templates.",
  "Integrations settings": "Integrations settings",
  "Integrations settings permission help": "Allows viewing or editing integrations.",
  "Backup and restore settings": "Backup and restore settings",
  "Backup and restore settings permission help": "Allows viewing or running backup and restore.",
  "Tenant capabilities permission help": "Allows viewing or editing tenant capabilities.",
  "Back to Application": "Back to Application",
  "Undo change history entries": "Undo change history entries",
  "Undo change history entries help": "Allows undoing checked change history entries. The matching domain permission is also required.",
  "Person data change": "Person data change",
  "Undo": "Undo",
  "rollback": "rollback",
  "rolled back": "rolled back",
  "recorded": "recorded",
  "Area": "Area",
  "Undo change?": "Undo change?",
  "The selected change will be rolled back.": "The selected change will be rolled back.",
  "Change rolled back.": "Change rolled back.",
  "This change cannot be rolled back.": "This change cannot be rolled back.",
  "partially recorded": "partially recorded",
  "not recorded": "not recorded",
  "External delivery": "External delivery",
  "Only entries with a complete snapshot and the required special permission can be rolled back.": "Only entries with a complete snapshot and the required special permission can be rolled back.",
  "Delete contact including person": "Delete contact including person",
  "Delete including person": "Delete including person",
  "Delete contact including person confirmation": "Really delete the contact and associated person? This is only possible when no other linked data exists.",
  "Contact and person deleted.": "Contact and person deleted.",
  "Test environment — external sending disabled": "Test environment — automatic communication is off",
  "Safe mode — external sending blocked": "Safe mode — external sending blocked",
  "Appointment change history": "Change history",
  "No appointment history yet": "No appointment history yet",
  "Appointment history could not be loaded": "The appointment history could not be loaded.",
  "Appointment history created": "created",
  "Appointment history updated": "updated",
  "Appointment history deleted": "deleted",
  "Appointment history moved": "moved",
  "Appointment history cancelled": "cancelled",
  "Appointment history confirmed": "confirmed",
  "Appointment history no-show": "marked as no-show",
  "Appointment history archived": "archived",
  "Appointment history moved summary": "moved from {0} to {1}",
  "Appointment history duration summary": "duration changed from {0} to {1}",
  "Appointment history price summary": "price changed from {0} to {1}",
  "Participant statuses": "Participant statuses",
  "No value": "no value",
  "Unknown account": "Unknown account",
  "Minutes short": "min",
  "Mixed reminder case": "Mixed reminder case",
  "All contract templates": "All contract templates",
  "Contract template filter": "Contract template filter",
  "Empty contract template filter applies to all contracts": "With no selection, the rule applies to all contract templates.",
  "Manual template selection": "Manual template selection",
  "After a chargeback": "After a chargeback",
  "Retry direct debit": "Retry direct debit",
  "Wait for payment": "Wait for payment",
  "Further handling after chargeback": "Further handling after the chargeback",
  "Please select further handling after chargeback": "Please select how to proceed after the chargeback.",
  "Include in next regular SEPA run": "Include in the next regular SEPA run",
  "Block SEPA until contribution is paid": "Block SEPA until the contribution is paid",
  "Block returned items only; continue collecting future contributions": "Block returned items only; continue collecting future contributions",
  "Further direct debits blocked by return reason": "The return reason blocks further direct debits. The SEPA mandate must be resolved first.",
  "Unavailable delivery integration": "Unavailable delivery integration",
  "Block type": "Block type",
  "Dunned contribution": "Dunned contribution",
  "Blocked at": "Blocked at",
  "Release condition": "Release condition",
  "All contracts": "All contracts",
  "This open item": "This open item",
  "Mandate block": "Mandate block",
  "After payment of dunned contribution": "After payment of the dunned contribution",
  "Manual release": "Manual release",
  "Released automatically": "released automatically",
  "Released at": "released at",
  "Released by": "released by",
  "Release blocks of this contract": "Release blocks of this contract",
  "Releasing also lifts the person-wide mandate block.": "Releasing also lifts the person-wide mandate block.",
  "Releasing also lifts the person-wide mandate block affecting other contracts.": "Releasing also lifts the person-wide mandate block — it also affects other contracts of this person.",
  "Manage SEPA block": "Manage SEPA block",
  "No active SEPA blocks.": "No active SEPA blocks.",
  "Block history": "Block history",
  "After a mandate block the mandate is voided — capture the new bank details and mandate here.": "After a mandate block the mandate is voided — capture the new bank details and mandate here.",
  "Released manually": "released manually",
  "According to reminder rule": "According to reminder rule",
  "According to reminder rule per payment": "According to reminder rule per payment",
  "Open SEPA block": "Open SEPA block",
  "Pin": "Pin",
  "Remove pin": "Remove pin",
  "Pinned pages": "Pinned pages",
  "Maximum number of pinned pages reached": "Maximum number of pinned pages reached",
  "This page is no longer available": "This page is no longer available",
  "Not classified": "not classified",

  "AiProviderAdministration.MenuTitle": "AI provider administration",
  "AiProviderAdministration.ProviderTab": "Providers",
  "AiProviderAdministration.ModelsTab": "Models",
  "AiProviderAdministration.AgentsTab": "Agents",
  "AiProviderAdministration.CostsTab": "Costs",
  "Default billing": "Default billing",
  "Default shipping": "Default shipping",
  "Label": "Label",
  "Last 12 months": "Last 12 months",
  "Last month": "Last month",
  "Max output tokens": "Max output tokens",
  "Max parallel": "Max parallel",
  "Max retry attempts": "Max retry attempts",
  "Model": "Model",
  "No models configured": "No models configured",
  "OfferedModels.ModelLocation": "Execution",
  "Pricing": "Pricing",
  "Pricing managed automatically": "Pricing managed automatically",
  "Profile Name": "Profile name",
  "Provider": "Provider",
  "ProviderAccess.AccessData": "Access data",
  "ProviderAccess.Provider": "Provider",
  "ProviderAccess.Status": "Status",
  "ProviderCost.UnknownCurrency": "Unknown currency",
  "Request delay": "Request delay",
  "Request timeout": "Request timeout",
  "Additional offers": "Additional offers",
  "Promotion free period detail": "{value} {unit} free",
  "Promotion free period training start": "{value} {unit} free from start of training",
  "Promotion fixed start detail": "Contract starts on {date}",
  "Promotion discount detail": "{cadence} price benefit from {anchor}: {duration}",
  "Promotion discount limited duration": "Price benefit for {duration} from {anchor}",
  "Promotion discount recurring unlimited": "{cadence} price benefit",
  "Promotion discount one time": "One-time price benefit from {anchor}",
  "Promotion: {0}": "Special: {0}",
  "ContractSigningStudioRequired": "Please select a studio first.",
  "ContractSigningOfferUnavailableForStudio": "This offer is not available for the selected studio. Please choose another studio or offer.",
  "ContractWidgetPackageTemplateNotFound": "At least one selected contract package does not exist or is invalid.",
  "ContractWidgetOptionGroupNotFound": "At least one selected option group does not exist or is invalid.",
  "ContractWidgetPromotionNotFound": "At least one assigned promotion does not exist or is invalid.",
  "Legal texts & Data protection": "Legal texts & Data privacy",
  "Legal texts, privacy, terms and impressum": "Legal texts, privacy, terms & impressum",
  "Inherited from master data": "Inherited from master data",
  "Custom widget logo": "Custom logo",
  "Reset to master data logo": "Reset to master data logo",
  "Surface background": "Surface & panel background",
  "Card background": "Card background",
  "Heading text color": "Heading text color",
  "Body text color": "Body text color",
  "Border color": "Border color",
  "Button text color": "Button text color",
  "Package highlights": "Package highlights",
  "Promotion highlight": "Promotion highlight",
  "Promotion discount duration": "{value} {unit}",
  "Contract period": "contract period",
  "Cycle unit days": "days",
  "Cycle unit weeks": "weeks",
  "Cycle unit months": "months",
  "Cycle unit years": "years",
  "Contract signing": "Contract signing",
  "Complete the contract together in a few friendly steps.": "Complete the contract together in a few friendly steps.",
  "You can create or edit the person in the person record before closing.": "You can create or edit the person in the person record before closing.",
  "The signing experience is still being checked. Please try again in a moment.": "The signing experience is still being checked. Please try again in a moment.",
  "The signing experience is not configured yet. Configure at least one active offer before opening it.": "The signing experience is not configured yet. Configure at least one active offer before opening it.",
  "Contract signing widgets: configure an active offer before sharing the link": "Configure at least one active offer before sharing the link.",
  "Open signing experience": "Signing experience",
  "Included in this offer": "Included in this offer",
  "Included service": "Included service",
  "Included wallet": "Included wallet",
  "Contract signing: price summary": "Price summary",
  "Contract signing: price preview unavailable": "The authoritative price preview could not be loaded. Check the selection and promotion code.",
  "Review your contract": "Review your contract",
  "Experience form": "Experience form",
  "Installment total": "Installment total",
  "Price per billing cycle": "Price per billing cycle",
  "Cycle unit contract period": "per contract period",
  "Promotion benefit": "Promotion benefit",
  "Choose an offer": "Choose an offer",
  "Choose the experience contract profile": "Choose the experience contract profile",
  "Choose the experience contract profile to continue.": "Choose the experience contract profile to continue.",
  "No offers are currently available.": "No offers are currently available.",
  "Check the experience contract configuration and active actions.": "Check the experience contract configuration and active actions.",
  "The experience contract form could not be loaded. Please try again.": "The experience contract form could not be loaded. Please try again.",
  "This experience contract profile has no studio that you are allowed to use.": "This experience contract profile has no studio that you are allowed to use.",
  "Letter integration": "Letter integration",
  "Contract signing: SEPA mandate confirmed": "SEPA direct debit mandate confirmed for this contract",
  "Component terms (legacy)": "Component terms (legacy)",
  "Legacy sales model uses component terms": "Legacy sales model uses component terms",
  "Choose a regular term before saving this migrated sales model.": "Choose a regular term before saving this migrated sales model.",
  "Review legacy migration": "Review legacy migration",
  "Legacy sales model migration": "Legacy sales model migration",
  "Migrate eligible legacy offers": "Migrate eligible legacy offers",
  "Only unambiguous offers will be migrated. Blocked offers remain unchanged.": "Only unambiguous offers will be migrated. Blocked offers remain unchanged.",
  "Migrate": "Migrate",
  "Legacy inventory changed. Review the preview again.": "The legacy inventory changed. Review the preview again.",
  "Eligible legacy offers migrated.": "Eligible legacy offers migrated.",
  "Legacy migration preview": "Legacy migration preview",
  "{0} eligible, {1} blocked, {2} legacy offers total": "{0} eligible, {1} blocked, {2} legacy offers total",
  "Legacy cutover status: eligible": "eligible",
  "Legacy cutover status: migrated": "migrated",
  "Legacy cutover status: blocked": "blocked",
  "Legacy cutover status: alreadyMapped": "already mapped",
  "Sales model conflict: partialTargetRelations": "The offer already contains incomplete target-model assignments.",
  "Sales model conflict: legacyPromotionMissing": "The offer's legacy sales promotion can no longer be resolved.",
  "Conflicts": "Conflicts",
  "No conflicts": "No conflicts",
  "CenterCom access gaps": "Access gaps",
  "CenterCom access gaps empty": "No access gaps detected.",
  "CenterCom access gaps affected contracts": "{0} affected contracts",
  "CenterCom access gaps contract template": "Contract type",
  "CenterCom access gaps affected": "Contracts",
  "CenterCom access gaps person": "Member",
  "CenterCom access gaps usage right": "Access right",
  "CenterCom access gaps period": "Period",
  "CenterCom access gaps open end": "open",
  "CenterCom access gaps decision": "Access gap decision",
  "CenterCom access gaps action assign": "assign existing contract template",
  "CenterCom access gaps action create": "create contract template",
  "CenterCom access gaps action leave open": "leave gap open",
  "CenterCom access gaps no components": "No active contract template with access rights - use “create contract template” instead.",
  "CenterCom access gaps component": "Contract template with access",
  "CenterCom access gaps create component name": "Name of the new contract template",
  "Document appearance": "Appearance",
  "Contents per column": "Contents per column",
  "Font size": "Font size",
  "Page and typography": "Page and typography",
  "Body font size": "Base font size",
  "Small font size": "Small text size",
  "Small font size tooltip": "Applies to the footer and the sender line.",
  "Margin top": "Margin top",
  "Margin bottom": "Margin bottom",
  "Margin left": "Margin left",
  "Margin right": "Margin right",
  "Address field top": "Address field from top edge",
  "Address field top tooltip": "Fixed position so the address field does not move with the logo height and still lines up with the envelope window. DIN 5008: 45 mm.",
  "Fold marks": "Fold marks",
  "Fold marks tooltip": "Short marks in the left margin as a guide for folding and filing (DIN 5008: 87 mm, 148.5 mm, 192 mm). Not needed when letters are inserted by machine.",
  "Document appearance choice tooltip": "Defines the layout, header, footer and styling of this document. Without a selection the text can be edited but not sent.",
  "No document appearance selected": "no appearance selected",
  "Without a document appearance this text set cannot be sent": "Without an appearance this template cannot be sent.",
  "Letter and email differ": "Letter and email differ",
  "Split channel content tooltip": "Separate texts: the email becomes the cover note and the letter is attached as a PDF. Shared text: one change applies to both outputs.",
  "Letterhead, logo and footer for letters and emails": "Letterhead, logo and footer for letters and emails",
  "Format name": "Format name",
  "mQorva standard": "mQorva standard",
  "Add format": "Add format",
  "Delete format?": "Delete format?",
  "Delete format hint": "The format is removed. The next level applies afterwards: studio, then tenant, then the shipped mQorva standard.",
  "Default format": "Default format",
  "Default format tooltip": "Applies when nothing else is chosen — at most one per scope.",
  "Email shell": "Email shell",
  "Email shell tooltip": "The card is the business look; plain reads like a handwritten message. The letter stays a complete business letter either way.",
  "Email appearance": "Email appearance",
  "Branded card": "Branded card",
  "Plain message": "Plain message",
  "Logo position": "Logo position",
  "Logo size": "Logo size",
  "Logo size tooltip": "The width follows the image's aspect ratio. DIN 5008 leaves about 45 mm above the address field; a larger logo reaches into the envelope window.",
  "Fill logo background": "Fill logo background",
  "Fill logo background tooltip": "Uses the detected edge colour of the logo. Without a fill, the header stays neutral.",
  "Sender line": "Sender line",
  "Footer columns": "Footer columns",
  "Preprinted stationery": "Preprinted stationery",
  "Preprinted stationery tooltip": "Header and footer are omitted; the margins stay so the content keeps its position.",
  "Email logo position": "Email logo position",
  "Centered": "Centered",
  "Letter preview": "Letter preview",
  "Email preview": "Email preview",
  "Notice text": "Notice",
  "Click a paragraph in the preview to edit it": "Click a paragraph in the preview to edit it",
  "Empty = shipped default": "Empty = shipped default",
  "Check PDF": "Check PDF",
  "Footer layout": "Footer layout",
  "Number of rows": "Number of rows",
  "Block position": "Block position",
  "Three columns": "Three columns",
  "Two columns": "Two columns",
  "One below another": "One below another",
  "Show divider line": "Show divider line",
  "Footer placement": "Footer placement",
  "Footer outside content": "Footer outside content",
  "Outside content": "Outside content",
  "Inside content": "Inside content",
  "Footer layout tooltip": "Columns sit side by side, rows stack across the full width.",
  "Footer columns tooltip": "The columns share the width equally.",
  "New format": "New format",
  "Unnamed format": "Unnamed format",
  "Format name is required": "Please enter a name for the format.",
  "Add block": "Add block",
  "Show in document": "Show in document",
  "Address field": "Address field",
  "Contract data": "Contract data",
  "Footer": "Footer",
  "Fixed text": "Fixed text",
  "Fixed text tooltip": "Appears in every document of this format, regardless of the case.",
  "Divider": "Divider",
  "Spacing": "Spacing",
  "Height": "Height",
  "Blocks": "Blocks",
  "Redo": "Redo",
  "Outputs": "Outputs",
  "Letter enabled tooltip": "Without a letter no PDF is produced — the case goes out by email only.",
  "Email enabled tooltip": "Without an email it stays letter post only.",
  "A format needs a letter or an email": "A format needs at least one output: letter or email.",
  "A text set needs a letter or an email": "The template needs at least one output: letter or email.",
  "Import texts": "Import texts",
  "Import proposal hint": "Proposal from the file. It replaces subject, salutation, introduction, notice and closing only once you apply it — and nothing is saved even then.",
  "SystemDocumentImportUnsupportedFile": "This file type is not read. Word files (.docx) and plain text (.txt, .md) are supported.",
  "SystemDocumentImportTruncated": "The file has more paragraphs than a letter; the surplus was left out.",
  "SystemDocumentImportNoStructure": "Neither salutation nor closing recognised — everything went into the introduction.",
  "SystemDocumentImportTablesDropped": "Tables were not imported. The contract data comes from the case.",
  "Reorder": "Reorder",
  "Closing formula": "Closing",
  "Logos": "Logos",
  "Letter logo": "Letter logo",
  "Standard logo": "Standard logo",
  "Studio image": "Studio image",
  "Format channel tooltip": "Which outputs this appearance applies to. Each selected type has its own design surface in the editor.",
  "System text channel tooltip": "Determines whether this template can be used for letters, emails, or both outputs.",
  "Visible in document": "Visible in document",
  "Hidden in document": "Hidden in document",
  "Company legal name": "Company name",
  "Address in one line": "Address in one line",
  "Designation of the representatives": "Designation of the representatives",
  "Register court": "Register court",
  "Register number": "Register number",
  "Register court and number": "Register court and number",
  "Footer text": "Footer text",
  "Differs from the appearance": "differs from the appearance",
  "Reset this block": "reset this block",
  "Reset all blocks": "reset all blocks",
  "Date line": "Place and date",
  "Text": "Text",
  "Merge letter and email": "Merge letter and email",
  "Merge letter and email hint": "There will be one text for both outputs. Which version should remain? The other one is deleted.",
  "Keep the letter version": "keep the letter version",
  "Keep the email version": "keep the email version",
  "Write text": "write text…",
  "Block name": "Block name",
  "Block name tooltip": "Text sets reference this block by name. Changing it leaves existing references pointing nowhere.",
  "Block name must be unique": "That name is already used in this document.",
  "Block": "Block",
  "Remove block?": "Remove block?",
  "No block selected": "no block selected",
  "Footer order": "Footer order",
  "Contents per row": "Contents per row",
  "Studio address": "Studio address",
  "Studio phone": "Studio phone",
  "Studio email": "Studio email",
  "Studio website": "Studio website",
  "Company address": "Company address",
  "Company phone": "Company phone",
  "Company email": "Company email",
  "Company website": "Company website",
  "Legal representatives": "Legal representatives",
  "Commercial register": "Commercial register",
  "Separator character": "Separator",
  "Separator color": "Separator color",
  "Separator formatting": "Separator formatting",
  "Placed": "Placed",
  "Full width": "Full width",
  "Sender placement": "Sender line placement",
  "Above the address field": "Above the address field",
  "Top right": "Top right",
  "Sender placement hint": "Above the address field is the DIN 5008 position — small and underlined, directly above the envelope window.",
  "Spacing above": "Spacing above",
  "Distance from sheet edge": "Distance from sheet edge",
  "Spacing below": "Spacing below",
  "Standard": "Standard",
  "Subject label": "Subject line label",
  "Subject only": "Subject only",
  "With label": "With “Subject:”",
  "Subject label hint": "Applies to the letter only. In an email the subject is the subject line and does not appear in the body.",
  "Data source": "Data source",
  "Legal details": "Legal details",
  "Legal details tab": "legal details",
  "Legal form": "Legal form",
  "Registered office": "Registered office",
  "Supervisory board chair": "Chair of the supervisory board",
  "Appointment series": "Appointment series",
  "Allow appointment series for staff": "Allow appointment series for staff",
  "Allow appointment series online": "Allow appointment series for online bookings",
  "Applies to the booking widget and member app.": "Applies to the booking widget and member app.",
  "Staff and online": "Staff and online",
  "Staff only": "staff only",
  "Online only": "online only",
  "No appointment series": "no appointment series",
  "Single appointment": "single appointment",
  "Recurring appointment series": "appointment series",
  "Recurrence pattern": "Recurrence",
  "Monthly on the same calendar day": "monthly on the same calendar day",
  "Interval in days": "Interval in days",
  "Interval in weeks": "Interval in weeks",
  "Interval in months": "Interval in months",
  "Monday short": "Mon",
  "Tuesday short": "Tue",
  "Wednesday short": "Wed",
  "Thursday short": "Thu",
  "Friday short": "Fri",
  "Saturday short": "Sat",
  "Sunday short": "Sun",
  "Select at least one weekday.": "Select at least one weekday.",
  "Months without this calendar day are skipped.": "Months without this calendar day are skipped.",
  "Series ends": "Series ends",
  "After number of appointments": "after a number of appointments",
  "On date": "on date",
  "Number of appointments": "Number of appointments",
  "Check appointment series": "Check appointment series",
  "All {0} appointments are available.": "All {0} appointments are available.",
  "{0} of {1} appointments are available.": "{0} of {1} appointments are available.",
  "Show appointments": "Show appointments",
  "Only this appointment": "only this appointment",
  "This and all following appointments": "this and all following appointments",
  "Entire appointment series": "entire appointment series",
  "Select affected appointments": "Select affected appointments",
  "The appointment series must be checked before saving.": "The appointment series must be checked before saving.",
  "Resolve all appointment series conflicts before saving.": "Resolve all appointment series conflicts before saving.",
  "The appointment series could not be checked.": "The appointment series could not be checked.",
  "Appointment series has conflicts": "Appointment series has conflicts",
  "Only available appointments will be created. Conflicting occurrences remain excluded from the series.": "Only available appointments will be created. Conflicting occurrences remain excluded from the series.",
  "Book available appointments": "book available appointments",
  "The appointment series is not fully available. Change its start, recurrence or end.": "The appointment series is not fully available. Change its start, recurrence or end.",
  "Appointment series created.": "Appointment series created.",
  "Appointment series booked successfully": "Appointment series booked successfully",
  "{0} appointments": "{0} appointments",
  "Every {0} days": "every {0} days",
  "Every {0} weeks": "every {0} weeks",
  "Every {0} months": "every {0} months",
  "Price per appointment": "Price per appointment",
  "Series appointment": "Series appointment",
  "Series appointments can only be moved within the same calendar.": "Series appointments can only be moved within the same calendar.",
  "The duration of a series appointment cannot be changed here.": "The duration of a series appointment cannot be changed here.",
  "This change is not supported for appointment series.": "This change is not supported for appointment series.",
  "Page number": "Page number",
  "Page number text": "Page number text",
  "Page number text tooltip": "Printed bottom right on every page. Empty means the standard wording.",
  "Current page": "Current page",
  "Total pages": "Total pages",
  "Every page": "Every page",
  "From page 2": "From page 2",
  "Pages": "Pages",
  "All pages": "All pages",
  "First page": "First page",
  "Following pages": "Following pages",
  "Format settings": "Format settings",
  "Page and format settings": "Page and format settings",
  "Email format and styling": "Email format and styling",
  "Paragraph spacing": "Paragraph spacing",
  "Paragraph spacing tooltip": "Spacing below paragraphs of text.",
  "Document elements": "Document elements",
  "Custom elements": "Custom elements",
  "Block already added": "Block already added",
  "Drag into document or click to add": "Drag into document or click to add",
  "Standard (6 pt)": "Standard (6 pt)",
  "Standard (1,35)": "Standard (1.35)",
  "Standard (10 pt)": "Standard (10 pt)",
  "Standard (12 pt)": "Standard (12 pt)",
  "Standard (1,6)": "Standard (1.6)",
  "Standard (14 px)": "Standard (14 px)",
  "System document subject tooltip": "Subject line of the email. In a letter the subject is a block on the sheet and is written there.",
  "Reset content to template": "Reset content to template",
  "Reset content to template confirmation": "All text changes and hidden blocks of this template are lost.",
  "A text set needs a title": "A template needs a title",
  "A text set needs a document appearance": "A template needs an appearance",
  "Duplicate text set": "Duplicate template",
  "Letter and email templates": "Letter and email templates",
  "Letter and email template": "Letter and email template",
  "Reusable letters and emails for recurring workflows": "Reusable letters and emails for recurring workflows",
  "WhatsApp templates": "WhatsApp templates",
  "Local assignments to approved Meta templates": "Local assignments to approved Meta templates",
  "SMS templates": "SMS templates",
  "Plain-text messages for notifications and workflows": "Plain-text messages for notifications and workflows",
  "The contract document is generated from the saved contract data.": "The contract document is generated from the saved contract data.",
  "The contract will be created without a signature.": "The contract will be created without a signature.",
  "Payment reminder": "Payment reminder",
  "Free message": "Free message",
  "Message text": "Message text",
  "Delete SMS template?": "Delete SMS template?",
  "Delete SMS template hint": "The SMS template will be deleted permanently.",
  "Add SMS template": "Add SMS template",
  "Edit SMS template": "Edit SMS template",
  "Message text is required": "Message text is required",
  "1 character": "1 character",
  "1 SMS segment": "1 SMS segment",
  "{0} SMS segments": "{0} SMS segments",
  "Approved Meta template": "Approved Meta template",
  "Meta template is required": "A Meta template is required",
  "Select Meta template": "Select Meta template",
  "Remove binding": "Remove binding",
  "Selected Meta template is no longer available": "The selected Meta template is no longer available",
  "Provider bindings": "Provider bindings",
  "Meta approval required": "Meta approval required",
  "Delete WhatsApp template?": "Delete WhatsApp template?",
  "Delete WhatsApp template hint": "The WhatsApp template and its provider bindings will be deleted permanently.",
  "Add WhatsApp template": "Add WhatsApp template",
  "Edit WhatsApp template": "Edit WhatsApp template",
  "WhatsApp appearance": "WhatsApp appearance",
  "No appearance": "No appearance",
  "Parameter mapping": "Parameter mapping",
  "Select variables in provider order": "Select variables in provider placeholder order",
  "At least one provider binding is required": "At least one provider binding is required",
  "Add provider binding": "Add provider binding",
  "An appearance needs at least one output type": "An appearance needs at least one output type",
  "WhatsApp profile": "WhatsApp profile",
  "Header type": "Header type",
  "Header type is required": "A header type is required",
  "No header": "No header",
  "Text header": "Text header",
  "Image header": "Image header",
  "Video header": "Video header",
  "Document header": "Document header",
  "Header text": "Header text",
  "Header text is required": "Header text is required",
  "WhatsApp buttons": "WhatsApp buttons",
  "Button type": "Button type",
  "Button type is required": "A button type is required",
  "Quick view": "Quick view",
  "Quick reply": "Quick reply",
  "Button label is required": "A button label is required",
  "Target URL": "Target URL",
  "Phone number": "Phone number",
  "Button target is required": "A target is required",
  "Add WhatsApp button": "Add WhatsApp button",
  "Message variable availability hint": "Person and studio fields are generally available. Appointment fields are resolved only for appointment confirmations and reminders.",
  "Provider parameter {0}": "Provider parameter {0}",
  "A variable is required": "A variable is required",
  "Select variable": "Select variable",
  "Remove parameter": "Remove parameter",
  "Add parameter": "Add parameter",
  "Template length": "Template length",
  "SMS segment count runtime hint": "The actual character encoding and number of SMS segments are known only after variables are resolved at send time.",
  "WhatsApp message preview": "The message text of the linked WhatsApp template will appear here.",
  "WhatsApp media header preview": "{0} as media header",
  "WhatsApp button preview": "WhatsApp button",
  "WhatsApp appearance reapproval hint": "Resubmit the Meta template with the current appearance and sync it after approval.",
  "Configure categories": "Configure categories",
  "No category": "No category",
  "System document category tooltip": "The category limits the variables offered. Without a category, all variables are available.",
  "Send document subject tooltip": "Subject of this dispatch. Leave empty to use the maintained subject of the template including its variables.",
  "As maintained": "as maintained",
  "Send document title tooltip": "The title under which the letter is filed in the digital file. Without an entry the subject applies.",
  "Send document appearance tooltip": "Stationery for this single letter. The template stays unchanged.",
  "Send document appearance permission missing": "Changing the document appearance of a single dispatch requires the corresponding permission.",
  "Choose document appearance when sending": "Choose document appearance when sending",
  "Choose document appearance when sending help": "Allows choosing a different stationery for a single letter. The template stays unchanged.",
  "Review before sending": "Review before sending",
  "Confirmation not sent": "Confirmation not sent",
  "Rest period saved without confirmation hint": "The rest period has been saved. No letter was sent.",
  "Contract cancelled without confirmation hint": "The cancellation has been saved. No letter was sent.",
  "Confirmation sent.": "Confirmation sent.",
  "Dispatch details": "Dispatch details",
  "Created by": "Created by",
  "Approved at": "Approved at",
  "Queued at": "Queued at",
  "Cancelled at": "Cancelled at",
  "External message id": "Provider message id",
  "Reject": "Reject",
  "Working time permission help": "View and edit working time reports",
  "Approve working time": "Approve working time",
  "Approve working time help": "Approve reports or correct and approve them, and close the month",
  "Without time tracking the plan alone counts, as before.": "Without time tracking the plan alone counts, as before.",
  "Automatic break": "Automatic break",
  "Deduct break automatically": "Deduct break automatically",
  "Applies when no break was reported.": "Applies when no break was reported.",
  "The highest exceeded step applies. German law asks for 30 minutes above six hours and 45 above nine; other countries and collective agreements differ.": "The highest exceeded step applies. German law asks for 30 minutes above six hours and 45 above nine; other countries and collective agreements differ.",
  "Read only": "Read only",
  "Adjust hour balance": "Hour balance",
  "Please enter hours": "Please enter hours",
  "Pay out hours from the hour balance": "Pay out hours from the hour balance",
  "Take hours from the balance into this month.": "Take hours from the balance into this month.",
  "Add hours to the hour balance": "Add hours to the hour balance",
  "Credit extra hours without paying them out.": "Credit extra hours without paying them out.",
  "Hours the employee already has before the first payroll month.": "Hours the employee already has before the first payroll month. If you leave this empty, 0 applies.",
  "Hours to pay out": "Hours to pay out",
  "Hours to add to the hour balance": "Hours to add to the hour balance",
  "Plus and minus hours stay on the hour balance when you close the month.": "Plus and minus hours stay on the hour balance when you close the month.",
  "This booking": "This booking",
  "Keep extra hours on the hour balance.": "Keep extra hours on the hour balance.",
  "Hand extra hours to payroll this month.": "Hand extra hours to payroll this month.",
  "Pay extra hours only while monthly pay stays within the mini-job limit.": "Pay extra hours only while monthly pay stays within the mini-job limit.",
  "Overtime on monthly salary": "Overtime on monthly salary",
  "Overtime on hourly wage": "Overtime on hourly wage",
  "Overtime this month": "Overtime this month",
  "Use the default overtime rule": "Use the default overtime rule",
  "Uses the HR setting for salary or hourly wage.": "Uses the HR setting for salary or hourly wage.",
  "Not tracked": "Not tracked",
  "Time grid, working days, time tracking & shared week plan links": "Time grid, working days, time tracking & shared week plan links",
  "Time grid, working days and booking fallback": "Time grid, working days and booking fallback",
  "Working time recording, daily confirmation and break rules": "Working time recording, daily confirmation and break rules",
  "Vacation, payroll and minimum wage": "Vacation, payroll and minimum wage",
  "Public links for the shared week plan": "Public links for the shared week plan",
  "Hour balance": "Hour balance",
  "Daily confirmation": "Daily confirmation",
  "Require daily confirmation in the employee app": "Require daily confirmation in m1app",
  "(required for online login)": "(required for online login)",
  "(required for online login and m1app)": "(required for online login and m1app)",
  "Sign-in options": "Sign-in options",
  "Studio role": "Studio role",
  "Place of birth": "Place of birth",
  "Nationality": "Nationality",
  "Time tracking and HR": "Time tracking and HR",
  "Working time recording, HR and overtime defaults": "Working time recording, HR, overtime and break rules",
  "StaffHrDisabled": "HR features are turned off.",
  "StaffIsStaffRequiresScheduling": "Listing as staff requires the staff scheduling module.",
  "Channel not configured": "Channel not configured",
  "No integration is configured for this channel. Configure one under Settings › Integrations or remove the channel.": "No integration is configured for this channel. Configure one under Settings › Integrations or remove the channel.",
  "Contact outcome": "Contact outcome",
  "Contact result none": "no result",
  "Contact result appointment booked": "appointment booked",
  "Contact result training agreed": "training agreed",
  "Contact result retained": "retained",
  "Contact result declined": "declined",
  "Contact result follow-up": "follow-up",
  "Contact channel in person": "in person",
  "Contact blocked calls notice": "This person does not want to be called. An outbound call will not be saved — inbound calls and conversations in the studio are allowed.",
  "Contact blocked messages notice": "This person does not want to receive messages. Messages on our own initiative will not be saved — replies to inbound messages are allowed.",
  "Contact direction": "Direction",
  "Contact direction outbound call": "we called",
  "Contact direction inbound call": "person called",
  "Contact direction outbound": "outbound",
  "Contact direction inbound": "inbound",
  "Contact automated": "automated",
  "Log in-person contact": "Conversation in studio",
  "Member care": "Member care",
  "New member care case": "New case",
  "Member care cases": "Member care cases",
  "Member care permission help": "View and work on member care cases for existing members.",
  "Delete member care cases": "Delete member care cases",
  "Delete member care cases help": "allows deleting member care cases including their history.",
  "Member care pipelines settings": "Member care pipelines",
  "Member care pipelines settings permission help": "Manage pipelines and phases of member care.",
  "Member care reports": "Member care reports",
  "Member care reports permission help": "View daily production and member care metrics.",
  "Member care settings": "Member care",
  "Back to member care settings": "back to member care",
  "Member care pipelines description": "Pipelines and phases for onboarding, birthday, reactivation, win-back",
  "Member care reopen after days": "Minimum interval in days",
  "Member care reopen after days help": "For this many days after a case is closed, no new case is created for the same person in this pipeline.",
  "Phase transition requires reached": "only when reached",
  "Please select a member": "please select a member",
  "Search member": "Search member …",
  "Type at least 2 characters": "type at least 2 characters",
  "Please select a pipeline": "please select a pipeline",
  "Select pipeline": "Select pipeline",
  "Capability member care": "Member care",
  "ContactBlockedCalls": "This person does not want to be called. The outbound call was not saved.",
  "ContactBlockedMessages": "This person does not want to receive messages. The message was not sent.",
  "LeadContactChannelRequired": "Channel and direction of the contact are missing.",
  "LeadContactAppointmentNotFound": "The linked appointment was not found.",
  "ReceptionContactStudioRequired": "The reception studio is missing or not assigned to this account.",
  "ReceptionContactKindRequired": "Choose a walk-in or an inbound call.",
  "ReceptionContactPersonRequired": "A person is required for the contact or an appointment — search or enter first and last name.",
  "ReceptionContactAppointmentAlreadySet": "This reception contact already has an appointment.",
  "ReceptionContactLeadDefaultsInvalid": "The lead cannot be created because pipeline or phase is not unique.",
  "MemberCarePipelineInvalid": "The selected pipeline is not an active member care pipeline or has no phase yet.",
  "MemberCarePersonNotMember": "Member care cases exist for members only.",
  "MemberCareOpenCaseExists": "An open case for this person already exists in this pipeline.",
  "MemberCareEpisodeAlreadyHandled": "This occasion has already been handled for this person.",
  "MemberCareWithinReopenInterval": "The last case in this pipeline was closed only recently — the pipeline's minimum interval has not passed yet.",
  "RegistrationInvalid": "Please complete all fields.",
  "RegistrationPasswordWeak": "The password needs at least 8 characters with upper- and lowercase letters, a digit and a special character.",
  "RegistrationRateLimited": "Too many registration attempts. Please try again later.",
  "RegistrationDisabled": "Registration is currently not available.",
  "RegistrationLimitReached": "No further registrations are possible at the moment.",
  "RegistrationConflict": "An account or pending registration already exists for this email address.",
  "RegistrationEmailNotConfigured": "Registration is not set up on the system side yet (no sending mailbox).",
  "RegistrationEmailNotSent": "The confirmation email could not be delivered. Please try again.",
  "Without a template tenant, a new tenant starts empty.": "Without a template tenant, a new tenant starts empty.",
  "RegistrationProvisioningFailed": "The account could not be created on the system side.",
  "InvalidEmailConfirmationToken": "The confirmation link is invalid or has expired.",
  "Self-registration": "Self-registration",
  "Maximum self-registered tenants": "Maximum self-registered tenants",
  "Template tenant": "Template tenant",
  "Self-registered tenants": "Self-registered tenants",
  "Phase entry action": "on entering the phase",
  "Phase entry action what": "automatic action",
  "Phase entry action help": "Runs for every case that enters this phase from now on — existing cases are not affected.",
  "Phase entry action none": "none",
  "Phase entry action send email": "send email",
  "Phase entry action send sms": "send SMS",
  "Phase entry action send whatsapp": "send WhatsApp",
  "Phase entry action create follow-up": "create follow-up for staff",
  "Phase entry fallback follow-up": "when contact is blocked, create follow-up “talk in person” instead",
  "Phase entry fallback follow-up help": "Without this option the message is skipped when messages are blocked and the chain continues.",
  "SMS template": "SMS template",
  "WhatsApp template": "WhatsApp template",
  "Follow-up title": "Follow-up title",
  "Follow-up title placeholder": "e.g. call",
  "Follow-up due after days": "due after days",
  "Follow-up due after days help": "0 = due immediately. Counted from entering the phase.",
  "Phase transition trigger dwell elapsed": "after dwell time in phase",
  "Phase transition dwell days": "dwell time in days",
  "Phase transition only without contact": "only without a reached contact since entry",
  "Create member care case": "Create member care case",
  "Member care pipeline": "Member care pipeline",
  "Member care pipeline automation help": "The case is created in this pipeline — once per person and occasion, respecting the pipeline's minimum interval.",
  "No member care pipelines yet": "no member care pipeline yet",
  "Automation scenario contract cancelled": "Cancellation received",
  "Cancellations of the last days": "Cancellations of the last days",
  "No open member care cases": "no open member care case",
  "Case since {0}": "case since {0}",
  "Closed member care cases: {0}": "closed: {0}",
  "last {0} on {1}": "last {0} on {1}",
  "Member care lost": "lost",
  "Open member care cases": "open member care cases",
  "Member care follow-ups due": "member care due",
  "Daily production": "Daily production",
  "Daily production description": "Calls, trial sessions, walk-ins and member care conversations per day",
  "All employees": "all employees",
  "DPR inbound calls": "inbound calls",
  "DPR outbound call attempts": "outbound call attempts",
  "DPR outbound calls reached": "outbound reached",
  "DPR trials booked from inbound": "trials booked from inbound calls",
  "DPR trials booked from outbound": "trials booked from outbound calls",
  "DPR trials scheduled": "trials scheduled",
  "DPR trials held": "trials held",
  "DPR trials closed": "trials closed",
  "DPR walk-ins": "walk-ins",
  "DPR walk-ins booked": "walk-ins booked",
  "DPR walk-ins closed": "walk-ins closed",
  "DPR birthday calls": "birthday calls",
  "DPR win-back calls reached": "win-back calls reached",
  "DPR win-back talks in studio": "win-back talks in studio",
  "DPR win-back retained": "cancellations retained",
  "DPR reactivation call attempts": "reactivation call attempts",
  "DPR reactivation calls reached": "reactivation calls reached",
  "DPR reactivation trainings agreed": "reactivation trainings agreed",
  "DPR automated messages": "automated messages",
  "DPR booking rate inbound": "booking rate inbound",
  "DPR reach rate outbound": "reach rate outbound",
  "DPR booking rate outbound": "booking rate outbound",
  "DPR show rate trials": "show rate trials",
  "DPR close rate trials": "close rate trials",
  "DPR close rate walk-ins": "close rate walk-ins",
  "DPR win-back rate": "win-back rate",
  "DPR reactivation success": "reactivation success rate",
  "DPR reactivation open cases": "reactivation list (open)",
  "Pipeline report role": "Role in daily production",
  "Pipeline report role help": "The daily production report assigns birthday, reactivation and win-back conversations via this role — not by name.",
  "Pipeline report role none": "none",
  "Pipeline report role onboarding": "onboarding",
  "Pipeline report role birthday": "birthday",
  "Pipeline report role reactivation": "reactivation (motivation list)",
  "Pipeline report role win-back": "win-back (cancellation)",
  "Pipeline report role renewal": "renewal",
  "Pipeline report role reentry": "re-entry",
  "Locations & Branches": "Locations & Branches",
  "Members, Finance & Access": "Members, Finance & Access",
  "Studio Operations & App": "Studio Operations & App",
  "Staff & Sales": "Staff & Sales",
  "AI & Support": "AI & Support",
  "To report": "To report",
  "App requests": "App requests",
  "Rest period from": "Rest period from",
  "Rest period until": "Rest period until",
  "Days remaining": "Days remaining",
  "Rest period ends within 30 days": "Rest period ends within 30 days",
  "Contract ends": "Contract ends",
  "Contract ends by month": "Contract ends by month",
  "Remaining term in days": "Remaining term in days",
  "Wallet type": "Type",
  "Wallet type value": "Credit",
  "Wallet type points": "Points",
  "Last transaction": "Last transaction",
  "Balance total": "Total balance",
  "Average balance": "Average balance",
  "Contracts with a rest period running today": "Contracts with a rest period running today",
  "Cancelled contracts that have not ended yet": "Cancelled contracts that have not ended yet",
  "Active wallets and their balances": "Active wallets and their balances",
  "Fee exempt": "Fee exempt",
  "E_TenantDeletionSubscriptionActive": "The plan is still running. The deletion can be requested once it has been cancelled.",
  "E_TenantDeletionAlreadyRequested": "The deletion has already been requested.",
  "E_TenantDeletionConfirmationMismatch": "The name does not match the tenant name.",
  "E_TenantDeletionPasswordInvalid": "The password is incorrect.",
  "E_TenantDeletionNotRevocable": "There is no deletion request that can be revoked.",
  "E_TenantDeletionFailed": "The tenant could not be deleted. The operation has been logged.",
  "Type {name} to confirm": "type “{name}” to confirm",
  "The name does not match.": "The name does not match.",
  "Your password": "your password",
  "Deletion requested": "Deletion requested",
  "Tenant will be deleted on {date}": "Your data will be permanently deleted on {date}.",
  "All data and documents will then be permanently deleted.": "All data and documents will then be permanently deleted.",
  "The tenant is being deleted.": "Your data is being deleted.",
  "Deletion revoke": "Cancel deletion",
  "Deleting the tenant permanently removes all studios, members, contracts, payments, documents, users and settings.": "Deleting the tenant permanently removes all studios, members, contracts, payments, documents, users and settings.",
  "Your data will be permanently deleted {days} days after your request. Until then, you can cancel the deletion here yourself.": "Your data will be permanently deleted {days} days after your request. Until then, you can cancel the deletion here yourself.",
  "Until then, you can cancel the deletion here yourself.": "Until then, you can cancel the deletion here yourself.",
  "Requested by {name}. Until then, any company administrator can revoke the request.": "Requested by {name}. Until then, any company administrator can revoke the request.",
  "Only company administrators can request the deletion.": "Only company administrators can request the deletion.",
  "The deletion takes place {days} days after the request and can be revoked until then.": "The deletion takes place {days} days after the request and can be revoked until then.",
  "Enter the tenant name and your password to request the deletion.": "Enter the tenant name and your password to request the deletion.",
  "Request deletion": "Request deletion",
  "Request the deletion of all data after the plan has ended": "Request the deletion of all data after the plan has ended",
  "All data and documents of the tenant will be permanently deleted immediately. Our invoices to the tenant remain.": "All data and documents of the tenant will be permanently deleted immediately. Our invoices to the tenant remain.",
  "E_StudioOperationLocked": "This location is locked in your plan. Operations and changes to its members and contracts are possible again after increasing the number of locations.",
  "E_StudioLockSelectionInvalid": "Please select exactly as many locations to lock as are being removed.",
  "Plan lock": "Plan lock",
  "locked from {date}": "locked from {date}",
  "Unlock location": "Unlock location",
  "Unlock location?": "Unlock location?",
  "Location unlocked": "Location unlocked",
  "The location becomes operational again and occupies one of the booked locations.": "The location becomes operational again and occupies one of the booked locations.",
  "Locked in plan: {names}": "Locked in plan: {names}",
  "No check-in, no payments, no new contracts and no changes to members and contracts of these locations. Data remains readable.": "No check-in, no payments, no new contracts and no changes to members and contracts of these locations. Data remains readable.",
  "{count} locations": "{count} locations",
  "E_StudioQuotaReached": "All booked locations are in use. Increase the number of locations in your plan to activate another studio.",
  "Increase number of locations?": "Increase number of locations?",
  "to the plan page": "to the plan page",
  "E_StudioQuotaBelowActive": "The selected number of locations is lower than the number of active studios.",
  "E_MemberLimitReached": "The number of members included in your plan has been reached.",
  "E_UserLimitReached": "The number of users included in your plan has been reached.",
  "E_ReaderLimitReached": "The number of reader devices included in your plan has been reached.",
  "Locations": "Locations",
  "number of usable studio locations": "number of usable studio locations",
  "1 location": "1 location",
  "single license": "single license",
  "up to {count} locations": "up to {count} locations",
  "bookable": "bookable",
  "any number": "any number",
  "any number of locations bookable": "any number of locations bookable",
  "{count} / mo.": "{count} / mo.",
  "up to {count} members": "up to {count} members",
  "up to {count} users": "up to {count} users",
  "up to {count} reader devices": "up to {count} reader devices",
  "{count} AI contract cases / month included": "{count} AI contract cases / month included",
  "individual": "individual",
  "as needed": "as needed",
  "included": "included",
  "TenantFeeExemptionDescription": "The plan and add-ons are billed at €0. Features and quantity limits of the selected plan remain in effect. Turning this off restores regular prices for new bookings and renewals.",
  "Payment allocation count": "{0} allocations",
  "Payment transactions could not be loaded": "Payments could not be loaded.",
  "Payment allocation": "Allocation",
  "Payment allocation item": "Receivable",
  "Payment allocated amount": "Allocated amount",
  "Reminder action": "Action",
  "ReminderRetryCreated": "Direct debit retry scheduled",
  "ReminderRetryNotificationConfirmed": "Collection notification letter dispatch confirmed",
  "Request payment": "Request payment",
  "Retry collection date": "Retry collection date",
  "Retry notification required": "Check notification delivery",
  "Retry collection scheduled": "retry collection scheduled",
  "Retry collection submitted": "retry included in direct debit run",
  "Retry collection processing": "collection processing",
  "Retry collection missed": "collection date missed",
  "Retry collection cancelled": "collection attempt cancelled",
  "Retry collection failed": "retry did not settle balance",
  "Retry amount changed": "announced amount has changed",
  "Confirm retry letter sent": "Confirm letter dispatch",
  "Confirm retry letter sent hint": "Only confirm if the collection notification was actually sent by letter today. Generating or printing a PDF is insufficient.",
  "Payment chargeback line": "Chargeback",
  "E_ReminderRetryIneligible": "The current payment method, mandate or SEPA block does not allow a retry. Check the selected items.",
  "E_ReminderRetryDate": "No common scheduled collection date satisfies the 14-day notification period. Check the date, direct debit groups and selected items.",
  "E_ReminderRetryNotification": "The collection notification has not been effectively sent. Check the document, letter dispatch or email status. The appearance must contain introduction and notice blocks.",
  "E_ReminderRetryRun": "The collection instruction no longer matches the current case. Check delivery, date, outstanding amounts and the linked direct debit run.",
  "E_ReminderActionConflict": "The selected items result in different reminder actions. Check the selection and rules of the involved reminder levels.",
  "USC platform access": "Urban Sports Club – platform access",
  "USC client ID": "Client ID",
  "USC client secret": "Client secret",
  "USC secret unchanged": "keep saved secret",
  "USC platform settings unavailable": "The platform access settings could not be loaded.",
  "USC application authentication successful": "Central USC authentication succeeded. Studio approval is handled separately by USC.",
  "USC removing platform access disables tenant USC access": "Removing platform access disables USC access validation for all tenants. Studio mappings are retained.",
  "USC studio approval required": "USC approves your studio for m1member; approved locations are retrieved afterwards.",
  "E_UscPlatformCredentialsInvalid": "Central USC credentials are incomplete or invalid. Check client ID and client secret. A new client ID requires a new secret.",
  "E_UscPlatformUnavailable": "Central USC authentication could not be checked at this time.",
  "E_UscOnboardingNotConfigured": "USC requests are not available yet. The platform operator must configure the recipient and USC webhook.",
  "E_UscRequestConflict": "This USC identifier already has a request or mapping.",
  "E_UscPlatformMailUnavailable": "Platform notification email delivery is not configured.",
  "E_UscProviderInvalid": "The USC partner/studio number or confirmed provider ID is invalid.",
  "USC support request email": "USC approval request recipient",
  "USC webhook URL": "public webhook URL",
  "USC webhook URL help": "HTTPS address of this installation with path /api/v1/webhooks/urban-sports-club.",
  "USC webhook registration missing": "The USC webhook is not registered yet. Check settings and save again.",
  "USC connections unavailable": "USC requests and locations could not be loaded.",
  "USC provider ID": "USC provider ID",
  "USC provider ID help": "USC provider ID; not a membership number or location ID.",
  "Request USC approval": "Request USC approval",
  "Refresh USC locations": "Refresh USC locations",
  "USC status Requested": "approval pending",
  "USC status Synchronizing": "loading locations",
  "USC status Active": "approved",
  "USC status Removed": "approval ended",
  "USC status SyncFailed": "location retrieval failed",
  "USC request mail failed": "request email failed",
  "USC request mail queued": "sending request",
  "Retry USC request email": "Retry request email",
  "USC partner ID": "USC partner/studio number",
  "USC partner ID help": "Your partner/studio number from your USC partnership.",
  "USC pending request": "pending USC request",
  "USC confirmed provider ID": "USC-confirmed provider ID",
  "USC confirmed assignment help": "Assign only the provider ID USC confirmed for this request. The webhook does not contain the partner/studio number.",
  "Confirm USC assignment": "Confirm USC assignment",
  "E_UscDisconnectPending": "USC has not confirmed disconnection yet. You can request approval again afterwards.",
  "USC status Disconnected": "disconnected locally",
  "Disconnect USC integration": "Disconnect USC integration",
  "Disconnect USC integration confirmation": "USC access for this provider and all mapped locations is blocked immediately. USC receives a removal request automatically. Contract and reader assignments are retained.",
  "USC removal pending": "USC confirmation pending",
  "USC removal email failed": "removal request not sent; local access remains blocked",
  "Request USC approval again": "Request USC approval again",
  "Disconnect": "Disconnect",
  "Lead widget: default headline": "Get in touch",
  "Lead widget: step contact": "Your details",
  "Lead widget: choose studio": "Choose a studio",
  "Lead widget: submit failed": "The request could not be sent. Please try again.",
  "Lead widgets: active": "Lead form active",
  "Lead widgets: tab basis": "Basics",
  "Lead widgets: tab form fields": "Form fields",
  "Lead widgets: tab success": "Confirmation",
  "Lead widgets: tab display": "Appearance",
  "Lead widgets: colors": "Colors",
  "Lead widgets: images": "Images",
  "Lead widgets: texts": "Texts",
  "Lead widgets: headline": "Headline",
  "Lead widgets: link": "Form link",
  "Lead widgets: open as customer": "Open as customer",
  "Lead widgets: regenerate link?": "Regenerate link?",
  "Lead widgets: regenerate link hint": "The previous link will stop working.",
  "Lead widgets: save first": "The link and embed code are available after saving for the first time.",
  "Lead widgets: logo help": "The logo appears in the form header.",
  "Lead widgets: background help": "The image is shown dimmed behind the form.",
  "Lead widgets: preview form": "Form",
  "Lead widgets: preview confirmation": "Confirmation",
  "Lead widgets: saved": "Lead form saved",
  "Lead widgets: created": "Lead form created",
  "Lead widgets: copy suffix": "(copy)",
  "Widget design sources: load": "Load design from …",
  "Widget design sources: form": "Form",
  "Widget design sources: choose": "Choose a form",
  "Widget design sources: none": "No other forms available",
  "Widget design sources: load failed": "The forms could not be loaded.",
  "Widget design sources: Contact": "Contact form",
  "Widget design sources: Booking": "Booking form",
  "Widget design sources: Contract": "Contract form",
  "E_WidgetDesignTemplate_NameRequired": "Please enter a name for the template.",
  "E_WidgetDesignTemplate_NameTaken": "A template with this name already exists.",
  "E_WidgetDesignTemplate_DesignInvalid": "The appearance could not be saved.",
  "Checking availability": "Checking availability",
  "{0} min": "{0} min",
  "Booking widget: default headline": "Book an appointment",
  "Booking widget: thank you title": "Thank you for your booking!",
  "Booking widget: thank you message": "Your booking is confirmed. You will receive an email with all details.",
  "Booking widget: booking failed": "The booking could not be completed. Please try again.",
  "Booking widget: step type": "Appointment type",
  "Booking widget: step time": "Date and time",
  "Booking widget: step contact": "Your details",
  "Booking widget: step finish": "Summary",
  "Booking widget: choose studio": "Choose a studio",
  "Booking widget: choose type": "Choose an appointment type",
  "Booking widget: choose time": "Choose day and time",
  "Booking widget: day": "Day",
  "Booking widget: time": "Time",
  "Booking widget: free": "Free",
  "Booking widget: book as series": "Book as a recurring series",
  "Booking widget: first appointment": "First appointment",
  "Booking widget: appointment": "Appointment",
  "Booking widget: series": "Series",
  "Booking widget: contact": "Contact",
  "Booking widgets: active": "Online booking active",
  "Booking widgets: confirmation variables": "In title and message, {{bookingNumber}} is replaced by the booking number.",
  "Quick search placeholder": "Search person or page …",
  "Quick search": "Search",
  "Ask Qeddy": "Ask Qeddy",
  "Recently opened": "Recently opened",
  "Ctrl+K": "Ctrl+K",
  "Cancellation…": "Cancellation…",
  "No cancellable contract package.": "There is no contract package that can be cancelled.",
  "Dispatch approval": "Dispatch approval",
  "Chargeback task drawer title": "Chargeback",
  "Chargeback task mark done": "Mark as done",
  "Chargeback task done message": "Chargeback marked as done.",
  "Dispatch approved.": "Dispatch approved.",
  "Dispatch rejected.": "Dispatch rejected.",
  "Reject dispatch?": "Reject dispatch?",
  "Dashboard preset placeholder": "Apply template",
  "Dashboard preset reception": "Front desk",
  "Dashboard preset management": "Studio management",
  "Dashboard preset accounting": "Accounting",
  "Admin dashboard active tenants": "Active tenants",
  "Admin dashboard tenants caption": "of {0} · {1} new in 30 days",
  "Admin dashboard active studios": "Active studios",
  "Admin dashboard persons": "Persons",
  "Admin dashboard revenue": "Revenue 30 days (net)",
  "Admin dashboard open invoices": "Open invoices",
  "Admin dashboard running jobs": "Running background jobs",
  "Admin dashboard queued jobs": "{0} queued",
  "Admin dashboard action services": "Services",
  "Admin dashboard action logs": "System log",
  "Admin dashboard critical issues": "{0} critical startup issues",
  "Admin dashboard system errors": "{0} system errors in the last 24 hours",
  "Admin dashboard failed services": "Last run failed: {0}",
  "Admin dashboard failed jobs": "{0} background jobs failed in 24 hours",
  "Admin dashboard failed invoices": "{0} invoices with failed payment",
  "Admin dashboard failed emails": "{0} emails not delivered in 7 days ({1} tenants)",
  "Admin dashboard pending emails": "{0} emails waiting for more than an hour",
  "Admin dashboard stopped services": "Stopped services: {0}",
  "Admin dashboard attention": "Attention required",
  "Admin dashboard no attention": "Nothing requires attention",
  "Admin dashboard load failed": "The overview could not be loaded.",
  "Account statement": "Account statement",
  "Account statement booking": "Booking",
  "Account statement path": "Path",
  "Account statement debit": "Debit",
  "Account statement credit": "Credit",
  "Account statement balance": "Balance",
  "Account statement open balance": "{0} open",
  "Account statement credit balance": "{0} credit",
  "Account statement in collection amount": "of which in collection {0}",
  "Account statement debt collection amount": "debt collection {0}",
  "Account statement due since": "due since",
  "Account statement day": "{0} day",
  "Account statement days": "{0} days",
  "Account statement reminder eligible from": "reminders possible from {0}",
  "Account statement next collection": "next collection",
  "Account statement next contribution": "next contribution",
  "Account statement all bookings": "all bookings",
  "Account statement only open": "open only",
  "Account statement payment": "Payment",
  "Account statement show future": "{0} future contributions until {1} · {2}",
  "Account statement hide future": "hide future contributions",
  "Account statement rest": "remaining {0}",
  "Account statement credit offset": "Offset against credit",
  "Account statement unassigned payment": "not assigned to an item",
  "Account statement installment plan": "Installment plan",
  "Account statement installment plan detail": "{0} installments of {1}, {2} open",
  "Account statement load failed": "The account statement could not be loaded.",
  "Account statement status planned": "planned",
  "Account statement status due": "due",
  "Account statement status reminder eligible": "reminder due",
  "Account statement status in collection": "in collection",
  "Account statement status paid": "paid",
  "Account statement status settled": "settled",
  "Account statement status cancelled": "cancelled",
  "Account statement status debt collection": "debt collection",
  "Account statement adjustment credit applied": "Credit applied",
  "Account statement adjustment cancelled": "cancelled without correction document",
  "Account statement adjustment cancelled after payment": "Payment on cancelled claim, not kept as credit",
  "Account statement adjustment overpayment": "Overpayment, not kept as credit",
  "Account statement adjustment credit overapplied": "Credit applied beyond its amount",
  "Account statement adjustment other": "Adjustment to open items",
  "Reminder eligible (status)": "reminder due",
  "Receivables": "Receivables",
  "Receivables card description": "Path of each claim from due to debt collection",
  "Receivables permission help": "Allows viewing the receivables path. Runs, payments and blocks require their own permission.",
  "Receivables stages": "Stages of the receivables path",
  "Receivables stage due": "due",
  "Receivables stage inCollection": "in collection",
  "Receivables stage returned": "returned",
  "Receivables stage reminded": "reminded",
  "Receivables stage debtCollection": "debt collection",
  "Receivables column claim": "Claim",
  "Receivables column stage": "Stage",
  "Receivables column returned at": "Returned on",
  "Receivables column return reason": "Return reason",
  "Receivables reminder level value": "Level {0}",
  "Receivables flag dunning due": "reminder due",
  "Receivables flag payment cancelled": "payment cancelled",
  "Receivables filter sepa blocked": "SEPA blocked only",
  "Receivables filter payment cancelled": "with payment cancellation only",
  "Receivables action recollect": "Collect again",
  "Receivables action prepare reminder run": "Prepare reminder run",
  "Receivables action open run": "Direct debit run",
  "Receivables dunning due summary": "of which reminder due: {0} · {1}",
  ...memberAdminNavigationEn,
} as const;
